(() => {

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6bfa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6bfa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hUnSM", function(module, exports) {
"use strict";
module.exports = "3.22.6";

});

parcelRegister("9w6zV", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ var $6edc348f0c32ccf9$var$Hogan = {};
(function(Hogan) {
    Hogan.Template = function(codeObj, text, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text || "";
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = "";
    };
    Hogan.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
            return "";
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
            return this.ri([
                context
            ], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
            return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol, partials) {
            var partial = this.partials[symbol];
            // check to see that if we've instantiated this partial before
            var template = partials[partial.name];
            if (partial.instance && partial.base == template) return partial.instance;
            if (typeof template == "string") {
                if (!this.c) throw new Error("No compiler available.");
                template = this.c.compile(template, this.options);
            }
            if (!template) return null;
            // We use this to check whether the partials dictionary has changed
            this.partials[symbol].base = template;
            if (partial.subs) {
                // Make sure we consider parent template now
                if (!partials.stackText) partials.stackText = {};
                for(key in partial.subs)if (!partials.stackText[key]) partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
                template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
            }
            this.partials[symbol].instance = template;
            return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol, context, partials, indent) {
            var partial = this.ep(symbol, partials);
            if (!partial) return "";
            return partial.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
            var tail = context[context.length - 1];
            if (!isArray(tail)) {
                section(context, partials, this);
                return;
            }
            for(var i = 0; i < tail.length; i++){
                context.push(tail[i]);
                section(context, partials, this);
                context.pop();
            }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
            var pass;
            if (isArray(val) && val.length === 0) return false;
            if (typeof val == "function") val = this.ms(val, ctx, partials, inverted, start, end, tags);
            pass = !!val;
            if (!inverted && pass && ctx) ctx.push(typeof val == "object" ? val : ctx[ctx.length - 1]);
            return pass;
        },
        // find values with dotted names
        d: function(key1, ctx, partials, returnFound) {
            var found, names = key1.split("."), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx = null;
            if (key1 === "." && isArray(ctx[ctx.length - 2])) val = ctx[ctx.length - 1];
            else for(var i = 1; i < names.length; i++){
                found = findInScope(names[i], val, doModelGet);
                if (found !== undefined) {
                    cx = val;
                    val = found;
                } else val = "";
            }
            if (returnFound && !val) return false;
            if (!returnFound && typeof val == "function") {
                ctx.push(cx);
                val = this.mv(val, ctx, partials);
                ctx.pop();
            }
            return val;
        },
        // find values with normal names
        f: function(key1, ctx, partials, returnFound) {
            var val = false, v = null, found = false, doModelGet = this.options.modelGet;
            for(var i = ctx.length - 1; i >= 0; i--){
                v = ctx[i];
                val = findInScope(key1, v, doModelGet);
                if (val !== undefined) {
                    found = true;
                    break;
                }
            }
            if (!found) return returnFound ? false : "";
            if (!returnFound && typeof val == "function") val = this.mv(val, ctx, partials);
            return val;
        },
        // higher order templates
        ls: function(func, cx, partials, text, tags) {
            var oldTags = this.options.delimiters;
            this.options.delimiters = tags;
            this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
            this.options.delimiters = oldTags;
            return false;
        },
        // compile text
        ct: function(text, cx, partials) {
            if (this.options.disableLambda) throw new Error("Lambda features disabled.");
            return this.c.compile(text, this.options).render(cx, partials);
        },
        // template result buffering
        b: function(s) {
            this.buf += s;
        },
        fl: function() {
            var r = this.buf;
            this.buf = "";
            return r;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
            var textSource, cx = ctx[ctx.length - 1], result = func.call(cx);
            if (typeof result == "function") {
                if (inverted) return true;
                else {
                    textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
                    return this.ls(result, cx, partials, textSource.substring(start, end), tags);
                }
            }
            return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
            var cx = ctx[ctx.length - 1];
            var result = func.call(cx);
            if (typeof result == "function") return this.ct(coerceToString(result.call(cx)), cx, partials);
            return result;
        },
        sub: function(name, context, partials, indent) {
            var f = this.subs[name];
            if (f) {
                this.activeSub = name;
                f(context, partials, this, indent);
                this.activeSub = false;
            }
        }
    };
    //Find a key in an object
    function findInScope(key1, scope, doModelGet) {
        var val;
        if (scope && typeof scope == "object") {
            if (scope[key1] !== undefined) val = scope[key1];
            else if (doModelGet && scope.get && typeof scope.get == "function") val = scope.get(key1);
        }
        return val;
    }
    function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {}
        PartialTemplate.prototype = instance;
        function Substitutions() {}
        Substitutions.prototype = instance.subs;
        var key1;
        var partial = new PartialTemplate();
        partial.subs = new Substitutions();
        partial.subsText = {}; //hehe. substext.
        partial.buf = "";
        stackSubs = stackSubs || {};
        partial.stackSubs = stackSubs;
        partial.subsText = stackText;
        for(key1 in subs)if (!stackSubs[key1]) stackSubs[key1] = subs[key1];
        for(key1 in stackSubs)partial.subs[key1] = stackSubs[key1];
        stackPartials = stackPartials || {};
        partial.stackPartials = stackPartials;
        for(key1 in partials)if (!stackPartials[key1]) stackPartials[key1] = partials[key1];
        for(key1 in stackPartials)partial.partials[key1] = stackPartials[key1];
        return partial;
    }
    var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
    function coerceToString(val) {
        return String(val === null || val === undefined ? "" : val);
    }
    function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, "&amp;").replace(rLt, "&lt;").replace(rGt, "&gt;").replace(rApos, "&#39;").replace(rQuot, "&quot;") : str;
    }
    var isArray = Array.isArray || function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
    };
})(module.exports);

});

parcelRegister("91jyD", function(module, exports) {
(function(self1) {
    var irrelevant = function(exports) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis !== "undefined" && globalThis || typeof self1 !== "undefined" && self1 || // eslint-disable-next-line no-undef
        typeof $parcel$global !== "undefined" && $parcel$global || {};
        var support = {
            searchParams: "URLSearchParams" in g,
            iterable: "Symbol" in g && "iterator" in Symbol,
            blob: "FileReader" in g && "Blob" in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in g,
            arrayBuffer: "ArrayBuffer" in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : "utf-8";
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = "";
                } else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error("could not read as ArrayBuffer");
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "CONNECT",
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "PATCH",
            "POST",
            "PUT",
            "TRACE"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ("AbortController" in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn("Response " + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ""
            });
            response.ok = false;
            response.status = 0;
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports.DOMException = g.DOMException;
        try {
            new exports.DOMException();
        } catch (err) {
            exports.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports.DOMException.prototype = Object.create(Error.prototype);
            exports.DOMException.prototype.constructor = exports.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request timed out"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports.Headers = Headers;
        exports.Request = Request;
        exports.Response = Response;
        exports.fetch = fetch;
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        return exports;
    }({});
})(typeof self !== "undefined" ? self : module.exports);

});


var $2bd4b9c31e857ffa$var$Events = /** @class */ function() {
    function Events(eventType, eventFunctions) {
        if (eventFunctions === void 0) eventFunctions = [];
        this._eventType = eventType;
        this._eventFunctions = eventFunctions;
    }
    Events.prototype.init = function() {
        var _this = this;
        this._eventFunctions.forEach(function(eventFunction) {
            if (typeof window !== "undefined") window.addEventListener(_this._eventType, eventFunction);
        });
    };
    return Events;
}();
var $2bd4b9c31e857ffa$export$2e2bcd8739ae039 = $2bd4b9c31e857ffa$var$Events;


var $5d5682da381fac09$var$Instances = /** @class */ function() {
    function Instances() {
        this._instances = {
            Accordion: {},
            Carousel: {},
            Collapse: {},
            Dial: {},
            Dismiss: {},
            Drawer: {},
            Dropdown: {},
            Modal: {},
            Popover: {},
            Tabs: {},
            Tooltip: {},
            InputCounter: {},
            CopyClipboard: {},
            Datepicker: {}
        };
    }
    Instances.prototype.addInstance = function(component, instance, id, override) {
        if (override === void 0) override = false;
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (this._instances[component][id] && !override) {
            console.warn("Flowbite: Instance with ID ".concat(id, " already exists."));
            return;
        }
        if (override && this._instances[component][id]) this._instances[component][id].destroyAndRemoveInstance();
        this._instances[component][id ? id : this._generateRandomId()] = instance;
    };
    Instances.prototype.getAllInstances = function() {
        return this._instances;
    };
    Instances.prototype.getInstances = function(component) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        return this._instances[component];
    };
    Instances.prototype.getInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return;
        }
        return this._instances[component][id];
    };
    Instances.prototype.destroyAndRemoveInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this.destroyInstanceObject(component, id);
        this.removeInstance(component, id);
    };
    Instances.prototype.removeInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        delete this._instances[component][id];
    };
    Instances.prototype.destroyInstanceObject = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this._instances[component][id].destroy();
    };
    Instances.prototype.instanceExists = function(component, id) {
        if (!this._instances[component]) return false;
        if (!this._instances[component][id]) return false;
        return true;
    };
    Instances.prototype._generateRandomId = function() {
        return Math.random().toString(36).substr(2, 9);
    };
    Instances.prototype._componentAndInstanceCheck = function(component, id) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return false;
        }
        return true;
    };
    return Instances;
}();
var $5d5682da381fac09$var$instances = new $5d5682da381fac09$var$Instances();
var $5d5682da381fac09$export$2e2bcd8739ae039 = $5d5682da381fac09$var$instances;
if (typeof window !== "undefined") window.FlowbiteInstances = $5d5682da381fac09$var$instances;


var $d93a619a461d9c03$var$__assign = undefined && undefined.__assign || function() {
    $d93a619a461d9c03$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d93a619a461d9c03$var$__assign.apply(this, arguments);
};
var $d93a619a461d9c03$var$Default = {
    alwaysOpen: false,
    activeClasses: "bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white",
    inactiveClasses: "text-gray-500 dark:text-gray-400",
    onOpen: function() {},
    onClose: function() {},
    onToggle: function() {}
};
var $d93a619a461d9c03$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $d93a619a461d9c03$var$Accordion = /** @class */ function() {
    function Accordion(accordionEl, items, options, instanceOptions) {
        if (accordionEl === void 0) accordionEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $d93a619a461d9c03$var$Default;
        if (instanceOptions === void 0) instanceOptions = $d93a619a461d9c03$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : accordionEl.id;
        this._accordionEl = accordionEl;
        this._items = items;
        this._options = $d93a619a461d9c03$var$__assign($d93a619a461d9c03$var$__assign({}, $d93a619a461d9c03$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Accordion", this, this._instanceId, instanceOptions.override);
    }
    Accordion.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // show accordion item based on click
            this._items.forEach(function(item) {
                if (item.active) _this.open(item.id);
                var clickHandler = function() {
                    _this.toggle(item.id);
                };
                item.triggerEl.addEventListener("click", clickHandler);
                // Store the clickHandler in a property of the item for removal later
                item.clickHandler = clickHandler;
            });
            this._initialized = true;
        }
    };
    Accordion.prototype.destroy = function() {
        if (this._items.length && this._initialized) {
            this._items.forEach(function(item) {
                item.triggerEl.removeEventListener("click", item.clickHandler);
                // Clean up by deleting the clickHandler property from the item
                delete item.clickHandler;
            });
            this._initialized = false;
        }
    };
    Accordion.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Accordion", this._instanceId);
    };
    Accordion.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Accordion.prototype.getItem = function(id) {
        return this._items.filter(function(item) {
            return item.id === id;
        })[0];
    };
    Accordion.prototype.open = function(id) {
        var _a, _b;
        var _this = this;
        var item = this.getItem(id);
        // don't hide other accordions if always open
        if (!this._options.alwaysOpen) this._items.map(function(i) {
            var _a, _b;
            if (i !== item) {
                (_a = i.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(" "));
                (_b = i.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(" "));
                i.targetEl.classList.add("hidden");
                i.triggerEl.setAttribute("aria-expanded", "false");
                i.active = false;
                // rotate icon if set
                if (i.iconEl) i.iconEl.classList.add("rotate-180");
            }
        });
        // show active item
        (_a = item.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(" "));
        (_b = item.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(" "));
        item.triggerEl.setAttribute("aria-expanded", "true");
        item.targetEl.classList.remove("hidden");
        item.active = true;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.remove("rotate-180");
        // callback function
        this._options.onOpen(this, item);
    };
    Accordion.prototype.toggle = function(id) {
        var item = this.getItem(id);
        if (item.active) this.close(id);
        else this.open(id);
        // callback function
        this._options.onToggle(this, item);
    };
    Accordion.prototype.close = function(id) {
        var _a, _b;
        var item = this.getItem(id);
        (_a = item.triggerEl.classList).remove.apply(_a, this._options.activeClasses.split(" "));
        (_b = item.triggerEl.classList).add.apply(_b, this._options.inactiveClasses.split(" "));
        item.targetEl.classList.add("hidden");
        item.triggerEl.setAttribute("aria-expanded", "false");
        item.active = false;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.add("rotate-180");
        // callback function
        this._options.onClose(this, item);
    };
    Accordion.prototype.updateOnOpen = function(callback) {
        this._options.onOpen = callback;
    };
    Accordion.prototype.updateOnClose = function(callback) {
        this._options.onClose = callback;
    };
    Accordion.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Accordion;
}();
function $d93a619a461d9c03$export$226c1dc98323ee4d() {
    document.querySelectorAll("[data-accordion]").forEach(function($accordionEl) {
        var alwaysOpen = $accordionEl.getAttribute("data-accordion");
        var activeClasses = $accordionEl.getAttribute("data-active-classes");
        var inactiveClasses = $accordionEl.getAttribute("data-inactive-classes");
        var items = [];
        $accordionEl.querySelectorAll("[data-accordion-target]").forEach(function($triggerEl) {
            // Consider only items that directly belong to $accordionEl
            // (to make nested accordions work).
            if ($triggerEl.closest("[data-accordion]") === $accordionEl) {
                var item = {
                    id: $triggerEl.getAttribute("data-accordion-target"),
                    triggerEl: $triggerEl,
                    targetEl: document.querySelector($triggerEl.getAttribute("data-accordion-target")),
                    iconEl: $triggerEl.querySelector("[data-accordion-icon]"),
                    active: $triggerEl.getAttribute("aria-expanded") === "true" ? true : false
                };
                items.push(item);
            }
        });
        new $d93a619a461d9c03$var$Accordion($accordionEl, items, {
            alwaysOpen: alwaysOpen === "open" ? true : false,
            activeClasses: activeClasses ? activeClasses : $d93a619a461d9c03$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $d93a619a461d9c03$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== "undefined") {
    window.Accordion = $d93a619a461d9c03$var$Accordion;
    window.initAccordions = $d93a619a461d9c03$export$226c1dc98323ee4d;
}
var $d93a619a461d9c03$export$2e2bcd8739ae039 = $d93a619a461d9c03$var$Accordion;



var $fc7ccf099a511882$var$__assign = undefined && undefined.__assign || function() {
    $fc7ccf099a511882$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc7ccf099a511882$var$__assign.apply(this, arguments);
};
var $fc7ccf099a511882$var$Default = {
    onCollapse: function() {},
    onExpand: function() {},
    onToggle: function() {}
};
var $fc7ccf099a511882$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $fc7ccf099a511882$var$Collapse = /** @class */ function() {
    function Collapse(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $fc7ccf099a511882$var$Default;
        if (instanceOptions === void 0) instanceOptions = $fc7ccf099a511882$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $fc7ccf099a511882$var$__assign($fc7ccf099a511882$var$__assign({}, $fc7ccf099a511882$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Collapse", this, this._instanceId, instanceOptions.override);
    }
    Collapse.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            if (this._triggerEl.hasAttribute("aria-expanded")) this._visible = this._triggerEl.getAttribute("aria-expanded") === "true";
            else // fix until v2 not to break previous single collapses which became dismiss
            this._visible = !this._targetEl.classList.contains("hidden");
            this._clickHandler = function() {
                _this.toggle();
            };
            this._triggerEl.addEventListener("click", this._clickHandler);
            this._initialized = true;
        }
    };
    Collapse.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener("click", this._clickHandler);
            this._initialized = false;
        }
    };
    Collapse.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Collapse", this._instanceId);
    };
    Collapse.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Collapse.prototype.collapse = function() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "false");
        this._visible = false;
        // callback function
        this._options.onCollapse(this);
    };
    Collapse.prototype.expand = function() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "true");
        this._visible = true;
        // callback function
        this._options.onExpand(this);
    };
    Collapse.prototype.toggle = function() {
        if (this._visible) this.collapse();
        else this.expand();
        // callback function
        this._options.onToggle(this);
    };
    Collapse.prototype.updateOnCollapse = function(callback) {
        this._options.onCollapse = callback;
    };
    Collapse.prototype.updateOnExpand = function(callback) {
        this._options.onExpand = callback;
    };
    Collapse.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Collapse;
}();
function $fc7ccf099a511882$export$355ba5a528b4009a() {
    document.querySelectorAll("[data-collapse-toggle]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-collapse-toggle");
        var $targetEl = document.getElementById(targetId);
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $5d5682da381fac09$export$2e2bcd8739ae039).instanceExists("Collapse", $targetEl.getAttribute("id"))) new $fc7ccf099a511882$var$Collapse($targetEl, $triggerEl);
            else // if instance exists already for the same target element then create a new one with a different trigger element
            new $fc7ccf099a511882$var$Collapse($targetEl, $triggerEl, {}, {
                id: $targetEl.getAttribute("id") + "_" + (0, $5d5682da381fac09$export$2e2bcd8739ae039)._generateRandomId()
            });
        } else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-collapse-toggle attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Collapse = $fc7ccf099a511882$var$Collapse;
    window.initCollapses = $fc7ccf099a511882$export$355ba5a528b4009a;
}
var $fc7ccf099a511882$export$2e2bcd8739ae039 = $fc7ccf099a511882$var$Collapse;



var $c1b11beef829dd56$var$__assign = undefined && undefined.__assign || function() {
    $c1b11beef829dd56$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1b11beef829dd56$var$__assign.apply(this, arguments);
};
var $c1b11beef829dd56$var$Default = {
    defaultPosition: 0,
    indicators: {
        items: [],
        activeClasses: "bg-white dark:bg-gray-800",
        inactiveClasses: "bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800"
    },
    interval: 3000,
    onNext: function() {},
    onPrev: function() {},
    onChange: function() {}
};
var $c1b11beef829dd56$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $c1b11beef829dd56$var$Carousel = /** @class */ function() {
    function Carousel(carouselEl, items, options, instanceOptions) {
        if (carouselEl === void 0) carouselEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $c1b11beef829dd56$var$Default;
        if (instanceOptions === void 0) instanceOptions = $c1b11beef829dd56$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : carouselEl.id;
        this._carouselEl = carouselEl;
        this._items = items;
        this._options = $c1b11beef829dd56$var$__assign($c1b11beef829dd56$var$__assign($c1b11beef829dd56$var$__assign({}, $c1b11beef829dd56$var$Default), options), {
            indicators: $c1b11beef829dd56$var$__assign($c1b11beef829dd56$var$__assign({}, $c1b11beef829dd56$var$Default.indicators), options.indicators)
        });
        this._activeItem = this.getItem(this._options.defaultPosition);
        this._indicators = this._options.indicators.items;
        this._intervalDuration = this._options.interval;
        this._intervalInstance = null;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Carousel", this, this._instanceId, instanceOptions.override);
    }
    /**
     * initialize carousel and items based on active one
     */ Carousel.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            this._items.map(function(item) {
                item.el.classList.add("absolute", "inset-0", "transition-transform", "transform");
            });
            // if no active item is set then first position is default
            if (this.getActiveItem()) this.slideTo(this.getActiveItem().position);
            else this.slideTo(0);
            this._indicators.map(function(indicator, position) {
                indicator.el.addEventListener("click", function() {
                    _this.slideTo(position);
                });
            });
            this._initialized = true;
        }
    };
    Carousel.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Carousel.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Carousel", this._instanceId);
    };
    Carousel.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Carousel.prototype.getItem = function(position) {
        return this._items[position];
    };
    /**
     * Slide to the element based on id
     * @param {*} position
     */ Carousel.prototype.slideTo = function(position) {
        var nextItem = this._items[position];
        var rotationItems = {
            left: nextItem.position === 0 ? this._items[this._items.length - 1] : this._items[nextItem.position - 1],
            middle: nextItem,
            right: nextItem.position === this._items.length - 1 ? this._items[0] : this._items[nextItem.position + 1]
        };
        this._rotate(rotationItems);
        this._setActiveItem(nextItem);
        if (this._intervalInstance) {
            this.pause();
            this.cycle();
        }
        this._options.onChange(this);
    };
    /**
     * Based on the currently active item it will go to the next position
     */ Carousel.prototype.next = function() {
        var activeItem = this.getActiveItem();
        var nextItem = null;
        // check if last item
        if (activeItem.position === this._items.length - 1) nextItem = this._items[0];
        else nextItem = this._items[activeItem.position + 1];
        this.slideTo(nextItem.position);
        // callback function
        this._options.onNext(this);
    };
    /**
     * Based on the currently active item it will go to the previous position
     */ Carousel.prototype.prev = function() {
        var activeItem = this.getActiveItem();
        var prevItem = null;
        // check if first item
        if (activeItem.position === 0) prevItem = this._items[this._items.length - 1];
        else prevItem = this._items[activeItem.position - 1];
        this.slideTo(prevItem.position);
        // callback function
        this._options.onPrev(this);
    };
    /**
     * This method applies the transform classes based on the left, middle, and right rotation carousel items
     * @param {*} rotationItems
     */ Carousel.prototype._rotate = function(rotationItems) {
        // reset
        this._items.map(function(item) {
            item.el.classList.add("hidden");
        });
        // Handling the case when there is only one item
        if (this._items.length === 1) {
            rotationItems.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10");
            rotationItems.middle.el.classList.add("translate-x-0", "z-20");
            return;
        }
        // left item (previously active)
        rotationItems.left.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-20");
        rotationItems.left.el.classList.add("-translate-x-full", "z-10");
        // currently active item
        rotationItems.middle.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-10");
        rotationItems.middle.el.classList.add("translate-x-0", "z-30");
        // right item (upcoming active)
        rotationItems.right.el.classList.remove("-translate-x-full", "translate-x-full", "translate-x-0", "hidden", "z-30");
        rotationItems.right.el.classList.add("translate-x-full", "z-20");
    };
    /**
     * Set an interval to cycle through the carousel items
     */ Carousel.prototype.cycle = function() {
        var _this = this;
        if (typeof window !== "undefined") this._intervalInstance = window.setInterval(function() {
            _this.next();
        }, this._intervalDuration);
    };
    /**
     * Clears the cycling interval
     */ Carousel.prototype.pause = function() {
        clearInterval(this._intervalInstance);
    };
    /**
     * Get the currently active item
     */ Carousel.prototype.getActiveItem = function() {
        return this._activeItem;
    };
    /**
     * Set the currently active item and data attribute
     * @param {*} position
     */ Carousel.prototype._setActiveItem = function(item) {
        var _a, _b;
        var _this = this;
        this._activeItem = item;
        var position = item.position;
        // update the indicators if available
        if (this._indicators.length) {
            this._indicators.map(function(indicator) {
                var _a, _b;
                indicator.el.setAttribute("aria-current", "false");
                (_a = indicator.el.classList).remove.apply(_a, _this._options.indicators.activeClasses.split(" "));
                (_b = indicator.el.classList).add.apply(_b, _this._options.indicators.inactiveClasses.split(" "));
            });
            (_a = this._indicators[position].el.classList).add.apply(_a, this._options.indicators.activeClasses.split(" "));
            (_b = this._indicators[position].el.classList).remove.apply(_b, this._options.indicators.inactiveClasses.split(" "));
            this._indicators[position].el.setAttribute("aria-current", "true");
        }
    };
    Carousel.prototype.updateOnNext = function(callback) {
        this._options.onNext = callback;
    };
    Carousel.prototype.updateOnPrev = function(callback) {
        this._options.onPrev = callback;
    };
    Carousel.prototype.updateOnChange = function(callback) {
        this._options.onChange = callback;
    };
    return Carousel;
}();
function $c1b11beef829dd56$export$3ab77386b16b9e58() {
    document.querySelectorAll("[data-carousel]").forEach(function($carouselEl) {
        var interval = $carouselEl.getAttribute("data-carousel-interval");
        var slide = $carouselEl.getAttribute("data-carousel") === "slide" ? true : false;
        var items = [];
        var defaultPosition = 0;
        if ($carouselEl.querySelectorAll("[data-carousel-item]").length) Array.from($carouselEl.querySelectorAll("[data-carousel-item]")).map(function($carouselItemEl, position) {
            items.push({
                position: position,
                el: $carouselItemEl
            });
            if ($carouselItemEl.getAttribute("data-carousel-item") === "active") defaultPosition = position;
        });
        var indicators = [];
        if ($carouselEl.querySelectorAll("[data-carousel-slide-to]").length) Array.from($carouselEl.querySelectorAll("[data-carousel-slide-to]")).map(function($indicatorEl) {
            indicators.push({
                position: parseInt($indicatorEl.getAttribute("data-carousel-slide-to")),
                el: $indicatorEl
            });
        });
        var carousel = new $c1b11beef829dd56$var$Carousel($carouselEl, items, {
            defaultPosition: defaultPosition,
            indicators: {
                items: indicators
            },
            interval: interval ? interval : $c1b11beef829dd56$var$Default.interval
        });
        if (slide) carousel.cycle();
        // check for controls
        var carouselNextEl = $carouselEl.querySelector("[data-carousel-next]");
        var carouselPrevEl = $carouselEl.querySelector("[data-carousel-prev]");
        if (carouselNextEl) carouselNextEl.addEventListener("click", function() {
            carousel.next();
        });
        if (carouselPrevEl) carouselPrevEl.addEventListener("click", function() {
            carousel.prev();
        });
    });
}
if (typeof window !== "undefined") {
    window.Carousel = $c1b11beef829dd56$var$Carousel;
    window.initCarousels = $c1b11beef829dd56$export$3ab77386b16b9e58;
}
var $c1b11beef829dd56$export$2e2bcd8739ae039 = $c1b11beef829dd56$var$Carousel;



var $6d6d37a8acee51c1$var$__assign = undefined && undefined.__assign || function() {
    $6d6d37a8acee51c1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d6d37a8acee51c1$var$__assign.apply(this, arguments);
};
var $6d6d37a8acee51c1$var$Default = {
    transition: "transition-opacity",
    duration: 300,
    timing: "ease-out",
    onHide: function() {}
};
var $6d6d37a8acee51c1$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $6d6d37a8acee51c1$var$Dismiss = /** @class */ function() {
    function Dismiss(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $6d6d37a8acee51c1$var$Default;
        if (instanceOptions === void 0) instanceOptions = $6d6d37a8acee51c1$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $6d6d37a8acee51c1$var$__assign($6d6d37a8acee51c1$var$__assign({}, $6d6d37a8acee51c1$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Dismiss", this, this._instanceId, instanceOptions.override);
    }
    Dismiss.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._clickHandler = function() {
                _this.hide();
            };
            this._triggerEl.addEventListener("click", this._clickHandler);
            this._initialized = true;
        }
    };
    Dismiss.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener("click", this._clickHandler);
            this._initialized = false;
        }
    };
    Dismiss.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Dismiss", this._instanceId);
    };
    Dismiss.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dismiss.prototype.hide = function() {
        var _this = this;
        this._targetEl.classList.add(this._options.transition, "duration-".concat(this._options.duration), this._options.timing, "opacity-0");
        setTimeout(function() {
            _this._targetEl.classList.add("hidden");
        }, this._options.duration);
        // callback function
        this._options.onHide(this, this._targetEl);
    };
    Dismiss.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Dismiss;
}();
function $6d6d37a8acee51c1$export$69c84787a503daef() {
    document.querySelectorAll("[data-dismiss-target]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-dismiss-target");
        var $dismissEl = document.querySelector(targetId);
        if ($dismissEl) new $6d6d37a8acee51c1$var$Dismiss($dismissEl, $triggerEl);
        else console.error('The dismiss element with id "'.concat(targetId, '" does not exist. Please check the data-dismiss-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Dismiss = $6d6d37a8acee51c1$var$Dismiss;
    window.initDismisses = $6d6d37a8acee51c1$export$69c84787a503daef;
}
var $6d6d37a8acee51c1$export$2e2bcd8739ae039 = $6d6d37a8acee51c1$var$Dismiss;


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}


function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}







function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


var $f5c54167a3c62105$export$1e95b668f3b82d = "top";
var $f5c54167a3c62105$export$40e543e69a8b3fbb = "bottom";
var $f5c54167a3c62105$export$79ffe56a765070d2 = "right";
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = "left";
var $f5c54167a3c62105$export$dfb5619354ba860 = "auto";
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = "start";
var $f5c54167a3c62105$export$bd5df0f255a350f8 = "end";
var $f5c54167a3c62105$export$390fd549c5303b4d = "clippingParents";
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = "viewport";
var $f5c54167a3c62105$export$ae5ab1c730825774 = "popper";
var $f5c54167a3c62105$export$ca50aac9f3ba507f = "reference";
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = "beforeRead";
var $f5c54167a3c62105$export$aafa59e2e03f2942 = "read";
var $f5c54167a3c62105$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = "beforeMain";
var $f5c54167a3c62105$export$f22da7240b7add18 = "main";
var $f5c54167a3c62105$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = "beforeWrite";
var $f5c54167a3c62105$export$68d8715fc104d294 = "write";
var $f5c54167a3c62105$export$70a6e5159acce2e6 = "afterWrite";
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};










var $c8f8eadcf7685dc5$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $7c04da2e958a3fe8$var$offset
};


var $825ae98fe4f5d029$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: "end",
    end: "start"
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}







function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $174d14927bb4f43b$var$hide
};




var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $9d7e083df5284b15$var$__assign = undefined && undefined.__assign || function() {
    $9d7e083df5284b15$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d7e083df5284b15$var$__assign.apply(this, arguments);
};
var $9d7e083df5284b15$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9d7e083df5284b15$var$Default = {
    placement: "bottom",
    triggerType: "click",
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300,
    ignoreClickOutsideClass: false,
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $9d7e083df5284b15$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $9d7e083df5284b15$var$Dropdown = /** @class */ function() {
    function Dropdown(targetElement, triggerElement, options, instanceOptions) {
        if (targetElement === void 0) targetElement = null;
        if (triggerElement === void 0) triggerElement = null;
        if (options === void 0) options = $9d7e083df5284b15$var$Default;
        if (instanceOptions === void 0) instanceOptions = $9d7e083df5284b15$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetElement.id;
        this._targetEl = targetElement;
        this._triggerEl = triggerElement;
        this._options = $9d7e083df5284b15$var$__assign($9d7e083df5284b15$var$__assign({}, $9d7e083df5284b15$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Dropdown", this, this._instanceId, instanceOptions.override);
    }
    Dropdown.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._popperInstance = this._createPopperInstance();
            this._setupEventListeners();
            this._initialized = true;
        }
    };
    Dropdown.prototype.destroy = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        // Remove click event listeners for trigger element
        if (this._options.triggerType === "click") triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.removeEventListener(ev, _this._clickHandler);
        });
        // Remove hover event listeners for trigger and target elements
        if (this._options.triggerType === "hover") {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverHideHandler);
            });
        }
        this._popperInstance.destroy();
        this._initialized = false;
    };
    Dropdown.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Dropdown", this._instanceId);
    };
    Dropdown.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dropdown.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._clickHandler = function() {
            _this.toggle();
        };
        // click event handling for trigger element
        if (this._options.triggerType === "click") triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._clickHandler);
        });
        this._hoverShowTriggerElHandler = function(ev) {
            if (ev.type === "click") _this.toggle();
            else setTimeout(function() {
                _this.show();
            }, _this._options.delay);
        };
        this._hoverShowTargetElHandler = function() {
            _this.show();
        };
        this._hoverHideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(":hover")) _this.hide();
            }, _this._options.delay);
        };
        // hover event handling for trigger element
        if (this._options.triggerType === "hover") {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.addEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.addEventListener(ev, _this._hoverHideHandler);
            });
        }
    };
    Dropdown.prototype._createPopperInstance = function() {
        return (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            this._options.offsetSkidding,
                            this._options.offsetDistance
                        ]
                    }
                }
            ]
        });
    };
    Dropdown.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        // Ignore clicks on the trigger element (ie. a datepicker input)
        var ignoreClickOutsideClass = this._options.ignoreClickOutsideClass;
        var isIgnored = false;
        if (ignoreClickOutsideClass) {
            var ignoredClickOutsideEls = document.querySelectorAll(".".concat(ignoreClickOutsideClass));
            ignoredClickOutsideEls.forEach(function(el) {
                if (el.contains(clickedEl)) {
                    isIgnored = true;
                    return;
                }
            });
        }
        // Ignore clicks on the target element (ie. dropdown itself)
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && !isIgnored && this.isVisible()) this.hide();
    };
    Dropdown.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "click"
                    ],
                    hideEvents: [
                        "mouseleave"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click"
                    ],
                    hideEvents: []
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "click"
                    ],
                    hideEvents: []
                };
        }
    };
    Dropdown.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Dropdown.prototype.isVisible = function() {
        return this._visible;
    };
    Dropdown.prototype.show = function() {
        this._targetEl.classList.remove("hidden");
        this._targetEl.classList.add("block");
        this._targetEl.removeAttribute("aria-hidden");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $9d7e083df5284b15$var$__assign($9d7e083df5284b15$var$__assign({}, options), {
                modifiers: $9d7e083df5284b15$var$__spreadArray($9d7e083df5284b15$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        this._setupClickOutsideListener();
        // Update its position
        this._popperInstance.update();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dropdown.prototype.hide = function() {
        this._targetEl.classList.remove("block");
        this._targetEl.classList.add("hidden");
        this._targetEl.setAttribute("aria-hidden", "true");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $9d7e083df5284b15$var$__assign($9d7e083df5284b15$var$__assign({}, options), {
                modifiers: $9d7e083df5284b15$var$__spreadArray($9d7e083df5284b15$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        this._visible = false;
        this._removeClickOutsideListener();
        // callback function
        this._options.onHide(this);
    };
    Dropdown.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dropdown.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dropdown.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dropdown;
}();
function $9d7e083df5284b15$export$8cb65a02593bf108() {
    document.querySelectorAll("[data-dropdown-toggle]").forEach(function($triggerEl) {
        var dropdownId = $triggerEl.getAttribute("data-dropdown-toggle");
        var $dropdownEl = document.getElementById(dropdownId);
        if ($dropdownEl) {
            var placement = $triggerEl.getAttribute("data-dropdown-placement");
            var offsetSkidding = $triggerEl.getAttribute("data-dropdown-offset-skidding");
            var offsetDistance = $triggerEl.getAttribute("data-dropdown-offset-distance");
            var triggerType = $triggerEl.getAttribute("data-dropdown-trigger");
            var delay = $triggerEl.getAttribute("data-dropdown-delay");
            var ignoreClickOutsideClass = $triggerEl.getAttribute("data-dropdown-ignore-click-outside-class");
            new $9d7e083df5284b15$var$Dropdown($dropdownEl, $triggerEl, {
                placement: placement ? placement : $9d7e083df5284b15$var$Default.placement,
                triggerType: triggerType ? triggerType : $9d7e083df5284b15$var$Default.triggerType,
                offsetSkidding: offsetSkidding ? parseInt(offsetSkidding) : $9d7e083df5284b15$var$Default.offsetSkidding,
                offsetDistance: offsetDistance ? parseInt(offsetDistance) : $9d7e083df5284b15$var$Default.offsetDistance,
                delay: delay ? parseInt(delay) : $9d7e083df5284b15$var$Default.delay,
                ignoreClickOutsideClass: ignoreClickOutsideClass ? ignoreClickOutsideClass : $9d7e083df5284b15$var$Default.ignoreClickOutsideClass
            });
        } else console.error('The dropdown element with id "'.concat(dropdownId, '" does not exist. Please check the data-dropdown-toggle attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Dropdown = $9d7e083df5284b15$var$Dropdown;
    window.initDropdowns = $9d7e083df5284b15$export$8cb65a02593bf108;
}
var $9d7e083df5284b15$export$2e2bcd8739ae039 = $9d7e083df5284b15$var$Dropdown;



var $eaca6a069237aaf5$var$__assign = undefined && undefined.__assign || function() {
    $eaca6a069237aaf5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eaca6a069237aaf5$var$__assign.apply(this, arguments);
};
var $eaca6a069237aaf5$var$Default = {
    placement: "center",
    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
    backdrop: "dynamic",
    closable: true,
    onHide: function() {},
    onShow: function() {},
    onToggle: function() {}
};
var $eaca6a069237aaf5$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $eaca6a069237aaf5$var$Modal = /** @class */ function() {
    function Modal(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $eaca6a069237aaf5$var$Default;
        if (instanceOptions === void 0) instanceOptions = $eaca6a069237aaf5$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $eaca6a069237aaf5$var$__assign($eaca6a069237aaf5$var$__assign({}, $eaca6a069237aaf5$var$Default), options);
        this._isHidden = true;
        this._backdropEl = null;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Modal", this, this._instanceId, instanceOptions.override);
    }
    Modal.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._getPlacementClasses().map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._initialized = true;
        }
    };
    Modal.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            this._initialized = false;
        }
    };
    Modal.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Modal", this._instanceId);
    };
    Modal.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Modal.prototype._createBackdrop = function() {
        var _a;
        if (this._isHidden) {
            var backdropEl = document.createElement("div");
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(" "));
            document.querySelector("body").append(backdropEl);
            this._backdropEl = backdropEl;
        }
    };
    Modal.prototype._destroyBackdropEl = function() {
        if (!this._isHidden && this._backdropEl) {
            this._backdropEl.remove();
            this._backdropEl = null;
        }
    };
    Modal.prototype._setupModalCloseEventListeners = function() {
        var _this = this;
        if (this._options.backdrop === "dynamic") {
            this._clickOutsideEventListener = function(ev) {
                _this._handleOutsideClick(ev.target);
            };
            this._targetEl.addEventListener("click", this._clickOutsideEventListener, true);
        }
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Modal.prototype._removeModalCloseEventListeners = function() {
        if (this._options.backdrop === "dynamic") this._targetEl.removeEventListener("click", this._clickOutsideEventListener, true);
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Modal.prototype._handleOutsideClick = function(target) {
        if (target === this._targetEl || target === this._backdropEl && this.isVisible()) this.hide();
    };
    Modal.prototype._getPlacementClasses = function() {
        switch(this._options.placement){
            // top
            case "top-left":
                return [
                    "justify-start",
                    "items-start"
                ];
            case "top-center":
                return [
                    "justify-center",
                    "items-start"
                ];
            case "top-right":
                return [
                    "justify-end",
                    "items-start"
                ];
            // center
            case "center-left":
                return [
                    "justify-start",
                    "items-center"
                ];
            case "center":
                return [
                    "justify-center",
                    "items-center"
                ];
            case "center-right":
                return [
                    "justify-end",
                    "items-center"
                ];
            // bottom
            case "bottom-left":
                return [
                    "justify-start",
                    "items-end"
                ];
            case "bottom-center":
                return [
                    "justify-center",
                    "items-end"
                ];
            case "bottom-right":
                return [
                    "justify-end",
                    "items-end"
                ];
            default:
                return [
                    "justify-center",
                    "items-center"
                ];
        }
    };
    Modal.prototype.toggle = function() {
        if (this._isHidden) this.show();
        else this.hide();
        // callback function
        this._options.onToggle(this);
    };
    Modal.prototype.show = function() {
        if (this.isHidden) {
            this._targetEl.classList.add("flex");
            this._targetEl.classList.remove("hidden");
            this._targetEl.setAttribute("aria-modal", "true");
            this._targetEl.setAttribute("role", "dialog");
            this._targetEl.removeAttribute("aria-hidden");
            this._createBackdrop();
            this._isHidden = false;
            // Add keyboard event listener to the document
            if (this._options.closable) this._setupModalCloseEventListeners();
            // prevent body scroll
            document.body.classList.add("overflow-hidden");
            // callback function
            this._options.onShow(this);
        }
    };
    Modal.prototype.hide = function() {
        if (this.isVisible) {
            this._targetEl.classList.add("hidden");
            this._targetEl.classList.remove("flex");
            this._targetEl.setAttribute("aria-hidden", "true");
            this._targetEl.removeAttribute("aria-modal");
            this._targetEl.removeAttribute("role");
            this._destroyBackdropEl();
            this._isHidden = true;
            // re-apply body scroll
            document.body.classList.remove("overflow-hidden");
            if (this._options.closable) this._removeModalCloseEventListeners();
            // callback function
            this._options.onHide(this);
        }
    };
    Modal.prototype.isVisible = function() {
        return !this._isHidden;
    };
    Modal.prototype.isHidden = function() {
        return this._isHidden;
    };
    Modal.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Modal.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Modal.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Modal.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Modal.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Modal.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Modal;
}();
function $eaca6a069237aaf5$export$e14d3bc873a8b9b1() {
    // initiate modal based on data-modal-target
    document.querySelectorAll("[data-modal-target]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-target");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var placement = $modalEl.getAttribute("data-modal-placement");
            var backdrop = $modalEl.getAttribute("data-modal-backdrop");
            new $eaca6a069237aaf5$var$Modal($modalEl, {
                placement: placement ? placement : $eaca6a069237aaf5$var$Default.placement,
                backdrop: backdrop ? backdrop : $eaca6a069237aaf5$var$Default.backdrop
            });
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-target attribute points to the correct modal id?."));
    });
    // toggle modal visibility
    document.querySelectorAll("[data-modal-toggle]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-toggle");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_1 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance("Modal", modalId);
            if (modal_1) {
                var toggleModal = function() {
                    modal_1.toggle();
                };
                $triggerEl.addEventListener("click", toggleModal);
                modal_1.addEventListenerInstance($triggerEl, "click", toggleModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-toggle attribute points to the correct modal id?"));
    });
    // show modal on click if exists based on id
    document.querySelectorAll("[data-modal-show]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-show");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_2 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance("Modal", modalId);
            if (modal_2) {
                var showModal = function() {
                    modal_2.show();
                };
                $triggerEl.addEventListener("click", showModal);
                modal_2.addEventListenerInstance($triggerEl, "click", showModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-show attribute points to the correct modal id?"));
    });
    // hide modal on click if exists based on id
    document.querySelectorAll("[data-modal-hide]").forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute("data-modal-hide");
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_3 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance("Modal", modalId);
            if (modal_3) {
                var hideModal = function() {
                    modal_3.hide();
                };
                $triggerEl.addEventListener("click", hideModal);
                modal_3.addEventListenerInstance($triggerEl, "click", hideModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-hide attribute points to the correct modal id?"));
    });
}
if (typeof window !== "undefined") {
    window.Modal = $eaca6a069237aaf5$var$Modal;
    window.initModals = $eaca6a069237aaf5$export$e14d3bc873a8b9b1;
}
var $eaca6a069237aaf5$export$2e2bcd8739ae039 = $eaca6a069237aaf5$var$Modal;



var $48c8331f22e653e8$var$__assign = undefined && undefined.__assign || function() {
    $48c8331f22e653e8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $48c8331f22e653e8$var$__assign.apply(this, arguments);
};
var $48c8331f22e653e8$var$Default = {
    placement: "left",
    bodyScrolling: false,
    backdrop: true,
    edge: false,
    edgeOffset: "bottom-[60px]",
    backdropClasses: "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $48c8331f22e653e8$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $48c8331f22e653e8$var$Drawer = /** @class */ function() {
    function Drawer(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $48c8331f22e653e8$var$Default;
        if (instanceOptions === void 0) instanceOptions = $48c8331f22e653e8$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $48c8331f22e653e8$var$__assign($48c8331f22e653e8$var$__assign({}, $48c8331f22e653e8$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Drawer", this, this._instanceId, instanceOptions.override);
    }
    Drawer.prototype.init = function() {
        var _this = this;
        // set initial accessibility attributes
        if (this._targetEl && !this._initialized) {
            this._targetEl.setAttribute("aria-hidden", "true");
            this._targetEl.classList.add("transition-transform");
            // set base placement classes
            this._getPlacementClasses(this._options.placement).base.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._handleEscapeKey = function(event) {
                if (event.key === "Escape") // if 'Escape' key is pressed
                {
                    if (_this.isVisible()) // if the Drawer is visible
                    _this.hide(); // hide the Drawer
                }
            };
            // add keyboard event listener to document
            document.addEventListener("keydown", this._handleEscapeKey);
            this._initialized = true;
        }
    };
    Drawer.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            // Remove the keyboard event listener
            document.removeEventListener("keydown", this._handleEscapeKey);
            this._initialized = false;
        }
    };
    Drawer.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Drawer", this._instanceId);
    };
    Drawer.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Drawer.prototype.hide = function() {
        var _this = this;
        // based on the edge option show placement classes
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + "-edge").active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute("aria-hidden", "true");
        this._targetEl.removeAttribute("aria-modal");
        this._targetEl.removeAttribute("role");
        // enable body scroll
        if (!this._options.bodyScrolling) document.body.classList.remove("overflow-hidden");
        // destroy backdrop
        if (this._options.backdrop) this._destroyBackdropEl();
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Drawer.prototype.show = function() {
        var _this = this;
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + "-edge").active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement + "-edge").inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute("aria-modal", "true");
        this._targetEl.setAttribute("role", "dialog");
        this._targetEl.removeAttribute("aria-hidden");
        // disable body scroll
        if (!this._options.bodyScrolling) document.body.classList.add("overflow-hidden");
        // show backdrop
        if (this._options.backdrop) this._createBackdrop();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Drawer.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Drawer.prototype._createBackdrop = function() {
        var _a;
        var _this = this;
        if (!this._visible) {
            var backdropEl = document.createElement("div");
            backdropEl.setAttribute("drawer-backdrop", "");
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(" "));
            document.querySelector("body").append(backdropEl);
            backdropEl.addEventListener("click", function() {
                _this.hide();
            });
        }
    };
    Drawer.prototype._destroyBackdropEl = function() {
        if (this._visible && document.querySelector("[drawer-backdrop]") !== null) document.querySelector("[drawer-backdrop]").remove();
    };
    Drawer.prototype._getPlacementClasses = function(placement) {
        switch(placement){
            case "top":
                return {
                    base: [
                        "top-0",
                        "left-0",
                        "right-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-y-full"
                    ]
                };
            case "right":
                return {
                    base: [
                        "right-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-x-full"
                    ]
                };
            case "bottom":
                return {
                    base: [
                        "bottom-0",
                        "left-0",
                        "right-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-y-full"
                    ]
                };
            case "left":
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-x-full"
                    ]
                };
            case "bottom-edge":
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "translate-y-full",
                        this._options.edgeOffset
                    ]
                };
            default:
                return {
                    base: [
                        "left-0",
                        "top-0"
                    ],
                    active: [
                        "transform-none"
                    ],
                    inactive: [
                        "-translate-x-full"
                    ]
                };
        }
    };
    Drawer.prototype.isHidden = function() {
        return !this._visible;
    };
    Drawer.prototype.isVisible = function() {
        return this._visible;
    };
    Drawer.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Drawer.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Drawer.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Drawer.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Drawer.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Drawer.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Drawer;
}();
function $48c8331f22e653e8$export$319df2b10e87c8ec() {
    document.querySelectorAll("[data-drawer-target]").forEach(function($triggerEl) {
        // mandatory
        var drawerId = $triggerEl.getAttribute("data-drawer-target");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var placement = $triggerEl.getAttribute("data-drawer-placement");
            var bodyScrolling = $triggerEl.getAttribute("data-drawer-body-scrolling");
            var backdrop = $triggerEl.getAttribute("data-drawer-backdrop");
            var edge = $triggerEl.getAttribute("data-drawer-edge");
            var edgeOffset = $triggerEl.getAttribute("data-drawer-edge-offset");
            new $48c8331f22e653e8$var$Drawer($drawerEl, {
                placement: placement ? placement : $48c8331f22e653e8$var$Default.placement,
                bodyScrolling: bodyScrolling ? bodyScrolling === "true" ? true : false : $48c8331f22e653e8$var$Default.bodyScrolling,
                backdrop: backdrop ? backdrop === "true" ? true : false : $48c8331f22e653e8$var$Default.backdrop,
                edge: edge ? edge === "true" ? true : false : $48c8331f22e653e8$var$Default.edge,
                edgeOffset: edgeOffset ? edgeOffset : $48c8331f22e653e8$var$Default.edgeOffset
            });
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll("[data-drawer-toggle]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-toggle");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_1 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance("Drawer", drawerId);
            if (drawer_1) {
                var toggleDrawer = function() {
                    drawer_1.toggle();
                };
                $triggerEl.addEventListener("click", toggleDrawer);
                drawer_1.addEventListenerInstance($triggerEl, "click", toggleDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll("[data-drawer-dismiss], [data-drawer-hide]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-dismiss") ? $triggerEl.getAttribute("data-drawer-dismiss") : $triggerEl.getAttribute("data-drawer-hide");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_2 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance("Drawer", drawerId);
            if (drawer_2) {
                var hideDrawer = function() {
                    drawer_2.hide();
                };
                $triggerEl.addEventListener("click", hideDrawer);
                drawer_2.addEventListenerInstance($triggerEl, "click", hideDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id"));
    });
    document.querySelectorAll("[data-drawer-show]").forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute("data-drawer-show");
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_3 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance("Drawer", drawerId);
            if (drawer_3) {
                var showDrawer = function() {
                    drawer_3.show();
                };
                $triggerEl.addEventListener("click", showDrawer);
                drawer_3.addEventListenerInstance($triggerEl, "click", showDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
}
if (typeof window !== "undefined") {
    window.Drawer = $48c8331f22e653e8$var$Drawer;
    window.initDrawers = $48c8331f22e653e8$export$319df2b10e87c8ec;
}
var $48c8331f22e653e8$export$2e2bcd8739ae039 = $48c8331f22e653e8$var$Drawer;



var $d9a3b96db6d5dbb4$var$__assign = undefined && undefined.__assign || function() {
    $d9a3b96db6d5dbb4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9a3b96db6d5dbb4$var$__assign.apply(this, arguments);
};
var $d9a3b96db6d5dbb4$var$Default = {
    defaultTabId: null,
    activeClasses: "text-blue-600 hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 border-blue-600 dark:border-blue-500",
    inactiveClasses: "dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300",
    onShow: function() {}
};
var $d9a3b96db6d5dbb4$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $d9a3b96db6d5dbb4$var$Tabs = /** @class */ function() {
    function Tabs(tabsEl, items, options, instanceOptions) {
        if (tabsEl === void 0) tabsEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $d9a3b96db6d5dbb4$var$Default;
        if (instanceOptions === void 0) instanceOptions = $d9a3b96db6d5dbb4$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : tabsEl.id;
        this._tabsEl = tabsEl;
        this._items = items;
        this._activeTab = options ? this.getTab(options.defaultTabId) : null;
        this._options = $d9a3b96db6d5dbb4$var$__assign($d9a3b96db6d5dbb4$var$__assign({}, $d9a3b96db6d5dbb4$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Tabs", this, this._instanceId, instanceOptions.override);
    }
    Tabs.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) this.setActiveTab(this._items[0]);
            // force show the first default tab
            this.show(this._activeTab.id, true);
            // show tab content based on click
            this._items.map(function(tab) {
                tab.triggerEl.addEventListener("click", function(event) {
                    event.preventDefault();
                    _this.show(tab.id);
                });
            });
        }
    };
    Tabs.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Tabs.prototype.removeInstance = function() {
        this.destroy();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Tabs", this._instanceId);
    };
    Tabs.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tabs.prototype.getActiveTab = function() {
        return this._activeTab;
    };
    Tabs.prototype.setActiveTab = function(tab) {
        this._activeTab = tab;
    };
    Tabs.prototype.getTab = function(id) {
        return this._items.filter(function(t) {
            return t.id === id;
        })[0];
    };
    Tabs.prototype.show = function(id, forceShow) {
        var _a, _b;
        var _this = this;
        if (forceShow === void 0) forceShow = false;
        var tab = this.getTab(id);
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) return;
        // hide other tabs
        this._items.map(function(t) {
            var _a, _b;
            if (t !== tab) {
                (_a = t.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(" "));
                (_b = t.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(" "));
                t.targetEl.classList.add("hidden");
                t.triggerEl.setAttribute("aria-selected", "false");
            }
        });
        // show active tab
        (_a = tab.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(" "));
        (_b = tab.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(" "));
        tab.triggerEl.setAttribute("aria-selected", "true");
        tab.targetEl.classList.remove("hidden");
        this.setActiveTab(tab);
        // callback function
        this._options.onShow(this, tab);
    };
    Tabs.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    return Tabs;
}();
function $d9a3b96db6d5dbb4$export$c92e8f569ad2976f() {
    document.querySelectorAll("[data-tabs-toggle]").forEach(function($parentEl) {
        var tabItems = [];
        var activeClasses = $parentEl.getAttribute("data-tabs-active-classes");
        var inactiveClasses = $parentEl.getAttribute("data-tabs-inactive-classes");
        var defaultTabId = null;
        $parentEl.querySelectorAll('[role="tab"]').forEach(function($triggerEl) {
            var isActive = $triggerEl.getAttribute("aria-selected") === "true";
            var tab = {
                id: $triggerEl.getAttribute("data-tabs-target"),
                triggerEl: $triggerEl,
                targetEl: document.querySelector($triggerEl.getAttribute("data-tabs-target"))
            };
            tabItems.push(tab);
            if (isActive) defaultTabId = tab.id;
        });
        new $d9a3b96db6d5dbb4$var$Tabs($parentEl, tabItems, {
            defaultTabId: defaultTabId,
            activeClasses: activeClasses ? activeClasses : $d9a3b96db6d5dbb4$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $d9a3b96db6d5dbb4$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== "undefined") {
    window.Tabs = $d9a3b96db6d5dbb4$var$Tabs;
    window.initTabs = $d9a3b96db6d5dbb4$export$c92e8f569ad2976f;
}
var $d9a3b96db6d5dbb4$export$2e2bcd8739ae039 = $d9a3b96db6d5dbb4$var$Tabs;




var $91c32ed640e0fec6$var$__assign = undefined && undefined.__assign || function() {
    $91c32ed640e0fec6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $91c32ed640e0fec6$var$__assign.apply(this, arguments);
};
var $91c32ed640e0fec6$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $91c32ed640e0fec6$var$Default = {
    placement: "top",
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $91c32ed640e0fec6$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $91c32ed640e0fec6$var$Tooltip = /** @class */ function() {
    function Tooltip(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $91c32ed640e0fec6$var$Default;
        if (instanceOptions === void 0) instanceOptions = $91c32ed640e0fec6$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $91c32ed640e0fec6$var$__assign($91c32ed640e0fec6$var$__assign({}, $91c32ed640e0fec6$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Tooltip", this, this._instanceId, instanceOptions.override);
    }
    Tooltip.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Tooltip.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Tooltip.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Tooltip", this._instanceId);
    };
    Tooltip.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tooltip.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            _this.hide();
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Tooltip.prototype._createPopperInstance = function() {
        return (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                }
            ]
        });
    };
    Tooltip.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Tooltip.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Tooltip.prototype._removeKeydownListener = function() {
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Tooltip.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Tooltip.prototype.isVisible = function() {
        return this._visible;
    };
    Tooltip.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Tooltip.prototype.show = function() {
        this._targetEl.classList.remove("opacity-0", "invisible");
        this._targetEl.classList.add("opacity-100", "visible");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $91c32ed640e0fec6$var$__assign($91c32ed640e0fec6$var$__assign({}, options), {
                modifiers: $91c32ed640e0fec6$var$__spreadArray($91c32ed640e0fec6$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Tooltip.prototype.hide = function() {
        this._targetEl.classList.remove("opacity-100", "visible");
        this._targetEl.classList.add("opacity-0", "invisible");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $91c32ed640e0fec6$var$__assign($91c32ed640e0fec6$var$__assign({}, options), {
                modifiers: $91c32ed640e0fec6$var$__spreadArray($91c32ed640e0fec6$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Tooltip.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Tooltip.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Tooltip.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Tooltip;
}();
function $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e() {
    document.querySelectorAll("[data-tooltip-target]").forEach(function($triggerEl) {
        var tooltipId = $triggerEl.getAttribute("data-tooltip-target");
        var $tooltipEl = document.getElementById(tooltipId);
        if ($tooltipEl) {
            var triggerType = $triggerEl.getAttribute("data-tooltip-trigger");
            var placement = $triggerEl.getAttribute("data-tooltip-placement");
            new $91c32ed640e0fec6$var$Tooltip($tooltipEl, $triggerEl, {
                placement: placement ? placement : $91c32ed640e0fec6$var$Default.placement,
                triggerType: triggerType ? triggerType : $91c32ed640e0fec6$var$Default.triggerType
            });
        } else console.error('The tooltip element with id "'.concat(tooltipId, '" does not exist. Please check the data-tooltip-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Tooltip = $91c32ed640e0fec6$var$Tooltip;
    window.initTooltips = $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e;
}
var $91c32ed640e0fec6$export$2e2bcd8739ae039 = $91c32ed640e0fec6$var$Tooltip;




var $6aca18f5cd7d8b7b$var$__assign = undefined && undefined.__assign || function() {
    $6aca18f5cd7d8b7b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6aca18f5cd7d8b7b$var$__assign.apply(this, arguments);
};
var $6aca18f5cd7d8b7b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6aca18f5cd7d8b7b$var$Default = {
    placement: "top",
    offset: 10,
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $6aca18f5cd7d8b7b$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $6aca18f5cd7d8b7b$var$Popover = /** @class */ function() {
    function Popover(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $6aca18f5cd7d8b7b$var$Default;
        if (instanceOptions === void 0) instanceOptions = $6aca18f5cd7d8b7b$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $6aca18f5cd7d8b7b$var$__assign($6aca18f5cd7d8b7b$var$__assign({}, $6aca18f5cd7d8b7b$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Popover", this, instanceOptions.id ? instanceOptions.id : this._targetEl.id, instanceOptions.override);
    }
    Popover.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Popover.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element and target element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
                _this._targetEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
                _this._targetEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Popover.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Popover", this._instanceId);
    };
    Popover.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Popover.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(":hover")) _this.hide();
            }, 100);
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
            _this._targetEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
            _this._targetEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Popover.prototype._createPopperInstance = function() {
        return (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            this._options.offset
                        ]
                    }
                }
            ]
        });
    };
    Popover.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Popover.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === "Escape") _this.hide();
        };
        document.body.addEventListener("keydown", this._keydownEventListener, true);
    };
    Popover.prototype._removeKeydownListener = function() {
        document.body.removeEventListener("keydown", this._keydownEventListener, true);
    };
    Popover.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener("click", this._clickOutsideEventListener, true);
    };
    Popover.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener("click", this._clickOutsideEventListener, true);
    };
    Popover.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Popover.prototype.isVisible = function() {
        return this._visible;
    };
    Popover.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Popover.prototype.show = function() {
        this._targetEl.classList.remove("opacity-0", "invisible");
        this._targetEl.classList.add("opacity-100", "visible");
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $6aca18f5cd7d8b7b$var$__assign($6aca18f5cd7d8b7b$var$__assign({}, options), {
                modifiers: $6aca18f5cd7d8b7b$var$__spreadArray($6aca18f5cd7d8b7b$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility to true
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Popover.prototype.hide = function() {
        this._targetEl.classList.remove("opacity-100", "visible");
        this._targetEl.classList.add("opacity-0", "invisible");
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $6aca18f5cd7d8b7b$var$__assign($6aca18f5cd7d8b7b$var$__assign({}, options), {
                modifiers: $6aca18f5cd7d8b7b$var$__spreadArray($6aca18f5cd7d8b7b$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: "eventListeners",
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility to false
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Popover.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Popover.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Popover.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Popover;
}();
function $6aca18f5cd7d8b7b$export$200409e83b2a0dd4() {
    document.querySelectorAll("[data-popover-target]").forEach(function($triggerEl) {
        var popoverID = $triggerEl.getAttribute("data-popover-target");
        var $popoverEl = document.getElementById(popoverID);
        if ($popoverEl) {
            var triggerType = $triggerEl.getAttribute("data-popover-trigger");
            var placement = $triggerEl.getAttribute("data-popover-placement");
            var offset = $triggerEl.getAttribute("data-popover-offset");
            new $6aca18f5cd7d8b7b$var$Popover($popoverEl, $triggerEl, {
                placement: placement ? placement : $6aca18f5cd7d8b7b$var$Default.placement,
                offset: offset ? parseInt(offset) : $6aca18f5cd7d8b7b$var$Default.offset,
                triggerType: triggerType ? triggerType : $6aca18f5cd7d8b7b$var$Default.triggerType
            });
        } else console.error('The popover element with id "'.concat(popoverID, '" does not exist. Please check the data-popover-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.Popover = $6aca18f5cd7d8b7b$var$Popover;
    window.initPopovers = $6aca18f5cd7d8b7b$export$200409e83b2a0dd4;
}
var $6aca18f5cd7d8b7b$export$2e2bcd8739ae039 = $6aca18f5cd7d8b7b$var$Popover;



var $027785b5e7762569$var$__assign = undefined && undefined.__assign || function() {
    $027785b5e7762569$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $027785b5e7762569$var$__assign.apply(this, arguments);
};
var $027785b5e7762569$var$Default = {
    triggerType: "hover",
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $027785b5e7762569$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $027785b5e7762569$var$Dial = /** @class */ function() {
    function Dial(parentEl, triggerEl, targetEl, options, instanceOptions) {
        if (parentEl === void 0) parentEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $027785b5e7762569$var$Default;
        if (instanceOptions === void 0) instanceOptions = $027785b5e7762569$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._parentEl = parentEl;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $027785b5e7762569$var$__assign($027785b5e7762569$var$__assign({}, $027785b5e7762569$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Dial", this, this._instanceId, instanceOptions.override);
    }
    Dial.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            this._showEventHandler = function() {
                _this.show();
            };
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._showEventHandler);
                _this._targetEl.addEventListener(ev, _this._showEventHandler);
            });
            this._hideEventHandler = function() {
                if (!_this._parentEl.matches(":hover")) _this.hide();
            };
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.addEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = true;
        }
    };
    Dial.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showEventHandler);
                _this._targetEl.removeEventListener(ev, _this._showEventHandler);
            });
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.removeEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = false;
        }
    };
    Dial.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Dial", this._instanceId);
    };
    Dial.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dial.prototype.hide = function() {
        this._targetEl.classList.add("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "false");
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Dial.prototype.show = function() {
        this._targetEl.classList.remove("hidden");
        if (this._triggerEl) this._triggerEl.setAttribute("aria-expanded", "true");
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dial.prototype.toggle = function() {
        if (this._visible) this.hide();
        else this.show();
    };
    Dial.prototype.isHidden = function() {
        return !this._visible;
    };
    Dial.prototype.isVisible = function() {
        return this._visible;
    };
    Dial.prototype._getTriggerEventTypes = function(triggerType) {
        switch(triggerType){
            case "hover":
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
            case "click":
                return {
                    showEvents: [
                        "click",
                        "focus"
                    ],
                    hideEvents: [
                        "focusout",
                        "blur"
                    ]
                };
            case "none":
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        "mouseenter",
                        "focus"
                    ],
                    hideEvents: [
                        "mouseleave",
                        "blur"
                    ]
                };
        }
    };
    Dial.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dial.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dial.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dial;
}();
function $027785b5e7762569$export$33aa68e0bfaa065d() {
    document.querySelectorAll("[data-dial-init]").forEach(function($parentEl) {
        var $triggerEl = $parentEl.querySelector("[data-dial-toggle]");
        if ($triggerEl) {
            var dialId = $triggerEl.getAttribute("data-dial-toggle");
            var $dialEl = document.getElementById(dialId);
            if ($dialEl) {
                var triggerType = $triggerEl.getAttribute("data-dial-trigger");
                new $027785b5e7762569$var$Dial($parentEl, $triggerEl, $dialEl, {
                    triggerType: triggerType ? triggerType : $027785b5e7762569$var$Default.triggerType
                });
            } else console.error("Dial with id ".concat(dialId, " does not exist. Are you sure that the data-dial-toggle attribute points to the correct modal id?"));
        } else console.error("Dial with id ".concat($parentEl.id, " does not have a trigger element. Are you sure that the data-dial-toggle attribute exists?"));
    });
}
if (typeof window !== "undefined") {
    window.Dial = $027785b5e7762569$var$Dial;
    window.initDials = $027785b5e7762569$export$33aa68e0bfaa065d;
}
var $027785b5e7762569$export$2e2bcd8739ae039 = $027785b5e7762569$var$Dial;



var $5252bf9f038f0bda$var$__assign = undefined && undefined.__assign || function() {
    $5252bf9f038f0bda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5252bf9f038f0bda$var$__assign.apply(this, arguments);
};
var $5252bf9f038f0bda$var$Default = {
    minValue: null,
    maxValue: null,
    onIncrement: function() {},
    onDecrement: function() {}
};
var $5252bf9f038f0bda$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $5252bf9f038f0bda$var$InputCounter = /** @class */ function() {
    function InputCounter(targetEl, incrementEl, decrementEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (incrementEl === void 0) incrementEl = null;
        if (decrementEl === void 0) decrementEl = null;
        if (options === void 0) options = $5252bf9f038f0bda$var$Default;
        if (instanceOptions === void 0) instanceOptions = $5252bf9f038f0bda$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._incrementEl = incrementEl;
        this._decrementEl = decrementEl;
        this._options = $5252bf9f038f0bda$var$__assign($5252bf9f038f0bda$var$__assign({}, $5252bf9f038f0bda$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("InputCounter", this, this._instanceId, instanceOptions.override);
    }
    InputCounter.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._inputHandler = function(event) {
                var target = event.target;
                // check if the value is numeric
                if (!/^\d*$/.test(target.value)) // Regex to check if the value is numeric
                target.value = target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
                // check for max value
                if (_this._options.maxValue !== null && parseInt(target.value) > _this._options.maxValue) target.value = _this._options.maxValue.toString();
                // check for min value
                if (_this._options.minValue !== null && parseInt(target.value) < _this._options.minValue) target.value = _this._options.minValue.toString();
            };
            this._incrementClickHandler = function() {
                _this.increment();
            };
            this._decrementClickHandler = function() {
                _this.decrement();
            };
            // Add event listener to restrict input to numeric values only
            this._targetEl.addEventListener("input", this._inputHandler);
            if (this._incrementEl) this._incrementEl.addEventListener("click", this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.addEventListener("click", this._decrementClickHandler);
            this._initialized = true;
        }
    };
    InputCounter.prototype.destroy = function() {
        if (this._targetEl && this._initialized) {
            this._targetEl.removeEventListener("input", this._inputHandler);
            if (this._incrementEl) this._incrementEl.removeEventListener("click", this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.removeEventListener("click", this._decrementClickHandler);
            this._initialized = false;
        }
    };
    InputCounter.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("InputCounter", this._instanceId);
    };
    InputCounter.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    InputCounter.prototype.getCurrentValue = function() {
        return parseInt(this._targetEl.value) || 0;
    };
    InputCounter.prototype.increment = function() {
        // don't increment if the value is already at the maximum value
        if (this._options.maxValue !== null && this.getCurrentValue() >= this._options.maxValue) return;
        this._targetEl.value = (this.getCurrentValue() + 1).toString();
        this._options.onIncrement(this);
    };
    InputCounter.prototype.decrement = function() {
        // don't decrement if the value is already at the minimum value
        if (this._options.minValue !== null && this.getCurrentValue() <= this._options.minValue) return;
        this._targetEl.value = (this.getCurrentValue() - 1).toString();
        this._options.onDecrement(this);
    };
    InputCounter.prototype.updateOnIncrement = function(callback) {
        this._options.onIncrement = callback;
    };
    InputCounter.prototype.updateOnDecrement = function(callback) {
        this._options.onDecrement = callback;
    };
    return InputCounter;
}();
function $5252bf9f038f0bda$export$4352dd3b7a1676ab() {
    document.querySelectorAll("[data-input-counter]").forEach(function($targetEl) {
        var targetId = $targetEl.id;
        var $incrementEl = document.querySelector('[data-input-counter-increment="' + targetId + '"]');
        var $decrementEl = document.querySelector('[data-input-counter-decrement="' + targetId + '"]');
        var minValue = $targetEl.getAttribute("data-input-counter-min");
        var maxValue = $targetEl.getAttribute("data-input-counter-max");
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $5d5682da381fac09$export$2e2bcd8739ae039).instanceExists("InputCounter", $targetEl.getAttribute("id"))) new $5252bf9f038f0bda$var$InputCounter($targetEl, $incrementEl ? $incrementEl : null, $decrementEl ? $decrementEl : null, {
                minValue: minValue ? parseInt(minValue) : null,
                maxValue: maxValue ? parseInt(maxValue) : null
            });
        } else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-input-counter attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.InputCounter = $5252bf9f038f0bda$var$InputCounter;
    window.initInputCounters = $5252bf9f038f0bda$export$4352dd3b7a1676ab;
}
var $5252bf9f038f0bda$export$2e2bcd8739ae039 = $5252bf9f038f0bda$var$InputCounter;



var $d10e6c36a2232fe1$var$__assign = undefined && undefined.__assign || function() {
    $d10e6c36a2232fe1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d10e6c36a2232fe1$var$__assign.apply(this, arguments);
};
var $d10e6c36a2232fe1$var$Default = {
    htmlEntities: false,
    contentType: "input",
    onCopy: function() {}
};
var $d10e6c36a2232fe1$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $d10e6c36a2232fe1$var$CopyClipboard = /** @class */ function() {
    function CopyClipboard(triggerEl, targetEl, options, instanceOptions) {
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $d10e6c36a2232fe1$var$Default;
        if (instanceOptions === void 0) instanceOptions = $d10e6c36a2232fe1$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $d10e6c36a2232fe1$var$__assign($d10e6c36a2232fe1$var$__assign({}, $d10e6c36a2232fe1$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("CopyClipboard", this, this._instanceId, instanceOptions.override);
    }
    CopyClipboard.prototype.init = function() {
        var _this = this;
        if (this._targetEl && this._triggerEl && !this._initialized) {
            this._triggerElClickHandler = function() {
                _this.copy();
            };
            // clicking on the trigger element should copy the value of the target element
            if (this._triggerEl) this._triggerEl.addEventListener("click", this._triggerElClickHandler);
            this._initialized = true;
        }
    };
    CopyClipboard.prototype.destroy = function() {
        if (this._triggerEl && this._targetEl && this._initialized) {
            if (this._triggerEl) this._triggerEl.removeEventListener("click", this._triggerElClickHandler);
            this._initialized = false;
        }
    };
    CopyClipboard.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("CopyClipboard", this._instanceId);
    };
    CopyClipboard.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    CopyClipboard.prototype.getTargetValue = function() {
        if (this._options.contentType === "input") return this._targetEl.value;
        if (this._options.contentType === "innerHTML") return this._targetEl.innerHTML;
        if (this._options.contentType === "textContent") return this._targetEl.textContent.replace(/\s+/g, " ").trim();
    };
    CopyClipboard.prototype.copy = function() {
        var textToCopy = this.getTargetValue();
        // Check if HTMLEntities option is enabled
        if (this._options.htmlEntities) // Encode the text using HTML entities
        textToCopy = this.decodeHTML(textToCopy);
        // Create a temporary textarea element
        var tempTextArea = document.createElement("textarea");
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);
        // Select the text inside the textarea and copy it to the clipboard
        tempTextArea.select();
        document.execCommand("copy");
        // Remove the temporary textarea
        document.body.removeChild(tempTextArea);
        // Callback function
        this._options.onCopy(this);
        return textToCopy;
    };
    // Function to encode text into HTML entities
    CopyClipboard.prototype.decodeHTML = function(html) {
        var textarea = document.createElement("textarea");
        textarea.innerHTML = html;
        return textarea.textContent;
    };
    CopyClipboard.prototype.updateOnCopyCallback = function(callback) {
        this._options.onCopy = callback;
    };
    return CopyClipboard;
}();
function $d10e6c36a2232fe1$export$ad4117886fd6cf74() {
    document.querySelectorAll("[data-copy-to-clipboard-target]").forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute("data-copy-to-clipboard-target");
        var $targetEl = document.getElementById(targetId);
        var contentType = $triggerEl.getAttribute("data-copy-to-clipboard-content-type");
        var htmlEntities = $triggerEl.getAttribute("data-copy-to-clipboard-html-entities");
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $5d5682da381fac09$export$2e2bcd8739ae039).instanceExists("CopyClipboard", $targetEl.getAttribute("id"))) new $d10e6c36a2232fe1$var$CopyClipboard($triggerEl, $targetEl, {
                htmlEntities: htmlEntities && htmlEntities === "true" ? true : $d10e6c36a2232fe1$var$Default.htmlEntities,
                contentType: contentType ? contentType : $d10e6c36a2232fe1$var$Default.contentType
            });
        } else console.error('The target element with id "'.concat(targetId, '" does not exist. Please check the data-copy-to-clipboard-target attribute.'));
    });
}
if (typeof window !== "undefined") {
    window.CopyClipboard = $d10e6c36a2232fe1$var$CopyClipboard;
    window.initClipboards = $d10e6c36a2232fe1$export$ad4117886fd6cf74;
}
var $d10e6c36a2232fe1$export$2e2bcd8739ae039 = $d10e6c36a2232fe1$var$CopyClipboard;



function $7c39ee59de2954f9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7c39ee59de2954f9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $7c39ee59de2954f9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7c39ee59de2954f9$var$_arrayLikeToArray(r);
}
function $7c39ee59de2954f9$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $7c39ee59de2954f9$var$_callSuper(t, o, e) {
    return o = $7c39ee59de2954f9$var$_getPrototypeOf(o), $7c39ee59de2954f9$var$_possibleConstructorReturn(t, $7c39ee59de2954f9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7c39ee59de2954f9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7c39ee59de2954f9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $7c39ee59de2954f9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7c39ee59de2954f9$var$_toPropertyKey(o.key), o);
    }
}
function $7c39ee59de2954f9$var$_createClass(e, r, t) {
    return r && $7c39ee59de2954f9$var$_defineProperties(e.prototype, r), t && $7c39ee59de2954f9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $7c39ee59de2954f9$var$_get() {
    return $7c39ee59de2954f9$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $7c39ee59de2954f9$var$_superPropBase(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $7c39ee59de2954f9$var$_get.apply(null, arguments);
}
function $7c39ee59de2954f9$var$_getPrototypeOf(t) {
    return $7c39ee59de2954f9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7c39ee59de2954f9$var$_getPrototypeOf(t);
}
function $7c39ee59de2954f9$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7c39ee59de2954f9$var$_setPrototypeOf(t, e);
}
function $7c39ee59de2954f9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7c39ee59de2954f9$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $7c39ee59de2954f9$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $7c39ee59de2954f9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7c39ee59de2954f9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7c39ee59de2954f9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7c39ee59de2954f9$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $7c39ee59de2954f9$var$_assertThisInitialized(t);
}
function $7c39ee59de2954f9$var$_setPrototypeOf(t, e) {
    return $7c39ee59de2954f9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7c39ee59de2954f9$var$_setPrototypeOf(t, e);
}
function $7c39ee59de2954f9$var$_slicedToArray(r, e) {
    return $7c39ee59de2954f9$var$_arrayWithHoles(r) || $7c39ee59de2954f9$var$_iterableToArrayLimit(r, e) || $7c39ee59de2954f9$var$_unsupportedIterableToArray(r, e) || $7c39ee59de2954f9$var$_nonIterableRest();
}
function $7c39ee59de2954f9$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $7c39ee59de2954f9$var$_getPrototypeOf(t)););
    return t;
}
function $7c39ee59de2954f9$var$_toConsumableArray(r) {
    return $7c39ee59de2954f9$var$_arrayWithoutHoles(r) || $7c39ee59de2954f9$var$_iterableToArray(r) || $7c39ee59de2954f9$var$_unsupportedIterableToArray(r) || $7c39ee59de2954f9$var$_nonIterableSpread();
}
function $7c39ee59de2954f9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7c39ee59de2954f9$var$_toPropertyKey(t) {
    var i = $7c39ee59de2954f9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c39ee59de2954f9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7c39ee59de2954f9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7c39ee59de2954f9$var$_typeof(o);
}
function $7c39ee59de2954f9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7c39ee59de2954f9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7c39ee59de2954f9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7c39ee59de2954f9$var$hasProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $7c39ee59de2954f9$var$lastItemOf(arr) {
    return arr[arr.length - 1];
}
// push only the items not included in the array
function $7c39ee59de2954f9$var$pushUnique(arr) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)items[_key - 1] = arguments[_key];
    items.forEach(function(item) {
        if (arr.includes(item)) return;
        arr.push(item);
    });
    return arr;
}
function $7c39ee59de2954f9$var$stringToArray(str, separator) {
    // convert empty string to an empty array
    return str ? str.split(separator) : [];
}
function $7c39ee59de2954f9$var$isInRange(testVal, min, max) {
    var minOK = min === undefined || testVal >= min;
    var maxOK = max === undefined || testVal <= max;
    return minOK && maxOK;
}
function $7c39ee59de2954f9$var$limitToRange(val, min, max) {
    if (val < min) return min;
    if (val > max) return max;
    return val;
}
function $7c39ee59de2954f9$var$createTagRepeat(tagName, repeat) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var html = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
    var openTagSrc = Object.keys(attributes).reduce(function(src, attr) {
        var val = attributes[attr];
        if (typeof val === "function") val = val(index);
        return "".concat(src, " ").concat(attr, '="').concat(val, '"');
    }, tagName);
    html += "<".concat(openTagSrc, "></").concat(tagName, ">");
    var next = index + 1;
    return next < repeat ? $7c39ee59de2954f9$var$createTagRepeat(tagName, repeat, attributes, next, html) : html;
}
// Remove the spacing surrounding tags for HTML parser not to create text nodes
// before/after elements
function $7c39ee59de2954f9$var$optimizeTemplateHTML(html) {
    return html.replace(/>\s+/g, ">").replace(/\s+</, "<");
}
function $7c39ee59de2954f9$var$stripTime(timeValue) {
    return new Date(timeValue).setHours(0, 0, 0, 0);
}
function $7c39ee59de2954f9$var$today() {
    return new Date().setHours(0, 0, 0, 0);
}
// Get the time value of the start of given date or year, month and day
function $7c39ee59de2954f9$var$dateValue() {
    switch(arguments.length){
        case 0:
            return $7c39ee59de2954f9$var$today();
        case 1:
            return $7c39ee59de2954f9$var$stripTime(arguments.length <= 0 ? undefined : arguments[0]);
    }
    // use setFullYear() to keep 2-digit year from being mapped to 1900-1999
    var newDate = new Date(0);
    newDate.setFullYear.apply(newDate, arguments);
    return newDate.setHours(0, 0, 0, 0);
}
function $7c39ee59de2954f9$var$addDays(date, amount) {
    var newDate = new Date(date);
    return newDate.setDate(newDate.getDate() + amount);
}
function $7c39ee59de2954f9$var$addWeeks(date, amount) {
    return $7c39ee59de2954f9$var$addDays(date, amount * 7);
}
function $7c39ee59de2954f9$var$addMonths(date, amount) {
    // If the day of the date is not in the new month, the last day of the new
    // month will be returned. e.g. Jan 31 + 1 month → Feb 28 (not Mar 03)
    var newDate = new Date(date);
    var monthsToSet = newDate.getMonth() + amount;
    var expectedMonth = monthsToSet % 12;
    if (expectedMonth < 0) expectedMonth += 12;
    var time = newDate.setMonth(monthsToSet);
    return newDate.getMonth() !== expectedMonth ? newDate.setDate(0) : time;
}
function $7c39ee59de2954f9$var$addYears(date, amount) {
    // If the date is Feb 29 and the new year is not a leap year, Feb 28 of the
    // new year will be returned.
    var newDate = new Date(date);
    var expectedMonth = newDate.getMonth();
    var time = newDate.setFullYear(newDate.getFullYear() + amount);
    return expectedMonth === 1 && newDate.getMonth() === 2 ? newDate.setDate(0) : time;
}
// Calculate the distance bettwen 2 days of the week
function $7c39ee59de2954f9$var$dayDiff(day, from) {
    return (day - from + 7) % 7;
}
// Get the date of the specified day of the week of given base date
function $7c39ee59de2954f9$var$dayOfTheWeekOf(baseDate, dayOfWeek) {
    var weekStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var baseDay = new Date(baseDate).getDay();
    return $7c39ee59de2954f9$var$addDays(baseDate, $7c39ee59de2954f9$var$dayDiff(dayOfWeek, weekStart) - $7c39ee59de2954f9$var$dayDiff(baseDay, weekStart));
}
// Get the ISO week of a date
function $7c39ee59de2954f9$var$getWeek(date) {
    // start of ISO week is Monday
    var thuOfTheWeek = $7c39ee59de2954f9$var$dayOfTheWeekOf(date, 4, 1);
    // 1st week == the week where the 4th of January is in
    var firstThu = $7c39ee59de2954f9$var$dayOfTheWeekOf(new Date(thuOfTheWeek).setMonth(0, 4), 4, 1);
    return Math.round((thuOfTheWeek - firstThu) / 604800000) + 1;
}
// Get the start year of the period of years that includes given date
// years: length of the year period
function $7c39ee59de2954f9$var$startOfYearPeriod(date, years) {
    /* @see https://en.wikipedia.org/wiki/Year_zero#ISO_8601 */ var year = new Date(date).getFullYear();
    return Math.floor(year / years) * years;
}
// pattern for format parts
var $7c39ee59de2954f9$var$reFormatTokens = /dd?|DD?|mm?|MM?|yy?(?:yy)?/;
// pattern for non date parts
var $7c39ee59de2954f9$var$reNonDateParts = /[\s!-/:-@[-`{-~年月日]+/;
// cache for persed formats
var $7c39ee59de2954f9$var$knownFormats = {};
// parse funtions for date parts
var $7c39ee59de2954f9$var$parseFns = {
    y: function y(date, year) {
        return new Date(date).setFullYear(parseInt(year, 10));
    },
    m: function m(date, month, locale) {
        var newDate = new Date(date);
        var monthIndex = parseInt(month, 10) - 1;
        if (isNaN(monthIndex)) {
            if (!month) return NaN;
            var monthName = month.toLowerCase();
            var compareNames = function compareNames(name) {
                return name.toLowerCase().startsWith(monthName);
            };
            // compare with both short and full names because some locales have periods
            // in the short names (not equal to the first X letters of the full names)
            monthIndex = locale.monthsShort.findIndex(compareNames);
            if (monthIndex < 0) monthIndex = locale.months.findIndex(compareNames);
            if (monthIndex < 0) return NaN;
        }
        newDate.setMonth(monthIndex);
        return newDate.getMonth() !== $7c39ee59de2954f9$var$normalizeMonth(monthIndex) ? newDate.setDate(0) : newDate.getTime();
    },
    d: function d(date, day) {
        return new Date(date).setDate(parseInt(day, 10));
    }
};
// format functions for date parts
var $7c39ee59de2954f9$var$formatFns = {
    d: function d(date) {
        return date.getDate();
    },
    dd: function dd(date) {
        return $7c39ee59de2954f9$var$padZero(date.getDate(), 2);
    },
    D: function D(date, locale) {
        return locale.daysShort[date.getDay()];
    },
    DD: function DD(date, locale) {
        return locale.days[date.getDay()];
    },
    m: function m(date) {
        return date.getMonth() + 1;
    },
    mm: function mm(date) {
        return $7c39ee59de2954f9$var$padZero(date.getMonth() + 1, 2);
    },
    M: function M(date, locale) {
        return locale.monthsShort[date.getMonth()];
    },
    MM: function MM(date, locale) {
        return locale.months[date.getMonth()];
    },
    y: function y(date) {
        return date.getFullYear();
    },
    yy: function yy(date) {
        return $7c39ee59de2954f9$var$padZero(date.getFullYear(), 2).slice(-2);
    },
    yyyy: function yyyy(date) {
        return $7c39ee59de2954f9$var$padZero(date.getFullYear(), 4);
    }
};
// get month index in normal range (0 - 11) from any number
function $7c39ee59de2954f9$var$normalizeMonth(monthIndex) {
    return monthIndex > -1 ? monthIndex % 12 : $7c39ee59de2954f9$var$normalizeMonth(monthIndex + 12);
}
function $7c39ee59de2954f9$var$padZero(num, length) {
    return num.toString().padStart(length, "0");
}
function $7c39ee59de2954f9$var$parseFormatString(format) {
    if (typeof format !== "string") throw new Error("Invalid date format.");
    if (format in $7c39ee59de2954f9$var$knownFormats) return $7c39ee59de2954f9$var$knownFormats[format];
    // sprit the format string into parts and seprators
    var separators = format.split($7c39ee59de2954f9$var$reFormatTokens);
    var parts = format.match(new RegExp($7c39ee59de2954f9$var$reFormatTokens, "g"));
    if (separators.length === 0 || !parts) throw new Error("Invalid date format.");
    // collect format functions used in the format
    var partFormatters = parts.map(function(token) {
        return $7c39ee59de2954f9$var$formatFns[token];
    });
    // collect parse function keys used in the format
    // iterate over parseFns' keys in order to keep the order of the keys.
    var partParserKeys = Object.keys($7c39ee59de2954f9$var$parseFns).reduce(function(keys, key) {
        var token = parts.find(function(part) {
            return part[0] !== "D" && part[0].toLowerCase() === key;
        });
        if (token) keys.push(key);
        return keys;
    }, []);
    return $7c39ee59de2954f9$var$knownFormats[format] = {
        parser: function parser(dateStr, locale) {
            var dateParts = dateStr.split($7c39ee59de2954f9$var$reNonDateParts).reduce(function(dtParts, part, index) {
                if (part.length > 0 && parts[index]) {
                    var token = parts[index][0];
                    if (token === "M") dtParts.m = part;
                    else if (token !== "D") dtParts[token] = part;
                }
                return dtParts;
            }, {});
            // iterate over partParserkeys so that the parsing is made in the oder
            // of year, month and day to prevent the day parser from correcting last
            // day of month wrongly
            return partParserKeys.reduce(function(origDate, key) {
                var newDate = $7c39ee59de2954f9$var$parseFns[key](origDate, dateParts[key], locale);
                // ingnore the part failed to parse
                return isNaN(newDate) ? origDate : newDate;
            }, $7c39ee59de2954f9$var$today());
        },
        formatter: function formatter(date, locale) {
            var dateStr = partFormatters.reduce(function(str, fn, index) {
                return str += "".concat(separators[index]).concat(fn(date, locale));
            }, "");
            // separators' length is always parts' length + 1,
            return dateStr += $7c39ee59de2954f9$var$lastItemOf(separators);
        }
    };
}
function $7c39ee59de2954f9$var$parseDate(dateStr, format, locale) {
    if (dateStr instanceof Date || typeof dateStr === "number") {
        var date = $7c39ee59de2954f9$var$stripTime(dateStr);
        return isNaN(date) ? undefined : date;
    }
    if (!dateStr) return undefined;
    if (dateStr === "today") return $7c39ee59de2954f9$var$today();
    if (format && format.toValue) {
        var _date = format.toValue(dateStr, format, locale);
        return isNaN(_date) ? undefined : $7c39ee59de2954f9$var$stripTime(_date);
    }
    return $7c39ee59de2954f9$var$parseFormatString(format).parser(dateStr, locale);
}
function $7c39ee59de2954f9$var$formatDate(date, format, locale) {
    if (isNaN(date) || !date && date !== 0) return "";
    var dateObj = typeof date === "number" ? new Date(date) : date;
    if (format.toDisplay) return format.toDisplay(dateObj, format, locale);
    return $7c39ee59de2954f9$var$parseFormatString(format).formatter(dateObj, locale);
}
var $7c39ee59de2954f9$var$listenerRegistry = new WeakMap();
var $7c39ee59de2954f9$var$_EventTarget$prototyp = EventTarget.prototype, $7c39ee59de2954f9$var$addEventListener = $7c39ee59de2954f9$var$_EventTarget$prototyp.addEventListener, $7c39ee59de2954f9$var$removeEventListener = $7c39ee59de2954f9$var$_EventTarget$prototyp.removeEventListener;
// Register event listeners to a key object
// listeners: array of listener definitions;
//   - each definition must be a flat array of event target and the arguments
//     used to call addEventListener() on the target
function $7c39ee59de2954f9$var$registerListeners(keyObj, listeners) {
    var registered = $7c39ee59de2954f9$var$listenerRegistry.get(keyObj);
    if (!registered) {
        registered = [];
        $7c39ee59de2954f9$var$listenerRegistry.set(keyObj, registered);
    }
    listeners.forEach(function(listener) {
        $7c39ee59de2954f9$var$addEventListener.call.apply($7c39ee59de2954f9$var$addEventListener, $7c39ee59de2954f9$var$_toConsumableArray(listener));
        registered.push(listener);
    });
}
function $7c39ee59de2954f9$var$unregisterListeners(keyObj) {
    var listeners = $7c39ee59de2954f9$var$listenerRegistry.get(keyObj);
    if (!listeners) return;
    listeners.forEach(function(listener) {
        $7c39ee59de2954f9$var$removeEventListener.call.apply($7c39ee59de2954f9$var$removeEventListener, $7c39ee59de2954f9$var$_toConsumableArray(listener));
    });
    $7c39ee59de2954f9$var$listenerRegistry["delete"](keyObj);
}
// Event.composedPath() polyfill for Edge
// based on https://gist.github.com/kleinfreund/e9787d73776c0e3750dcfcdc89f100ec
if (!Event.prototype.composedPath) {
    var $7c39ee59de2954f9$var$getComposedPath = function getComposedPath(node) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        path.push(node);
        var parent;
        if (node.parentNode) parent = node.parentNode;
        else if (node.host) // ShadowRoot
        parent = node.host;
        else if (node.defaultView) // Document
        parent = node.defaultView;
        return parent ? getComposedPath(parent, path) : path;
    };
    Event.prototype.composedPath = function() {
        return $7c39ee59de2954f9$var$getComposedPath(this.target);
    };
}
function $7c39ee59de2954f9$var$findFromPath(path, criteria, currentTarget) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var el = path[index];
    if (criteria(el)) return el;
    else if (el === currentTarget || !el.parentElement) // stop when reaching currentTarget or <html>
    return;
    return $7c39ee59de2954f9$var$findFromPath(path, criteria, currentTarget, index + 1);
}
// Search for the actual target of a delegated event
function $7c39ee59de2954f9$var$findElementInEventPath(ev, selector) {
    var criteria = typeof selector === "function" ? selector : function(el) {
        return el.matches(selector);
    };
    return $7c39ee59de2954f9$var$findFromPath(ev.composedPath(), criteria, ev.currentTarget);
}
// default locales
var $7c39ee59de2954f9$var$locales = {
    en: {
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        daysShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        daysMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        today: "Today",
        clear: "Clear",
        titleFormat: "MM y"
    }
};
// config options updatable by setOptions() and their default values
var $7c39ee59de2954f9$var$defaultOptions = {
    autohide: false,
    beforeShowDay: null,
    beforeShowDecade: null,
    beforeShowMonth: null,
    beforeShowYear: null,
    calendarWeeks: false,
    clearBtn: false,
    dateDelimiter: ",",
    datesDisabled: [],
    daysOfWeekDisabled: [],
    daysOfWeekHighlighted: [],
    defaultViewDate: undefined,
    // placeholder, defaults to today() by the program
    disableTouchKeyboard: false,
    format: "mm/dd/yyyy",
    language: "en",
    maxDate: null,
    maxNumberOfDates: 1,
    maxView: 3,
    minDate: null,
    nextArrow: '<svg class="w-4 h-4 rtl:rotate-180 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/></svg>',
    orientation: "auto",
    pickLevel: 0,
    prevArrow: '<svg class="w-4 h-4 rtl:rotate-180 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4"/></svg>',
    showDaysOfWeek: true,
    showOnClick: true,
    showOnFocus: true,
    startView: 0,
    title: "",
    todayBtn: false,
    todayBtnMode: 0,
    todayHighlight: false,
    updateOnBlur: true,
    weekStart: 0
};
var $7c39ee59de2954f9$var$range = null;
function $7c39ee59de2954f9$var$parseHTML(html) {
    if ($7c39ee59de2954f9$var$range == null) $7c39ee59de2954f9$var$range = document.createRange();
    return $7c39ee59de2954f9$var$range.createContextualFragment(html);
}
function $7c39ee59de2954f9$var$hideElement(el) {
    if (el.style.display === "none") return;
    // back up the existing display setting in data-style-display
    if (el.style.display) el.dataset.styleDisplay = el.style.display;
    el.style.display = "none";
}
function $7c39ee59de2954f9$var$showElement(el) {
    if (el.style.display !== "none") return;
    if (el.dataset.styleDisplay) {
        // restore backed-up dispay property
        el.style.display = el.dataset.styleDisplay;
        delete el.dataset.styleDisplay;
    } else el.style.display = "";
}
function $7c39ee59de2954f9$var$emptyChildNodes(el) {
    if (el.firstChild) {
        el.removeChild(el.firstChild);
        $7c39ee59de2954f9$var$emptyChildNodes(el);
    }
}
function $7c39ee59de2954f9$var$replaceChildNodes(el, newChildNodes) {
    $7c39ee59de2954f9$var$emptyChildNodes(el);
    if (newChildNodes instanceof DocumentFragment) el.appendChild(newChildNodes);
    else if (typeof newChildNodes === "string") el.appendChild($7c39ee59de2954f9$var$parseHTML(newChildNodes));
    else if (typeof newChildNodes.forEach === "function") newChildNodes.forEach(function(node) {
        el.appendChild(node);
    });
}
var $7c39ee59de2954f9$var$defaultLang = $7c39ee59de2954f9$var$defaultOptions.language, $7c39ee59de2954f9$var$defaultFormat = $7c39ee59de2954f9$var$defaultOptions.format, $7c39ee59de2954f9$var$defaultWeekStart = $7c39ee59de2954f9$var$defaultOptions.weekStart;
// Reducer function to filter out invalid day-of-week from the input
function $7c39ee59de2954f9$var$sanitizeDOW(dow, day) {
    return dow.length < 6 && day >= 0 && day < 7 ? $7c39ee59de2954f9$var$pushUnique(dow, day) : dow;
}
function $7c39ee59de2954f9$var$calcEndOfWeek(startOfWeek) {
    return (startOfWeek + 6) % 7;
}
// validate input date. if invalid, fallback to the original value
function $7c39ee59de2954f9$var$validateDate(value, format, locale, origValue) {
    var date = $7c39ee59de2954f9$var$parseDate(value, format, locale);
    return date !== undefined ? date : origValue;
}
// Validate viewId. if invalid, fallback to the original value
function $7c39ee59de2954f9$var$validateViewId(value, origValue) {
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var viewId = parseInt(value, 10);
    return viewId >= 0 && viewId <= max ? viewId : origValue;
}
// Create Datepicker configuration to set
function $7c39ee59de2954f9$var$processOptions(options, datepicker) {
    var inOpts = Object.assign({}, options);
    var config = {};
    var locales = datepicker.constructor.locales;
    var _ref = datepicker.config || {}, format = _ref.format, language = _ref.language, locale = _ref.locale, maxDate = _ref.maxDate, maxView = _ref.maxView, minDate = _ref.minDate, pickLevel = _ref.pickLevel, startView = _ref.startView, weekStart = _ref.weekStart;
    if (inOpts.language) {
        var lang;
        if (inOpts.language !== language) {
            if (locales[inOpts.language]) lang = inOpts.language;
            else {
                // Check if langauge + region tag can fallback to the one without
                // region (e.g. fr-CA → fr)
                lang = inOpts.language.split("-")[0];
                if (locales[lang] === undefined) lang = false;
            }
        }
        delete inOpts.language;
        if (lang) {
            language = config.language = lang;
            // update locale as well when updating language
            var origLocale = locale || locales[$7c39ee59de2954f9$var$defaultLang];
            // use default language's properties for the fallback
            locale = Object.assign({
                format: $7c39ee59de2954f9$var$defaultFormat,
                weekStart: $7c39ee59de2954f9$var$defaultWeekStart
            }, locales[$7c39ee59de2954f9$var$defaultLang]);
            if (language !== $7c39ee59de2954f9$var$defaultLang) Object.assign(locale, locales[language]);
            config.locale = locale;
            // if format and/or weekStart are the same as old locale's defaults,
            // update them to new locale's defaults
            if (format === origLocale.format) format = config.format = locale.format;
            if (weekStart === origLocale.weekStart) {
                weekStart = config.weekStart = locale.weekStart;
                config.weekEnd = $7c39ee59de2954f9$var$calcEndOfWeek(locale.weekStart);
            }
        }
    }
    if (inOpts.format) {
        var hasToDisplay = typeof inOpts.format.toDisplay === "function";
        var hasToValue = typeof inOpts.format.toValue === "function";
        var validFormatString = $7c39ee59de2954f9$var$reFormatTokens.test(inOpts.format);
        if (hasToDisplay && hasToValue || validFormatString) format = config.format = inOpts.format;
        delete inOpts.format;
    }
    //*** dates ***//
    // while min and maxDate for "no limit" in the options are better to be null
    // (especially when updating), the ones in the config have to be undefined
    // because null is treated as 0 (= unix epoch) when comparing with time value
    var minDt = minDate;
    var maxDt = maxDate;
    if (inOpts.minDate !== undefined) {
        minDt = inOpts.minDate === null ? $7c39ee59de2954f9$var$dateValue(0, 0, 1) // set 0000-01-01 to prevent negative values for year
         : $7c39ee59de2954f9$var$validateDate(inOpts.minDate, format, locale, minDt);
        delete inOpts.minDate;
    }
    if (inOpts.maxDate !== undefined) {
        maxDt = inOpts.maxDate === null ? undefined : $7c39ee59de2954f9$var$validateDate(inOpts.maxDate, format, locale, maxDt);
        delete inOpts.maxDate;
    }
    if (maxDt < minDt) {
        minDate = config.minDate = maxDt;
        maxDate = config.maxDate = minDt;
    } else {
        if (minDate !== minDt) minDate = config.minDate = minDt;
        if (maxDate !== maxDt) maxDate = config.maxDate = maxDt;
    }
    if (inOpts.datesDisabled) {
        config.datesDisabled = inOpts.datesDisabled.reduce(function(dates, dt) {
            var date = $7c39ee59de2954f9$var$parseDate(dt, format, locale);
            return date !== undefined ? $7c39ee59de2954f9$var$pushUnique(dates, date) : dates;
        }, []);
        delete inOpts.datesDisabled;
    }
    if (inOpts.defaultViewDate !== undefined) {
        var viewDate = $7c39ee59de2954f9$var$parseDate(inOpts.defaultViewDate, format, locale);
        if (viewDate !== undefined) config.defaultViewDate = viewDate;
        delete inOpts.defaultViewDate;
    }
    //*** days of week ***//
    if (inOpts.weekStart !== undefined) {
        var wkStart = Number(inOpts.weekStart) % 7;
        if (!isNaN(wkStart)) {
            weekStart = config.weekStart = wkStart;
            config.weekEnd = $7c39ee59de2954f9$var$calcEndOfWeek(wkStart);
        }
        delete inOpts.weekStart;
    }
    if (inOpts.daysOfWeekDisabled) {
        config.daysOfWeekDisabled = inOpts.daysOfWeekDisabled.reduce($7c39ee59de2954f9$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekDisabled;
    }
    if (inOpts.daysOfWeekHighlighted) {
        config.daysOfWeekHighlighted = inOpts.daysOfWeekHighlighted.reduce($7c39ee59de2954f9$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekHighlighted;
    }
    //*** multi date ***//
    if (inOpts.maxNumberOfDates !== undefined) {
        var maxNumberOfDates = parseInt(inOpts.maxNumberOfDates, 10);
        if (maxNumberOfDates >= 0) {
            config.maxNumberOfDates = maxNumberOfDates;
            config.multidate = maxNumberOfDates !== 1;
        }
        delete inOpts.maxNumberOfDates;
    }
    if (inOpts.dateDelimiter) {
        config.dateDelimiter = String(inOpts.dateDelimiter);
        delete inOpts.dateDelimiter;
    }
    //*** pick level & view ***//
    var newPickLevel = pickLevel;
    if (inOpts.pickLevel !== undefined) {
        newPickLevel = $7c39ee59de2954f9$var$validateViewId(inOpts.pickLevel, 2);
        delete inOpts.pickLevel;
    }
    if (newPickLevel !== pickLevel) pickLevel = config.pickLevel = newPickLevel;
    var newMaxView = maxView;
    if (inOpts.maxView !== undefined) {
        newMaxView = $7c39ee59de2954f9$var$validateViewId(inOpts.maxView, maxView);
        delete inOpts.maxView;
    }
    // ensure max view >= pick level
    newMaxView = pickLevel > newMaxView ? pickLevel : newMaxView;
    if (newMaxView !== maxView) maxView = config.maxView = newMaxView;
    var newStartView = startView;
    if (inOpts.startView !== undefined) {
        newStartView = $7c39ee59de2954f9$var$validateViewId(inOpts.startView, newStartView);
        delete inOpts.startView;
    }
    // ensure pick level <= start view <= max view
    if (newStartView < pickLevel) newStartView = pickLevel;
    else if (newStartView > maxView) newStartView = maxView;
    if (newStartView !== startView) config.startView = newStartView;
    //*** template ***//
    if (inOpts.prevArrow) {
        var prevArrow = $7c39ee59de2954f9$var$parseHTML(inOpts.prevArrow);
        if (prevArrow.childNodes.length > 0) config.prevArrow = prevArrow.childNodes;
        delete inOpts.prevArrow;
    }
    if (inOpts.nextArrow) {
        var nextArrow = $7c39ee59de2954f9$var$parseHTML(inOpts.nextArrow);
        if (nextArrow.childNodes.length > 0) config.nextArrow = nextArrow.childNodes;
        delete inOpts.nextArrow;
    }
    //*** misc ***//
    if (inOpts.disableTouchKeyboard !== undefined) {
        config.disableTouchKeyboard = "ontouchstart" in document && !!inOpts.disableTouchKeyboard;
        delete inOpts.disableTouchKeyboard;
    }
    if (inOpts.orientation) {
        var orientation = inOpts.orientation.toLowerCase().split(/\s+/g);
        config.orientation = {
            x: orientation.find(function(x) {
                return x === "left" || x === "right";
            }) || "auto",
            y: orientation.find(function(y) {
                return y === "top" || y === "bottom";
            }) || "auto"
        };
        delete inOpts.orientation;
    }
    if (inOpts.todayBtnMode !== undefined) {
        switch(inOpts.todayBtnMode){
            case 0:
            case 1:
                config.todayBtnMode = inOpts.todayBtnMode;
        }
        delete inOpts.todayBtnMode;
    }
    //*** copy the rest ***//
    Object.keys(inOpts).forEach(function(key) {
        if (inOpts[key] !== undefined && $7c39ee59de2954f9$var$hasProperty($7c39ee59de2954f9$var$defaultOptions, key)) config[key] = inOpts[key];
    });
    return config;
}
var $7c39ee59de2954f9$var$pickerTemplate = $7c39ee59de2954f9$var$optimizeTemplateHTML('<div class="datepicker hidden">\n  <div class="datepicker-picker inline-block rounded-lg bg-white dark:bg-gray-700 shadow-lg p-4">\n    <div class="datepicker-header">\n      <div class="datepicker-title bg-white dark:bg-gray-700 dark:text-white px-2 py-3 text-center font-semibold"></div>\n      <div class="datepicker-controls flex justify-between mb-2">\n        <button type="button" class="bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 prev-btn"></button>\n        <button type="button" class="text-sm rounded-lg text-gray-900 dark:text-white bg-white dark:bg-gray-700 font-semibold py-2.5 px-5 hover:bg-gray-100 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-200 view-switch"></button>\n        <button type="button" class="bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 next-btn"></button>\n      </div>\n    </div>\n    <div class="datepicker-main p-1"></div>\n    <div class="datepicker-footer">\n      <div class="datepicker-controls flex space-x-2 rtl:space-x-reverse mt-2">\n        <button type="button" class="%buttonClass% today-btn text-white bg-blue-700 !bg-primary-700 dark:bg-blue-600 dark:!bg-primary-600 hover:bg-blue-800 hover:!bg-primary-800 dark:hover:bg-blue-700 dark:hover:!bg-primary-700 focus:ring-4 focus:ring-blue-300 focus:!ring-primary-300 font-medium rounded-lg text-sm px-5 py-2 text-center w-1/2"></button>\n        <button type="button" class="%buttonClass% clear-btn text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 focus:!ring-primary-300 font-medium rounded-lg text-sm px-5 py-2 text-center w-1/2"></button>\n      </div>\n    </div>\n  </div>\n</div>');
var $7c39ee59de2954f9$var$daysTemplate = $7c39ee59de2954f9$var$optimizeTemplateHTML('<div class="days">\n  <div class="days-of-week grid grid-cols-7 mb-1">'.concat($7c39ee59de2954f9$var$createTagRepeat("span", 7, {
    "class": "dow block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm"
}), '</div>\n  <div class="datepicker-grid w-64 grid grid-cols-7">').concat($7c39ee59de2954f9$var$createTagRepeat("span", 42, {
    "class": "block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400"
}), "</div>\n</div>"));
var $7c39ee59de2954f9$var$calendarWeeksTemplate = $7c39ee59de2954f9$var$optimizeTemplateHTML('<div class="calendar-weeks">\n  <div class="days-of-week flex"><span class="dow h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400"></span></div>\n  <div class="weeks">'.concat($7c39ee59de2954f9$var$createTagRepeat("span", 6, {
    "class": "week block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm"
}), "</div>\n</div>"));
// Base class of the view classes
var $7c39ee59de2954f9$var$View = /*#__PURE__*/ function() {
    function View(picker, config) {
        $7c39ee59de2954f9$var$_classCallCheck(this, View);
        Object.assign(this, config, {
            picker: picker,
            element: $7c39ee59de2954f9$var$parseHTML('<div class="datepicker-view flex"></div>').firstChild,
            selected: []
        });
        this.init(this.picker.datepicker.config);
    }
    return $7c39ee59de2954f9$var$_createClass(View, [
        {
            key: "init",
            value: function init(options) {
                if (options.pickLevel !== undefined) this.isMinView = this.id === options.pickLevel;
                this.setOptions(options);
                this.updateFocus();
                this.updateSelection();
            }
        },
        {
            key: "performBeforeHook",
            value: function performBeforeHook(el, current, timeValue) {
                var result = this.beforeShow(new Date(timeValue));
                switch($7c39ee59de2954f9$var$_typeof(result)){
                    case "boolean":
                        result = {
                            enabled: result
                        };
                        break;
                    case "string":
                        result = {
                            classes: result
                        };
                }
                if (result) {
                    if (result.enabled === false) {
                        el.classList.add("disabled");
                        $7c39ee59de2954f9$var$pushUnique(this.disabled, current);
                    }
                    if (result.classes) {
                        var _el$classList;
                        var extraClasses = result.classes.split(/\s+/);
                        (_el$classList = el.classList).add.apply(_el$classList, $7c39ee59de2954f9$var$_toConsumableArray(extraClasses));
                        if (extraClasses.includes("disabled")) $7c39ee59de2954f9$var$pushUnique(this.disabled, current);
                    }
                    if (result.content) $7c39ee59de2954f9$var$replaceChildNodes(el, result.content);
                }
            }
        }
    ]);
}();
var $7c39ee59de2954f9$var$DaysView = /*#__PURE__*/ function(_View) {
    function DaysView(picker) {
        $7c39ee59de2954f9$var$_classCallCheck(this, DaysView);
        return $7c39ee59de2954f9$var$_callSuper(this, DaysView, [
            picker,
            {
                id: 0,
                name: "days",
                cellClass: "day"
            }
        ]);
    }
    $7c39ee59de2954f9$var$_inherits(DaysView, _View);
    return $7c39ee59de2954f9$var$_createClass(DaysView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    var inner = $7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$daysTemplate).firstChild;
                    this.dow = inner.firstChild;
                    this.grid = inner.lastChild;
                    this.element.appendChild(inner);
                }
                $7c39ee59de2954f9$var$_get($7c39ee59de2954f9$var$_getPrototypeOf(DaysView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _this = this;
                var updateDOW;
                if ($7c39ee59de2954f9$var$hasProperty(options, "minDate")) this.minDate = options.minDate;
                if ($7c39ee59de2954f9$var$hasProperty(options, "maxDate")) this.maxDate = options.maxDate;
                if (options.datesDisabled) this.datesDisabled = options.datesDisabled;
                if (options.daysOfWeekDisabled) {
                    this.daysOfWeekDisabled = options.daysOfWeekDisabled;
                    updateDOW = true;
                }
                if (options.daysOfWeekHighlighted) this.daysOfWeekHighlighted = options.daysOfWeekHighlighted;
                if (options.todayHighlight !== undefined) this.todayHighlight = options.todayHighlight;
                if (options.weekStart !== undefined) {
                    this.weekStart = options.weekStart;
                    this.weekEnd = options.weekEnd;
                    updateDOW = true;
                }
                if (options.locale) {
                    var locale = this.locale = options.locale;
                    this.dayNames = locale.daysMin;
                    this.switchLabelFormat = locale.titleFormat;
                    updateDOW = true;
                }
                if (options.beforeShowDay !== undefined) this.beforeShow = typeof options.beforeShowDay === "function" ? options.beforeShowDay : undefined;
                if (options.calendarWeeks !== undefined) {
                    if (options.calendarWeeks && !this.calendarWeeks) {
                        var weeksElem = $7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$calendarWeeksTemplate).firstChild;
                        this.calendarWeeks = {
                            element: weeksElem,
                            dow: weeksElem.firstChild,
                            weeks: weeksElem.lastChild
                        };
                        this.element.insertBefore(weeksElem, this.element.firstChild);
                    } else if (this.calendarWeeks && !options.calendarWeeks) {
                        this.element.removeChild(this.calendarWeeks.element);
                        this.calendarWeeks = null;
                    }
                }
                if (options.showDaysOfWeek !== undefined) {
                    if (options.showDaysOfWeek) {
                        $7c39ee59de2954f9$var$showElement(this.dow);
                        if (this.calendarWeeks) $7c39ee59de2954f9$var$showElement(this.calendarWeeks.dow);
                    } else {
                        $7c39ee59de2954f9$var$hideElement(this.dow);
                        if (this.calendarWeeks) $7c39ee59de2954f9$var$hideElement(this.calendarWeeks.dow);
                    }
                }
                // update days-of-week when locale, daysOfweekDisabled or weekStart is changed
                if (updateDOW) Array.from(this.dow.children).forEach(function(el, index) {
                    var dow = (_this.weekStart + index) % 7;
                    el.textContent = _this.dayNames[dow];
                    el.className = _this.daysOfWeekDisabled.includes(dow) ? "dow disabled text-center h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400 cursor-not-allowed" : "dow text-center h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400";
                });
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                var viewYear = viewDate.getFullYear();
                var viewMonth = viewDate.getMonth();
                var firstOfMonth = $7c39ee59de2954f9$var$dateValue(viewYear, viewMonth, 1);
                var start = $7c39ee59de2954f9$var$dayOfTheWeekOf(firstOfMonth, this.weekStart, this.weekStart);
                this.first = firstOfMonth;
                this.last = $7c39ee59de2954f9$var$dateValue(viewYear, viewMonth + 1, 0);
                this.start = start;
                this.focused = this.picker.viewDate;
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates;
                if (rangepicker) this.range = rangepicker.dates;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // update today marker on ever render
                this.today = this.todayHighlight ? $7c39ee59de2954f9$var$today() : undefined;
                // refresh disabled dates on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = $7c39ee59de2954f9$var$_toConsumableArray(this.datesDisabled);
                var switchLabel = $7c39ee59de2954f9$var$formatDate(this.focused, this.switchLabelFormat, this.locale);
                this.picker.setViewSwitchLabel(switchLabel);
                this.picker.setPrevBtnDisabled(this.first <= this.minDate);
                this.picker.setNextBtnDisabled(this.last >= this.maxDate);
                if (this.calendarWeeks) {
                    // start of the UTC week (Monday) of the 1st of the month
                    var startOfWeek = $7c39ee59de2954f9$var$dayOfTheWeekOf(this.first, 1, 1);
                    Array.from(this.calendarWeeks.weeks.children).forEach(function(el, index) {
                        el.textContent = $7c39ee59de2954f9$var$getWeek($7c39ee59de2954f9$var$addWeeks(startOfWeek, index));
                    });
                }
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var current = $7c39ee59de2954f9$var$addDays(_this2.start, index);
                    var date = new Date(current);
                    var day = date.getDay();
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this2.cellClass);
                    el.dataset.date = current;
                    el.textContent = date.getDate();
                    if (current < _this2.first) classList.add("prev", "text-gray-500", "dark:text-white");
                    else if (current > _this2.last) classList.add("next", "text-gray-500", "dark:text-white");
                    if (_this2.today === current) classList.add("today", "bg-gray-100", "dark:bg-gray-600");
                    if (current < _this2.minDate || current > _this2.maxDate || _this2.disabled.includes(current)) {
                        classList.add("disabled", "cursor-not-allowed", "text-gray-400", "dark:text-gray-500");
                        classList.remove("hover:bg-gray-100", "dark:hover:bg-gray-600", "text-gray-900", "dark:text-white", "cursor-pointer");
                    }
                    if (_this2.daysOfWeekDisabled.includes(day)) {
                        classList.add("disabled", "cursor-not-allowed", "text-gray-400", "dark:text-gray-500");
                        classList.remove("hover:bg-gray-100", "dark:hover:bg-gray-600", "text-gray-900", "dark:text-white", "cursor-pointer");
                        $7c39ee59de2954f9$var$pushUnique(_this2.disabled, current);
                    }
                    if (_this2.daysOfWeekHighlighted.includes(day)) classList.add("highlighted");
                    if (_this2.range) {
                        var _this2$range = $7c39ee59de2954f9$var$_slicedToArray(_this2.range, 2), rangeStart = _this2$range[0], rangeEnd = _this2$range[1];
                        if (current > rangeStart && current < rangeEnd) {
                            classList.add("range", "bg-gray-200", "dark:bg-gray-600");
                            classList.remove("rounded-lg", "rounded-l-lg", "rounded-r-lg");
                        }
                        if (current === rangeStart) {
                            classList.add("range-start", "bg-gray-100", "dark:bg-gray-600", "rounded-l-lg");
                            classList.remove("rounded-lg", "rounded-r-lg");
                        }
                        if (current === rangeEnd) {
                            classList.add("range-end", "bg-gray-100", "dark:bg-gray-600", "rounded-r-lg");
                            classList.remove("rounded-lg", "rounded-l-lg");
                        }
                    }
                    if (_this2.selected.includes(current)) {
                        classList.add("selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white");
                        classList.remove("text-gray-900", "text-gray-500", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600", "dark:bg-gray-600", "bg-gray-100", "bg-gray-200");
                    }
                    if (current === _this2.focused) classList.add("focused");
                    if (_this2.beforeShow) _this2.performBeforeHook(el, current, current);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var _ref = this.range || [], _ref2 = $7c39ee59de2954f9$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll(".range, .range-start, .range-end, .selected, .focused").forEach(function(el) {
                    el.classList.remove("range", "range-start", "range-end", "selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white", "focused");
                    el.classList.add("text-gray-900", "rounded-lg", "dark:text-white");
                });
                Array.from(this.grid.children).forEach(function(el) {
                    var current = Number(el.dataset.date);
                    var classList = el.classList;
                    classList.remove("bg-gray-200", "dark:bg-gray-600", "rounded-l-lg", "rounded-r-lg");
                    if (current > rangeStart && current < rangeEnd) {
                        classList.add("range", "bg-gray-200", "dark:bg-gray-600");
                        classList.remove("rounded-lg");
                    }
                    if (current === rangeStart) {
                        classList.add("range-start", "bg-gray-200", "dark:bg-gray-600", "rounded-l-lg");
                        classList.remove("rounded-lg");
                    }
                    if (current === rangeEnd) {
                        classList.add("range-end", "bg-gray-200", "dark:bg-gray-600", "rounded-r-lg");
                        classList.remove("rounded-lg");
                    }
                    if (_this3.selected.includes(current)) {
                        classList.add("selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white");
                        classList.remove("text-gray-900", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600", "bg-gray-100", "bg-gray-200", "dark:bg-gray-600");
                    }
                    if (current === _this3.focused) classList.add("focused");
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                var index = Math.round((this.focused - this.start) / 86400000);
                this.grid.querySelectorAll(".focused").forEach(function(el) {
                    el.classList.remove("focused");
                });
                this.grid.children[index].classList.add("focused");
            }
        }
    ]);
}($7c39ee59de2954f9$var$View);
function $7c39ee59de2954f9$var$computeMonthRange(range, thisYear) {
    if (!range || !range[0] || !range[1]) return;
    var _range = $7c39ee59de2954f9$var$_slicedToArray(range, 2), _range$ = $7c39ee59de2954f9$var$_slicedToArray(_range[0], 2), startY = _range$[0], startM = _range$[1], _range$2 = $7c39ee59de2954f9$var$_slicedToArray(_range[1], 2), endY = _range$2[0], endM = _range$2[1];
    if (startY > thisYear || endY < thisYear) return;
    return [
        startY === thisYear ? startM : -1,
        endY === thisYear ? endM : 12
    ];
}
var $7c39ee59de2954f9$var$MonthsView = /*#__PURE__*/ function(_View) {
    function MonthsView(picker) {
        $7c39ee59de2954f9$var$_classCallCheck(this, MonthsView);
        return $7c39ee59de2954f9$var$_callSuper(this, MonthsView, [
            picker,
            {
                id: 1,
                name: "months",
                cellClass: "month"
            }
        ]);
    }
    $7c39ee59de2954f9$var$_inherits(MonthsView, _View);
    return $7c39ee59de2954f9$var$_createClass(MonthsView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    this.grid = this.element;
                    this.element.classList.add("months", "datepicker-grid", "w-64", "grid", "grid-cols-4");
                    this.grid.appendChild($7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$createTagRepeat("span", 12, {
                        "data-month": function dataMonth(ix) {
                            return ix;
                        }
                    })));
                }
                $7c39ee59de2954f9$var$_get($7c39ee59de2954f9$var$_getPrototypeOf(MonthsView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options.locale) this.monthNames = options.locale.monthsShort;
                if ($7c39ee59de2954f9$var$hasProperty(options, "minDate")) {
                    if (options.minDate === undefined) this.minYear = this.minMonth = this.minDate = undefined;
                    else {
                        var minDateObj = new Date(options.minDate);
                        this.minYear = minDateObj.getFullYear();
                        this.minMonth = minDateObj.getMonth();
                        this.minDate = minDateObj.setDate(1);
                    }
                }
                if ($7c39ee59de2954f9$var$hasProperty(options, "maxDate")) {
                    if (options.maxDate === undefined) this.maxYear = this.maxMonth = this.maxDate = undefined;
                    else {
                        var maxDateObj = new Date(options.maxDate);
                        this.maxYear = maxDateObj.getFullYear();
                        this.maxMonth = maxDateObj.getMonth();
                        this.maxDate = $7c39ee59de2954f9$var$dateValue(this.maxYear, this.maxMonth + 1, 0);
                    }
                }
                if (options.beforeShowMonth !== undefined) this.beforeShow = typeof options.beforeShowMonth === "function" ? options.beforeShowMonth : undefined;
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                this.year = viewDate.getFullYear();
                this.focused = viewDate.getMonth();
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates.reduce(function(selected, timeValue) {
                    var date = new Date(timeValue);
                    var year = date.getFullYear();
                    var month = date.getMonth();
                    if (selected[year] === undefined) selected[year] = [
                        month
                    ];
                    else $7c39ee59de2954f9$var$pushUnique(selected[year], month);
                    return selected;
                }, {});
                if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map(function(timeValue) {
                    var date = new Date(timeValue);
                    return isNaN(date) ? undefined : [
                        date.getFullYear(),
                        date.getMonth()
                    ];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                // refresh disabled months on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = [];
                this.picker.setViewSwitchLabel(this.year);
                this.picker.setPrevBtnDisabled(this.year <= this.minYear);
                this.picker.setNextBtnDisabled(this.year >= this.maxYear);
                var selected = this.selected[this.year] || [];
                var yrOutOfRange = this.year < this.minYear || this.year > this.maxYear;
                var isMinYear = this.year === this.minYear;
                var isMaxYear = this.year === this.maxYear;
                var range = $7c39ee59de2954f9$var$computeMonthRange(this.range, this.year);
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var date = $7c39ee59de2954f9$var$dateValue(_this.year, index, 1);
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this.cellClass);
                    if (_this.isMinView) el.dataset.date = date;
                    // reset text on every render to clear the custom content set
                    // by beforeShow hook at previous render
                    el.textContent = _this.monthNames[index];
                    if (yrOutOfRange || isMinYear && index < _this.minMonth || isMaxYear && index > _this.maxMonth) classList.add("disabled");
                    if (range) {
                        var _range2 = $7c39ee59de2954f9$var$_slicedToArray(range, 2), rangeStart = _range2[0], rangeEnd = _range2[1];
                        if (index > rangeStart && index < rangeEnd) classList.add("range");
                        if (index === rangeStart) classList.add("range-start");
                        if (index === rangeEnd) classList.add("range-end");
                    }
                    if (selected.includes(index)) {
                        classList.add("selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white");
                        classList.remove("text-gray-900", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600");
                    }
                    if (index === _this.focused) classList.add("focused");
                    if (_this.beforeShow) _this.performBeforeHook(el, index, date);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this2 = this;
                var selected = this.selected[this.year] || [];
                var _ref = $7c39ee59de2954f9$var$computeMonthRange(this.range, this.year) || [], _ref2 = $7c39ee59de2954f9$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll(".range, .range-start, .range-end, .selected, .focused").forEach(function(el) {
                    el.classList.remove("range", "range-start", "range-end", "selected", "bg-blue-700", "!bg-primary-700", "dark:bg-blue-600", "dark:!bg-primary-700", "dark:text-white", "text-white", "focused");
                    el.classList.add("text-gray-900", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600");
                });
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    if (index > rangeStart && index < rangeEnd) classList.add("range");
                    if (index === rangeStart) classList.add("range-start");
                    if (index === rangeEnd) classList.add("range-end");
                    if (selected.includes(index)) {
                        classList.add("selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white");
                        classList.remove("text-gray-900", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600");
                    }
                    if (index === _this2.focused) classList.add("focused");
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                this.grid.querySelectorAll(".focused").forEach(function(el) {
                    el.classList.remove("focused");
                });
                this.grid.children[this.focused].classList.add("focused");
            }
        }
    ]);
}($7c39ee59de2954f9$var$View);
function $7c39ee59de2954f9$var$toTitleCase(word) {
    return $7c39ee59de2954f9$var$_toConsumableArray(word).reduce(function(str, ch, ix) {
        return str += ix ? ch : ch.toUpperCase();
    }, "");
}
// Class representing the years and decades view elements
var $7c39ee59de2954f9$var$YearsView = /*#__PURE__*/ function(_View) {
    function YearsView(picker, config) {
        $7c39ee59de2954f9$var$_classCallCheck(this, YearsView);
        return $7c39ee59de2954f9$var$_callSuper(this, YearsView, [
            picker,
            config
        ]);
    }
    $7c39ee59de2954f9$var$_inherits(YearsView, _View);
    return $7c39ee59de2954f9$var$_createClass(YearsView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    this.navStep = this.step * 10;
                    this.beforeShowOption = "beforeShow".concat($7c39ee59de2954f9$var$toTitleCase(this.cellClass));
                    this.grid = this.element;
                    this.element.classList.add(this.name, "datepicker-grid", "w-64", "grid", "grid-cols-4");
                    this.grid.appendChild($7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$createTagRepeat("span", 12)));
                }
                $7c39ee59de2954f9$var$_get($7c39ee59de2954f9$var$_getPrototypeOf(YearsView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if ($7c39ee59de2954f9$var$hasProperty(options, "minDate")) {
                    if (options.minDate === undefined) this.minYear = this.minDate = undefined;
                    else {
                        this.minYear = $7c39ee59de2954f9$var$startOfYearPeriod(options.minDate, this.step);
                        this.minDate = $7c39ee59de2954f9$var$dateValue(this.minYear, 0, 1);
                    }
                }
                if ($7c39ee59de2954f9$var$hasProperty(options, "maxDate")) {
                    if (options.maxDate === undefined) this.maxYear = this.maxDate = undefined;
                    else {
                        this.maxYear = $7c39ee59de2954f9$var$startOfYearPeriod(options.maxDate, this.step);
                        this.maxDate = $7c39ee59de2954f9$var$dateValue(this.maxYear, 11, 31);
                    }
                }
                if (options[this.beforeShowOption] !== undefined) {
                    var beforeShow = options[this.beforeShowOption];
                    this.beforeShow = typeof beforeShow === "function" ? beforeShow : undefined;
                }
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                var first = $7c39ee59de2954f9$var$startOfYearPeriod(viewDate, this.navStep);
                var last = first + 9 * this.step;
                this.first = first;
                this.last = last;
                this.start = first - this.step;
                this.focused = $7c39ee59de2954f9$var$startOfYearPeriod(viewDate, this.step);
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this = this;
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates.reduce(function(years, timeValue) {
                    return $7c39ee59de2954f9$var$pushUnique(years, $7c39ee59de2954f9$var$startOfYearPeriod(timeValue, _this.step));
                }, []);
                if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map(function(timeValue) {
                    if (timeValue !== undefined) return $7c39ee59de2954f9$var$startOfYearPeriod(timeValue, _this.step);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // refresh disabled years on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = [];
                this.picker.setViewSwitchLabel("".concat(this.first, "-").concat(this.last));
                this.picker.setPrevBtnDisabled(this.first <= this.minYear);
                this.picker.setNextBtnDisabled(this.last >= this.maxYear);
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var current = _this2.start + index * _this2.step;
                    var date = $7c39ee59de2954f9$var$dateValue(current, 0, 1);
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this2.cellClass);
                    if (_this2.isMinView) el.dataset.date = date;
                    el.textContent = el.dataset.year = current;
                    if (index === 0) classList.add("prev");
                    else if (index === 11) classList.add("next");
                    if (current < _this2.minYear || current > _this2.maxYear) classList.add("disabled");
                    if (_this2.range) {
                        var _this2$range = $7c39ee59de2954f9$var$_slicedToArray(_this2.range, 2), rangeStart = _this2$range[0], rangeEnd = _this2$range[1];
                        if (current > rangeStart && current < rangeEnd) classList.add("range");
                        if (current === rangeStart) classList.add("range-start");
                        if (current === rangeEnd) classList.add("range-end");
                    }
                    if (_this2.selected.includes(current)) {
                        classList.add("selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white");
                        classList.remove("text-gray-900", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600");
                    }
                    if (current === _this2.focused) classList.add("focused");
                    if (_this2.beforeShow) _this2.performBeforeHook(el, current, date);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var _ref = this.range || [], _ref2 = $7c39ee59de2954f9$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll(".range, .range-start, .range-end, .selected, .focused").forEach(function(el) {
                    el.classList.remove("range", "range-start", "range-end", "selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark!bg-primary-600", "dark:text-white", "focused");
                });
                Array.from(this.grid.children).forEach(function(el) {
                    var current = Number(el.textContent);
                    var classList = el.classList;
                    if (current > rangeStart && current < rangeEnd) classList.add("range");
                    if (current === rangeStart) classList.add("range-start");
                    if (current === rangeEnd) classList.add("range-end");
                    if (_this3.selected.includes(current)) {
                        classList.add("selected", "bg-blue-700", "!bg-primary-700", "text-white", "dark:bg-blue-600", "dark:!bg-primary-600", "dark:text-white");
                        classList.remove("text-gray-900", "hover:bg-gray-100", "dark:text-white", "dark:hover:bg-gray-600");
                    }
                    if (current === _this3.focused) classList.add("focused");
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                var index = Math.round((this.focused - this.start) / this.step);
                this.grid.querySelectorAll(".focused").forEach(function(el) {
                    el.classList.remove("focused");
                });
                this.grid.children[index].classList.add("focused");
            }
        }
    ]);
}($7c39ee59de2954f9$var$View);
function $7c39ee59de2954f9$var$triggerDatepickerEvent(datepicker, type) {
    var detail = {
        date: datepicker.getDate(),
        viewDate: new Date(datepicker.picker.viewDate),
        viewId: datepicker.picker.currentView.id,
        datepicker: datepicker
    };
    datepicker.element.dispatchEvent(new CustomEvent(type, {
        detail: detail
    }));
}
// direction: -1 (to previous), 1 (to next)
function $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, direction) {
    var _datepicker$config = datepicker.config, minDate = _datepicker$config.minDate, maxDate = _datepicker$config.maxDate;
    var _datepicker$picker = datepicker.picker, currentView = _datepicker$picker.currentView, viewDate = _datepicker$picker.viewDate;
    var newViewDate;
    switch(currentView.id){
        case 0:
            newViewDate = $7c39ee59de2954f9$var$addMonths(viewDate, direction);
            break;
        case 1:
            newViewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction);
            break;
        default:
            newViewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction * currentView.navStep);
    }
    newViewDate = $7c39ee59de2954f9$var$limitToRange(newViewDate, minDate, maxDate);
    datepicker.picker.changeFocus(newViewDate).render();
}
function $7c39ee59de2954f9$var$switchView(datepicker) {
    var viewId = datepicker.picker.currentView.id;
    if (viewId === datepicker.config.maxView) return;
    datepicker.picker.changeView(viewId + 1).render();
}
function $7c39ee59de2954f9$var$unfocus(datepicker) {
    if (datepicker.config.updateOnBlur) datepicker.update({
        autohide: true
    });
    else {
        datepicker.refresh("input");
        datepicker.hide();
    }
}
function $7c39ee59de2954f9$var$goToSelectedMonthOrYear(datepicker, selection) {
    var picker = datepicker.picker;
    var viewDate = new Date(picker.viewDate);
    var viewId = picker.currentView.id;
    var newDate = viewId === 1 ? $7c39ee59de2954f9$var$addMonths(viewDate, selection - viewDate.getMonth()) : $7c39ee59de2954f9$var$addYears(viewDate, selection - viewDate.getFullYear());
    picker.changeFocus(newDate).changeView(viewId - 1).render();
}
function $7c39ee59de2954f9$var$onClickTodayBtn(datepicker) {
    var picker = datepicker.picker;
    var currentDate = $7c39ee59de2954f9$var$today();
    if (datepicker.config.todayBtnMode === 1) {
        if (datepicker.config.autohide) {
            datepicker.setDate(currentDate);
            return;
        }
        datepicker.setDate(currentDate, {
            render: false
        });
        picker.update();
    }
    if (picker.viewDate !== currentDate) picker.changeFocus(currentDate);
    picker.changeView(0).render();
}
function $7c39ee59de2954f9$var$onClickClearBtn(datepicker) {
    datepicker.setDate({
        clear: true
    });
}
function $7c39ee59de2954f9$var$onClickViewSwitch(datepicker) {
    $7c39ee59de2954f9$var$switchView(datepicker);
}
function $7c39ee59de2954f9$var$onClickPrevBtn(datepicker) {
    $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, -1);
}
function $7c39ee59de2954f9$var$onClickNextBtn(datepicker) {
    $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, 1);
}
// For the picker's main block to delegete the events from `datepicker-cell`s
function $7c39ee59de2954f9$var$onClickView(datepicker, ev) {
    var target = $7c39ee59de2954f9$var$findElementInEventPath(ev, ".datepicker-cell");
    if (!target || target.classList.contains("disabled")) return;
    var _datepicker$picker$cu = datepicker.picker.currentView, id = _datepicker$picker$cu.id, isMinView = _datepicker$picker$cu.isMinView;
    if (isMinView) datepicker.setDate(Number(target.dataset.date));
    else if (id === 1) $7c39ee59de2954f9$var$goToSelectedMonthOrYear(datepicker, Number(target.dataset.month));
    else $7c39ee59de2954f9$var$goToSelectedMonthOrYear(datepicker, Number(target.dataset.year));
}
function $7c39ee59de2954f9$var$onClickPicker(datepicker) {
    if (!datepicker.inline && !datepicker.config.disableTouchKeyboard) datepicker.inputField.focus();
}
function $7c39ee59de2954f9$var$processPickerOptions(picker, options) {
    if (options.title !== undefined) {
        if (options.title) {
            picker.controls.title.textContent = options.title;
            $7c39ee59de2954f9$var$showElement(picker.controls.title);
        } else {
            picker.controls.title.textContent = "";
            $7c39ee59de2954f9$var$hideElement(picker.controls.title);
        }
    }
    if (options.prevArrow) {
        var prevBtn = picker.controls.prevBtn;
        $7c39ee59de2954f9$var$emptyChildNodes(prevBtn);
        options.prevArrow.forEach(function(node) {
            prevBtn.appendChild(node.cloneNode(true));
        });
    }
    if (options.nextArrow) {
        var nextBtn = picker.controls.nextBtn;
        $7c39ee59de2954f9$var$emptyChildNodes(nextBtn);
        options.nextArrow.forEach(function(node) {
            nextBtn.appendChild(node.cloneNode(true));
        });
    }
    if (options.locale) {
        picker.controls.todayBtn.textContent = options.locale.today;
        picker.controls.clearBtn.textContent = options.locale.clear;
    }
    if (options.todayBtn !== undefined) {
        if (options.todayBtn) $7c39ee59de2954f9$var$showElement(picker.controls.todayBtn);
        else $7c39ee59de2954f9$var$hideElement(picker.controls.todayBtn);
    }
    if ($7c39ee59de2954f9$var$hasProperty(options, "minDate") || $7c39ee59de2954f9$var$hasProperty(options, "maxDate")) {
        var _picker$datepicker$co = picker.datepicker.config, minDate = _picker$datepicker$co.minDate, maxDate = _picker$datepicker$co.maxDate;
        picker.controls.todayBtn.disabled = !$7c39ee59de2954f9$var$isInRange($7c39ee59de2954f9$var$today(), minDate, maxDate);
    }
    if (options.clearBtn !== undefined) {
        if (options.clearBtn) $7c39ee59de2954f9$var$showElement(picker.controls.clearBtn);
        else $7c39ee59de2954f9$var$hideElement(picker.controls.clearBtn);
    }
}
// Compute view date to reset, which will be...
// - the last item of the selected dates or defaultViewDate if no selection
// - limitted to minDate or maxDate if it exceeds the range
function $7c39ee59de2954f9$var$computeResetViewDate(datepicker) {
    var dates = datepicker.dates, config = datepicker.config;
    var viewDate = dates.length > 0 ? $7c39ee59de2954f9$var$lastItemOf(dates) : config.defaultViewDate;
    return $7c39ee59de2954f9$var$limitToRange(viewDate, config.minDate, config.maxDate);
}
// Change current view's view date
function $7c39ee59de2954f9$var$setViewDate(picker, newDate) {
    var oldViewDate = new Date(picker.viewDate);
    var newViewDate = new Date(newDate);
    var _picker$currentView = picker.currentView, id = _picker$currentView.id, year = _picker$currentView.year, first = _picker$currentView.first, last = _picker$currentView.last;
    var viewYear = newViewDate.getFullYear();
    picker.viewDate = newDate;
    if (viewYear !== oldViewDate.getFullYear()) $7c39ee59de2954f9$var$triggerDatepickerEvent(picker.datepicker, "changeYear");
    if (newViewDate.getMonth() !== oldViewDate.getMonth()) $7c39ee59de2954f9$var$triggerDatepickerEvent(picker.datepicker, "changeMonth");
    // return whether the new date is in different period on time from the one
    // displayed in the current view
    // when true, the view needs to be re-rendered on the next UI refresh.
    switch(id){
        case 0:
            return newDate < first || newDate > last;
        case 1:
            return viewYear !== year;
        default:
            return viewYear < first || viewYear > last;
    }
}
function $7c39ee59de2954f9$var$getTextDirection(el) {
    return window.getComputedStyle(el).direction;
}
// Class representing the picker UI
var $7c39ee59de2954f9$var$Picker = /*#__PURE__*/ function() {
    function Picker(datepicker) {
        $7c39ee59de2954f9$var$_classCallCheck(this, Picker);
        this.datepicker = datepicker;
        var template = $7c39ee59de2954f9$var$pickerTemplate.replace(/%buttonClass%/g, datepicker.config.buttonClass);
        var element = this.element = $7c39ee59de2954f9$var$parseHTML(template).firstChild;
        var _element$firstChild$c = $7c39ee59de2954f9$var$_slicedToArray(element.firstChild.children, 3), header = _element$firstChild$c[0], main = _element$firstChild$c[1], footer = _element$firstChild$c[2];
        var title = header.firstElementChild;
        var _header$lastElementCh = $7c39ee59de2954f9$var$_slicedToArray(header.lastElementChild.children, 3), prevBtn = _header$lastElementCh[0], viewSwitch = _header$lastElementCh[1], nextBtn = _header$lastElementCh[2];
        var _footer$firstChild$ch = $7c39ee59de2954f9$var$_slicedToArray(footer.firstChild.children, 2), todayBtn = _footer$firstChild$ch[0], clearBtn = _footer$firstChild$ch[1];
        var controls = {
            title: title,
            prevBtn: prevBtn,
            viewSwitch: viewSwitch,
            nextBtn: nextBtn,
            todayBtn: todayBtn,
            clearBtn: clearBtn
        };
        this.main = main;
        this.controls = controls;
        var elementClass = datepicker.inline ? "inline" : "dropdown";
        element.classList.add("datepicker-".concat(elementClass));
        elementClass === "dropdown" && element.classList.add("dropdown", "absolute", "top-0", "left-0", "z-50", "pt-2");
        $7c39ee59de2954f9$var$processPickerOptions(this, datepicker.config);
        this.viewDate = $7c39ee59de2954f9$var$computeResetViewDate(datepicker);
        // set up event listeners
        $7c39ee59de2954f9$var$registerListeners(datepicker, [
            [
                element,
                "click",
                $7c39ee59de2954f9$var$onClickPicker.bind(null, datepicker),
                {
                    capture: true
                }
            ],
            [
                main,
                "click",
                $7c39ee59de2954f9$var$onClickView.bind(null, datepicker)
            ],
            [
                controls.viewSwitch,
                "click",
                $7c39ee59de2954f9$var$onClickViewSwitch.bind(null, datepicker)
            ],
            [
                controls.prevBtn,
                "click",
                $7c39ee59de2954f9$var$onClickPrevBtn.bind(null, datepicker)
            ],
            [
                controls.nextBtn,
                "click",
                $7c39ee59de2954f9$var$onClickNextBtn.bind(null, datepicker)
            ],
            [
                controls.todayBtn,
                "click",
                $7c39ee59de2954f9$var$onClickTodayBtn.bind(null, datepicker)
            ],
            [
                controls.clearBtn,
                "click",
                $7c39ee59de2954f9$var$onClickClearBtn.bind(null, datepicker)
            ]
        ]);
        // set up views
        this.views = [
            new $7c39ee59de2954f9$var$DaysView(this),
            new $7c39ee59de2954f9$var$MonthsView(this),
            new $7c39ee59de2954f9$var$YearsView(this, {
                id: 2,
                name: "years",
                cellClass: "year",
                step: 1
            }),
            new $7c39ee59de2954f9$var$YearsView(this, {
                id: 3,
                name: "decades",
                cellClass: "decade",
                step: 10
            })
        ];
        this.currentView = this.views[datepicker.config.startView];
        this.currentView.render();
        this.main.appendChild(this.currentView.element);
        datepicker.config.container.appendChild(this.element);
    }
    return $7c39ee59de2954f9$var$_createClass(Picker, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                $7c39ee59de2954f9$var$processPickerOptions(this, options);
                this.views.forEach(function(view) {
                    view.init(options, false);
                });
                this.currentView.render();
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.datepicker.config.container.removeChild(this.element);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.active) return;
                this.element.classList.add("active", "block");
                this.element.classList.remove("hidden");
                this.active = true;
                var datepicker = this.datepicker;
                if (!datepicker.inline) {
                    // ensure picker's direction matches input's
                    var inputDirection = $7c39ee59de2954f9$var$getTextDirection(datepicker.inputField);
                    if (inputDirection !== $7c39ee59de2954f9$var$getTextDirection(datepicker.config.container)) this.element.dir = inputDirection;
                    else if (this.element.dir) this.element.removeAttribute("dir");
                    this.place();
                    if (datepicker.config.disableTouchKeyboard) datepicker.inputField.blur();
                }
                $7c39ee59de2954f9$var$triggerDatepickerEvent(datepicker, "show");
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (!this.active) return;
                this.datepicker.exitEditMode();
                this.element.classList.remove("active", "block");
                this.element.classList.add("active", "block", "hidden");
                this.active = false;
                $7c39ee59de2954f9$var$triggerDatepickerEvent(this.datepicker, "hide");
            }
        },
        {
            key: "place",
            value: function place() {
                var _this$element = this.element, classList = _this$element.classList, style = _this$element.style;
                var _this$datepicker = this.datepicker, config = _this$datepicker.config, inputField = _this$datepicker.inputField;
                var container = config.container;
                var _this$element$getBoun = this.element.getBoundingClientRect(), calendarWidth = _this$element$getBoun.width, calendarHeight = _this$element$getBoun.height;
                var _container$getBoundin = container.getBoundingClientRect(), containerLeft = _container$getBoundin.left, containerTop = _container$getBoundin.top, containerWidth = _container$getBoundin.width;
                var _inputField$getBoundi = inputField.getBoundingClientRect(), inputLeft = _inputField$getBoundi.left, inputTop = _inputField$getBoundi.top, inputWidth = _inputField$getBoundi.width, inputHeight = _inputField$getBoundi.height;
                var _config$orientation = config.orientation, orientX = _config$orientation.x, orientY = _config$orientation.y;
                var scrollTop;
                var left;
                var top;
                if (container === document.body) {
                    scrollTop = window.scrollY;
                    left = inputLeft + window.scrollX;
                    top = inputTop + scrollTop;
                } else {
                    scrollTop = container.scrollTop;
                    left = inputLeft - containerLeft;
                    top = inputTop - containerTop + scrollTop;
                }
                if (orientX === "auto") {
                    if (left < 0) {
                        // align to the left and move into visible area if input's left edge < window's
                        orientX = "left";
                        left = 10;
                    } else if (left + calendarWidth > containerWidth) // align to the right if canlendar's right edge > container's
                    orientX = "right";
                    else orientX = $7c39ee59de2954f9$var$getTextDirection(inputField) === "rtl" ? "right" : "left";
                }
                if (orientX === "right") left -= calendarWidth - inputWidth;
                if (orientY === "auto") orientY = top - calendarHeight < scrollTop ? "bottom" : "top";
                if (orientY === "top") top -= calendarHeight;
                else top += inputHeight;
                classList.remove("datepicker-orient-top", "datepicker-orient-bottom", "datepicker-orient-right", "datepicker-orient-left");
                classList.add("datepicker-orient-".concat(orientY), "datepicker-orient-".concat(orientX));
                style.top = top ? "".concat(top, "px") : top;
                style.left = left ? "".concat(left, "px") : left;
            }
        },
        {
            key: "setViewSwitchLabel",
            value: function setViewSwitchLabel(labelText) {
                this.controls.viewSwitch.textContent = labelText;
            }
        },
        {
            key: "setPrevBtnDisabled",
            value: function setPrevBtnDisabled(disabled) {
                this.controls.prevBtn.disabled = disabled;
            }
        },
        {
            key: "setNextBtnDisabled",
            value: function setNextBtnDisabled(disabled) {
                this.controls.nextBtn.disabled = disabled;
            }
        },
        {
            key: "changeView",
            value: function changeView(viewId) {
                var oldView = this.currentView;
                var newView = this.views[viewId];
                if (newView.id !== oldView.id) {
                    this.currentView = newView;
                    this._renderMethod = "render";
                    $7c39ee59de2954f9$var$triggerDatepickerEvent(this.datepicker, "changeView");
                    this.main.replaceChild(newView.element, oldView.element);
                }
                return this;
            }
        },
        {
            key: "changeFocus",
            value: function changeFocus(newViewDate) {
                this._renderMethod = $7c39ee59de2954f9$var$setViewDate(this, newViewDate) ? "render" : "refreshFocus";
                this.views.forEach(function(view) {
                    view.updateFocus();
                });
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var newViewDate = $7c39ee59de2954f9$var$computeResetViewDate(this.datepicker);
                this._renderMethod = $7c39ee59de2954f9$var$setViewDate(this, newViewDate) ? "render" : "refresh";
                this.views.forEach(function(view) {
                    view.updateFocus();
                    view.updateSelection();
                });
                return this;
            }
        },
        {
            key: "render",
            value: function render() {
                var quickRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var renderMethod = quickRender && this._renderMethod || "render";
                delete this._renderMethod;
                this.currentView[renderMethod]();
            }
        }
    ]);
}();
// Find the closest date that doesn't meet the condition for unavailable date
// Returns undefined if no available date is found
// addFn: function to calculate the next date
//   - args: time value, amount
// increase: amount to pass to addFn
// testFn: function to test the unavailablity of the date
//   - args: time value; retun: true if unavailable
function $7c39ee59de2954f9$var$findNextAvailableOne(date, addFn, increase, testFn, min, max) {
    if (!$7c39ee59de2954f9$var$isInRange(date, min, max)) return;
    if (testFn(date)) {
        var newDate = addFn(date, increase);
        return $7c39ee59de2954f9$var$findNextAvailableOne(newDate, addFn, increase, testFn, min, max);
    }
    return date;
}
// direction: -1 (left/up), 1 (right/down)
// vertical: true for up/down, false for left/right
function $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, direction, vertical) {
    var picker = datepicker.picker;
    var currentView = picker.currentView;
    var step = currentView.step || 1;
    var viewDate = picker.viewDate;
    var addFn;
    var testFn;
    switch(currentView.id){
        case 0:
            if (vertical) viewDate = $7c39ee59de2954f9$var$addDays(viewDate, direction * 7);
            else if (ev.ctrlKey || ev.metaKey) viewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction);
            else viewDate = $7c39ee59de2954f9$var$addDays(viewDate, direction);
            addFn = $7c39ee59de2954f9$var$addDays;
            testFn = function testFn(date) {
                return currentView.disabled.includes(date);
            };
            break;
        case 1:
            viewDate = $7c39ee59de2954f9$var$addMonths(viewDate, vertical ? direction * 4 : direction);
            addFn = $7c39ee59de2954f9$var$addMonths;
            testFn = function testFn(date) {
                var dt = new Date(date);
                var year = currentView.year, disabled = currentView.disabled;
                return dt.getFullYear() === year && disabled.includes(dt.getMonth());
            };
            break;
        default:
            viewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction * (vertical ? 4 : 1) * step);
            addFn = $7c39ee59de2954f9$var$addYears;
            testFn = function testFn(date) {
                return currentView.disabled.includes($7c39ee59de2954f9$var$startOfYearPeriod(date, step));
            };
    }
    viewDate = $7c39ee59de2954f9$var$findNextAvailableOne(viewDate, addFn, direction < 0 ? -step : step, testFn, currentView.minDate, currentView.maxDate);
    if (viewDate !== undefined) picker.changeFocus(viewDate).render();
}
function $7c39ee59de2954f9$var$onKeydown(datepicker, ev) {
    if (ev.key === "Tab") {
        $7c39ee59de2954f9$var$unfocus(datepicker);
        return;
    }
    var picker = datepicker.picker;
    var _picker$currentView = picker.currentView, id = _picker$currentView.id, isMinView = _picker$currentView.isMinView;
    if (!picker.active) switch(ev.key){
        case "ArrowDown":
        case "Escape":
            picker.show();
            break;
        case "Enter":
            datepicker.update();
            break;
        default:
            return;
    }
    else if (datepicker.editMode) switch(ev.key){
        case "Escape":
            picker.hide();
            break;
        case "Enter":
            datepicker.exitEditMode({
                update: true,
                autohide: datepicker.config.autohide
            });
            break;
        default:
            return;
    }
    else switch(ev.key){
        case "Escape":
            picker.hide();
            break;
        case "ArrowLeft":
            if (ev.ctrlKey || ev.metaKey) $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, -1);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, -1, false);
            break;
        case "ArrowRight":
            if (ev.ctrlKey || ev.metaKey) $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, 1);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, 1, false);
            break;
        case "ArrowUp":
            if (ev.ctrlKey || ev.metaKey) $7c39ee59de2954f9$var$switchView(datepicker);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, -1, true);
            break;
        case "ArrowDown":
            if (ev.shiftKey && !ev.ctrlKey && !ev.metaKey) {
                datepicker.enterEditMode();
                return;
            }
            $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, 1, true);
            break;
        case "Enter":
            if (isMinView) datepicker.setDate(picker.viewDate);
            else picker.changeView(id - 1).render();
            break;
        case "Backspace":
        case "Delete":
            datepicker.enterEditMode();
            return;
        default:
            if (ev.key.length === 1 && !ev.ctrlKey && !ev.metaKey) datepicker.enterEditMode();
            return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
function $7c39ee59de2954f9$var$onFocus(datepicker) {
    if (datepicker.config.showOnFocus && !datepicker._showing) datepicker.show();
}
// for the prevention for entering edit mode while getting focus on click
function $7c39ee59de2954f9$var$onMousedown(datepicker, ev) {
    var el = ev.target;
    if (datepicker.picker.active || datepicker.config.showOnClick) {
        el._active = el === document.activeElement;
        el._clicking = setTimeout(function() {
            delete el._active;
            delete el._clicking;
        }, 2000);
    }
}
function $7c39ee59de2954f9$var$onClickInput(datepicker, ev) {
    var el = ev.target;
    if (!el._clicking) return;
    clearTimeout(el._clicking);
    delete el._clicking;
    if (el._active) datepicker.enterEditMode();
    delete el._active;
    if (datepicker.config.showOnClick) datepicker.show();
}
function $7c39ee59de2954f9$var$onPaste(datepicker, ev) {
    if (ev.clipboardData.types.includes("text/plain")) datepicker.enterEditMode();
}
// for the `document` to delegate the events from outside the picker/input field
function $7c39ee59de2954f9$var$onClickOutside(datepicker, ev) {
    var element = datepicker.element;
    if (element !== document.activeElement) return;
    var pickerElem = datepicker.picker.element;
    if ($7c39ee59de2954f9$var$findElementInEventPath(ev, function(el) {
        return el === element || el === pickerElem;
    })) return;
    $7c39ee59de2954f9$var$unfocus(datepicker);
}
function $7c39ee59de2954f9$var$stringifyDates(dates, config) {
    return dates.map(function(dt) {
        return $7c39ee59de2954f9$var$formatDate(dt, config.format, config.locale);
    }).join(config.dateDelimiter);
}
// parse input dates and create an array of time values for selection
// returns undefined if there are no valid dates in inputDates
// when origDates (current selection) is passed, the function works to mix
// the input dates into the current selection
function $7c39ee59de2954f9$var$processInputDates(datepicker, inputDates) {
    var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var config = datepicker.config, origDates = datepicker.dates, rangepicker = datepicker.rangepicker;
    if (inputDates.length === 0) // empty input is considered valid unless origiDates is passed
    return clear ? [] : undefined;
    var rangeEnd = rangepicker && datepicker === rangepicker.datepickers[1];
    var newDates = inputDates.reduce(function(dates, dt) {
        var date = $7c39ee59de2954f9$var$parseDate(dt, config.format, config.locale);
        if (date === undefined) return dates;
        if (config.pickLevel > 0) {
            // adjust to 1st of the month/Jan 1st of the year
            // or to the last day of the monh/Dec 31st of the year if the datepicker
            // is the range-end picker of a rangepicker
            var _dt = new Date(date);
            if (config.pickLevel === 1) date = rangeEnd ? _dt.setMonth(_dt.getMonth() + 1, 0) : _dt.setDate(1);
            else date = rangeEnd ? _dt.setFullYear(_dt.getFullYear() + 1, 0, 0) : _dt.setMonth(0, 1);
        }
        if ($7c39ee59de2954f9$var$isInRange(date, config.minDate, config.maxDate) && !dates.includes(date) && !config.datesDisabled.includes(date) && !config.daysOfWeekDisabled.includes(new Date(date).getDay())) dates.push(date);
        return dates;
    }, []);
    if (newDates.length === 0) return;
    if (config.multidate && !clear) // get the synmetric difference between origDates and newDates
    newDates = newDates.reduce(function(dates, date) {
        if (!origDates.includes(date)) dates.push(date);
        return dates;
    }, origDates.filter(function(date) {
        return !newDates.includes(date);
    }));
    // do length check always because user can input multiple dates regardless of the mode
    return config.maxNumberOfDates && newDates.length > config.maxNumberOfDates ? newDates.slice(config.maxNumberOfDates * -1) : newDates;
}
// refresh the UI elements
// modes: 1: input only, 2, picker only, 3 both
function $7c39ee59de2954f9$var$refreshUI(datepicker) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var quickRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var config = datepicker.config, picker = datepicker.picker, inputField = datepicker.inputField;
    if (mode & 2) {
        var newView = picker.active ? config.pickLevel : config.startView;
        picker.update().changeView(newView).render(quickRender);
    }
    if (mode & 1 && inputField) inputField.value = $7c39ee59de2954f9$var$stringifyDates(datepicker.dates, config);
}
function $7c39ee59de2954f9$var$_setDate(datepicker, inputDates, options) {
    var clear = options.clear, render = options.render, autohide = options.autohide;
    if (render === undefined) render = true;
    if (!render) autohide = false;
    else if (autohide === undefined) autohide = datepicker.config.autohide;
    var newDates = $7c39ee59de2954f9$var$processInputDates(datepicker, inputDates, clear);
    if (!newDates) return;
    if (newDates.toString() !== datepicker.dates.toString()) {
        datepicker.dates = newDates;
        $7c39ee59de2954f9$var$refreshUI(datepicker, render ? 3 : 1);
        $7c39ee59de2954f9$var$triggerDatepickerEvent(datepicker, "changeDate");
    } else $7c39ee59de2954f9$var$refreshUI(datepicker, 1);
    if (autohide) datepicker.hide();
}
/**
 * Class representing a date picker
 */ var $7c39ee59de2954f9$export$7235422eca03ec90 = /*#__PURE__*/ function() {
    /**
   * Create a date picker
   * @param  {Element} element - element to bind a date picker
   * @param  {Object} [options] - config options
   * @param  {DateRangePicker} [rangepicker] - DateRangePicker instance the
   * date picker belongs to. Use this only when creating date picker as a part
   * of date range picker
   */ function Datepicker(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var rangepicker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        $7c39ee59de2954f9$var$_classCallCheck(this, Datepicker);
        element.datepicker = this;
        this.element = element;
        // set up config
        var config = this.config = Object.assign({
            buttonClass: options.buttonClass && String(options.buttonClass) || "button",
            container: document.body,
            defaultViewDate: $7c39ee59de2954f9$var$today(),
            maxDate: undefined,
            minDate: undefined
        }, $7c39ee59de2954f9$var$processOptions($7c39ee59de2954f9$var$defaultOptions, this));
        this._options = options;
        Object.assign(config, $7c39ee59de2954f9$var$processOptions(options, this));
        // configure by type
        var inline = this.inline = element.tagName !== "INPUT";
        var inputField;
        var initialDates;
        if (inline) {
            config.container = element;
            initialDates = $7c39ee59de2954f9$var$stringToArray(element.dataset.date, config.dateDelimiter);
            delete element.dataset.date;
        } else {
            var container = options.container ? document.querySelector(options.container) : null;
            if (container) config.container = container;
            inputField = this.inputField = element;
            inputField.classList.add("datepicker-input");
            initialDates = $7c39ee59de2954f9$var$stringToArray(inputField.value, config.dateDelimiter);
        }
        if (rangepicker) {
            // check validiry
            var index = rangepicker.inputs.indexOf(inputField);
            var datepickers = rangepicker.datepickers;
            if (index < 0 || index > 1 || !Array.isArray(datepickers)) throw Error("Invalid rangepicker object.");
            // attach itaelf to the rangepicker here so that processInputDates() can
            // determine if this is the range-end picker of the rangepicker while
            // setting inital values when pickLevel > 0
            datepickers[index] = this;
            // add getter for rangepicker
            Object.defineProperty(this, "rangepicker", {
                get: function get() {
                    return rangepicker;
                }
            });
        }
        // set initial dates
        this.dates = [];
        // process initial value
        var inputDateValues = $7c39ee59de2954f9$var$processInputDates(this, initialDates);
        if (inputDateValues && inputDateValues.length > 0) this.dates = inputDateValues;
        if (inputField) inputField.value = $7c39ee59de2954f9$var$stringifyDates(this.dates, config);
        var picker = this.picker = new $7c39ee59de2954f9$var$Picker(this);
        if (inline) this.show();
        else {
            // set up event listeners in other modes
            var onMousedownDocument = $7c39ee59de2954f9$var$onClickOutside.bind(null, this);
            var listeners = [
                [
                    inputField,
                    "keydown",
                    $7c39ee59de2954f9$var$onKeydown.bind(null, this)
                ],
                [
                    inputField,
                    "focus",
                    $7c39ee59de2954f9$var$onFocus.bind(null, this)
                ],
                [
                    inputField,
                    "mousedown",
                    $7c39ee59de2954f9$var$onMousedown.bind(null, this)
                ],
                [
                    inputField,
                    "click",
                    $7c39ee59de2954f9$var$onClickInput.bind(null, this)
                ],
                [
                    inputField,
                    "paste",
                    $7c39ee59de2954f9$var$onPaste.bind(null, this)
                ],
                [
                    document,
                    "mousedown",
                    onMousedownDocument
                ],
                [
                    document,
                    "touchstart",
                    onMousedownDocument
                ],
                [
                    window,
                    "resize",
                    picker.place.bind(picker)
                ]
            ];
            $7c39ee59de2954f9$var$registerListeners(this, listeners);
        }
    }
    /**
   * Format Date object or time value in given format and language
   * @param  {Date|Number} date - date or time value to format
   * @param  {String|Object} format - format string or object that contains
   * toDisplay() custom formatter, whose signature is
   * - args:
   *   - date: {Date} - Date instance of the date passed to the method
   *   - format: {Object} - the format object passed to the method
   *   - locale: {Object} - locale for the language specified by `lang`
   * - return:
   *     {String} formatted date
   * @param  {String} [lang=en] - language code for the locale to use
   * @return {String} formatted date
   */ return $7c39ee59de2954f9$var$_createClass(Datepicker, [
        {
            key: "active",
            get: /**
     * @type {Boolean} - Whether the picker element is shown. `true` whne shown
     */ function get() {
                return !!(this.picker && this.picker.active);
            }
        },
        {
            key: "pickerElement",
            get: function get() {
                return this.picker ? this.picker.element : undefined;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var picker = this.picker;
                var newOptions = $7c39ee59de2954f9$var$processOptions(options, this);
                Object.assign(this._options, options);
                Object.assign(this.config, newOptions);
                picker.setOptions(newOptions);
                $7c39ee59de2954f9$var$refreshUI(this, 3);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.inputField) {
                    if (this.inputField.disabled) return;
                    if (this.inputField !== document.activeElement) {
                        this._showing = true;
                        this.inputField.focus();
                        delete this._showing;
                    }
                }
                this.picker.show();
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.inline) return;
                this.picker.hide();
                this.picker.update().changeView(this.config.startView).render();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.hide();
                $7c39ee59de2954f9$var$unregisterListeners(this);
                this.picker.detach();
                if (!this.inline) this.inputField.classList.remove("datepicker-input");
                delete this.element.datepicker;
                return this;
            }
        },
        {
            key: "getDate",
            value: function getDate() {
                var _this = this;
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var callback = format ? function(date) {
                    return $7c39ee59de2954f9$var$formatDate(date, format, _this.config.locale);
                } : function(date) {
                    return new Date(date);
                };
                if (this.config.multidate) return this.dates.map(callback);
                if (this.dates.length > 0) return callback(this.dates[0]);
            }
        },
        {
            key: "setDate",
            value: function setDate() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var dates = [].concat(args);
                var opts = {};
                var lastArg = $7c39ee59de2954f9$var$lastItemOf(args);
                if ($7c39ee59de2954f9$var$_typeof(lastArg) === "object" && !Array.isArray(lastArg) && !(lastArg instanceof Date) && lastArg) Object.assign(opts, dates.pop());
                var inputDates = Array.isArray(dates[0]) ? dates[0] : dates;
                $7c39ee59de2954f9$var$_setDate(this, inputDates, opts);
            }
        },
        {
            key: "update",
            value: function update() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                if (this.inline) return;
                var opts = {
                    clear: true,
                    autohide: !!(options && options.autohide)
                };
                var inputDates = $7c39ee59de2954f9$var$stringToArray(this.inputField.value, this.config.dateDelimiter);
                $7c39ee59de2954f9$var$_setDate(this, inputDates, opts);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var forceRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (target && typeof target !== "string") {
                    forceRender = target;
                    target = undefined;
                }
                var mode;
                if (target === "picker") mode = 2;
                else if (target === "input") mode = 1;
                else mode = 3;
                $7c39ee59de2954f9$var$refreshUI(this, mode, !forceRender);
            }
        },
        {
            key: "enterEditMode",
            value: function enterEditMode() {
                if (this.inline || !this.picker.active || this.editMode) return;
                this.editMode = true;
                this.inputField.classList.add("in-edit", "border-blue-700", "!border-primary-700");
            }
        },
        {
            key: "exitEditMode",
            value: function exitEditMode() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                if (this.inline || !this.editMode) return;
                var opts = Object.assign({
                    update: false
                }, options);
                delete this.editMode;
                this.inputField.classList.remove("in-edit", "border-blue-700", "!border-primary-700");
                if (opts.update) this.update(opts);
            }
        }
    ], [
        {
            key: "formatDate",
            value: function formatDate$1(date, format, lang) {
                return $7c39ee59de2954f9$var$formatDate(date, format, lang && $7c39ee59de2954f9$var$locales[lang] || $7c39ee59de2954f9$var$locales.en);
            }
        },
        {
            key: "parseDate",
            value: function parseDate$1(dateStr, format, lang) {
                return $7c39ee59de2954f9$var$parseDate(dateStr, format, lang && $7c39ee59de2954f9$var$locales[lang] || $7c39ee59de2954f9$var$locales.en);
            }
        },
        {
            key: "locales",
            get: function get() {
                return $7c39ee59de2954f9$var$locales;
            }
        }
    ]);
}();
// filter out the config options inapproprite to pass to Datepicker
function $7c39ee59de2954f9$var$filterOptions(options) {
    var newOpts = Object.assign({}, options);
    delete newOpts.inputs;
    delete newOpts.allowOneSidedRange;
    delete newOpts.maxNumberOfDates; // to ensure each datepicker handles a single date
    return newOpts;
}
function $7c39ee59de2954f9$var$setupDatepicker(rangepicker, changeDateListener, el, options) {
    $7c39ee59de2954f9$var$registerListeners(rangepicker, [
        [
            el,
            "changeDate",
            changeDateListener
        ]
    ]);
    new $7c39ee59de2954f9$export$7235422eca03ec90(el, options, rangepicker);
}
function $7c39ee59de2954f9$var$onChangeDate(rangepicker, ev) {
    // to prevent both datepickers trigger the other side's update each other
    if (rangepicker._updating) return;
    rangepicker._updating = true;
    var target = ev.target;
    if (target.datepicker === undefined) return;
    var datepickers = rangepicker.datepickers;
    var setDateOptions = {
        render: false
    };
    var changedSide = rangepicker.inputs.indexOf(target);
    var otherSide = changedSide === 0 ? 1 : 0;
    var changedDate = datepickers[changedSide].dates[0];
    var otherDate = datepickers[otherSide].dates[0];
    if (changedDate !== undefined && otherDate !== undefined) {
        // if the start of the range > the end, swap them
        if (changedSide === 0 && changedDate > otherDate) {
            datepickers[0].setDate(otherDate, setDateOptions);
            datepickers[1].setDate(changedDate, setDateOptions);
        } else if (changedSide === 1 && changedDate < otherDate) {
            datepickers[0].setDate(changedDate, setDateOptions);
            datepickers[1].setDate(otherDate, setDateOptions);
        }
    } else if (!rangepicker.allowOneSidedRange) // to prevent the range from becoming one-sided, copy changed side's
    // selection (no matter if it's empty) to the other side
    {
        if (changedDate !== undefined || otherDate !== undefined) {
            setDateOptions.clear = true;
            datepickers[otherSide].setDate(datepickers[changedSide].dates, setDateOptions);
        }
    }
    datepickers[0].picker.update().render();
    datepickers[1].picker.update().render();
    delete rangepicker._updating;
}
/**
 * Class representing a date range picker
 */ var $7c39ee59de2954f9$export$17334619f3ac2224 = /*#__PURE__*/ function() {
    /**
   * Create a date range picker
   * @param  {Element} element - element to bind a date range picker
   * @param  {Object} [options] - config options
   */ function DateRangePicker(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $7c39ee59de2954f9$var$_classCallCheck(this, DateRangePicker);
        var inputs = Array.isArray(options.inputs) ? options.inputs : Array.from(element.querySelectorAll("input"));
        if (inputs.length < 2) return;
        element.rangepicker = this;
        this.element = element;
        this.inputs = inputs.slice(0, 2);
        this.allowOneSidedRange = !!options.allowOneSidedRange;
        var changeDateListener = $7c39ee59de2954f9$var$onChangeDate.bind(null, this);
        var cleanOptions = $7c39ee59de2954f9$var$filterOptions(options);
        // in order for initial date setup to work right when pcicLvel > 0,
        // let Datepicker constructor add the instance to the rangepicker
        var datepickers = [];
        Object.defineProperty(this, "datepickers", {
            get: function get() {
                return datepickers;
            }
        });
        $7c39ee59de2954f9$var$setupDatepicker(this, changeDateListener, this.inputs[0], cleanOptions);
        $7c39ee59de2954f9$var$setupDatepicker(this, changeDateListener, this.inputs[1], cleanOptions);
        Object.freeze(datepickers);
        // normalize the range if inital dates are given
        if (datepickers[0].dates.length > 0) $7c39ee59de2954f9$var$onChangeDate(this, {
            target: this.inputs[0]
        });
        else if (datepickers[1].dates.length > 0) $7c39ee59de2954f9$var$onChangeDate(this, {
            target: this.inputs[1]
        });
    }
    /**
   * @type {Array} - selected date of the linked date pickers
   */ return $7c39ee59de2954f9$var$_createClass(DateRangePicker, [
        {
            key: "dates",
            get: function get() {
                return this.datepickers.length === 2 ? [
                    this.datepickers[0].dates[0],
                    this.datepickers[1].dates[0]
                ] : undefined;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.allowOneSidedRange = !!options.allowOneSidedRange;
                var cleanOptions = $7c39ee59de2954f9$var$filterOptions(options);
                this.datepickers[0].setOptions(cleanOptions);
                this.datepickers[1].setOptions(cleanOptions);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.datepickers[0].destroy();
                this.datepickers[1].destroy();
                $7c39ee59de2954f9$var$unregisterListeners(this);
                delete this.element.rangepicker;
            }
        },
        {
            key: "getDates",
            value: function getDates() {
                var _this = this;
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var callback = format ? function(date) {
                    return $7c39ee59de2954f9$var$formatDate(date, format, _this.datepickers[0].config.locale);
                } : function(date) {
                    return new Date(date);
                };
                return this.dates.map(function(date) {
                    return date === undefined ? date : callback(date);
                });
            }
        },
        {
            key: "setDates",
            value: function setDates(rangeStart, rangeEnd) {
                var _this$datepickers = $7c39ee59de2954f9$var$_slicedToArray(this.datepickers, 2), datepicker0 = _this$datepickers[0], datepicker1 = _this$datepickers[1];
                var origDates = this.dates;
                // If range normalization runs on every change, we can't set a new range
                // that starts after the end of the current range correctly because the
                // normalization process swaps start↔︎end right after setting the new start
                // date. To prevent this, the normalization process needs to run once after
                // both of the new dates are set.
                this._updating = true;
                datepicker0.setDate(rangeStart);
                datepicker1.setDate(rangeEnd);
                delete this._updating;
                if (datepicker1.dates[0] !== origDates[1]) $7c39ee59de2954f9$var$onChangeDate(this, {
                    target: this.inputs[1]
                });
                else if (datepicker0.dates[0] !== origDates[0]) $7c39ee59de2954f9$var$onChangeDate(this, {
                    target: this.inputs[0]
                });
            }
        }
    ]);
}();


var $b94af47b4b1b850b$var$__assign = undefined && undefined.__assign || function() {
    $b94af47b4b1b850b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b94af47b4b1b850b$var$__assign.apply(this, arguments);
};
var $b94af47b4b1b850b$var$Default = {
    defaultDatepickerId: null,
    autohide: false,
    format: "mm/dd/yyyy",
    maxDate: null,
    minDate: null,
    orientation: "bottom",
    buttons: false,
    autoSelectToday: 0,
    title: null,
    language: "en",
    rangePicker: false,
    onShow: function() {},
    onHide: function() {}
};
var $b94af47b4b1b850b$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $b94af47b4b1b850b$var$Datepicker = /** @class */ function() {
    function Datepicker(datepickerEl, options, instanceOptions) {
        if (datepickerEl === void 0) datepickerEl = null;
        if (options === void 0) options = $b94af47b4b1b850b$var$Default;
        if (instanceOptions === void 0) instanceOptions = $b94af47b4b1b850b$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : datepickerEl.id;
        this._datepickerEl = datepickerEl;
        this._datepickerInstance = null;
        this._options = $b94af47b4b1b850b$var$__assign($b94af47b4b1b850b$var$__assign({}, $b94af47b4b1b850b$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance("Datepicker", this, this._instanceId, instanceOptions.override);
    }
    Datepicker.prototype.init = function() {
        if (this._datepickerEl && !this._initialized) {
            if (this._options.rangePicker) this._datepickerInstance = new (0, $7c39ee59de2954f9$export$17334619f3ac2224)(this._datepickerEl, this._getDatepickerOptions(this._options));
            else this._datepickerInstance = new (0, $7c39ee59de2954f9$export$7235422eca03ec90)(this._datepickerEl, this._getDatepickerOptions(this._options));
            this._initialized = true;
        }
    };
    Datepicker.prototype.destroy = function() {
        if (this._initialized) {
            this._initialized = false;
            this._datepickerInstance.destroy();
        }
    };
    Datepicker.prototype.removeInstance = function() {
        this.destroy();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance("Datepicker", this._instanceId);
    };
    Datepicker.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Datepicker.prototype.getDatepickerInstance = function() {
        return this._datepickerInstance;
    };
    Datepicker.prototype.getDate = function() {
        if (this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$17334619f3ac2224)) return this._datepickerInstance.getDates();
        if (!this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$7235422eca03ec90)) return this._datepickerInstance.getDate();
    };
    Datepicker.prototype.setDate = function(date) {
        if (this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$17334619f3ac2224)) return this._datepickerInstance.setDates(date);
        if (!this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$7235422eca03ec90)) return this._datepickerInstance.setDate(date);
    };
    Datepicker.prototype.show = function() {
        this._datepickerInstance.show();
        this._options.onShow(this);
    };
    Datepicker.prototype.hide = function() {
        this._datepickerInstance.hide();
        this._options.onHide(this);
    };
    Datepicker.prototype._getDatepickerOptions = function(options) {
        var datepickerOptions = {};
        if (options.buttons) {
            datepickerOptions.todayBtn = true;
            datepickerOptions.clearBtn = true;
            if (options.autoSelectToday) datepickerOptions.todayBtnMode = 1;
        }
        if (options.autohide) datepickerOptions.autohide = true;
        if (options.format) datepickerOptions.format = options.format;
        if (options.maxDate) datepickerOptions.maxDate = options.maxDate;
        if (options.minDate) datepickerOptions.minDate = options.minDate;
        if (options.orientation) datepickerOptions.orientation = options.orientation;
        if (options.title) datepickerOptions.title = options.title;
        if (options.language) datepickerOptions.language = options.language;
        return datepickerOptions;
    };
    Datepicker.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Datepicker.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Datepicker;
}();
function $b94af47b4b1b850b$export$81c9f52a292162ae() {
    document.querySelectorAll("[datepicker], [inline-datepicker], [date-rangepicker]").forEach(function($datepickerEl) {
        if ($datepickerEl) {
            var buttons = $datepickerEl.hasAttribute("datepicker-buttons");
            var autoselectToday = $datepickerEl.hasAttribute("datepicker-autoselect-today");
            var autohide = $datepickerEl.hasAttribute("datepicker-autohide");
            var format = $datepickerEl.getAttribute("datepicker-format");
            var maxDate = $datepickerEl.getAttribute("datepicker-max-date");
            var minDate = $datepickerEl.getAttribute("datepicker-min-date");
            var orientation_1 = $datepickerEl.getAttribute("datepicker-orientation");
            var title = $datepickerEl.getAttribute("datepicker-title");
            var language = $datepickerEl.getAttribute("datepicker-language");
            var rangePicker = $datepickerEl.hasAttribute("date-rangepicker");
            new $b94af47b4b1b850b$var$Datepicker($datepickerEl, {
                buttons: buttons ? buttons : $b94af47b4b1b850b$var$Default.buttons,
                autoSelectToday: autoselectToday ? autoselectToday : $b94af47b4b1b850b$var$Default.autoSelectToday,
                autohide: autohide ? autohide : $b94af47b4b1b850b$var$Default.autohide,
                format: format ? format : $b94af47b4b1b850b$var$Default.format,
                maxDate: maxDate ? maxDate : $b94af47b4b1b850b$var$Default.maxDate,
                minDate: minDate ? minDate : $b94af47b4b1b850b$var$Default.minDate,
                orientation: orientation_1 ? orientation_1 : $b94af47b4b1b850b$var$Default.orientation,
                title: title ? title : $b94af47b4b1b850b$var$Default.title,
                language: language ? language : $b94af47b4b1b850b$var$Default.language,
                rangePicker: rangePicker ? rangePicker : $b94af47b4b1b850b$var$Default.rangePicker
            });
        } else console.error("The datepicker element does not exist. Please check the datepicker attribute.");
    });
}
if (typeof window !== "undefined") {
    window.Datepicker = $b94af47b4b1b850b$var$Datepicker;
    window.initDatepickers = $b94af47b4b1b850b$export$81c9f52a292162ae;
}
var $b94af47b4b1b850b$export$2e2bcd8739ae039 = $b94af47b4b1b850b$var$Datepicker;
















function $60d1a2d369db67b0$export$4cd50b9c69a85fd5() {
    (0, $d93a619a461d9c03$export$226c1dc98323ee4d)();
    (0, $fc7ccf099a511882$export$355ba5a528b4009a)();
    (0, $c1b11beef829dd56$export$3ab77386b16b9e58)();
    (0, $6d6d37a8acee51c1$export$69c84787a503daef)();
    (0, $9d7e083df5284b15$export$8cb65a02593bf108)();
    (0, $eaca6a069237aaf5$export$e14d3bc873a8b9b1)();
    (0, $48c8331f22e653e8$export$319df2b10e87c8ec)();
    (0, $d9a3b96db6d5dbb4$export$c92e8f569ad2976f)();
    (0, $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e)();
    (0, $6aca18f5cd7d8b7b$export$200409e83b2a0dd4)();
    (0, $027785b5e7762569$export$33aa68e0bfaa065d)();
    (0, $5252bf9f038f0bda$export$4352dd3b7a1676ab)();
    (0, $d10e6c36a2232fe1$export$ad4117886fd6cf74)();
    (0, $b94af47b4b1b850b$export$81c9f52a292162ae)();
}
if (typeof window !== "undefined") window.initFlowbite = $60d1a2d369db67b0$export$4cd50b9c69a85fd5;






























































// setup events for data attributes
var $948592d8c330c4e7$var$events = new (0, $2bd4b9c31e857ffa$export$2e2bcd8739ae039)("load", [
    (0, $d93a619a461d9c03$export$226c1dc98323ee4d),
    (0, $fc7ccf099a511882$export$355ba5a528b4009a),
    (0, $c1b11beef829dd56$export$3ab77386b16b9e58),
    (0, $6d6d37a8acee51c1$export$69c84787a503daef),
    (0, $9d7e083df5284b15$export$8cb65a02593bf108),
    (0, $eaca6a069237aaf5$export$e14d3bc873a8b9b1),
    (0, $48c8331f22e653e8$export$319df2b10e87c8ec),
    (0, $d9a3b96db6d5dbb4$export$c92e8f569ad2976f),
    (0, $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e),
    (0, $6aca18f5cd7d8b7b$export$200409e83b2a0dd4),
    (0, $027785b5e7762569$export$33aa68e0bfaa065d),
    (0, $5252bf9f038f0bda$export$4352dd3b7a1676ab),
    (0, $d10e6c36a2232fe1$export$ad4117886fd6cf74),
    (0, $b94af47b4b1b850b$export$81c9f52a292162ae)
]);
$948592d8c330c4e7$var$events.init();




function $f2f086fa702b7d9c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f2f086fa702b7d9c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f2f086fa702b7d9c$var$_typeof(obj);
}
var $f2f086fa702b7d9c$export$d900da7fa9a86f36 = "_ALGOLIA";
function $f2f086fa702b7d9c$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $f2f086fa702b7d9c$var$_typeof(document)) !== "object" || typeof document.cookie !== "string") return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $f2f086fa702b7d9c$export$61f1c6e9cd2ed687() {
    return $f2f086fa702b7d9c$var$getCookie($f2f086fa702b7d9c$export$d900da7fa9a86f36);
}
function $f2f086fa702b7d9c$export$2e2bcd8739ae039() {
    return $f2f086fa702b7d9c$export$61f1c6e9cd2ed687();
}

var $26d2f3c47ecadc8f$var$NAMESPACE = "ais";
var $26d2f3c47ecadc8f$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($26d2f3c47ecadc8f$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};


function $4dc7e5862e881a8a$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $fcb98432e82f2808$var$htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
// Used to match HTML entities and HTML characters.
var $fcb98432e82f2808$var$regexUnescapedHtml = /[&<>"']/g;
var $fcb98432e82f2808$var$regexHasUnescapedHtml = RegExp($fcb98432e82f2808$var$regexUnescapedHtml.source);
function $fcb98432e82f2808$export$4e7f196112fea3c5(value) {
    return value && $fcb98432e82f2808$var$regexHasUnescapedHtml.test(value) ? value.replace($fcb98432e82f2808$var$regexUnescapedHtml, function(character) {
        return $fcb98432e82f2808$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $fcb98432e82f2808$var$htmlCharacters = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
// Used to match HTML entities and HTML characters.
var $fcb98432e82f2808$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $fcb98432e82f2808$var$regexHasEscapedHtml = RegExp($fcb98432e82f2808$var$regexEscapedHtml.source);
function $fcb98432e82f2808$export$e8bacd2802a88316(value) {
    return value && $fcb98432e82f2808$var$regexHasEscapedHtml.test(value) ? value.replace($fcb98432e82f2808$var$regexEscapedHtml, function(character) {
        return $fcb98432e82f2808$var$htmlCharacters[character];
    }) : value;
}


function $75a4fd312a615f00$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $75a4fd312a615f00$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $75a4fd312a615f00$var$_typeof(obj);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $75a4fd312a615f00$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $75a4fd312a615f00$var$isObjectLike(value) {
    return $75a4fd312a615f00$var$_typeof(value) === "object" && value !== null;
}
function $75a4fd312a615f00$export$53b83ca8eaab0383(value) {
    if (!$75a4fd312a615f00$var$isObjectLike(value) || $75a4fd312a615f00$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}


function $ea7b3b8ada1be339$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ea7b3b8ada1be339$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ea7b3b8ada1be339$var$_typeof(obj);
}
function $ea7b3b8ada1be339$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $ea7b3b8ada1be339$var$_extends() {
    $ea7b3b8ada1be339$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ea7b3b8ada1be339$var$_extends.apply(this, arguments);
}
function $ea7b3b8ada1be339$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ea7b3b8ada1be339$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ea7b3b8ada1be339$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ea7b3b8ada1be339$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ea7b3b8ada1be339$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ea7b3b8ada1be339$var$_defineProperty(obj, key, value) {
    key = $ea7b3b8ada1be339$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ea7b3b8ada1be339$var$_toPropertyKey(arg) {
    var key = $ea7b3b8ada1be339$var$_toPrimitive(arg, "string");
    return $ea7b3b8ada1be339$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ea7b3b8ada1be339$var$_toPrimitive(input, hint) {
    if ($ea7b3b8ada1be339$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ea7b3b8ada1be339$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ea7b3b8ada1be339$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $ea7b3b8ada1be339$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
// @MAJOR: in the future, this should only escape, not replace
function $ea7b3b8ada1be339$var$replaceTagsAndEscape(value) {
    return (0, $fcb98432e82f2808$export$4e7f196112fea3c5)(value).replace(new RegExp($ea7b3b8ada1be339$export$1e7338a8952eaf35.highlightPreTag, "g"), $ea7b3b8ada1be339$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($ea7b3b8ada1be339$export$1e7338a8952eaf35.highlightPostTag, "g"), $ea7b3b8ada1be339$export$62e796b7905e8e6b.highlightPostTag);
}
function $ea7b3b8ada1be339$var$recursiveEscape(input) {
    if ((0, $75a4fd312a615f00$export$53b83ca8eaab0383)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $ea7b3b8ada1be339$var$_objectSpread($ea7b3b8ada1be339$var$_objectSpread({}, acc), {}, $ea7b3b8ada1be339$var$_defineProperty({}, key, $ea7b3b8ada1be339$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($ea7b3b8ada1be339$var$recursiveEscape);
    return $ea7b3b8ada1be339$var$_objectSpread($ea7b3b8ada1be339$var$_objectSpread({}, input), {}, {
        value: $ea7b3b8ada1be339$var$replaceTagsAndEscape(input.value)
    });
}
function $ea7b3b8ada1be339$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $ea7b3b8ada1be339$var$_extends({}, ($ea7b3b8ada1be339$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $ea7b3b8ada1be339$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $ea7b3b8ada1be339$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $ea7b3b8ada1be339$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $ea7b3b8ada1be339$var$_objectSpread($ea7b3b8ada1be339$var$_objectSpread({}, h), {}, {
            highlighted: $ea7b3b8ada1be339$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}


var $c84ade2a4f4913d0$var$suit = (0, $26d2f3c47ecadc8f$export$d8556a2a8f973135)("Highlight");
function $c84ade2a4f4913d0$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $c84ade2a4f4913d0$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

function $61d6f7a445550123$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $61d6f7a445550123$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}


function $62dc5ddd84fbc4d2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $62dc5ddd84fbc4d2$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $62dc5ddd84fbc4d2$var$_typeof(obj);
}
function $62dc5ddd84fbc4d2$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $61d6f7a445550123$export$706ea24b0964bee9)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $62dc5ddd84fbc4d2$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($62dc5ddd84fbc4d2$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $61d6f7a445550123$export$44b4521aa38272f2)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $62dc5ddd84fbc4d2$export$2e2bcd8739ae039(method, payload) {
    return $62dc5ddd84fbc4d2$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}



function $e2136b4fe8cbe1d7$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPreTag, highlightPostTag = (0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}


function $d11e96c67ca5e4d5$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPostTag, highlightPreTag = (0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}


var $e2cd73fbcf03a3df$var$hasAlphanumeric = new RegExp(/\w/i);
function $e2cd73fbcf03a3df$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$e2cd73fbcf03a3df$var$hasAlphanumeric.test((0, $fcb98432e82f2808$export$e8bacd2802a88316)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}


function $c5cff96bdf3b7f7e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c5cff96bdf3b7f7e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c5cff96bdf3b7f7e$var$_typeof(obj);
}
function $c5cff96bdf3b7f7e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c5cff96bdf3b7f7e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c5cff96bdf3b7f7e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c5cff96bdf3b7f7e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c5cff96bdf3b7f7e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c5cff96bdf3b7f7e$var$_defineProperty(obj, key, value) {
    key = $c5cff96bdf3b7f7e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c5cff96bdf3b7f7e$var$_toPropertyKey(arg) {
    var key = $c5cff96bdf3b7f7e$var$_toPrimitive(arg, "string");
    return $c5cff96bdf3b7f7e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c5cff96bdf3b7f7e$var$_toPrimitive(input, hint) {
    if ($c5cff96bdf3b7f7e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c5cff96bdf3b7f7e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c5cff96bdf3b7f7e$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $c5cff96bdf3b7f7e$var$_objectSpread($c5cff96bdf3b7f7e$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $c5cff96bdf3b7f7e$var$_objectSpread($c5cff96bdf3b7f7e$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $e2cd73fbcf03a3df$export$60c97785b669d08a)(parts, i)
        });
    });
}


var $a9544a7c7ea19d28$var$suit = (0, $26d2f3c47ecadc8f$export$d8556a2a8f973135)("ReverseHighlight");
function $a9544a7c7ea19d28$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $a9544a7c7ea19d28$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $e2136b4fe8cbe1d7$export$a34fe2fceda1929e)((0, $c5cff96bdf3b7f7e$export$8d1202a2cf66e93)((0, $d11e96c67ca5e4d5$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $007f848d940fdaf1$var$suit = (0, $26d2f3c47ecadc8f$export$d8556a2a8f973135)("ReverseSnippet");
function $007f848d940fdaf1$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $007f848d940fdaf1$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $e2136b4fe8cbe1d7$export$a34fe2fceda1929e)((0, $c5cff96bdf3b7f7e$export$8d1202a2cf66e93)((0, $d11e96c67ca5e4d5$export$e04d28e65b830ebf)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}



var $42f86c36b36dbd78$var$suit = (0, $26d2f3c47ecadc8f$export$d8556a2a8f973135)("Snippet");
function $42f86c36b36dbd78$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $42f86c36b36dbd78$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $ea7b3b8ada1be339$export$62e796b7905e8e6b).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}


function $4198f5cd959b5a7d$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $4198f5cd959b5a7d$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($4198f5cd959b5a7d$var$isPrimitive(first) || $4198f5cd959b5a7d$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$4198f5cd959b5a7d$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $ae549b2844b692c1$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}


var $58d1e602d478cf2f$var$_excluded = [
    "page"
];
function $58d1e602d478cf2f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $58d1e602d478cf2f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $58d1e602d478cf2f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $58d1e602d478cf2f$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $58d1e602d478cf2f$var$_objectWithoutProperties(_ref, $58d1e602d478cf2f$var$_excluded);
    return rest;
}
function $58d1e602d478cf2f$export$2e2bcd8739ae039() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, key = _ref2.key;
    var KEY = [
        "ais.infiniteHits",
        key
    ].filter(Boolean).join(":");
    return {
        read: function read(_ref3) {
            var state = _ref3.state;
            var sessionStorage = (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref4) {
                var window = _ref4.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return null;
            try {
                var cache = JSON.parse(// @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
                sessionStorage.getItem(KEY));
                return cache && (0, $4198f5cd959b5a7d$export$248d38f6296296c5)(cache.state, $58d1e602d478cf2f$var$getStateWithoutPage(state)) ? cache.hits : null;
            } catch (error) {
                if (error instanceof SyntaxError) try {
                    sessionStorage.removeItem(KEY);
                } catch (err) {
                // do nothing
                }
                return null;
            }
        },
        write: function write(_ref5) {
            var state = _ref5.state, hits = _ref5.hits;
            var sessionStorage = (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref6) {
                var window = _ref6.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return;
            try {
                sessionStorage.setItem(KEY, JSON.stringify({
                    state: $58d1e602d478cf2f$var$getStateWithoutPage(state),
                    hits: hits
                }));
            } catch (error) {
            // do nothing
            }
        }
    };
}


var $d2f3ec49777c2f55$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $d2f3ec49777c2f55$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
$d2f3ec49777c2f55$exports = $d2f3ec49777c2f55$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$d2f3ec49777c2f55$var$EventEmitter.prototype._events = undefined;
$d2f3ec49777c2f55$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$d2f3ec49777c2f55$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$d2f3ec49777c2f55$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$d2f3ec49777c2f55$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$d2f3ec49777c2f55$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $d2f3ec49777c2f55$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($d2f3ec49777c2f55$var$isUndefined(handler)) return false;
    if ($d2f3ec49777c2f55$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($d2f3ec49777c2f55$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$d2f3ec49777c2f55$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$d2f3ec49777c2f55$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $d2f3ec49777c2f55$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($d2f3ec49777c2f55$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($d2f3ec49777c2f55$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$d2f3ec49777c2f55$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $d2f3ec49777c2f55$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$d2f3ec49777c2f55$var$EventEmitter.prototype.on = $d2f3ec49777c2f55$var$EventEmitter.prototype.addListener;
$d2f3ec49777c2f55$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$d2f3ec49777c2f55$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$d2f3ec49777c2f55$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$d2f3ec49777c2f55$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $d2f3ec49777c2f55$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($d2f3ec49777c2f55$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$d2f3ec49777c2f55$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($d2f3ec49777c2f55$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$d2f3ec49777c2f55$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($d2f3ec49777c2f55$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$d2f3ec49777c2f55$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($d2f3ec49777c2f55$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$d2f3ec49777c2f55$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $d2f3ec49777c2f55$var$isFunction(arg) {
    return typeof arg === "function";
}
function $d2f3ec49777c2f55$var$isNumber(arg) {
    return typeof arg === "number";
}
function $d2f3ec49777c2f55$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $d2f3ec49777c2f55$var$isUndefined(arg) {
    return arg === void 0;
}


var $6c359160e6887998$exports = {};
"use strict";
var $ab905b70bbf6a740$exports = {};
"use strict";

var $b57af9a08b47e48e$exports = {};
"use strict";

var $6c0c921167d16aa0$exports = {};
"use strict";
function $6c0c921167d16aa0$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
$6c0c921167d16aa0$exports = $6c0c921167d16aa0$var$inherits;


/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $b57af9a08b47e48e$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$6c0c921167d16aa0$exports($b57af9a08b47e48e$var$DerivedHelper, $d2f3ec49777c2f55$exports);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $b57af9a08b47e48e$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$b57af9a08b47e48e$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$b57af9a08b47e48e$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
$b57af9a08b47e48e$exports = $b57af9a08b47e48e$var$DerivedHelper;


var $aaf73120eb76b950$exports = {};
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $aaf73120eb76b950$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $aaf73120eb76b950$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
$aaf73120eb76b950$exports = {
    escapeFacetValue: $aaf73120eb76b950$var$escapeFacetValue,
    unescapeFacetValue: $aaf73120eb76b950$var$unescapeFacetValue
};


var $ab905b70bbf6a740$require$escapeFacetValue = $aaf73120eb76b950$exports.escapeFacetValue;

var $5223709f7c606ea7$exports = {};
"use strict";
function $5223709f7c606ea7$var$clone(value) {
    if (typeof value === "object" && value !== null) return $5223709f7c606ea7$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $5223709f7c606ea7$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $5223709f7c606ea7$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($5223709f7c606ea7$var$isObjectOrArrayOrFunction(targetVal) && $5223709f7c606ea7$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $5223709f7c606ea7$var$_merge(targetVal, sourceVal);
        else target[key] = $5223709f7c606ea7$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $5223709f7c606ea7$var$merge(target) {
    if (!$5223709f7c606ea7$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($5223709f7c606ea7$var$isObjectOrArrayOrFunction(source)) $5223709f7c606ea7$var$_merge(target, source);
    }
    return target;
}
$5223709f7c606ea7$exports = $5223709f7c606ea7$var$merge;


var $c0c10d49c54a249b$exports = {};
"use strict";
function $c0c10d49c54a249b$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
$c0c10d49c54a249b$exports = $c0c10d49c54a249b$var$objectHasKeys;


var $d5a032e94ef65cbb$exports = {};
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $d5a032e94ef65cbb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$d5a032e94ef65cbb$exports = $d5a032e94ef65cbb$var$_objectWithoutPropertiesLoose;


var $336fa3444e711b93$exports = {};
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $336fa3444e711b93$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$336fa3444e711b93$var$RecommendParameters.prototype = {
    constructor: $336fa3444e711b93$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $336fa3444e711b93$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $336fa3444e711b93$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
$336fa3444e711b93$exports = $336fa3444e711b93$var$RecommendParameters;


var $2f1ad7c174e74881$exports = {};
"use strict";
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $2f1ad7c174e74881$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$2f1ad7c174e74881$var$RecommendResults.prototype = {
    constructor: $2f1ad7c174e74881$var$RecommendResults
};
$2f1ad7c174e74881$exports = $2f1ad7c174e74881$var$RecommendResults;


var $c2fb9d98022cd5ed$exports = {};
"use strict";

function $c2fb9d98022cd5ed$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $c2fb9d98022cd5ed$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $c2fb9d98022cd5ed$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $c2fb9d98022cd5ed$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $c2fb9d98022cd5ed$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($c2fb9d98022cd5ed$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $c2fb9d98022cd5ed$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $c2fb9d98022cd5ed$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $c2fb9d98022cd5ed$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $c2fb9d98022cd5ed$var$sortObject($5223709f7c606ea7$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $c2fb9d98022cd5ed$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $c2fb9d98022cd5ed$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $c2fb9d98022cd5ed$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $c2fb9d98022cd5ed$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $c2fb9d98022cd5ed$var$sortObject($5223709f7c606ea7$exports({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $c2fb9d98022cd5ed$var$sortObject($5223709f7c606ea7$exports({}, $c2fb9d98022cd5ed$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
$c2fb9d98022cd5ed$exports = $c2fb9d98022cd5ed$var$requestBuilder;


var $b98b552440c412c7$exports = {};
"use strict";
var $835decef46f26c5e$exports = {};
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
$835decef46f26c5e$exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};


var $18a18427f3d6914e$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
$18a18427f3d6914e$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};


var $1f358bf4e51305f6$exports = {};
"use strict";
function $1f358bf4e51305f6$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
$1f358bf4e51305f6$exports = $1f358bf4e51305f6$var$intersection;





var $0012e4ff1c99fe7e$exports = {};
"use strict";
function $0012e4ff1c99fe7e$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($0012e4ff1c99fe7e$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
$0012e4ff1c99fe7e$exports = $0012e4ff1c99fe7e$var$valToNumber;


var $c0e6e601e5d1a93f$exports = {};
"use strict";
$c0e6e601e5d1a93f$exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};


var $285f5e4df955497a$exports = {};
"use strict";



var $285f5e4df955497a$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($285f5e4df955497a$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $835decef46f26c5e$exports(mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $285f5e4df955497a$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $285f5e4df955497a$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($285f5e4df955497a$var$lib.isRefined(refinementList, attribute, value)) return $285f5e4df955497a$var$lib.removeRefinement(refinementList, attribute, value);
        return $285f5e4df955497a$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$c0c10d49c54a249b$exports(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $d5a032e94ef65cbb$exports(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
$285f5e4df955497a$exports = $285f5e4df955497a$var$lib;


/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $b98b552440c412c7$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $b98b552440c412c7$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $b98b552440c412c7$var$findArray(array, searchedValue) {
    return $18a18427f3d6914e$exports(array, function(currentValue) {
        return $b98b552440c412c7$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $b98b552440c412c7$var$SearchParameters(newParameters) {
    var params = newParameters ? $b98b552440c412c7$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$c0e6e601e5d1a93f$exports(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $b98b552440c412c7$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $b98b552440c412c7$var$SearchParameters.PARAMETERS = Object.keys(new $b98b552440c412c7$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $b98b552440c412c7$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $b98b552440c412c7$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $5223709f7c606ea7$exports(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $b98b552440c412c7$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $b98b552440c412c7$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $b98b552440c412c7$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $c0c10d49c54a249b$exports(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($c0c10d49c54a249b$exports(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$b98b552440c412c7$var$SearchParameters.prototype = {
    constructor: $b98b552440c412c7$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $285f5e4df955497a$exports.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $285f5e4df955497a$exports.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $285f5e4df955497a$exports.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $285f5e4df955497a$exports.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $0012e4ff1c99fe7e$exports(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $5223709f7c606ea7$exports({}, this.numericRefinements);
        mod[attribute] = $5223709f7c606ea7$exports({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $b98b552440c412c7$var$isEqualNumericRefinement(value.val, $0012e4ff1c99fe7e$exports(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$c0c10d49c54a249b$exports(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $d5a032e94ef65cbb$exports(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($285f5e4df955497a$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $285f5e4df955497a$exports.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($285f5e4df955497a$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $285f5e4df955497a$exports.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($285f5e4df955497a$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $285f5e4df955497a$exports.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$285f5e4df955497a$exports.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $285f5e4df955497a$exports.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$285f5e4df955497a$exports.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $285f5e4df955497a$exports.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$285f5e4df955497a$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $285f5e4df955497a$exports.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $285f5e4df955497a$exports.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $285f5e4df955497a$exports.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $285f5e4df955497a$exports.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $835decef46f26c5e$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $835decef46f26c5e$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $835decef46f26c5e$exports(mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $285f5e4df955497a$exports.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $285f5e4df955497a$exports.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $285f5e4df955497a$exports.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $0012e4ff1c99fe7e$exports(value);
        var isAttributeValueDefined = $b98b552440c412c7$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $1f358bf4e51305f6$exports(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $1f358bf4e51305f6$exports(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $b98b552440c412c7$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $b98b552440c412c7$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $d5a032e94ef65cbb$exports(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $18a18427f3d6914e$exports(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ $b98b552440c412c7$exports = $b98b552440c412c7$var$SearchParameters;


var $b9a4763f536f329f$exports = {};
"use strict";
var $75eb274710432a4f$exports = {};
"use strict";
$75eb274710432a4f$exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};





var $d38a2c9c99bdf9ed$exports = {};
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
$d38a2c9c99bdf9ed$exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};


var $42d739a744cbfc0c$exports = {};
"use strict";

/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ $42d739a744cbfc0c$exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $18a18427f3d6914e$exports(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};


var $e49c9a312dceb9b5$exports = {};
"use strict";
function $e49c9a312dceb9b5$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $e49c9a312dceb9b5$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $e49c9a312dceb9b5$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
$e49c9a312dceb9b5$exports = $e49c9a312dceb9b5$var$orderBy;


var $b9a4763f536f329f$var$escapeFacetValue = $aaf73120eb76b950$exports.escapeFacetValue;
var $b9a4763f536f329f$var$unescapeFacetValue = $aaf73120eb76b950$exports.unescapeFacetValue;
var $6b16ac2b1f94f8b3$exports = {};
"use strict";
$6b16ac2b1f94f8b3$exports = $6b16ac2b1f94f8b3$var$generateTrees;




var $6b16ac2b1f94f8b3$var$escapeFacetValue = $aaf73120eb76b950$exports.escapeFacetValue;
var $6b16ac2b1f94f8b3$var$unescapeFacetValue = $aaf73120eb76b950$exports.unescapeFacetValue;
function $6b16ac2b1f94f8b3$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $42d739a744cbfc0c$exports(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $6b16ac2b1f94f8b3$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $6b16ac2b1f94f8b3$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $18a18427f3d6914e$exports(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $6b16ac2b1f94f8b3$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $e49c9a312dceb9b5$exports(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $6b16ac2b1f94f8b3$var$format(facetCount, facetValue, hierarchicalSeparator, $6b16ac2b1f94f8b3$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $6b16ac2b1f94f8b3$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $6b16ac2b1f94f8b3$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $6b16ac2b1f94f8b3$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}


/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $b9a4763f536f329f$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $b9a4763f536f329f$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $b9a4763f536f329f$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $18a18427f3d6914e$exports(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $b9a4763f536f329f$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $835decef46f26c5e$exports(options, {
        persistHierarchicalRootCount: false
    });
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $b9a4763f536f329f$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $b9a4763f536f329f$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $b9a4763f536f329f$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $d38a2c9c99bdf9ed$exports(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $b9a4763f536f329f$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $b9a4763f536f329f$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $75eb274710432a4f$exports(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $d38a2c9c99bdf9ed$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $d38a2c9c99bdf9ed$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = self.persistHierarchicalRootCount ? $835decef46f26c5e$exports(self.hierarchicalFacets[position][attributeIndex].data, facetResults) : $835decef46f26c5e$exports(facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $835decef46f26c5e$exports(dataFromMainRequest, facetResults),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $b9a4763f536f329f$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($b9a4763f536f329f$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $d38a2c9c99bdf9ed$exports(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $d38a2c9c99bdf9ed$exports(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $835decef46f26c5e$exports(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($6b16ac2b1f94f8b3$exports(state));
    /**
   * @type {Array}
   */ this.facets = $75eb274710432a4f$exports(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $75eb274710432a4f$exports(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $b9a4763f536f329f$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $18a18427f3d6914e$exports(this.facets, predicate) || $18a18427f3d6914e$exports(this.disjunctiveFacets, predicate) || $18a18427f3d6914e$exports(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $b9a4763f536f329f$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $18a18427f3d6914e$exports(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $b9a4763f536f329f$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $18a18427f3d6914e$exports(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $b9a4763f536f329f$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $18a18427f3d6914e$exports(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $b9a4763f536f329f$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $b9a4763f536f329f$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $b9a4763f536f329f$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $b9a4763f536f329f$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $b9a4763f536f329f$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $b9a4763f536f329f$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $835decef46f26c5e$exports({
        data: sortedChildren
    }, node);
    return newNode;
}
$b9a4763f536f329f$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $b9a4763f536f329f$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $b9a4763f536f329f$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($e49c9a312dceb9b5$exports(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $b9a4763f536f329f$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $b9a4763f536f329f$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $b9a4763f536f329f$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $835decef46f26c5e$exports(opts, {
        sortBy: $b9a4763f536f329f$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $b9a4763f536f329f$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $b9a4763f536f329f$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $b9a4763f536f329f$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $42d739a744cbfc0c$exports(options.sortBy, $b9a4763f536f329f$var$SearchResults.DEFAULT_SORT);
            return $e49c9a312dceb9b5$exports(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $b9a4763f536f329f$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $b9a4763f536f329f$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $b9a4763f536f329f$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $b9a4763f536f329f$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $b9a4763f536f329f$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $18a18427f3d6914e$exports(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $b9a4763f536f329f$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($b9a4763f536f329f$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($b9a4763f536f329f$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($b9a4763f536f329f$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($b9a4763f536f329f$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $b9a4763f536f329f$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $18a18427f3d6914e$exports(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $b9a4763f536f329f$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $18a18427f3d6914e$exports(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $18a18427f3d6914e$exports(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
$b9a4763f536f329f$exports = $b9a4763f536f329f$var$SearchResults;


var $80b82b1113590c35$exports = {};
"use strict";

var $e2829d966c35c18a$exports = {};
// @MAJOR: remove this function and use Array.prototype.flat
$e2829d966c35c18a$exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};


function $80b82b1113590c35$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $80b82b1113590c35$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $80b82b1113590c35$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $18a18427f3d6914e$exports($e2829d966c35c18a$exports(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
$80b82b1113590c35$exports = $80b82b1113590c35$var$sortAndMergeRecommendations;



var $hUnSM = parcelRequire("hUnSM");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $ab905b70bbf6a740$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $hUnSM + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $b98b552440c412c7$exports.make(opts);
    this.recommendState = new $336fa3444e711b93$exports({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$6c0c921167d16aa0$exports($ab905b70bbf6a740$var$AlgoliaSearchHelper, $d2f3ec49777c2f55$exports);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $c2fb9d98022cd5ed$exports._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $c2fb9d98022cd5ed$exports._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $b9a4763f536f329f$exports(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $b9a4763f536f329f$exports(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $5223709f7c606ea7$exports({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $d5a032e94ef65cbb$exports($c2fb9d98022cd5ed$exports._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $c2fb9d98022cd5ed$exports.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $ab905b70bbf6a740$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $ab905b70bbf6a740$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setCurrentPage = $ab905b70bbf6a740$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setPage = $ab905b70bbf6a740$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $b98b552440c412c7$exports.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $b98b552440c412c7$exports(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($c0c10d49c54a249b$exports(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $ab905b70bbf6a740$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getCurrentPage = $ab905b70bbf6a740$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getPage = $ab905b70bbf6a740$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $c2fb9d98022cd5ed$exports._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $c2fb9d98022cd5ed$exports._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $336fa3444e711b93$exports());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $b9a4763f536f329f$exports(state, specificResults, self._searchResultsOptions);
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $80b82b1113590c35$exports(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $2f1ad7c174e74881$exports(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $hUnSM + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $b57af9a08b47e48e$exports(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $ab905b70bbf6a740$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ $ab905b70bbf6a740$exports = $ab905b70bbf6a740$var$AlgoliaSearchHelper;






/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $6c359160e6887998$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $ab905b70bbf6a740$exports(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $6c359160e6887998$var$algoliasearchHelper.version = (parcelRequire("hUnSM"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $6c359160e6887998$var$algoliasearchHelper.AlgoliaSearchHelper = $ab905b70bbf6a740$exports;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $6c359160e6887998$var$algoliasearchHelper.SearchParameters = $b98b552440c412c7$exports;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $6c359160e6887998$var$algoliasearchHelper.RecommendParameters = $336fa3444e711b93$exports;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $6c359160e6887998$var$algoliasearchHelper.SearchResults = $b9a4763f536f329f$exports;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $6c359160e6887998$var$algoliasearchHelper.RecommendResults = $2f1ad7c174e74881$exports;
$6c359160e6887998$exports = $6c359160e6887998$var$algoliasearchHelper;



// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $22d7156510102177$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}

// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $f99d383d75eac38e$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = "x-algolia-application-id";
        var API_KEY = "x-algolia-api-key";
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

function $dba781b2f4cd6c52$export$8793edee2d425525() {}


/**
 * Create UUID according to
 * https://www.ietf.org/rfc/rfc4122.txt.
 *
 * @returns Generated UUID.
 */ function $4d35a4718decc046$export$5dbf9a24b655dde4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        /* eslint-disable no-bitwise */ var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        /* eslint-enable */ return v.toString(16);
    });
}


function $9a5b72f3416804f0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9a5b72f3416804f0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9a5b72f3416804f0$var$_typeof(obj);
}
function $9a5b72f3416804f0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9a5b72f3416804f0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9a5b72f3416804f0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9a5b72f3416804f0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9a5b72f3416804f0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9a5b72f3416804f0$var$_defineProperty(obj, key, value) {
    key = $9a5b72f3416804f0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9a5b72f3416804f0$var$_toPropertyKey(arg) {
    var key = $9a5b72f3416804f0$var$_toPrimitive(arg, "string");
    return $9a5b72f3416804f0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9a5b72f3416804f0$var$_toPrimitive(input, hint) {
    if ($9a5b72f3416804f0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9a5b72f3416804f0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9a5b72f3416804f0$var$_slicedToArray(arr, i) {
    return $9a5b72f3416804f0$var$_arrayWithHoles(arr) || $9a5b72f3416804f0$var$_iterableToArrayLimit(arr, i) || $9a5b72f3416804f0$var$_unsupportedIterableToArray(arr, i) || $9a5b72f3416804f0$var$_nonIterableRest();
}
function $9a5b72f3416804f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a5b72f3416804f0$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $9a5b72f3416804f0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9a5b72f3416804f0$var$_toConsumableArray(arr) {
    return $9a5b72f3416804f0$var$_arrayWithoutHoles(arr) || $9a5b72f3416804f0$var$_iterableToArray(arr) || $9a5b72f3416804f0$var$_unsupportedIterableToArray(arr) || $9a5b72f3416804f0$var$_nonIterableSpread();
}
function $9a5b72f3416804f0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9a5b72f3416804f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9a5b72f3416804f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9a5b72f3416804f0$var$_arrayLikeToArray(o, minLen);
}
function $9a5b72f3416804f0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9a5b72f3416804f0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9a5b72f3416804f0$var$_arrayLikeToArray(arr);
}
function $9a5b72f3416804f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $9a5b72f3416804f0$var$ALGOLIA_INSIGHTS_VERSION = "2.17.2";
var $9a5b72f3416804f0$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($9a5b72f3416804f0$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $9a5b72f3416804f0$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $9a5b72f3416804f0$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $dba781b2f4cd6c52$export$8793edee2d425525);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === "ais.insights" && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $9a5b72f3416804f0$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $f99d383d75eac38e$export$58f35ab8a1251bc0)(instantSearchInstance.client), _getAppIdAndApiKey2 = $9a5b72f3416804f0$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedInitParams = undefined;
        var queuedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                "setUserToken",
                "init"
            ].map(function(key) {
                var _ref3 = (0, $22d7156510102177$export$71aa6c912b956294)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $9a5b72f3416804f0$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $9a5b72f3416804f0$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $9a5b72f3416804f0$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedInitParams = _map2[1];
        }
        // If user called `aa('setUserToken')` before creating the Insights middleware,
        // we temporarily store the token and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient("getUserToken", null, function(_error, userToken) {
            userTokenBeforeInit = $9a5b72f3416804f0$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$9a5b72f3416804f0$var$isModernInsightsClient(insightsClient)) insightsClient("init", $9a5b72f3416804f0$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: "ais.insights",
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                try {
                    var script = document.createElement("script");
                    script.async = true;
                    script.src = $9a5b72f3416804f0$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit("error", new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit("error", new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient("addAlgoliaAgent", "insights-middleware");
                helper = instantSearchInstance.mainHelper;
                var queueAtStart = insightsClient.queue;
                if (Array.isArray(queueAtStart)) {
                    var _map3 = [
                        "setUserToken",
                        "init"
                    ].map(function(key) {
                        var _ref7 = (0, $22d7156510102177$export$71aa6c912b956294)(queueAtStart.slice().reverse(), function(_ref9) {
                            var _ref10 = $9a5b72f3416804f0$var$_slicedToArray(_ref9, 1), method = _ref10[0];
                            return method === key;
                        }) || [], _ref8 = $9a5b72f3416804f0$var$_slicedToArray(_ref7, 2), value = _ref8[1];
                        return value;
                    });
                    var _map4 = $9a5b72f3416804f0$var$_slicedToArray(_map3, 2);
                    queuedUserToken = _map4[0];
                    queuedInitParams = _map4[1];
                }
                initialParameters = $9a5b72f3416804f0$var$getInitialParameters(instantSearchInstance);
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($9a5b72f3416804f0$var$_objectSpread($9a5b72f3416804f0$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $9a5b72f3416804f0$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($9a5b72f3416804f0$var$_objectSpread($9a5b72f3416804f0$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                function setUserToken(token) {
                    setUserTokenToSearch(token, true);
                    insightsClient("setUserToken", token);
                }
                var anonymousUserToken = undefined;
                var anonymousTokenFromInsights = (0, $f2f086fa702b7d9c$export$61f1c6e9cd2ed687)();
                if (anonymousTokenFromInsights) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken on instantsearch and insights. If it's not set as an insights
                // userToken before a sendEvent, insights automatically generates a new anonymous token,
                // causing a state change and an unnecessary query on instantsearch.
                anonymousUserToken = anonymousTokenFromInsights;
                else {
                    var token = "anonymous-".concat((0, $4d35a4718decc046$export$5dbf9a24b655dde4)());
                    anonymousUserToken = token;
                }
                var userTokenFromInit;
                // With SSR, the token could be be set on the state. We make sure
                // that insights is in sync with that token since, there is no
                // insights lib on the server.
                var tokenFromSearchParameters = initialParameters.userToken;
                // When the first query is sent, the token is possibly not yet set by
                // the insights onChange callbacks (if insights isn't yet loaded).
                // It is explicitly being set here so that the first query has the
                // initial tokens set and ensure a second query isn't automatically
                // made when the onChange callback actually changes the state.
                if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.userToken) userTokenFromInit = insightsInitParams.userToken;
                if (userTokenFromInit) setUserToken(userTokenFromInit);
                else if (tokenFromSearchParameters) setUserToken(tokenFromSearchParameters);
                else if (userTokenBeforeInit) setUserToken(userTokenBeforeInit);
                else if (queuedUserToken) setUserToken(queuedUserToken);
                else if (anonymousUserToken) {
                    var _queuedInitParams;
                    setUserToken(anonymousUserToken);
                    if (insightsInitParams !== null && insightsInitParams !== void 0 && insightsInitParams.useCookie || (_queuedInitParams = queuedInitParams) !== null && _queuedInitParams !== void 0 && _queuedInitParams.useCookie) {
                        var _queuedInitParams2;
                        $9a5b72f3416804f0$var$saveTokenAsCookie(anonymousUserToken, (insightsInitParams === null || insightsInitParams === void 0 ? void 0 : insightsInitParams.cookieDuration) || ((_queuedInitParams2 = queuedInitParams) === null || _queuedInitParams2 === void 0 ? void 0 : _queuedInitParams2.cookieDuration));
                    }
                }
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient("onUserTokenChange", function(token) {
                    return setUserTokenToSearch(token, true);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($9a5b72f3416804f0$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var extraParams = {
                        headers: {
                            "X-Algolia-Application-Id": appId,
                            "X-Algolia-API-Key": apiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                var viewedObjectIDs = new Set();
                var lastQueryId;
                instantSearchInstance.mainHelper.derivedHelpers[0].on("result", function(_ref11) {
                    var results = _ref11.results;
                    if (results && (!results.queryID || results.queryID !== lastQueryId)) {
                        lastQueryId = results.queryID;
                        viewedObjectIDs.clear();
                    }
                });
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        if (event.insightsMethod === "viewedObjectIDs") {
                            var _payload = event.payload;
                            var difference = _payload.objectIDs.filter(function(objectID) {
                                return !viewedObjectIDs.has(objectID);
                            });
                            if (difference.length === 0) return;
                            difference.forEach(function(objectID) {
                                return viewedObjectIDs.add(objectID);
                            });
                            _payload.objectIDs = difference;
                        }
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            "instantsearch"
                        ];
                        if ($$automatic) event.payload.algoliaSource.push("instantsearch-automatic");
                        if (event.eventModifier === "internal") event.payload.algoliaSource.push("instantsearch-internal");
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient("onUserTokenChange", undefined);
                instantSearchInstance.sendEventToInsights = (0, $dba781b2f4cd6c52$export$8793edee2d425525);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($9a5b72f3416804f0$var$_objectSpread($9a5b72f3416804f0$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
function $9a5b72f3416804f0$var$getInitialParameters(instantSearchInstance) {
    var _instantSearchInstanc, _instantSearchInstanc2;
    // in SSR, the initial state we use in this domain is set on the main index
    var stateFromInitialResults = ((_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : (_instantSearchInstanc2 = _instantSearchInstanc[instantSearchInstance.indexName]) === null || _instantSearchInstanc2 === void 0 ? void 0 : _instantSearchInstanc2.state) || {};
    var stateFromHelper = instantSearchInstance.mainHelper.state;
    return {
        userToken: stateFromInitialResults.userToken || stateFromHelper.userToken,
        clickAnalytics: stateFromInitialResults.clickAnalytics || stateFromHelper.clickAnalytics
    };
}
function $9a5b72f3416804f0$var$saveTokenAsCookie(token, cookieDuration) {
    var MONTH = 2592000000;
    var d = new Date();
    d.setTime(d.getTime() + (cookieDuration || MONTH * 6));
    var expires = "expires=".concat(d.toUTCString());
    document.cookie = "_ALGOLIA=".concat(token, ";").concat(expires, ";path=/");
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $9a5b72f3416804f0$var$isModernInsightsClient(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $9a5b72f3416804f0$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $9a5b72f3416804f0$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === "number" ? userToken.toString() : userToken;
}


function $d07e2cee6bb110b2$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $d07e2cee6bb110b2$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && "_state" in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}


function $de3e1eace8c55644$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $d07e2cee6bb110b2$export$dbf1227de6c1fbc6)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $de3e1eace8c55644$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $de3e1eace8c55644$export$4b4254890acf93e7() {
    return (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("Algolia Crawler")) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $de3e1eace8c55644$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            $$type: "ais.metadata",
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $de3e1eace8c55644$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}


var $eb6f7fc63f627fea$exports = {};
"use strict";
var $21a857f2c632f015$exports = {};
"use strict";
var $c28806fde4f5d743$exports = {};
"use strict";
var $e77cc7fa9fbe3dde$exports = {};
"use strict";
var $e77cc7fa9fbe3dde$var$replace = String.prototype.replace;
var $e77cc7fa9fbe3dde$var$percentTwenties = /%20/g;
var $e77cc7fa9fbe3dde$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$e77cc7fa9fbe3dde$exports = {
    "default": $e77cc7fa9fbe3dde$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $e77cc7fa9fbe3dde$var$replace.call(value, $e77cc7fa9fbe3dde$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $e77cc7fa9fbe3dde$var$Format.RFC1738,
    RFC3986: $e77cc7fa9fbe3dde$var$Format.RFC3986
};


var $c28806fde4f5d743$var$has = Object.prototype.hasOwnProperty;
var $c28806fde4f5d743$var$isArray = Array.isArray;
var $c28806fde4f5d743$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $c28806fde4f5d743$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($c28806fde4f5d743$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $c28806fde4f5d743$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $c28806fde4f5d743$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($c28806fde4f5d743$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$c28806fde4f5d743$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($c28806fde4f5d743$var$isArray(target) && !$c28806fde4f5d743$var$isArray(source)) mergeTarget = $c28806fde4f5d743$var$arrayToObject(target, options);
    if ($c28806fde4f5d743$var$isArray(target) && $c28806fde4f5d743$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($c28806fde4f5d743$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($c28806fde4f5d743$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $c28806fde4f5d743$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $c28806fde4f5d743$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $c28806fde4f5d743$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $e77cc7fa9fbe3dde$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $c28806fde4f5d743$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($c28806fde4f5d743$var$hexTable[0xC0 | c >> 6] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($c28806fde4f5d743$var$hexTable[0xE0 | c >> 12] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $c28806fde4f5d743$var$hexTable[0xF0 | c >> 18] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 12 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $c28806fde4f5d743$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $c28806fde4f5d743$var$compactQueue(queue);
    return value;
};
var $c28806fde4f5d743$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $c28806fde4f5d743$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $c28806fde4f5d743$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $c28806fde4f5d743$var$maybeMap = function maybeMap(val, fn) {
    if ($c28806fde4f5d743$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$c28806fde4f5d743$exports = {
    arrayToObject: $c28806fde4f5d743$var$arrayToObject,
    assign: $c28806fde4f5d743$var$assign,
    combine: $c28806fde4f5d743$var$combine,
    compact: $c28806fde4f5d743$var$compact,
    decode: $c28806fde4f5d743$var$decode,
    encode: $c28806fde4f5d743$var$encode,
    isBuffer: $c28806fde4f5d743$var$isBuffer,
    isRegExp: $c28806fde4f5d743$var$isRegExp,
    maybeMap: $c28806fde4f5d743$var$maybeMap,
    merge: $c28806fde4f5d743$var$merge
};



var $21a857f2c632f015$var$has = Object.prototype.hasOwnProperty;
var $21a857f2c632f015$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $21a857f2c632f015$var$isArray = Array.isArray;
var $21a857f2c632f015$var$split = String.prototype.split;
var $21a857f2c632f015$var$push = Array.prototype.push;
var $21a857f2c632f015$var$pushToArray = function(arr, valueOrArray) {
    $21a857f2c632f015$var$push.apply(arr, $21a857f2c632f015$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $21a857f2c632f015$var$toISO = Date.prototype.toISOString;
var $21a857f2c632f015$var$defaultFormat = $e77cc7fa9fbe3dde$exports.default;
var $21a857f2c632f015$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $c28806fde4f5d743$exports.encode,
    encodeValuesOnly: false,
    format: $21a857f2c632f015$var$defaultFormat,
    formatter: $e77cc7fa9fbe3dde$exports.formatters[$21a857f2c632f015$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $21a857f2c632f015$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $21a857f2c632f015$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $21a857f2c632f015$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) obj = $c28806fde4f5d743$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($21a857f2c632f015$var$isNonNullishPrimitive(obj) || $c28806fde4f5d743$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $21a857f2c632f015$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $21a857f2c632f015$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $21a857f2c632f015$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($21a857f2c632f015$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $21a857f2c632f015$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        $21a857f2c632f015$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $21a857f2c632f015$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $21a857f2c632f015$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $21a857f2c632f015$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $e77cc7fa9fbe3dde$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$21a857f2c632f015$var$has.call($e77cc7fa9fbe3dde$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $e77cc7fa9fbe3dde$exports.formatters[format];
    var filter = $21a857f2c632f015$var$defaults.filter;
    if (typeof opts.filter === "function" || $21a857f2c632f015$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $21a857f2c632f015$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $21a857f2c632f015$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $21a857f2c632f015$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $21a857f2c632f015$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $21a857f2c632f015$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $21a857f2c632f015$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $21a857f2c632f015$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $21a857f2c632f015$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $21a857f2c632f015$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $21a857f2c632f015$var$defaults.strictNullHandling
    };
};
$21a857f2c632f015$exports = function(object, opts) {
    var obj = object;
    var options = $21a857f2c632f015$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($21a857f2c632f015$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $21a857f2c632f015$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $21a857f2c632f015$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $21a857f2c632f015$var$pushToArray(keys, $21a857f2c632f015$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $85c239e60adf14b2$exports = {};
"use strict";

var $85c239e60adf14b2$var$has = Object.prototype.hasOwnProperty;
var $85c239e60adf14b2$var$isArray = Array.isArray;
var $85c239e60adf14b2$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $c28806fde4f5d743$exports.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $85c239e60adf14b2$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $85c239e60adf14b2$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $85c239e60adf14b2$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $85c239e60adf14b2$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $85c239e60adf14b2$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $85c239e60adf14b2$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $85c239e60adf14b2$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = $c28806fde4f5d743$exports.maybeMap($85c239e60adf14b2$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $85c239e60adf14b2$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $85c239e60adf14b2$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $85c239e60adf14b2$var$isArray(val) ? [
            val
        ] : val;
        if ($85c239e60adf14b2$var$has.call(obj, key)) obj[key] = $c28806fde4f5d743$exports.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $85c239e60adf14b2$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $85c239e60adf14b2$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $85c239e60adf14b2$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $85c239e60adf14b2$var$parseObject(keys, val, options, valuesParsed);
};
var $85c239e60adf14b2$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $85c239e60adf14b2$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $85c239e60adf14b2$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $85c239e60adf14b2$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $85c239e60adf14b2$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $85c239e60adf14b2$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $85c239e60adf14b2$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $85c239e60adf14b2$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $85c239e60adf14b2$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $c28806fde4f5d743$exports.isRegExp(opts.delimiter) ? opts.delimiter : $85c239e60adf14b2$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $85c239e60adf14b2$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $85c239e60adf14b2$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $85c239e60adf14b2$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $85c239e60adf14b2$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $85c239e60adf14b2$var$defaults.strictNullHandling
    };
};
$85c239e60adf14b2$exports = function(str, opts) {
    var options = $85c239e60adf14b2$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $85c239e60adf14b2$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $85c239e60adf14b2$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $c28806fde4f5d743$exports.merge(obj, newObj, options);
    }
    return $c28806fde4f5d743$exports.compact(obj);
};



$eb6f7fc63f627fea$exports = {
    formats: $e77cc7fa9fbe3dde$exports,
    parse: $85c239e60adf14b2$exports,
    stringify: $21a857f2c632f015$exports
};



function $0df67baa85c927c4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0df67baa85c927c4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0df67baa85c927c4$var$_typeof(obj);
}
function $0df67baa85c927c4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0df67baa85c927c4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $0df67baa85c927c4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $0df67baa85c927c4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0df67baa85c927c4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0df67baa85c927c4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $0df67baa85c927c4$var$_defineProperty(obj, key, value) {
    key = $0df67baa85c927c4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0df67baa85c927c4$var$_toPropertyKey(arg) {
    var key = $0df67baa85c927c4$var$_toPrimitive(arg, "string");
    return $0df67baa85c927c4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0df67baa85c927c4$var$_toPrimitive(input, hint) {
    if ($0df67baa85c927c4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0df67baa85c927c4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $0df67baa85c927c4$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $0df67baa85c927c4$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $0df67baa85c927c4$var$_classCallCheck(this, BrowserHistory);
        $0df67baa85c927c4$var$_defineProperty(this, "$$type", "ais.browser");
        /**
     * Transforms a UI state into a title for the page.
     */ $0df67baa85c927c4$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $0df67baa85c927c4$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $0df67baa85c927c4$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $0df67baa85c927c4$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $0df67baa85c927c4$var$_defineProperty(this, "getLocation", void 0);
        $0df67baa85c927c4$var$_defineProperty(this, "writeTimer", void 0);
        $0df67baa85c927c4$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $0df67baa85c927c4$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $0df67baa85c927c4$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $0df67baa85c927c4$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $0df67baa85c927c4$var$_defineProperty(this, "_start", void 0);
        $0df67baa85c927c4$var$_defineProperty(this, "_dispose", void 0);
        $0df67baa85c927c4$var$_defineProperty(this, "_push", void 0);
        $0df67baa85c927c4$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === "undefined" ? true : cleanUrlOnDispose;
        (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $0df67baa85c927c4$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $0df67baa85c927c4$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($eb6f7fc63f627fea$exports))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $0df67baa85c927c4$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || "", url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener("popstate", _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($eb6f7fc63f627fea$exports))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener("popstate", _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $0df67baa85c927c4$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function() {
        return (0, $ae549b2844b692c1$export$39f19eed34acd2f1)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $0df67baa85c927c4$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}


function $8bf1b0cf99a6caf0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8bf1b0cf99a6caf0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8bf1b0cf99a6caf0$var$_typeof(obj);
}
var $8bf1b0cf99a6caf0$var$_excluded = [
    "configure"
];
function $8bf1b0cf99a6caf0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8bf1b0cf99a6caf0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8bf1b0cf99a6caf0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8bf1b0cf99a6caf0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8bf1b0cf99a6caf0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8bf1b0cf99a6caf0$var$_defineProperty(obj, key, value) {
    key = $8bf1b0cf99a6caf0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8bf1b0cf99a6caf0$var$_toPropertyKey(arg) {
    var key = $8bf1b0cf99a6caf0$var$_toPrimitive(arg, "string");
    return $8bf1b0cf99a6caf0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8bf1b0cf99a6caf0$var$_toPrimitive(input, hint) {
    if ($8bf1b0cf99a6caf0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8bf1b0cf99a6caf0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8bf1b0cf99a6caf0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bf1b0cf99a6caf0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8bf1b0cf99a6caf0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8bf1b0cf99a6caf0$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $8bf1b0cf99a6caf0$var$_objectWithoutProperties(uiState, $8bf1b0cf99a6caf0$var$_excluded);
    return trackedUiState;
}
function $8bf1b0cf99a6caf0$export$2e2bcd8739ae039() {
    return {
        $$type: "ais.simple",
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $8bf1b0cf99a6caf0$var$_objectSpread($8bf1b0cf99a6caf0$var$_objectSpread({}, state), {}, $8bf1b0cf99a6caf0$var$_defineProperty({}, indexId, $8bf1b0cf99a6caf0$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $8bf1b0cf99a6caf0$var$_objectSpread($8bf1b0cf99a6caf0$var$_objectSpread({}, state), {}, $8bf1b0cf99a6caf0$var$_defineProperty({}, indexId, $8bf1b0cf99a6caf0$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}



function $cdb20223dbd2984c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cdb20223dbd2984c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cdb20223dbd2984c$var$_typeof(obj);
}
function $cdb20223dbd2984c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cdb20223dbd2984c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cdb20223dbd2984c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cdb20223dbd2984c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cdb20223dbd2984c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cdb20223dbd2984c$var$_defineProperty(obj, key, value) {
    key = $cdb20223dbd2984c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cdb20223dbd2984c$var$_toPropertyKey(arg) {
    var key = $cdb20223dbd2984c$var$_toPrimitive(arg, "string");
    return $cdb20223dbd2984c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cdb20223dbd2984c$var$_toPrimitive(input, hint) {
    if ($cdb20223dbd2984c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cdb20223dbd2984c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $cdb20223dbd2984c$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $0df67baa85c927c4$export$2e2bcd8739ae039)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $8bf1b0cf99a6caf0$export$2e2bcd8739ae039)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $cdb20223dbd2984c$var$_objectSpread($cdb20223dbd2984c$var$_objectSpread({}, acc), {}, $cdb20223dbd2984c$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || "__unknown__", ", stateMapping:").concat(stateMapping.$$type || "__unknown__", "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $4198f5cd959b5a7d$export$248d38f6296296c5)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $cdb20223dbd2984c$var$_objectSpread($cdb20223dbd2984c$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};



function $049fad80b24500a5$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
}
function $049fad80b24500a5$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $049fad80b24500a5$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
}

function $4e36965025504545$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}

// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $cd83db18a2b50813$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}


function $6b9ab3bbb605ca60$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}


function $cdcc1435cfc6072b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cdcc1435cfc6072b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cdcc1435cfc6072b$var$_typeof(obj);
}
var $cdcc1435cfc6072b$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $cdcc1435cfc6072b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cdcc1435cfc6072b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cdcc1435cfc6072b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cdcc1435cfc6072b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cdcc1435cfc6072b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cdcc1435cfc6072b$var$_defineProperty(obj, key, value) {
    key = $cdcc1435cfc6072b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cdcc1435cfc6072b$var$_toPropertyKey(arg) {
    var key = $cdcc1435cfc6072b$var$_toPrimitive(arg, "string");
    return $cdcc1435cfc6072b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cdcc1435cfc6072b$var$_toPrimitive(input, hint) {
    if ($cdcc1435cfc6072b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cdcc1435cfc6072b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cdcc1435cfc6072b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cdcc1435cfc6072b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cdcc1435cfc6072b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cdcc1435cfc6072b$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $cdcc1435cfc6072b$var$_objectWithoutProperties(right, $cdcc1435cfc6072b$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $cdcc1435cfc6072b$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $cdcc1435cfc6072b$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $cdcc1435cfc6072b$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $cd83db18a2b50813$export$de3a4d4a0d731119)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $cdcc1435cfc6072b$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $cdcc1435cfc6072b$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $cdcc1435cfc6072b$var$_objectSpread($cdcc1435cfc6072b$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $cdcc1435cfc6072b$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $cdcc1435cfc6072b$var$_objectSpread($cdcc1435cfc6072b$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $cdcc1435cfc6072b$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $cdcc1435cfc6072b$var$_objectSpread($cdcc1435cfc6072b$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $cdcc1435cfc6072b$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $cdcc1435cfc6072b$var$_objectSpread($cdcc1435cfc6072b$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $cdcc1435cfc6072b$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $cdcc1435cfc6072b$var$_objectSpread($cdcc1435cfc6072b$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $cdcc1435cfc6072b$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $6b9ab3bbb605ca60$export$f70730c3d1fc524e)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $cdcc1435cfc6072b$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $cdcc1435cfc6072b$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $cdcc1435cfc6072b$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $cdcc1435cfc6072b$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $cdcc1435cfc6072b$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $cdcc1435cfc6072b$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $cdcc1435cfc6072b$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $cdcc1435cfc6072b$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $cdcc1435cfc6072b$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $cdcc1435cfc6072b$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $cdcc1435cfc6072b$var$mergeFacets(ruleContextsMerged, right);
        return $cdcc1435cfc6072b$var$mergeWithRest(facetsMerged, right);
    });
};

function $28b51c9a5f8547cf$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}


var $cb0a0ad2d4c281cb$var$id = 0;
function $cb0a0ad2d4c281cb$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== "recommend") return;
    widget.$$id = $cb0a0ad2d4c281cb$var$id++;
}
function $cb0a0ad2d4c281cb$export$13e2e3d76152aecf() {
    $cb0a0ad2d4c281cb$var$id = 0;
}


function $bbcafcaaf02907c9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bbcafcaaf02907c9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bbcafcaaf02907c9$var$_typeof(obj);
}
var $bbcafcaaf02907c9$var$_excluded = [
    "initialSearchParameters"
], $bbcafcaaf02907c9$var$_excluded2 = [
    "initialRecommendParameters"
];
function $bbcafcaaf02907c9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbcafcaaf02907c9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbcafcaaf02907c9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbcafcaaf02907c9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbcafcaaf02907c9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbcafcaaf02907c9$var$_defineProperty(obj, key, value) {
    key = $bbcafcaaf02907c9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbcafcaaf02907c9$var$_toPropertyKey(arg) {
    var key = $bbcafcaaf02907c9$var$_toPrimitive(arg, "string");
    return $bbcafcaaf02907c9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bbcafcaaf02907c9$var$_toPrimitive(input, hint) {
    if ($bbcafcaaf02907c9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bbcafcaaf02907c9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bbcafcaaf02907c9$var$_toConsumableArray(arr) {
    return $bbcafcaaf02907c9$var$_arrayWithoutHoles(arr) || $bbcafcaaf02907c9$var$_iterableToArray(arr) || $bbcafcaaf02907c9$var$_unsupportedIterableToArray(arr) || $bbcafcaaf02907c9$var$_nonIterableSpread();
}
function $bbcafcaaf02907c9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bbcafcaaf02907c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bbcafcaaf02907c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bbcafcaaf02907c9$var$_arrayLikeToArray(o, minLen);
}
function $bbcafcaaf02907c9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bbcafcaaf02907c9$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bbcafcaaf02907c9$var$_arrayLikeToArray(arr);
}
function $bbcafcaaf02907c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bbcafcaaf02907c9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbcafcaaf02907c9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bbcafcaaf02907c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bbcafcaaf02907c9$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "index-widget"
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $bbcafcaaf02907c9$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $bbcafcaaf02907c9$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $4e36965025504545$export$a9c9a0d43506297d)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $bbcafcaaf02907c9$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $bbcafcaaf02907c9$var$_objectWithoutProperties(widgetSearchParametersOptions, $bbcafcaaf02907c9$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $4e36965025504545$export$a9c9a0d43506297d)(widget)) return state;
        if (widget.dependsOn === "search" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $bbcafcaaf02907c9$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $bbcafcaaf02907c9$var$_objectWithoutProperties(widgetRecommendParametersOptions, $bbcafcaaf02907c9$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $4e36965025504545$export$a9c9a0d43506297d)(widget) && widget.dependsOn === "recommend" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $bbcafcaaf02907c9$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $4e36965025504545$export$a9c9a0d43506297d));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $bbcafcaaf02907c9$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $bbcafcaaf02907c9$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $bbcafcaaf02907c9$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $4e36965025504545$export$a9c9a0d43506297d));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($bbcafcaaf02907c9$var$_toConsumableArray($bbcafcaaf02907c9$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $bbcafcaaf02907c9$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($bbcafcaaf02907c9$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== "recommend" || (0, $4e36965025504545$export$a9c9a0d43506297d)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $bbcafcaaf02907c9$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === "function") return localInstantSearchInstance._createURL($bbcafcaaf02907c9$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($bbcafcaaf02907c9$var$_defineProperty({}, indexId, $bbcafcaaf02907c9$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($bbcafcaaf02907c9$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($bbcafcaaf02907c9$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            widgets.forEach(function(widget) {
                if ((0, $4e36965025504545$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $cb0a0ad2d4c281cb$export$50b3ac0e47148c0b)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $bbcafcaaf02907c9$var$privateHelperSetState(helper, {
                    state: $bbcafcaaf02907c9$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $bbcafcaaf02907c9$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $d07e2cee6bb110b2$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $bbcafcaaf02907c9$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $d07e2cee6bb110b2$export$dbf1227de6c1fbc6)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($bbcafcaaf02907c9$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($bbcafcaaf02907c9$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $4e36965025504545$export$a9c9a0d43506297d)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $bbcafcaaf02907c9$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $bbcafcaaf02907c9$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $bbcafcaaf02907c9$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $bbcafcaaf02907c9$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $bbcafcaaf02907c9$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $bbcafcaaf02907c9$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $cdcc1435cfc6072b$export$8049d91f25899769).apply(void 0, [
                    mainHelper.state
                ].concat($bbcafcaaf02907c9$var$_toConsumableArray((0, $28b51c9a5f8547cf$export$1c33c9881dac6797)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $bbcafcaaf02907c9$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on("recommend:result", function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $d07e2cee6bb110b2$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
                    $bbcafcaaf02907c9$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $d07e2cee6bb110b2$export$dbf1227de6c1fbc6)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $bbcafcaaf02907c9$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === "error" && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $4e36965025504545$export$a9c9a0d43506297d));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $d07e2cee6bb110b2$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
                    $bbcafcaaf02907c9$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $d07e2cee6bb110b2$export$c3ba97e79c76dd38)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $4e36965025504545$export$a9c9a0d43506297d)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $bbcafcaaf02907c9$var$_objectSpread($bbcafcaaf02907c9$var$_objectSpread({}, uiState), {}, $bbcafcaaf02907c9$var$_defineProperty({}, indexId, $bbcafcaaf02907c9$var$_objectSpread($bbcafcaaf02907c9$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $bbcafcaaf02907c9$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $bbcafcaaf02907c9$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === "function" ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $bbcafcaaf02907c9$var$_objectSpread($bbcafcaaf02907c9$var$_objectSpread({}, state), {}, $bbcafcaaf02907c9$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $bbcafcaaf02907c9$export$2e2bcd8739ae039 = $bbcafcaaf02907c9$var$index;
function $bbcafcaaf02907c9$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $bbcafcaaf02907c9$var$_objectSpread($bbcafcaaf02907c9$var$_objectSpread({}, instantSearchInstance.renderState), {}, $bbcafcaaf02907c9$var$_defineProperty({}, parentIndexName, $bbcafcaaf02907c9$var$_objectSpread($bbcafcaaf02907c9$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}



function $9fd7029b79ebbbfb$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}


function $1895b248d7928836$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1895b248d7928836$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1895b248d7928836$var$_typeof(obj);
}
function $1895b248d7928836$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1895b248d7928836$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1895b248d7928836$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1895b248d7928836$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1895b248d7928836$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1895b248d7928836$var$_defineProperty(obj, key, value) {
    key = $1895b248d7928836$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1895b248d7928836$var$_toPropertyKey(arg) {
    var key = $1895b248d7928836$var$_toPrimitive(arg, "string");
    return $1895b248d7928836$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1895b248d7928836$var$_toPrimitive(input, hint) {
    if ($1895b248d7928836$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1895b248d7928836$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1895b248d7928836$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $9fd7029b79ebbbfb$export$f5dd818bff069720)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $c84ade2a4f4913d0$export$2e2bcd8739ae039)($1895b248d7928836$var$_objectSpread($1895b248d7928836$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $a9544a7c7ea19d28$export$2e2bcd8739ae039)($1895b248d7928836$var$_objectSpread($1895b248d7928836$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $42f86c36b36dbd78$export$2e2bcd8739ae039)($1895b248d7928836$var$_objectSpread($1895b248d7928836$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $007f848d940fdaf1$export$2e2bcd8739ae039)($1895b248d7928836$var$_objectSpread($1895b248d7928836$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $62dc5ddd84fbc4d2$export$2e2bcd8739ae039)(method, $1895b248d7928836$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}


var $8830dcf7f3e53e85$var$nextMicroTask = Promise.resolve();
function $8830dcf7f3e53e85$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $8830dcf7f3e53e85$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

function $cc566cca07861f8f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cc566cca07861f8f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cc566cca07861f8f$var$_typeof(obj);
}
function $cc566cca07861f8f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cc566cca07861f8f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cc566cca07861f8f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cc566cca07861f8f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cc566cca07861f8f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cc566cca07861f8f$var$_defineProperty(obj, key, value) {
    key = $cc566cca07861f8f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc566cca07861f8f$var$_toPropertyKey(arg) {
    var key = $cc566cca07861f8f$var$_toPrimitive(arg, "string");
    return $cc566cca07861f8f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cc566cca07861f8f$var$_toPrimitive(input, hint) {
    if ($cc566cca07861f8f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cc566cca07861f8f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $cc566cca07861f8f$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $cc566cca07861f8f$var$_objectSpread($cc566cca07861f8f$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}

function $3c1136bf908d01a0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3c1136bf908d01a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3c1136bf908d01a0$var$_typeof(obj);
}
function $3c1136bf908d01a0$var$_slicedToArray(arr, i) {
    return $3c1136bf908d01a0$var$_arrayWithHoles(arr) || $3c1136bf908d01a0$var$_iterableToArrayLimit(arr, i) || $3c1136bf908d01a0$var$_unsupportedIterableToArray(arr, i) || $3c1136bf908d01a0$var$_nonIterableRest();
}
function $3c1136bf908d01a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3c1136bf908d01a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3c1136bf908d01a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3c1136bf908d01a0$var$_arrayLikeToArray(o, minLen);
}
function $3c1136bf908d01a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3c1136bf908d01a0$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $3c1136bf908d01a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3c1136bf908d01a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3c1136bf908d01a0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3c1136bf908d01a0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3c1136bf908d01a0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3c1136bf908d01a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3c1136bf908d01a0$var$_defineProperty(obj, key, value) {
    key = $3c1136bf908d01a0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c1136bf908d01a0$var$_toPropertyKey(arg) {
    var key = $3c1136bf908d01a0$var$_toPrimitive(arg, "string");
    return $3c1136bf908d01a0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3c1136bf908d01a0$var$_toPrimitive(input, hint) {
    if ($3c1136bf908d01a0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3c1136bf908d01a0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3c1136bf908d01a0$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!("transporter" in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== "function")) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $3c1136bf908d01a0$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $3c1136bf908d01a0$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $3c1136bf908d01a0$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ("transporter" in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        // @ts-ignore wanting type checks for v3 on this would make this too complex
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = requests.map(function(request) {
                return $3c1136bf908d01a0$var$_objectSpread($3c1136bf908d01a0$var$_objectSpread({}, request), {}, {
                    params: $3c1136bf908d01a0$var$serializeQueryParameters(request.params)
                });
            });
            return client.transporter.responsesCache.get({
                method: "search",
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: "search",
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!("transporter" in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $3c1136bf908d01a0$var$_objectSpread($3c1136bf908d01a0$var$_objectSpread({}, client.cache), {}, $3c1136bf908d01a0$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $3c1136bf908d01a0$var$deserializeQueryParameters(parameters) {
    return parameters.split("&").reduce(function(acc, parameter) {
        var _parameter$split = parameter.split("="), _parameter$split2 = $3c1136bf908d01a0$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $3c1136bf908d01a0$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join("&");
}



function $e00cc39de32ae775$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $4e36965025504545$export$a9c9a0d43506297d)).forEach(function(widget) {
        return $e00cc39de32ae775$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}


var $9bacbeef4c25f81e$export$2e2bcd8739ae039 = "4.75.6";


function $43df3178656874f3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $43df3178656874f3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $43df3178656874f3$var$_typeof(obj);
}
function $43df3178656874f3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $43df3178656874f3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $43df3178656874f3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $43df3178656874f3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $43df3178656874f3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $43df3178656874f3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43df3178656874f3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $43df3178656874f3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $43df3178656874f3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $43df3178656874f3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $43df3178656874f3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $43df3178656874f3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $43df3178656874f3$var$_setPrototypeOf(subClass, superClass);
}
function $43df3178656874f3$var$_setPrototypeOf(o, p) {
    $43df3178656874f3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $43df3178656874f3$var$_setPrototypeOf(o, p);
}
function $43df3178656874f3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $43df3178656874f3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $43df3178656874f3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $43df3178656874f3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $43df3178656874f3$var$_possibleConstructorReturn(this, result);
    };
}
function $43df3178656874f3$var$_possibleConstructorReturn(self, call) {
    if (call && ($43df3178656874f3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $43df3178656874f3$var$_assertThisInitialized(self);
}
function $43df3178656874f3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $43df3178656874f3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $43df3178656874f3$var$_getPrototypeOf(o) {
    $43df3178656874f3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $43df3178656874f3$var$_getPrototypeOf(o);
}
function $43df3178656874f3$var$_defineProperty(obj, key, value) {
    key = $43df3178656874f3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $43df3178656874f3$var$_toPropertyKey(arg) {
    var key = $43df3178656874f3$var$_toPrimitive(arg, "string");
    return $43df3178656874f3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $43df3178656874f3$var$_toPrimitive(input, hint) {
    if ($43df3178656874f3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($43df3178656874f3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $43df3178656874f3$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "instantsearch"
});
function $43df3178656874f3$var$defaultCreateURL() {
    return "#";
}
var $43df3178656874f3$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $43df3178656874f3$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $43df3178656874f3$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $43df3178656874f3$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $43df3178656874f3$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "client", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "indexName", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "onStateChange", null);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "future", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "helper", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "started", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "renderState", {});
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_createURL", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "_insights", void 0);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "middleware", []);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "status", "idle");
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "error", undefined);
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "scheduleSearch", (0, $8830dcf7f3e53e85$export$260e5c0943f31606)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "scheduleRender", (0, $8830dcf7f3e53e85$export$260e5c0943f31606)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = "idle";
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $43df3178656874f3$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $43df3178656874f3$var$_defineProperty($43df3178656874f3$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $8830dcf7f3e53e85$export$260e5c0943f31606)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? "" : _options$indexName, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $43df3178656874f3$var$_objectSpread($43df3178656874f3$var$_objectSpread({}, $43df3178656874f3$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($43df3178656874f3$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $9bacbeef4c25f81e$export$2e2bcd8739ae039), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($43df3178656874f3$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $bbcafcaaf02907c9$export$2e2bcd8739ae039)({
            indexName: indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $1895b248d7928836$export$2e2bcd8739ae039)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $43df3178656874f3$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $dba781b2f4cd6c52$export$8793edee2d425525);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $cdb20223dbd2984c$export$1fe5128387816284)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === "boolean" ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $9a5b72f3416804f0$export$91e0bf09562e2c44)(insightsOptions));
        }
        if ((0, $de3e1eace8c55644$export$4b4254890acf93e7)()) _this.use((0, $de3e1eace8c55644$export$8ee9d2447935ed96)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $43df3178656874f3$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === "stalled";
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $43df3178656874f3$var$_objectSpread({
                        $$type: "__unknown__",
                        $$internal: false,
                        subscribe: (0, $dba781b2f4cd6c52$export$8793edee2d425525),
                        started: (0, $dba781b2f4cd6c52$export$8793edee2d425525),
                        unsubscribe: (0, $dba781b2f4cd6c52$export$8793edee2d425525),
                        onStateChange: (0, $dba781b2f4cd6c52$export$8793edee2d425525)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($43df3178656874f3$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($43df3178656874f3$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($43df3178656874f3$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($43df3178656874f3$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($43df3178656874f3$var$withUsage("The `start` method has already been called once."));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                mainHelper.search = function() {
                    _this3.status = "loading";
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) mainHelper.searchOnlyWithDerivedHelpers();
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $dba781b2f4cd6c52$export$8793edee2d425525));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = "error";
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit("error", error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $3c1136bf908d01a0$export$7edf4eca27ca3a19)(this.client, this._initialResults);
                    (0, $cc566cca07861f8f$export$53ef00b131a96aa6)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $8830dcf7f3e53e85$export$260e5c0943f31606)((0, $dba781b2f4cd6c52$export$8793edee2d425525));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $8830dcf7f3e53e85$export$260e5c0943f31606)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === "undefined") mainHelper.derivedHelpers[0].once("result", function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $9a5b72f3416804f0$export$91e0bf09562e2c44)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = "stalled";
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($43df3178656874f3$var$withUsage("The `start` method needs to be called before `setUiState`."));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $e00cc39de32ae775$export$fd5e8f1329b3d5e0)(typeof finalUiState === "function" ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $e00cc39de32ae775$export$fd5e8f1329b3d5e0)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($43df3178656874f3$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($43df3178656874f3$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($d2f3ec49777c2f55$exports))));
var $43df3178656874f3$export$2e2bcd8739ae039 = $43df3178656874f3$var$InstantSearch;



/**
 * Logs a warning when this function is called, in development environment only.
 */ var $e4443cc2a1f06031$export$b680e6b2c82f8c2f = function deprecate(fn, message) {
    return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */ var $e4443cc2a1f06031$export$c106dd0671a0fc2d = (0, $dba781b2f4cd6c52$export$8793edee2d425525);
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */ var $e4443cc2a1f06031$export$491112666e282270 = (0, $dba781b2f4cd6c52$export$8793edee2d425525);




/**
 * InstantSearch is the main component of InstantSearch.js. This object
 * manages the widget and lets you add new ones.
 *
 * Two parameters are required to get you started with InstantSearch.js:
 *  - `indexName`: the main index that you will use for your new search UI
 *  - `searchClient`: the search client to plug to InstantSearch.js
 *
 * The [search client provided by Algolia](algolia.com/doc/api-client/getting-started/what-is-the-api-client/javascript/)
 * needs an `appId` and an `apiKey`. Those parameters can be found in your
 * [Algolia dashboard](https://www.algolia.com/api-keys).
 *
 * If you want to get up and running quickly with InstantSearch.js, have a
 * look at the [getting started](https://www.algolia.com/doc/guides/building-search-ui/getting-started/js/).
 */ var $9a68c624c672fabe$var$instantsearch = function instantsearch(options) {
    return new (0, $43df3178656874f3$export$2e2bcd8739ae039)(options);
};
$9a68c624c672fabe$var$instantsearch.version = (0, $9bacbeef4c25f81e$export$2e2bcd8739ae039);
$9a68c624c672fabe$var$instantsearch.createInfiniteHitsSessionStorageCache = (0, $e4443cc2a1f06031$export$b680e6b2c82f8c2f)((0, $58d1e602d478cf2f$export$2e2bcd8739ae039), "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
$9a68c624c672fabe$var$instantsearch.highlight = (0, $e4443cc2a1f06031$export$b680e6b2c82f8c2f)((0, $c84ade2a4f4913d0$export$2e2bcd8739ae039), "import { highlight } from 'instantsearch.js/es/helpers'");
$9a68c624c672fabe$var$instantsearch.reverseHighlight = (0, $e4443cc2a1f06031$export$b680e6b2c82f8c2f)((0, $a9544a7c7ea19d28$export$2e2bcd8739ae039), "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
$9a68c624c672fabe$var$instantsearch.snippet = (0, $e4443cc2a1f06031$export$b680e6b2c82f8c2f)((0, $42f86c36b36dbd78$export$2e2bcd8739ae039), "import { snippet } from 'instantsearch.js/es/helpers'");
$9a68c624c672fabe$var$instantsearch.reverseSnippet = (0, $e4443cc2a1f06031$export$b680e6b2c82f8c2f)((0, $007f848d940fdaf1$export$2e2bcd8739ae039), "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
$9a68c624c672fabe$var$instantsearch.insights = (0, $62dc5ddd84fbc4d2$export$2e2bcd8739ae039);
$9a68c624c672fabe$var$instantsearch.getInsightsAnonymousUserToken = (0, $f2f086fa702b7d9c$export$2e2bcd8739ae039);
Object.defineProperty($9a68c624c672fabe$var$instantsearch, "widgets", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
    }
});
Object.defineProperty($9a68c624c672fabe$var$instantsearch, "connectors", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
    }
});
Object.defineProperty($9a68c624c672fabe$var$instantsearch, "templates", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.templates\" are not available from the ES build.\n\nTo import the templates:\n\nimport { carousel } from 'instantsearch.js/es/templates'");
    }
});
var $9a68c624c672fabe$export$2e2bcd8739ae039 = $9a68c624c672fabe$var$instantsearch;




function $82c6985a45454c6e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $82c6985a45454c6e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $82c6985a45454c6e$var$_typeof(obj);
}
function $82c6985a45454c6e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82c6985a45454c6e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $82c6985a45454c6e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $82c6985a45454c6e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $82c6985a45454c6e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $82c6985a45454c6e$var$_defineProperty(obj, key, value) {
    key = $82c6985a45454c6e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $82c6985a45454c6e$var$_toPropertyKey(arg) {
    var key = $82c6985a45454c6e$var$_toPrimitive(arg, "string");
    return $82c6985a45454c6e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $82c6985a45454c6e$var$_toPrimitive(input, hint) {
    if ($82c6985a45454c6e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($82c6985a45454c6e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * Refine the given search parameters.
 */ var $82c6985a45454c6e$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "configure",
    connector: true
});
function $82c6985a45454c6e$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, acc), {}, $82c6985a45454c6e$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $82c6985a45454c6e$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $dba781b2f4cd6c52$export$8793edee2d425525);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $dba781b2f4cd6c52$export$8793edee2d425525);
    return function(widgetParams) {
        if (!widgetParams || !(0, $75a4fd312a615f00$export$53b83ca8eaab0383)(widgetParams.searchParameters)) throw new Error($82c6985a45454c6e$var$withUsage("The `searchParameters` option expects an object."));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $82c6985a45454c6e$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $cdcc1435cfc6072b$export$8049d91f25899769)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: "ais.configure",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $82c6985a45454c6e$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, renderState), {}, {
                    configure: $82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $cdcc1435cfc6072b$export$8049d91f25899769)(new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $cdcc1435cfc6072b$export$8049d91f25899769)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($6c359160e6887998$exports))).SearchParameters($82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, uiState), {}, {
                    configure: $82c6985a45454c6e$var$_objectSpread($82c6985a45454c6e$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $82c6985a45454c6e$export$2e2bcd8739ae039 = $82c6985a45454c6e$var$connectConfigure;



function $d384af5640276fb9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $d384af5640276fb9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $d384af5640276fb9$var$_typeof(obj);
}
function $d384af5640276fb9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d384af5640276fb9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d384af5640276fb9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d384af5640276fb9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d384af5640276fb9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d384af5640276fb9$var$_defineProperty(obj, key, value) {
    key = $d384af5640276fb9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d384af5640276fb9$var$_toPropertyKey(arg) {
    var key = $d384af5640276fb9$var$_toPrimitive(arg, "string");
    return $d384af5640276fb9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d384af5640276fb9$var$_toPrimitive(input, hint) {
    if ($d384af5640276fb9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d384af5640276fb9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * A list of [search parameters](https://www.algolia.com/doc/api-reference/search-api-parameters/)
 * to enable when the widget mounts.
 */ var $d384af5640276fb9$var$configure = function configure(widgetParams) {
    // This is a renderless widget that falls back to the connector's
    // noop render and unmount functions.
    var makeWidget = (0, $82c6985a45454c6e$export$2e2bcd8739ae039)((0, $dba781b2f4cd6c52$export$8793edee2d425525));
    return $d384af5640276fb9$var$_objectSpread($d384af5640276fb9$var$_objectSpread({}, makeWidget({
        searchParameters: widgetParams
    })), {}, {
        $$widgetType: "ais.configure"
    });
};
var $d384af5640276fb9$export$2e2bcd8739ae039 = $d384af5640276fb9$var$configure;

var $fbb6a7bc8836e7ee$exports = {};
function $fbb6a7bc8836e7ee$var$_extends() {
    return $fbb6a7bc8836e7ee$exports = $fbb6a7bc8836e7ee$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fbb6a7bc8836e7ee$exports.__esModule = true, $fbb6a7bc8836e7ee$exports["default"] = $fbb6a7bc8836e7ee$exports, $fbb6a7bc8836e7ee$var$_extends.apply(null, arguments);
}
$fbb6a7bc8836e7ee$exports = $fbb6a7bc8836e7ee$var$_extends, $fbb6a7bc8836e7ee$exports.__esModule = true, $fbb6a7bc8836e7ee$exports["default"] = $fbb6a7bc8836e7ee$exports;


var $daf589439909d1f5$exports = {};
var $4a8c38fb0b611662$exports = {};
function $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$4a8c38fb0b611662$exports = $4a8c38fb0b611662$var$_objectWithoutPropertiesLoose, $4a8c38fb0b611662$exports.__esModule = true, $4a8c38fb0b611662$exports["default"] = $4a8c38fb0b611662$exports;


function $daf589439909d1f5$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4a8c38fb0b611662$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$daf589439909d1f5$exports = $daf589439909d1f5$var$_objectWithoutProperties, $daf589439909d1f5$exports.__esModule = true, $daf589439909d1f5$exports["default"] = $daf589439909d1f5$exports;


function $6475aab5ef6929da$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(" ");
}


var $3fecd81ee4a0b4ae$var$_excluded = [
    "classNames",
    "hits",
    "itemComponent",
    "sendEvent",
    "emptyComponent",
    "banner",
    "bannerComponent"
];
// Should be imported from a shared package in the future
function $3fecd81ee4a0b4ae$var$createDefaultBannerComponent(_ref) {
    var createElement = _ref.createElement;
    return function DefaultBanner(_ref2) {
        var classNames = _ref2.classNames, banner = _ref2.banner;
        if (!banner.image.urls[0].url) return null;
        return createElement("aside", {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot)
        }, banner.link ? createElement("a", {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-banner-link", classNames.bannerLink),
            href: banner.link.url,
            target: banner.link.target
        }, createElement("img", {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        })) : createElement("img", {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-banner-image", classNames.bannerImage),
            src: banner.image.urls[0].url,
            alt: banner.image.title
        }));
    };
}
function $3fecd81ee4a0b4ae$export$abc871145e3e685(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var DefaultBannerComponent = $3fecd81ee4a0b4ae$var$createDefaultBannerComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Hits(userProps) {
        var _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, hits = userProps.hits, ItemComponent = userProps.itemComponent, sendEvent = userProps.sendEvent, EmptyComponent = userProps.emptyComponent, banner = userProps.banner, BannerComponent = userProps.bannerComponent, props = (0, (/*@__PURE__*/$parcel$interopDefault($daf589439909d1f5$exports)))(userProps, $3fecd81ee4a0b4ae$var$_excluded);
        return createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, props, {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits", classNames.root, hits.length === 0 && (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits--empty", classNames.emptyRoot), props.className)
        }), banner && (BannerComponent ? createElement(BannerComponent, {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-banner", classNames.bannerRoot),
            banner: banner
        }) : createElement(DefaultBannerComponent, {
            classNames: classNames,
            banner: banner
        })), hits.length === 0 && EmptyComponent ? createElement(EmptyComponent, null) : createElement("ol", {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-list", classNames.list)
        }, hits.map(function(hit, index) {
            return createElement(ItemComponent, {
                key: hit.objectID,
                hit: hit,
                index: index,
                className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Hits-item", classNames.item),
                onClick: function onClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                },
                onAuxClick: function onAuxClick() {
                    sendEvent("click:internal", hit, "Hit Clicked");
                }
            });
        })));
    };
}


var $450fc775b2f7950e$var$n, $450fc775b2f7950e$export$41c562ebe57d11e2, $450fc775b2f7950e$var$u, $450fc775b2f7950e$export$a8257692ac88316c, $450fc775b2f7950e$var$i, $450fc775b2f7950e$var$r, $450fc775b2f7950e$var$o, $450fc775b2f7950e$var$e, $450fc775b2f7950e$var$f, $450fc775b2f7950e$var$c, $450fc775b2f7950e$var$s, $450fc775b2f7950e$var$a, $450fc775b2f7950e$var$h, $450fc775b2f7950e$var$p = {}, $450fc775b2f7950e$var$v = [], $450fc775b2f7950e$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $450fc775b2f7950e$var$d = Array.isArray;
function $450fc775b2f7950e$var$w(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $450fc775b2f7950e$var$_(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $450fc775b2f7950e$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $450fc775b2f7950e$var$m(l, e, i, r, null);
}
function $450fc775b2f7950e$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$450fc775b2f7950e$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $450fc775b2f7950e$export$41c562ebe57d11e2.vnode && $450fc775b2f7950e$export$41c562ebe57d11e2.vnode(e), e;
}
function $450fc775b2f7950e$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $450fc775b2f7950e$export$ffb0004e005737fa(n) {
    return n.children;
}
function $450fc775b2f7950e$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $450fc775b2f7950e$var$C(n, l) {
    if (null == l) return n.__ ? $450fc775b2f7950e$var$C(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $450fc775b2f7950e$var$C(n) : null;
}
function $450fc775b2f7950e$var$S(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $450fc775b2f7950e$var$S(n);
    }
}
function $450fc775b2f7950e$var$M(n) {
    (!n.__d && (n.__d = !0) && $450fc775b2f7950e$var$i.push(n) && !$450fc775b2f7950e$var$P.__r++ || $450fc775b2f7950e$var$r !== $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) && (($450fc775b2f7950e$var$r = $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) || $450fc775b2f7950e$var$o)($450fc775b2f7950e$var$P);
}
function $450fc775b2f7950e$var$P() {
    var n, u, t, r, o, f, c, s;
    for($450fc775b2f7950e$var$i.sort($450fc775b2f7950e$var$e); n = $450fc775b2f7950e$var$i.shift();)n.__d && (u = $450fc775b2f7950e$var$i.length, r = void 0, f = (o = (t = n).__v).__e, c = [], s = [], t.__P && ((r = $450fc775b2f7950e$var$w({}, o)).__v = o.__v + 1, $450fc775b2f7950e$export$41c562ebe57d11e2.vnode && $450fc775b2f7950e$export$41c562ebe57d11e2.vnode(r), $450fc775b2f7950e$var$j(t.__P, r, o, t.__n, t.__P.namespaceURI, 32 & o.__u ? [
        f
    ] : null, c, null == f ? $450fc775b2f7950e$var$C(o) : f, !!(32 & o.__u), s), r.__v = o.__v, r.__.__k[r.__i] = r, $450fc775b2f7950e$var$z(c, r, s), r.__e != f && $450fc775b2f7950e$var$S(r)), $450fc775b2f7950e$var$i.length > u && $450fc775b2f7950e$var$i.sort($450fc775b2f7950e$var$e));
    $450fc775b2f7950e$var$P.__r = 0;
}
function $450fc775b2f7950e$var$$(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, d, w, _, g = t && t.__k || $450fc775b2f7950e$var$v, m = l.length;
    for(f = $450fc775b2f7950e$var$I(u, l, g, f, m), a = 0; a < m; a++)null != (y = u.__k[a]) && (h = -1 === y.__i ? $450fc775b2f7950e$var$p : g[y.__i] || $450fc775b2f7950e$var$p, y.__i = a, _ = $450fc775b2f7950e$var$j(n, y, h, i, r, o, e, f, c, s), d = y.__e, y.ref && h.ref != y.ref && (h.ref && $450fc775b2f7950e$var$V(h.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 4 & y.__u || h.__k === y.__k ? f = $450fc775b2f7950e$var$A(y, f, n) : "function" == typeof y.type && void 0 !== _ ? f = _ : d && (f = d.nextSibling), y.__u &= -7);
    return u.__e = w, f;
}
function $450fc775b2f7950e$var$I(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $450fc775b2f7950e$var$m(null, o, null, null, null) : $450fc775b2f7950e$var$d(o) ? $450fc775b2f7950e$var$m($450fc775b2f7950e$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? $450fc775b2f7950e$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 !== (c = o.__i = $450fc775b2f7950e$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null === e.__v ? (-1 == c && h--, "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $450fc775b2f7950e$var$C(e)), $450fc775b2f7950e$var$q(e, e));
    return t;
}
function $450fc775b2f7950e$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $450fc775b2f7950e$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $450fc775b2f7950e$var$C(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $450fc775b2f7950e$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($450fc775b2f7950e$var$d(n) ? n.some(function(n) {
        $450fc775b2f7950e$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $450fc775b2f7950e$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f || f && o == f.key && e === f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e === f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e === f.type) return r;
            r++;
        }
    }
    return -1;
}
function $450fc775b2f7950e$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $450fc775b2f7950e$var$y.test(l) ? u : u + "px";
}
function $450fc775b2f7950e$var$F(n, l, u, t, i) {
    var r;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $450fc775b2f7950e$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $450fc775b2f7950e$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($450fc775b2f7950e$var$f, "$1")), l = l.toLowerCase() in n || "onFocusOut" == l || "onFocusIn" == l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $450fc775b2f7950e$var$c, n.addEventListener(l, r ? $450fc775b2f7950e$var$a : $450fc775b2f7950e$var$s, r)) : n.removeEventListener(l, r ? $450fc775b2f7950e$var$a : $450fc775b2f7950e$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $450fc775b2f7950e$var$O(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $450fc775b2f7950e$var$c++;
            else if (u.t < t.u) return;
            return t($450fc775b2f7950e$export$41c562ebe57d11e2.event ? $450fc775b2f7950e$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $450fc775b2f7950e$var$j(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, g, m, b, C, S, M, P, I, A, H, L, T, F = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $450fc775b2f7950e$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof F) try {
        if (b = u.props, C = "prototype" in F && F.prototype.render, S = (a = F.contextType) && i[a.__c], M = a ? S ? S.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (C ? u.__c = h = new F(b, M) : (u.__c = h = new $450fc775b2f7950e$export$16fa2f45be04daa8(b, M), h.constructor = F, h.render = $450fc775b2f7950e$var$B), S && S.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), C && null == h.__s && (h.__s = h.state), C && null != F.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $450fc775b2f7950e$var$w({}, h.__s)), $450fc775b2f7950e$var$w(h.__s, F.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) C && null == F.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), C && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (C && null == F.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v)) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), C && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, g);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, I = $450fc775b2f7950e$export$41c562ebe57d11e2.__r, A = 0, C) {
            for(h.state = h.__s, h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, I && I(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $450fc775b2f7950e$var$w($450fc775b2f7950e$var$w({}, i), h.getChildContext())), C && !p && null != h.getSnapshotBeforeUpdate && (g = h.getSnapshotBeforeUpdate(v, y)), f = $450fc775b2f7950e$var$$(n, $450fc775b2f7950e$var$d(L = null != a && a.type === $450fc775b2f7950e$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(T = o.length; T--;)$450fc775b2f7950e$var$_(o[T]);
        } else u.__e = t.__e, u.__k = t.__k;
        $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $450fc775b2f7950e$var$N(t.__e, u, t, i, r, o, e, c, s);
    return (a = $450fc775b2f7950e$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $450fc775b2f7950e$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$450fc775b2f7950e$var$V(t[i], t[++i], t[++i]);
    $450fc775b2f7950e$export$41c562ebe57d11e2.__c && $450fc775b2f7950e$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $450fc775b2f7950e$var$N(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, w, g, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((w = e[a]) && "setAttribute" in w == !!x && (x ? w.localName == x : 3 == w.nodeType)) {
            u = w, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($450fc775b2f7950e$export$41c562ebe57d11e2.__m && $450fc775b2f7950e$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null === x) b === k || c && u.data === k || (u.data = k);
    else {
        if (e = e && $450fc775b2f7950e$var$n.call(u.childNodes), b = i.props || $450fc775b2f7950e$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(w = u.attributes[a]).name] = w.value;
        for(a in b)if (w = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = w;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $450fc775b2f7950e$var$F(u, a, null, w, o);
        }
        for(a in k)w = k[a], "children" == a ? y = w : "dangerouslySetInnerHTML" == a ? h = w : "value" == a ? g = w : "checked" == a ? m = w : c && "function" != typeof w || b[a] === w || $450fc775b2f7950e$var$F(u, a, w, b[a], o);
        if (h) c || v && (h.__html === v.__html || h.__html === u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $450fc775b2f7950e$var$$(u, $450fc775b2f7950e$var$d(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $450fc775b2f7950e$var$C(i, 0), c, s), null != e) for(a = e.length; a--;)$450fc775b2f7950e$var$_(e[a]);
        c || (a = "value", "progress" == x && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" == x && !g || "option" == x && g !== b[a]) && $450fc775b2f7950e$var$F(u, a, g, b[a], o), a = "checked", void 0 !== m && m !== u[a] && $450fc775b2f7950e$var$F(u, a, m, b[a], o));
    }
    return u;
}
function $450fc775b2f7950e$var$V(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $450fc775b2f7950e$var$q(n, u, t) {
    var i, r;
    if ($450fc775b2f7950e$export$41c562ebe57d11e2.unmount && $450fc775b2f7950e$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $450fc775b2f7950e$var$V(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $450fc775b2f7950e$var$q(i[r], u, t || "function" != typeof n.type);
    t || $450fc775b2f7950e$var$_(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $450fc775b2f7950e$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $450fc775b2f7950e$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $450fc775b2f7950e$export$41c562ebe57d11e2.__ && $450fc775b2f7950e$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $450fc775b2f7950e$var$j(t, u = (!r && i || t).__k = $450fc775b2f7950e$export$c8a8987d4410bf2d($450fc775b2f7950e$export$ffb0004e005737fa, null, [
        u
    ]), o || $450fc775b2f7950e$var$p, $450fc775b2f7950e$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $450fc775b2f7950e$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $450fc775b2f7950e$var$z(e, u, f);
}
function $450fc775b2f7950e$export$fa8d919ba61d84db(n, l) {
    $450fc775b2f7950e$export$b3890eb0ae9dca99(n, l, $450fc775b2f7950e$export$fa8d919ba61d84db);
}
function $450fc775b2f7950e$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $450fc775b2f7950e$var$w({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && void 0 !== e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : t), $450fc775b2f7950e$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $450fc775b2f7950e$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $450fc775b2f7950e$var$h++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = new Set, (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.forEach(function(n) {
                    n.__e = !0, $450fc775b2f7950e$var$M(n);
                });
            }, this.sub = function(n) {
                u.add(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.delete(n), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$450fc775b2f7950e$var$n = $450fc775b2f7950e$var$v.slice, $450fc775b2f7950e$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $450fc775b2f7950e$var$u = 0, $450fc775b2f7950e$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $450fc775b2f7950e$var$w({}, this.state), "function" == typeof n && (n = n($450fc775b2f7950e$var$w({}, u), this.props)), n && $450fc775b2f7950e$var$w(u, n), null != n && this.__v && (l && this._sb.push(l), $450fc775b2f7950e$var$M(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $450fc775b2f7950e$var$M(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.render = $450fc775b2f7950e$export$ffb0004e005737fa, $450fc775b2f7950e$var$i = [], $450fc775b2f7950e$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $450fc775b2f7950e$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $450fc775b2f7950e$var$P.__r = 0, $450fc775b2f7950e$var$f = /(PointerCapture)$|Capture$/i, $450fc775b2f7950e$var$c = 0, $450fc775b2f7950e$var$s = $450fc775b2f7950e$var$O(!1), $450fc775b2f7950e$var$a = $450fc775b2f7950e$var$O(!0), $450fc775b2f7950e$var$h = 0;



var $6ebfb0054e7d59cd$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // This file is for use with Node.js. See dist/ for browser files.
var $62bac08dc0d55792$exports = {};
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ (function(Hogan) {
    // Setup regex  assignments
    // remove whitespace according to Mustache spec
    var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
    Hogan.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        "$": 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        "_v": 9,
        "{": 10,
        "&": 11,
        "_t": 12
    };
    Hogan.scan = function scan(text, delimiters) {
        var len = text.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = "", tokens = [], seenTag = false, i = 0, lineStart = 0, otag = "{{", ctag = "}}";
        function addBuf() {
            if (buf.length > 0) {
                tokens.push({
                    tag: "_t",
                    text: new String(buf)
                });
                buf = "";
            }
        }
        function lineIsWhitespace() {
            var isAllWhitespace = true;
            for(var j = lineStart; j < tokens.length; j++){
                isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags["_v"] || tokens[j].tag == "_t" && tokens[j].text.match(rIsWhitespace) === null;
                if (!isAllWhitespace) return false;
            }
            return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
            addBuf();
            if (haveSeenTag && lineIsWhitespace()) {
                for(var j = lineStart, next; j < tokens.length; j++)if (tokens[j].text) {
                    if ((next = tokens[j + 1]) && next.tag == ">") // set indent to token value
                    next.indent = tokens[j].text.toString();
                    tokens.splice(j, 1);
                }
            } else if (!noNewLine) tokens.push({
                tag: "\n"
            });
            seenTag = false;
            lineStart = tokens.length;
        }
        function changeDelimiters(text, index) {
            var close = "=" + ctag, closeIndex = text.indexOf(close, index), delimiters = trim(text.substring(text.indexOf("=", index) + 1, closeIndex)).split(" ");
            otag = delimiters[0];
            ctag = delimiters[delimiters.length - 1];
            return closeIndex + close.length - 1;
        }
        if (delimiters) {
            delimiters = delimiters.split(" ");
            otag = delimiters[0];
            ctag = delimiters[1];
        }
        for(i = 0; i < len; i++){
            if (state == IN_TEXT) {
                if (tagChange(otag, text, i)) {
                    --i;
                    addBuf();
                    state = IN_TAG_TYPE;
                } else if (text.charAt(i) == "\n") filterLine(seenTag);
                else buf += text.charAt(i);
            } else if (state == IN_TAG_TYPE) {
                i += otag.length - 1;
                tag = Hogan.tags[text.charAt(i + 1)];
                tagType = tag ? text.charAt(i + 1) : "_v";
                if (tagType == "=") {
                    i = changeDelimiters(text, i);
                    state = IN_TEXT;
                } else {
                    if (tag) i++;
                    state = IN_TAG;
                }
                seenTag = i;
            } else if (tagChange(ctag, text, i)) {
                tokens.push({
                    tag: tagType,
                    n: trim(buf),
                    otag: otag,
                    ctag: ctag,
                    i: tagType == "/" ? seenTag - otag.length : i + ctag.length
                });
                buf = "";
                i += ctag.length - 1;
                state = IN_TEXT;
                if (tagType == "{") {
                    if (ctag == "}}") i++;
                    else cleanTripleStache(tokens[tokens.length - 1]);
                }
            } else buf += text.charAt(i);
        }
        filterLine(seenTag, true);
        return tokens;
    };
    function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === "}") token.n = token.n.substring(0, token.n.length - 1);
    }
    function trim(s) {
        if (s.trim) return s.trim();
        return s.replace(/^\s*|\s*$/g, "");
    }
    function tagChange(tag, text, index) {
        if (text.charAt(index) != tag.charAt(0)) return false;
        for(var i = 1, l = tag.length; i < l; i++){
            if (text.charAt(index + i) != tag.charAt(i)) return false;
        }
        return true;
    }
    // the tags allowed inside super templates
    var allowedInSuper = {
        "_t": true,
        "\n": true,
        "$": true,
        "/": true
    };
    function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while(tokens.length > 0){
            token = tokens.shift();
            if (tail && tail.tag == "<" && !(token.tag in allowedInSuper)) throw new Error("Illegal content in < super tag.");
            if (Hogan.tags[token.tag] <= Hogan.tags["$"] || isOpener(token, customTags)) {
                stack.push(token);
                token.nodes = buildTree(tokens, token.tag, stack, customTags);
            } else if (token.tag == "/") {
                if (stack.length === 0) throw new Error("Closing tag without opener: /" + token.n);
                opener = stack.pop();
                if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) throw new Error("Nesting error: " + opener.n + " vs. " + token.n);
                opener.end = token.i;
                return instructions;
            } else if (token.tag == "\n") token.last = tokens.length == 0 || tokens[0].tag == "\n";
            instructions.push(token);
        }
        if (stack.length > 0) throw new Error("missing closing tag: " + stack.pop().n);
        return instructions;
    }
    function isOpener(token, tags) {
        for(var i = 0, l = tags.length; i < l; i++)if (tags[i].o == token.n) {
            token.tag = "#";
            return true;
        }
    }
    function isCloser(close, open, tags) {
        for(var i = 0, l = tags.length; i < l; i++){
            if (tags[i].c == close && tags[i].o == open) return true;
        }
    }
    function stringifySubstitutions(obj) {
        var items = [];
        for(var key in obj)items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + "}");
        return "{ " + items.join(",") + " }";
    }
    function stringifyPartials(codeObj) {
        var partials = [];
        for(var key in codeObj.partials)partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
    }
    Hogan.stringify = function(codeObj, text, options) {
        return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
    };
    var serialNo = 0;
    Hogan.generate = function(tree, text, options) {
        serialNo = 0;
        var context = {
            code: "",
            subs: {},
            partials: {}
        };
        Hogan.walk(tree, context);
        if (options.asString) return this.stringify(context, text, options);
        return this.makeTemplate(context, text, options);
    };
    Hogan.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + "return t.fl();";
    };
    Hogan.template = Hogan.Template;
    Hogan.makeTemplate = function(codeObj, text, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function("c", "p", "i", this.wrapMain(codeObj.code));
        return new this.template(template, text, this, options);
    };
    Hogan.makePartials = function(codeObj) {
        var key, template = {
            subs: {},
            partials: codeObj.partials,
            name: codeObj.name
        };
        for(key in template.partials)template.partials[key] = this.makePartials(template.partials[key]);
        for(key in codeObj.subs)template.subs[key] = new Function("c", "p", "t", "i", codeObj.subs[key]);
        return template;
    };
    function esc(s) {
        return s.replace(rSlash, "\\\\").replace(rQuot, '\\"').replace(rNewline, "\\n").replace(rCr, "\\r").replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
    }
    function chooseMethod(s) {
        return ~s.indexOf(".") ? "d" : "f";
    }
    function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = {
            name: node.n,
            partials: {}
        };
        context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || "") + '"));';
        return sym;
    }
    Hogan.codegen = {
        "#": function(node, context) {
            context.code += "if(t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + "c,p,0," + node.i + "," + node.end + ',"' + node.otag + " " + node.ctag + '")){' + "t.rs(c,p," + "function(c,p,t){";
            Hogan.walk(node.nodes, context);
            context.code += "});c.pop();}";
        },
        "^": function(node, context) {
            context.code += "if(!t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
            Hogan.walk(node.nodes, context);
            context.code += "};";
        },
        ">": createPartial,
        "<": function(node, context) {
            var ctx = {
                partials: {},
                code: "",
                subs: {},
                inPartial: true
            };
            Hogan.walk(node.nodes, ctx);
            var template = context.partials[createPartial(node, context)];
            template.subs = ctx.subs;
            template.partials = ctx.partials;
        },
        "$": function(node, context) {
            var ctx = {
                subs: {},
                code: "",
                partials: context.partials,
                prefix: node.n
            };
            Hogan.walk(node.nodes, ctx);
            context.subs[node.n] = ctx.code;
            if (!context.inPartial) context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
        },
        "\n": function(node, context) {
            context.code += write('"\\n"' + (node.last ? "" : " + i"));
        },
        "_v": function(node, context) {
            context.code += "t.b(t.v(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
        },
        "_t": function(node, context) {
            context.code += write('"' + esc(node.text) + '"');
        },
        "{": tripleStache,
        "&": tripleStache
    };
    function tripleStache(node, context) {
        context.code += "t.b(t.t(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    }
    function write(s) {
        return "t.b(" + s + ");";
    }
    Hogan.walk = function(nodelist, context) {
        var func;
        for(var i = 0, l = nodelist.length; i < l; i++){
            func = Hogan.codegen[nodelist[i].tag];
            func && func(nodelist[i], context);
        }
        return context;
    };
    Hogan.parse = function(tokens, text, options) {
        options = options || {};
        return buildTree(tokens, "", [], options.sectionTags || []);
    };
    Hogan.cache = {};
    Hogan.cacheKey = function(text, options) {
        return [
            text,
            !!options.asString,
            !!options.disableLambda,
            options.delimiters,
            !!options.modelGet
        ].join("||");
    };
    Hogan.compile = function(text, options) {
        options = options || {};
        var key = Hogan.cacheKey(text, options);
        var template = this.cache[key];
        if (template) {
            var partials = template.partials;
            for(var name in partials)delete partials[name].instance;
            return template;
        }
        template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
        return this.cache[key] = template;
    };
})($62bac08dc0d55792$exports);



$62bac08dc0d55792$exports.Template = (parcelRequire("9w6zV")).Template;
$62bac08dc0d55792$exports.template = $62bac08dc0d55792$exports.Template;
$6ebfb0054e7d59cd$exports = $62bac08dc0d55792$exports;



var $71e7bf294e7fa662$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $71e7bf294e7fa662$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $71e7bf294e7fa662$var$t = new Map;
function $71e7bf294e7fa662$export$2e2bcd8739ae039(s) {
    var r = $71e7bf294e7fa662$var$t.get(this);
    return r || (r = new Map, $71e7bf294e7fa662$var$t.set(this, r)), (r = $71e7bf294e7fa662$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}


var $55e67b5a79daa940$export$c0bb0b647f701bb5 = (0, $71e7bf294e7fa662$export$2e2bcd8739ae039).bind((0, $450fc775b2f7950e$export$c8a8987d4410bf2d));








var $65befea1bb82cce1$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $65befea1bb82cce1$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $65befea1bb82cce1$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $65befea1bb82cce1$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, (/*@__PURE__*/$parcel$interopDefault($daf589439909d1f5$exports)))(userProps, $65befea1bb82cce1$var$_excluded);
        return createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($fbb6a7bc8836e7ee$exports)))({}, props, {
            className: (0, $6475aab5ef6929da$export$a274e22fb40f762e)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}



var $4411ba54e9717fdd$export$57a0c6fc80bec05c = (0, $65befea1bb82cce1$export$c8682df1c852a966)({
    createElement: (0, $450fc775b2f7950e$export$c8a8987d4410bf2d),
    Fragment: (0, $450fc775b2f7950e$export$ffb0004e005737fa)
});


var $39c2e329ad4e993d$var$_excluded = [
    "classNames"
];
function $39c2e329ad4e993d$var$_extends() {
    $39c2e329ad4e993d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39c2e329ad4e993d$var$_extends.apply(this, arguments);
}
function $39c2e329ad4e993d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $39c2e329ad4e993d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $39c2e329ad4e993d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $39c2e329ad4e993d$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $39c2e329ad4e993d$var$_objectWithoutProperties(_ref, $39c2e329ad4e993d$var$_excluded);
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $4411ba54e9717fdd$export$57a0c6fc80bec05c), $39c2e329ad4e993d$var$_extends({
        classNames: {
            root: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Highlight", classNames.root),
            highlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Highlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Highlight-separator", classNames.separator)
        }
    }, props));
}


function $87f1e5e787fe4082$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}


var $28f44055999237d0$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $28f44055999237d0$var$_extends() {
    $28f44055999237d0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28f44055999237d0$var$_extends.apply(this, arguments);
}
function $28f44055999237d0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $28f44055999237d0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $28f44055999237d0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $28f44055999237d0$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $28f44055999237d0$var$_objectWithoutProperties(_ref, $28f44055999237d0$var$_excluded);
    var property = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = (0, $87f1e5e787fe4082$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $d11e96c67ca5e4d5$export$e04d28e65b830ebf)((0, $fcb98432e82f2808$export$e8bacd2802a88316)(value || ""));
    });
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $39c2e329ad4e993d$export$39dbc3f558091353), $28f44055999237d0$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $a6473540a03affad$var$_excluded = [
    "classNames"
];
function $a6473540a03affad$var$_extends() {
    $a6473540a03affad$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a6473540a03affad$var$_extends.apply(this, arguments);
}
function $a6473540a03affad$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a6473540a03affad$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a6473540a03affad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a6473540a03affad$export$f346643e8570b662(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $a6473540a03affad$var$_objectWithoutProperties(_ref, $a6473540a03affad$var$_excluded);
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $4411ba54e9717fdd$export$57a0c6fc80bec05c), $a6473540a03affad$var$_extends({
        classNames: {
            root: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseHighlight", classNames.root),
            highlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseHighlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseHighlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseHighlight-separator", classNames.separator)
        }
    }, props));
}



function $e1b494042a84ad23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e1b494042a84ad23$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e1b494042a84ad23$var$_typeof(obj);
}
var $e1b494042a84ad23$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $e1b494042a84ad23$var$_excluded2 = [
    "isHighlighted"
];
function $e1b494042a84ad23$var$_extends() {
    $e1b494042a84ad23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1b494042a84ad23$var$_extends.apply(this, arguments);
}
function $e1b494042a84ad23$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e1b494042a84ad23$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e1b494042a84ad23$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e1b494042a84ad23$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e1b494042a84ad23$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e1b494042a84ad23$var$_defineProperty(obj, key, value) {
    key = $e1b494042a84ad23$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e1b494042a84ad23$var$_toPropertyKey(arg) {
    var key = $e1b494042a84ad23$var$_toPrimitive(arg, "string");
    return $e1b494042a84ad23$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e1b494042a84ad23$var$_toPrimitive(input, hint) {
    if ($e1b494042a84ad23$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e1b494042a84ad23$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e1b494042a84ad23$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e1b494042a84ad23$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e1b494042a84ad23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e1b494042a84ad23$export$f346643e8570b662(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $e1b494042a84ad23$var$_objectWithoutProperties(_ref, $e1b494042a84ad23$var$_excluded);
    var property = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._highlightResult, attribute) || [];
    var properties = (0, $87f1e5e787fe4082$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $d11e96c67ca5e4d5$export$e04d28e65b830ebf)((0, $fcb98432e82f2808$export$e8bacd2802a88316)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $e1b494042a84ad23$var$_objectWithoutProperties(_ref3, $e1b494042a84ad23$var$_excluded2);
            return $e1b494042a84ad23$var$_objectSpread($e1b494042a84ad23$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $a6473540a03affad$export$f346643e8570b662), $e1b494042a84ad23$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $32be11c9b927149e$var$_excluded = [
    "classNames"
];
function $32be11c9b927149e$var$_extends() {
    $32be11c9b927149e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $32be11c9b927149e$var$_extends.apply(this, arguments);
}
function $32be11c9b927149e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $32be11c9b927149e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $32be11c9b927149e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $32be11c9b927149e$export$235f9e0721ad46fa(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $32be11c9b927149e$var$_objectWithoutProperties(_ref, $32be11c9b927149e$var$_excluded);
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $4411ba54e9717fdd$export$57a0c6fc80bec05c), $32be11c9b927149e$var$_extends({
        classNames: {
            root: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseSnippet", classNames.root),
            highlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseSnippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseSnippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-ReverseSnippet-separator", classNames.separator)
        }
    }, props));
}



function $080713b98092415a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $080713b98092415a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $080713b98092415a$var$_typeof(obj);
}
var $080713b98092415a$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $080713b98092415a$var$_excluded2 = [
    "isHighlighted"
];
function $080713b98092415a$var$_extends() {
    $080713b98092415a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $080713b98092415a$var$_extends.apply(this, arguments);
}
function $080713b98092415a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $080713b98092415a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $080713b98092415a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $080713b98092415a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $080713b98092415a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $080713b98092415a$var$_defineProperty(obj, key, value) {
    key = $080713b98092415a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $080713b98092415a$var$_toPropertyKey(arg) {
    var key = $080713b98092415a$var$_toPrimitive(arg, "string");
    return $080713b98092415a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $080713b98092415a$var$_toPrimitive(input, hint) {
    if ($080713b98092415a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($080713b98092415a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $080713b98092415a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $080713b98092415a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $080713b98092415a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $080713b98092415a$export$235f9e0721ad46fa(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $080713b98092415a$var$_objectWithoutProperties(_ref, $080713b98092415a$var$_excluded);
    var property = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = (0, $87f1e5e787fe4082$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $d11e96c67ca5e4d5$export$e04d28e65b830ebf)((0, $fcb98432e82f2808$export$e8bacd2802a88316)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $080713b98092415a$var$_objectWithoutProperties(_ref3, $080713b98092415a$var$_excluded2);
            return $080713b98092415a$var$_objectSpread($080713b98092415a$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $32be11c9b927149e$export$235f9e0721ad46fa), $080713b98092415a$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}





var $be8ff13b02e36d80$var$_excluded = [
    "classNames"
];
function $be8ff13b02e36d80$var$_extends() {
    $be8ff13b02e36d80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be8ff13b02e36d80$var$_extends.apply(this, arguments);
}
function $be8ff13b02e36d80$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $be8ff13b02e36d80$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $be8ff13b02e36d80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $be8ff13b02e36d80$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $be8ff13b02e36d80$var$_objectWithoutProperties(_ref, $be8ff13b02e36d80$var$_excluded);
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $4411ba54e9717fdd$export$57a0c6fc80bec05c), $be8ff13b02e36d80$var$_extends({
        classNames: {
            root: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Snippet", classNames.root),
            highlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Snippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $6475aab5ef6929da$export$a274e22fb40f762e)("ais-Snippet-separator", classNames.separator)
        }
    }, props));
}



var $bd33193f2ef679b8$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $bd33193f2ef679b8$var$_extends() {
    $bd33193f2ef679b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd33193f2ef679b8$var$_extends.apply(this, arguments);
}
function $bd33193f2ef679b8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bd33193f2ef679b8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bd33193f2ef679b8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bd33193f2ef679b8$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $bd33193f2ef679b8$var$_objectWithoutProperties(_ref, $bd33193f2ef679b8$var$_excluded);
    var property = (0, $4dc7e5862e881a8a$export$d14846335956eefa)(hit._snippetResult, attribute) || [];
    var properties = (0, $87f1e5e787fe4082$export$45b10814cc054894)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $d11e96c67ca5e4d5$export$e04d28e65b830ebf)((0, $fcb98432e82f2808$export$e8bacd2802a88316)(value || ""));
    });
    return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $be8ff13b02e36d80$export$10c56fa12fda26f9), $bd33193f2ef679b8$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}


function $3f879671235ebefb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3f879671235ebefb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3f879671235ebefb$var$_typeof(obj);
}
function $3f879671235ebefb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3f879671235ebefb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3f879671235ebefb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3f879671235ebefb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3f879671235ebefb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3f879671235ebefb$var$_defineProperty(obj, key, value) {
    key = $3f879671235ebefb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3f879671235ebefb$var$_toPropertyKey(arg) {
    var key = $3f879671235ebefb$var$_toPrimitive(arg, "string");
    return $3f879671235ebefb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3f879671235ebefb$var$_toPrimitive(input, hint) {
    if ($3f879671235ebefb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3f879671235ebefb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function $3f879671235ebefb$var$transformHelpersToHogan() {
    var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    return Object.keys(helpers).reduce(function(acc, helperKey) {
        return $3f879671235ebefb$var$_objectSpread($3f879671235ebefb$var$_objectSpread({}, acc), {}, $3f879671235ebefb$var$_defineProperty({}, helperKey, function() {
            var _this = this;
            return function(text) {
                var render = function render(value) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6ebfb0054e7d59cd$exports))).compile(value, compileOptions).render(_this);
                };
                return helpers[helperKey].call(data, text, render);
            };
        }));
    }, {});
}
function $3f879671235ebefb$export$b5c363744c17aeab(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, compileOptions = _ref.compileOptions, helpers = _ref.helpers, data = _ref.data, bindEvent = _ref.bindEvent, sendEvent = _ref.sendEvent;
    var template = templates[templateKey];
    if (typeof template !== "string" && typeof template !== "function") throw new Error("Template must be 'string' or 'function', was '".concat($3f879671235ebefb$var$_typeof(template), "' (key: ").concat(templateKey, ")"));
    if (typeof template === "function") {
        // @MAJOR no longer pass bindEvent when string templates are removed
        var params = bindEvent || {};
        params.html = (0, $55e67b5a79daa940$export$c0bb0b647f701bb5);
        params.sendEvent = sendEvent;
        params.components = {
            Highlight: (0, $28f44055999237d0$export$39dbc3f558091353),
            ReverseHighlight: (0, $e1b494042a84ad23$export$f346643e8570b662),
            Snippet: (0, $bd33193f2ef679b8$export$10c56fa12fda26f9),
            ReverseSnippet: (0, $080713b98092415a$export$235f9e0721ad46fa)
        };
        // @MAJOR remove the `as any` when string templates are removed
        // needed because not every template receives sendEvent
        return template(data, params);
    }
    var transformedHelpers = $3f879671235ebefb$var$transformHelpersToHogan(helpers, compileOptions, data);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6ebfb0054e7d59cd$exports))).compile(template, compileOptions).render($3f879671235ebefb$var$_objectSpread($3f879671235ebefb$var$_objectSpread({}, data), {}, {
        helpers: transformedHelpers
    })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
        return spaces.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
    }).trim();
}



function $cae24fad0dd36ab6$var$_extends() {
    $cae24fad0dd36ab6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cae24fad0dd36ab6$var$_extends.apply(this, arguments);
}
function $cae24fad0dd36ab6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cae24fad0dd36ab6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cae24fad0dd36ab6$var$_typeof(obj);
}
function $cae24fad0dd36ab6$var$_toConsumableArray(arr) {
    return $cae24fad0dd36ab6$var$_arrayWithoutHoles(arr) || $cae24fad0dd36ab6$var$_iterableToArray(arr) || $cae24fad0dd36ab6$var$_unsupportedIterableToArray(arr) || $cae24fad0dd36ab6$var$_nonIterableSpread();
}
function $cae24fad0dd36ab6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cae24fad0dd36ab6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cae24fad0dd36ab6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cae24fad0dd36ab6$var$_arrayLikeToArray(o, minLen);
}
function $cae24fad0dd36ab6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cae24fad0dd36ab6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cae24fad0dd36ab6$var$_arrayLikeToArray(arr);
}
function $cae24fad0dd36ab6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cae24fad0dd36ab6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cae24fad0dd36ab6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $cae24fad0dd36ab6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $cae24fad0dd36ab6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cae24fad0dd36ab6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cae24fad0dd36ab6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $cae24fad0dd36ab6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $cae24fad0dd36ab6$var$_setPrototypeOf(subClass, superClass);
}
function $cae24fad0dd36ab6$var$_setPrototypeOf(o, p) {
    $cae24fad0dd36ab6$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cae24fad0dd36ab6$var$_setPrototypeOf(o, p);
}
function $cae24fad0dd36ab6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cae24fad0dd36ab6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cae24fad0dd36ab6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cae24fad0dd36ab6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cae24fad0dd36ab6$var$_possibleConstructorReturn(this, result);
    };
}
function $cae24fad0dd36ab6$var$_possibleConstructorReturn(self, call) {
    if (call && ($cae24fad0dd36ab6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $cae24fad0dd36ab6$var$_assertThisInitialized(self);
}
function $cae24fad0dd36ab6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cae24fad0dd36ab6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cae24fad0dd36ab6$var$_getPrototypeOf(o) {
    $cae24fad0dd36ab6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cae24fad0dd36ab6$var$_getPrototypeOf(o);
}
function $cae24fad0dd36ab6$var$_defineProperty(obj, key, value) {
    key = $cae24fad0dd36ab6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cae24fad0dd36ab6$var$_toPropertyKey(arg) {
    var key = $cae24fad0dd36ab6$var$_toPrimitive(arg, "string");
    return $cae24fad0dd36ab6$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cae24fad0dd36ab6$var$_toPrimitive(input, hint) {
    if ($cae24fad0dd36ab6$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cae24fad0dd36ab6$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $cae24fad0dd36ab6$var$RawHtml = /*#__PURE__*/ function(_Component) {
    $cae24fad0dd36ab6$var$_inherits(RawHtml, _Component);
    var _super = $cae24fad0dd36ab6$var$_createSuper(RawHtml);
    function RawHtml() {
        var _this;
        $cae24fad0dd36ab6$var$_classCallCheck(this, RawHtml);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $cae24fad0dd36ab6$var$_defineProperty($cae24fad0dd36ab6$var$_assertThisInitialized(_this), "ref", (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)());
        $cae24fad0dd36ab6$var$_defineProperty($cae24fad0dd36ab6$var$_assertThisInitialized(_this), "nodes", []);
        return _this;
    }
    $cae24fad0dd36ab6$var$_createClass(RawHtml, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var fragment = new DocumentFragment();
                var root = document.createElement("div");
                root.innerHTML = this.props.content;
                this.nodes = $cae24fad0dd36ab6$var$_toConsumableArray(root.childNodes);
                this.nodes.forEach(function(node) {
                    return fragment.appendChild(node);
                });
                this.ref.current.replaceWith(fragment);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.nodes.forEach(function(node) {
                    if (node instanceof Element) {
                        node.outerHTML = "";
                        return;
                    }
                    node.nodeValue = "";
                });
                // if there is one TextNode first and one TextNode last, the
                // last one's nodeValue will be assigned to the first.
                if (this.nodes[0].nodeValue) this.nodes[0].nodeValue = "";
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                    ref: this.ref
                });
            }
        }
    ]);
    return RawHtml;
}((0, $450fc775b2f7950e$export$16fa2f45be04daa8));
var $cae24fad0dd36ab6$var$defaultProps = {
    data: {},
    rootTagName: "div",
    useCustomCompileOptions: {},
    templates: {},
    templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var $cae24fad0dd36ab6$var$Template = /*#__PURE__*/ function(_Component2) {
    $cae24fad0dd36ab6$var$_inherits(Template, _Component2);
    var _super2 = $cae24fad0dd36ab6$var$_createSuper(Template);
    function Template() {
        $cae24fad0dd36ab6$var$_classCallCheck(this, Template);
        return _super2.apply(this, arguments);
    }
    $cae24fad0dd36ab6$var$_createClass(Template, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $4198f5cd959b5a7d$export$248d38f6296296c5)(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !(0, $4198f5cd959b5a7d$export$248d38f6296296c5)(this.props.rootProps, nextProps.rootProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var nonFunctionTemplates;
                var RootTagName = this.props.rootTagName === "fragment" ? (0, $450fc775b2f7950e$export$ffb0004e005737fa) : this.props.rootTagName;
                var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
                var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
                var content = (0, $3f879671235ebefb$export$b5c363744c17aeab)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: compileOptions,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                    sendEvent: this.props.sendEvent
                });
                if (content === null) // Adds a noscript to the DOM but virtual DOM is null
                // See http://facebook.github.io/react/docs/component-specs.html#render
                return null;
                if ($cae24fad0dd36ab6$var$_typeof(content) === "object") return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(RootTagName, this.props.rootProps, content);
                // This is to handle Hogan templates with Fragment as rootTagName
                if (RootTagName === (0, $450fc775b2f7950e$export$ffb0004e005737fa)) return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($cae24fad0dd36ab6$var$RawHtml, {
                    content: content,
                    key: Math.random()
                });
                return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(RootTagName, $cae24fad0dd36ab6$var$_extends({}, this.props.rootProps, {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }));
            }
        }
    ]);
    return Template;
}((0, $450fc775b2f7950e$export$16fa2f45be04daa8));
$cae24fad0dd36ab6$var$_defineProperty($cae24fad0dd36ab6$var$Template, "defaultProps", $cae24fad0dd36ab6$var$defaultProps);
var $cae24fad0dd36ab6$export$2e2bcd8739ae039 = $cae24fad0dd36ab6$var$Template;


function $9efb32683b3714cf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9efb32683b3714cf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9efb32683b3714cf$var$_typeof(obj);
}
function $9efb32683b3714cf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9efb32683b3714cf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9efb32683b3714cf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9efb32683b3714cf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9efb32683b3714cf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9efb32683b3714cf$var$_defineProperty(obj, key, value) {
    key = $9efb32683b3714cf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9efb32683b3714cf$var$_toPropertyKey(arg) {
    var key = $9efb32683b3714cf$var$_toPrimitive(arg, "string");
    return $9efb32683b3714cf$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9efb32683b3714cf$var$_toPrimitive(input, hint) {
    if ($9efb32683b3714cf$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9efb32683b3714cf$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9efb32683b3714cf$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $9efb32683b3714cf$var$_objectSpread($9efb32683b3714cf$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

function $35cb44110fb52d3a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $35cb44110fb52d3a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $35cb44110fb52d3a$var$_typeof(obj);
}
function $35cb44110fb52d3a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $35cb44110fb52d3a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $35cb44110fb52d3a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $35cb44110fb52d3a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $35cb44110fb52d3a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $35cb44110fb52d3a$var$_defineProperty(obj, key, value) {
    key = $35cb44110fb52d3a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $35cb44110fb52d3a$var$_toPropertyKey(arg) {
    var key = $35cb44110fb52d3a$var$_toPrimitive(arg, "string");
    return $35cb44110fb52d3a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $35cb44110fb52d3a$var$_toPrimitive(input, hint) {
    if ($35cb44110fb52d3a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($35cb44110fb52d3a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $35cb44110fb52d3a$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $35cb44110fb52d3a$var$_objectSpread($35cb44110fb52d3a$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}

function $3e64027c30ce4d57$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}


function $86d1c5f90fff2f24$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $3e64027c30ce4d57$export$11cc42aebef2ef3a)(rendering), ").\n\n").concat(usage));
}


function $35748c0c4c0cd014$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $35748c0c4c0cd014$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $35748c0c4c0cd014$var$ownKeys(Object(source), !0).forEach(function(key) {
            $35748c0c4c0cd014$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $35748c0c4c0cd014$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $35748c0c4c0cd014$var$_defineProperty(obj, key, value) {
    key = $35748c0c4c0cd014$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $35748c0c4c0cd014$var$_toPropertyKey(arg) {
    var key = $35748c0c4c0cd014$var$_toPrimitive(arg, "string");
    return $35748c0c4c0cd014$var$_typeof(key) === "symbol" ? key : String(key);
}
function $35748c0c4c0cd014$var$_toPrimitive(input, hint) {
    if ($35748c0c4c0cd014$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($35748c0c4c0cd014$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $35748c0c4c0cd014$var$_slicedToArray(arr, i) {
    return $35748c0c4c0cd014$var$_arrayWithHoles(arr) || $35748c0c4c0cd014$var$_iterableToArrayLimit(arr, i) || $35748c0c4c0cd014$var$_unsupportedIterableToArray(arr, i) || $35748c0c4c0cd014$var$_nonIterableRest();
}
function $35748c0c4c0cd014$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $35748c0c4c0cd014$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $35748c0c4c0cd014$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $35748c0c4c0cd014$var$_arrayLikeToArray(o, minLen);
}
function $35748c0c4c0cd014$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $35748c0c4c0cd014$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $35748c0c4c0cd014$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $35748c0c4c0cd014$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $35748c0c4c0cd014$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $35748c0c4c0cd014$var$_typeof(obj);
}
function $35748c0c4c0cd014$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $35748c0c4c0cd014$export$2f82a8f6391c6db9(_ref) {
    var getIndex = _ref.getIndex, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $35748c0c4c0cd014$var$_typeof(args[0]) === "object") return [
        args[0]
    ];
    var _args$0$split = args[0].split(":"), _args$0$split2 = $35748c0c4c0cd014$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === "click" || eventType === "conversion") && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $35748c0c4c0cd014$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === "view") {
        if (instantSearchInstance.status !== "idle") return [];
        return hitsChunks.map(function(batch, i) {
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: widgetType,
                eventType: eventType,
                payload: $35748c0c4c0cd014$var$_objectSpread({
                    eventName: eventName || "Hits Viewed",
                    index: getIndex(),
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === "click") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $35748c0c4c0cd014$var$_objectSpread({
                eventName: eventName || "Hit Clicked",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === "conversion") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $35748c0c4c0cd014$var$_objectSpread({
                eventName: eventName || "Hit Converted",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $35748c0c4c0cd014$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, getIndex = _ref2.getIndex, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $35748c0c4c0cd014$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "sendEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $35748c0c4c0cd014$export$5a3d9973824d9b76(_ref3) {
    var getIndex = _ref3.getIndex, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $35748c0c4c0cd014$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "bindEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $61d6f7a445550123$export$44b4521aa38272f2)(payloads)) : "";
    };
    return bindEventForHits;
}


function $cf783656762e2f5f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $cf783656762e2f5f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $cf783656762e2f5f$var$_typeof(obj);
}
function $cf783656762e2f5f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cf783656762e2f5f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cf783656762e2f5f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cf783656762e2f5f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cf783656762e2f5f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cf783656762e2f5f$var$_defineProperty(obj, key, value) {
    key = $cf783656762e2f5f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf783656762e2f5f$var$_toPropertyKey(arg) {
    var key = $cf783656762e2f5f$var$_toPrimitive(arg, "string");
    return $cf783656762e2f5f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $cf783656762e2f5f$var$_toPrimitive(input, hint) {
    if ($cf783656762e2f5f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($cf783656762e2f5f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $cf783656762e2f5f$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "hits",
    connector: true
});
var $cf783656762e2f5f$export$2e2bcd8739ae039 = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $dba781b2f4cd6c52$export$8793edee2d425525);
    (0, $86d1c5f90fff2f24$export$adc2a8e09aa583ee)(renderFn, $cf783656762e2f5f$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($cf783656762e2f5f$var$_objectSpread($cf783656762e2f5f$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($cf783656762e2f5f$var$_objectSpread($cf783656762e2f5f$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent("view:internal", renderState.items);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $cf783656762e2f5f$var$_objectSpread($cf783656762e2f5f$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $35748c0c4c0cd014$export$4139f3a7130239e3)({
                    instantSearchInstance: instantSearchInstance,
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $35748c0c4c0cd014$export$5a3d9973824d9b76)({
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    items: [],
                    results: undefined,
                    banner: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $ea7b3b8ada1be339$export$9adb036445aab889)(results.hits);
                var hitsWithAbsolutePosition = (0, $9efb32683b3714cf$export$33d742d8ee5a4609)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $35cb44110fb52d3a$export$b8f834386ea30952)(hitsWithAbsolutePosition, results.queryID);
                var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                return {
                    hits: items,
                    items: items,
                    results: results,
                    banner: banner,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $ea7b3b8ada1be339$export$1e7338a8952eaf35)).reduce(function(acc, key) {
                    return $cf783656762e2f5f$var$_objectSpread($cf783656762e2f5f$var$_objectSpread({}, acc), {}, $cf783656762e2f5f$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $ea7b3b8ada1be339$export$1e7338a8952eaf35));
            }
        };
    };
};



function $b60166d8fe31c83e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b60166d8fe31c83e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b60166d8fe31c83e$var$_typeof(obj);
}
function $b60166d8fe31c83e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b60166d8fe31c83e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b60166d8fe31c83e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $b60166d8fe31c83e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $b60166d8fe31c83e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b60166d8fe31c83e$var$_defineProperty(obj, key, value) {
    key = $b60166d8fe31c83e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b60166d8fe31c83e$var$_toPropertyKey(arg) {
    var key = $b60166d8fe31c83e$var$_toPrimitive(arg, "string");
    return $b60166d8fe31c83e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $b60166d8fe31c83e$var$_toPrimitive(input, hint) {
    if ($b60166d8fe31c83e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b60166d8fe31c83e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $b60166d8fe31c83e$var$getSelectedHits = function getSelectedHits(hits, selectedObjectIDs) {
    return selectedObjectIDs.map(function(objectID) {
        var hit = (0, $22d7156510102177$export$71aa6c912b956294)(hits, function(h) {
            return h.objectID === objectID;
        });
        if (typeof hit === "undefined") throw new Error('Could not find objectID "'.concat(objectID, '" passed to `clickedObjectIDsAfterSearch` in the returned hits. This is necessary to infer the absolute position and the query ID.'));
        return hit;
    });
};
var $b60166d8fe31c83e$var$getQueryID = function getQueryID(selectedHits) {
    var queryIDs = (0, $6b9ab3bbb605ca60$export$f70730c3d1fc524e)(selectedHits.map(function(hit) {
        return hit.__queryID;
    }));
    if (queryIDs.length > 1) throw new Error("Insights currently allows a single `queryID`. The `objectIDs` provided map to multiple `queryID`s.");
    var queryID = queryIDs[0];
    if (typeof queryID !== "string") throw new Error("Could not infer `queryID`. Ensure InstantSearch `clickAnalytics: true` was added with the Configure widget.\n\nSee: https://alg.li/lNiZZ7");
    return queryID;
};
var $b60166d8fe31c83e$var$getPositions = function getPositions(selectedHits) {
    return selectedHits.map(function(hit) {
        return hit.__position;
    });
};
var $b60166d8fe31c83e$export$24bd91850d68b36c = function inferPayload(_ref) {
    var method = _ref.method, results = _ref.results, hits = _ref.hits, objectIDs = _ref.objectIDs;
    var index = results.index;
    var selectedHits = $b60166d8fe31c83e$var$getSelectedHits(hits, objectIDs);
    var queryID = $b60166d8fe31c83e$var$getQueryID(selectedHits);
    switch(method){
        case "clickedObjectIDsAfterSearch":
            var positions = $b60166d8fe31c83e$var$getPositions(selectedHits);
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs,
                positions: positions
            };
        case "convertedObjectIDsAfterSearch":
            return {
                index: index,
                queryID: queryID,
                objectIDs: objectIDs
            };
        default:
            throw new Error('Unsupported method passed to insights: "'.concat(method, '".'));
    }
};
var $b60166d8fe31c83e$var$wrapInsightsClient = function wrapInsightsClient(aa, results, hits) {
    return function(method) {
        for(var _len = arguments.length, payloads = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)payloads[_key - 1] = arguments[_key];
        var payload = payloads[0];
        if (!aa) {
            var withInstantSearchUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
                name: "instantsearch"
            });
            throw new Error(withInstantSearchUsage("The `insightsClient` option has not been provided to `instantsearch`."));
        }
        if (!Array.isArray(payload.objectIDs)) throw new TypeError("Expected `objectIDs` to be an array.");
        var inferredPayload = $b60166d8fe31c83e$export$24bd91850d68b36c({
            method: method,
            results: results,
            hits: hits,
            objectIDs: payload.objectIDs
        });
        aa(method, $b60166d8fe31c83e$var$_objectSpread($b60166d8fe31c83e$var$_objectSpread({}, inferredPayload), payload));
    };
};
function $b60166d8fe31c83e$export$2e2bcd8739ae039(connector) {
    return function(renderFn, unmountFn) {
        return connector(function(renderOptions, isFirstRender) {
            var results = renderOptions.results, hits = renderOptions.hits, instantSearchInstance = renderOptions.instantSearchInstance;
            if (results && hits && instantSearchInstance) {
                var insights = $b60166d8fe31c83e$var$wrapInsightsClient(instantSearchInstance.insightsClient, results, hits);
                return renderFn($b60166d8fe31c83e$var$_objectSpread($b60166d8fe31c83e$var$_objectSpread({}, renderOptions), {}, {
                    insights: insights
                }), isFirstRender);
            }
            return renderFn(renderOptions, isFirstRender);
        }, unmountFn);
    };
}





var $fc9ea6db8b6fe186$export$71d036cfbce90975 = function createInsightsEventHandler(_ref) {
    var insights = _ref.insights, sendEvent = _ref.sendEvent;
    return function(event) {
        // new way, e.g. bindEvent("click", hit, "Hit clicked")
        var insightsThroughSendEvent = $fc9ea6db8b6fe186$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute("data-insights-event");
        });
        if (insightsThroughSendEvent) {
            var payload = $fc9ea6db8b6fe186$var$parseInsightsEvent(insightsThroughSendEvent);
            payload.forEach(function(single) {
                return sendEvent(single);
            });
        }
        // old way, e.g. instantsearch.insights("clickedObjectIDsAfterSearch", { .. })
        var insightsThroughFunction = $fc9ea6db8b6fe186$var$findInsightsTarget(event.target, event.currentTarget, function(element) {
            return element.hasAttribute("data-insights-method") && element.hasAttribute("data-insights-payload");
        });
        if (insightsThroughFunction) {
            var _readDataAttributes = (0, $62dc5ddd84fbc4d2$export$cbcfede36ce7ab2e)(insightsThroughFunction), method = _readDataAttributes.method, _payload = _readDataAttributes.payload;
            insights(method, _payload);
        }
    };
};
function $fc9ea6db8b6fe186$var$findInsightsTarget(startElement, endElement, validator) {
    var element = startElement;
    while(element && !validator(element)){
        if (element === endElement) return null;
        element = element.parentElement;
    }
    return element;
}
function $fc9ea6db8b6fe186$var$parseInsightsEvent(element) {
    var serializedPayload = element.getAttribute("data-insights-event");
    if (typeof serializedPayload !== "string") throw new Error("The insights middleware expects `data-insights-event` to be a base64-encoded JSON string.");
    try {
        return (0, $61d6f7a445550123$export$706ea24b0964bee9)(serializedPayload);
    } catch (error) {
        throw new Error("The insights middleware was unable to parse `data-insights-event`.");
    }
}
function $fc9ea6db8b6fe186$export$2e2bcd8739ae039(BaseComponent) {
    return function WithInsightsListener(props) {
        var handleClick = $fc9ea6db8b6fe186$export$71d036cfbce90975(props);
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
            onClick: handleClick
        }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)(BaseComponent, props));
    };
}



function $1f15ae9d41409849$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1f15ae9d41409849$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1f15ae9d41409849$var$_typeof(obj);
}
function $1f15ae9d41409849$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1f15ae9d41409849$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1f15ae9d41409849$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1f15ae9d41409849$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1f15ae9d41409849$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1f15ae9d41409849$var$_defineProperty(obj, key, value) {
    key = $1f15ae9d41409849$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1f15ae9d41409849$var$_toPropertyKey(arg) {
    var key = $1f15ae9d41409849$var$_toPrimitive(arg, "string");
    return $1f15ae9d41409849$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1f15ae9d41409849$var$_toPrimitive(input, hint) {
    if ($1f15ae9d41409849$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1f15ae9d41409849$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1f15ae9d41409849$var$_toConsumableArray(arr) {
    return $1f15ae9d41409849$var$_arrayWithoutHoles(arr) || $1f15ae9d41409849$var$_iterableToArray(arr) || $1f15ae9d41409849$var$_unsupportedIterableToArray(arr) || $1f15ae9d41409849$var$_nonIterableSpread();
}
function $1f15ae9d41409849$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1f15ae9d41409849$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1f15ae9d41409849$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1f15ae9d41409849$var$_arrayLikeToArray(o, minLen);
}
function $1f15ae9d41409849$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1f15ae9d41409849$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1f15ae9d41409849$var$_arrayLikeToArray(arr);
}
function $1f15ae9d41409849$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1f15ae9d41409849$var$prepareTemplates(// can not use = {} here, since the template could have different constraints
defaultTemplates) {
    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allKeys = (0, $6b9ab3bbb605ca60$export$f70730c3d1fc524e)([].concat($1f15ae9d41409849$var$_toConsumableArray(Object.keys(defaultTemplates || {})), $1f15ae9d41409849$var$_toConsumableArray(Object.keys(templates))));
    return allKeys.reduce(function(config, key) {
        var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
        var customTemplate = templates[key];
        var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
        config.templates[key] = isCustomTemplate ? customTemplate : defaultTemplate;
        config.useCustomCompileOptions[key] = isCustomTemplate;
        return config;
    }, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        templates: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        useCustomCompileOptions: {}
    });
}
function $1f15ae9d41409849$export$2938ff6a58d41f25(_ref) {
    var defaultTemplates = _ref.defaultTemplates, templates = _ref.templates, templatesConfig = _ref.templatesConfig;
    var preparedTemplates = $1f15ae9d41409849$var$prepareTemplates(defaultTemplates, templates);
    return $1f15ae9d41409849$var$_objectSpread({
        templatesConfig: templatesConfig
    }, preparedTemplates);
}


function $667f900b0d79382b$export$124b2c3e0d3efb2d(object) {
    return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}


function $964d85af6623150d$export$ffb2c7b8d67c359a(selectorOrHTMLElement) {
    var isSelectorString = typeof selectorOrHTMLElement === "string";
    var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
    if (!(0, $667f900b0d79382b$export$124b2c3e0d3efb2d)(domElement)) {
        var errorMessage = "Container must be `string` or `HTMLElement`.";
        if (isSelectorString) errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
        throw new Error(errorMessage);
    }
    return domElement;
}


/**
 * Creates a new object with the same keys as the original object, but without the excluded keys.
 * @param source original object
 * @param excluded keys to remove from the original object
 * @returns the new object
 */ function $a0024d42ca1e729c$export$30a06c8d3562193f(source, excluded) {
    if (source === null || source === undefined) return source;
    return Object.keys(source).reduce(function(target, key) {
        if (excluded.indexOf(key) >= 0) return target;
        var validKey = key;
        target[validKey] = source[validKey];
        return target;
    }, {});
}


// false positive lint error
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
var $86221d5f03b17c54$var$defaultTemplates = {
    empty: function empty() {
        return "No results";
    },
    item: function item(data) {
        return JSON.stringify((0, $a0024d42ca1e729c$export$30a06c8d3562193f)(data, [
            "__hitIndex"
        ]), null, 2);
    }
};
var $86221d5f03b17c54$export$2e2bcd8739ae039 = $86221d5f03b17c54$var$defaultTemplates;


function $9169b8376f1e6cf3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9169b8376f1e6cf3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9169b8376f1e6cf3$var$_typeof(obj);
}
var $9169b8376f1e6cf3$var$_excluded = [
    "hit",
    "index"
];
function $9169b8376f1e6cf3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9169b8376f1e6cf3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9169b8376f1e6cf3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9169b8376f1e6cf3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9169b8376f1e6cf3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9169b8376f1e6cf3$var$_defineProperty(obj, key, value) {
    key = $9169b8376f1e6cf3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9169b8376f1e6cf3$var$_toPropertyKey(arg) {
    var key = $9169b8376f1e6cf3$var$_toPrimitive(arg, "string");
    return $9169b8376f1e6cf3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9169b8376f1e6cf3$var$_toPrimitive(input, hint) {
    if ($9169b8376f1e6cf3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9169b8376f1e6cf3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9169b8376f1e6cf3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9169b8376f1e6cf3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9169b8376f1e6cf3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9169b8376f1e6cf3$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $9169b8376f1e6cf3$var$_extends() {
    $9169b8376f1e6cf3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9169b8376f1e6cf3$var$_extends.apply(this, arguments);
}
var $9169b8376f1e6cf3$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "hits"
});
var $9169b8376f1e6cf3$var$Hits = (0, $3fecd81ee4a0b4ae$export$abc871145e3e685)({
    createElement: (0, $450fc775b2f7950e$export$c8a8987d4410bf2d),
    Fragment: (0, $450fc775b2f7950e$export$ffb0004e005737fa)
});
var $9169b8376f1e6cf3$var$renderer = function renderer(_ref) {
    var renderState = _ref.renderState, cssClasses = _ref.cssClasses, containerNode = _ref.containerNode, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var items = _ref2.items, results = _ref2.results, instantSearchInstance = _ref2.instantSearchInstance, insights = _ref2.insights, bindEvent = _ref2.bindEvent, sendEvent = _ref2.sendEvent, banner = _ref2.banner;
        if (isFirstRendering) {
            renderState.templateProps = (0, $1f15ae9d41409849$export$2938ff6a58d41f25)({
                defaultTemplates: (0, $86221d5f03b17c54$export$2e2bcd8739ae039),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        var handleInsightsClick = (0, $fc9ea6db8b6fe186$export$71d036cfbce90975)({
            insights: insights,
            sendEvent: sendEvent
        });
        var emptyComponent = function emptyComponent(_ref3) {
            var rootProps = $9169b8376f1e6cf3$var$_extends({}, ($9169b8376f1e6cf3$var$_objectDestructuringEmpty(_ref3), _ref3));
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $cae24fad0dd36ab6$export$2e2bcd8739ae039), $9169b8376f1e6cf3$var$_extends({}, renderState.templateProps, {
                rootProps: rootProps,
                templateKey: "empty",
                data: results,
                rootTagName: "fragment"
            }));
        };
        // @MAJOR: Move default hit component back to the UI library
        // once flavour specificities are erased
        var itemComponent = function itemComponent(_ref4) {
            var hit = _ref4.hit, index = _ref4.index, rootProps = $9169b8376f1e6cf3$var$_objectWithoutProperties(_ref4, $9169b8376f1e6cf3$var$_excluded);
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $cae24fad0dd36ab6$export$2e2bcd8739ae039), $9169b8376f1e6cf3$var$_extends({}, renderState.templateProps, {
                templateKey: "item",
                rootTagName: "li",
                rootProps: $9169b8376f1e6cf3$var$_objectSpread($9169b8376f1e6cf3$var$_objectSpread({}, rootProps), {}, {
                    onClick: function onClick(event) {
                        handleInsightsClick(event);
                        rootProps.onClick();
                    },
                    onAuxClick: function onAuxClick(event) {
                        handleInsightsClick(event);
                        rootProps.onAuxClick();
                    }
                }),
                data: $9169b8376f1e6cf3$var$_objectSpread($9169b8376f1e6cf3$var$_objectSpread({}, hit), {}, {
                    get __hitIndex () {
                        return index;
                    }
                }),
                bindEvent: bindEvent,
                sendEvent: sendEvent
            }));
        };
        var bannerComponent = function bannerComponent(props) {
            return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $cae24fad0dd36ab6$export$2e2bcd8739ae039), $9169b8376f1e6cf3$var$_extends({}, renderState.templateProps, {
                templateKey: "banner",
                data: props,
                rootTagName: "fragment"
            }));
        };
        (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)($9169b8376f1e6cf3$var$Hits, {
            hits: items,
            itemComponent: itemComponent,
            sendEvent: sendEvent,
            classNames: cssClasses,
            emptyComponent: emptyComponent,
            banner: banner,
            bannerComponent: templates.banner ? bannerComponent : undefined
        }), containerNode);
    };
};
var $9169b8376f1e6cf3$export$2e2bcd8739ae039 = function hits(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, escapeHTML = _ref5.escapeHTML, transformItems = _ref5.transformItems, _ref5$templates = _ref5.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates, _ref5$cssClasses = _ref5.cssClasses, cssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses;
    if (!container) throw new Error($9169b8376f1e6cf3$var$withUsage("The `container` option is required."));
    var containerNode = (0, $964d85af6623150d$export$ffb2c7b8d67c359a)(container);
    var specializedRenderer = $9169b8376f1e6cf3$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $b60166d8fe31c83e$export$2e2bcd8739ae039)((0, $cf783656762e2f5f$export$2e2bcd8739ae039))(specializedRenderer, function() {
        return (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $9169b8376f1e6cf3$var$_objectSpread($9169b8376f1e6cf3$var$_objectSpread({}, makeWidget({
        escapeHTML: escapeHTML,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.hits"
    });
};






function $5fc4f1c021bd59de$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5fc4f1c021bd59de$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5fc4f1c021bd59de$var$_typeof(obj);
}
function $5fc4f1c021bd59de$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5fc4f1c021bd59de$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5fc4f1c021bd59de$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5fc4f1c021bd59de$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5fc4f1c021bd59de$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5fc4f1c021bd59de$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5fc4f1c021bd59de$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $5fc4f1c021bd59de$var$_setPrototypeOf(subClass, superClass);
}
function $5fc4f1c021bd59de$var$_setPrototypeOf(o, p) {
    $5fc4f1c021bd59de$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5fc4f1c021bd59de$var$_setPrototypeOf(o, p);
}
function $5fc4f1c021bd59de$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5fc4f1c021bd59de$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $5fc4f1c021bd59de$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $5fc4f1c021bd59de$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5fc4f1c021bd59de$var$_possibleConstructorReturn(this, result);
    };
}
function $5fc4f1c021bd59de$var$_possibleConstructorReturn(self, call) {
    if (call && ($5fc4f1c021bd59de$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $5fc4f1c021bd59de$var$_assertThisInitialized(self);
}
function $5fc4f1c021bd59de$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5fc4f1c021bd59de$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5fc4f1c021bd59de$var$_getPrototypeOf(o) {
    $5fc4f1c021bd59de$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5fc4f1c021bd59de$var$_getPrototypeOf(o);
}
function $5fc4f1c021bd59de$var$_defineProperty(obj, key, value) {
    key = $5fc4f1c021bd59de$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5fc4f1c021bd59de$var$_toPropertyKey(arg) {
    var key = $5fc4f1c021bd59de$var$_toPrimitive(arg, "string");
    return $5fc4f1c021bd59de$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5fc4f1c021bd59de$var$_toPrimitive(input, hint) {
    if ($5fc4f1c021bd59de$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5fc4f1c021bd59de$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $5fc4f1c021bd59de$var$defaultProps = {
    query: "",
    showSubmit: true,
    showReset: true,
    showLoadingIndicator: true,
    autofocus: false,
    searchAsYouType: true,
    ignoreCompositionEvents: false,
    isSearchStalled: false,
    disabled: false,
    ariaLabel: "Search",
    onChange: (0, $dba781b2f4cd6c52$export$8793edee2d425525),
    onSubmit: (0, $dba781b2f4cd6c52$export$8793edee2d425525),
    onReset: (0, $dba781b2f4cd6c52$export$8793edee2d425525),
    refine: (0, $dba781b2f4cd6c52$export$8793edee2d425525)
};
var $5fc4f1c021bd59de$var$SearchBox = /*#__PURE__*/ function(_Component) {
    $5fc4f1c021bd59de$var$_inherits(SearchBox, _Component);
    var _super = $5fc4f1c021bd59de$var$_createSuper(SearchBox);
    function SearchBox() {
        var _this;
        $5fc4f1c021bd59de$var$_classCallCheck(this, SearchBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "state", {
            query: _this.props.query,
            focused: false
        });
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "input", (0, $450fc775b2f7950e$export$7d1e3a5e95ceca43)());
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "onInput", function(event) {
            var _this$props = _this.props, searchAsYouType = _this$props.searchAsYouType, refine = _this$props.refine, onChange = _this$props.onChange;
            var query = event.target.value;
            if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
                if (searchAsYouType) refine(query);
                _this.setState({
                    query: query
                });
                onChange(event);
            }
        });
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "onSubmit", function(event) {
            var _this$props2 = _this.props, searchAsYouType = _this$props2.searchAsYouType, refine = _this$props2.refine, onSubmit = _this$props2.onSubmit;
            event.preventDefault();
            event.stopPropagation();
            if (_this.input.current) _this.input.current.blur();
            if (!searchAsYouType) refine(_this.state.query);
            onSubmit(event);
            return false;
        });
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "onReset", function(event) {
            var _this$props3 = _this.props, refine = _this$props3.refine, onReset = _this$props3.onReset;
            var query = "";
            if (_this.input.current) _this.input.current.focus();
            refine(query);
            _this.setState({
                query: query
            });
            onReset(event);
        });
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "onBlur", function() {
            _this.setState({
                focused: false
            });
        });
        $5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$_assertThisInitialized(_this), "onFocus", function() {
            _this.setState({
                focused: true
            });
        });
        return _this;
    }
    $5fc4f1c021bd59de$var$_createClass(SearchBox, [
        {
            key: "resetInput",
            value: /**
     * This public method is used in the RefinementList SFFV search box
     * to reset the input state when an item is selected.
     *
     * @see RefinementList#componentWillReceiveProps
     * @return {undefined}
     */ function resetInput() {
                this.setState({
                    query: ""
                });
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                /**
       * when the user is typing, we don't want to replace the query typed
       * by the user (state.query) with the query exposed by the connector (props.query)
       * see: https://github.com/algolia/instantsearch/issues/4141
       */ if (!this.state.focused && nextProps.query !== this.state.query) this.setState({
                    query: nextProps.query
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, cssClasses = _this$props4.cssClasses, placeholder = _this$props4.placeholder, autofocus = _this$props4.autofocus, showSubmit = _this$props4.showSubmit, showReset = _this$props4.showReset, showLoadingIndicator = _this$props4.showLoadingIndicator, templates = _this$props4.templates, isSearchStalled = _this$props4.isSearchStalled, ariaLabel = _this$props4.ariaLabel;
                return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("div", {
                    className: cssClasses.root
                }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("form", {
                    action: "",
                    role: "search",
                    className: cssClasses.form,
                    noValidate: true,
                    onSubmit: this.onSubmit,
                    onReset: this.onReset
                }, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("input", {
                    ref: this.input,
                    value: this.state.query,
                    disabled: this.props.disabled,
                    className: cssClasses.input,
                    type: "search",
                    placeholder: placeholder,
                    autoFocus: autofocus,
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false",
                    maxLength: 512,
                    onInput: this.onInput,
                    oncompositionend: this.onInput,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    "aria-label": ariaLabel
                }), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $cae24fad0dd36ab6$export$2e2bcd8739ae039), {
                    templateKey: "submit",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.submit,
                        type: "submit",
                        title: "Submit the search query",
                        hidden: !showSubmit
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $cae24fad0dd36ab6$export$2e2bcd8739ae039), {
                    templateKey: "reset",
                    rootTagName: "button",
                    rootProps: {
                        className: cssClasses.reset,
                        type: "reset",
                        title: "Clear the search query",
                        hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                }), showLoadingIndicator && (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $cae24fad0dd36ab6$export$2e2bcd8739ae039), {
                    templateKey: "loadingIndicator",
                    rootTagName: "span",
                    rootProps: {
                        className: cssClasses.loadingIndicator,
                        hidden: !isSearchStalled
                    },
                    templates: templates,
                    data: {
                        cssClasses: cssClasses
                    }
                })));
            }
        }
    ]);
    return SearchBox;
}((0, $450fc775b2f7950e$export$16fa2f45be04daa8));
$5fc4f1c021bd59de$var$_defineProperty($5fc4f1c021bd59de$var$SearchBox, "defaultProps", $5fc4f1c021bd59de$var$defaultProps);
var $5fc4f1c021bd59de$export$2e2bcd8739ae039 = $5fc4f1c021bd59de$var$SearchBox;



function $a12c3d9b688c0963$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a12c3d9b688c0963$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a12c3d9b688c0963$var$_typeof(obj);
}
function $a12c3d9b688c0963$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a12c3d9b688c0963$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $a12c3d9b688c0963$var$ownKeys(Object(source), !0).forEach(function(key) {
            $a12c3d9b688c0963$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $a12c3d9b688c0963$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a12c3d9b688c0963$var$_defineProperty(obj, key, value) {
    key = $a12c3d9b688c0963$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a12c3d9b688c0963$var$_toPropertyKey(arg) {
    var key = $a12c3d9b688c0963$var$_toPrimitive(arg, "string");
    return $a12c3d9b688c0963$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a12c3d9b688c0963$var$_toPrimitive(input, hint) {
    if ($a12c3d9b688c0963$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a12c3d9b688c0963$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $a12c3d9b688c0963$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "search-box",
    connector: true
});
/**
 * @typedef {Object} CustomSearchBoxWidgetParams
 * @property {function(string, function(string))} [queryHook = undefined] A function that will be called every time
 * a new value for the query is set. The first parameter is the query and the second is a
 * function to actually trigger the search. The function takes the query as the parameter.
 *
 * This queryHook can be used to debounce the number of searches done from the searchBox.
 */ var $a12c3d9b688c0963$var$defaultQueryHook = function defaultQueryHook(query, hook) {
    return hook(query);
};
/**
 * **SearchBox** connector provides the logic to build a widget that will let the user search for a query.
 *
 * The connector provides to the rendering: `refine()` to set the query. The behaviour of this function
 * may be impacted by the `queryHook` widget parameter.
 */ var $a12c3d9b688c0963$var$connectSearchBox = function connectSearchBox(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $dba781b2f4cd6c52$export$8793edee2d425525);
    (0, $86d1c5f90fff2f24$export$adc2a8e09aa583ee)(renderFn, $a12c3d9b688c0963$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$queryHook = _ref.queryHook, queryHook = _ref$queryHook === void 0 ? $a12c3d9b688c0963$var$defaultQueryHook : _ref$queryHook;
        var _refine;
        var _clear;
        return {
            $$type: "ais.searchBox",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($a12c3d9b688c0963$var$_objectSpread($a12c3d9b688c0963$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($a12c3d9b688c0963$var$_objectSpread($a12c3d9b688c0963$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref2) {
                var state = _ref2.state;
                unmountFn();
                return state.setQueryParameter("query", undefined);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $a12c3d9b688c0963$var$_objectSpread($a12c3d9b688c0963$var$_objectSpread({}, renderState), {}, {
                    searchBox: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref3) {
                var helper = _ref3.helper, instantSearchInstance = _ref3.instantSearchInstance, state = _ref3.state;
                if (!_refine) {
                    _refine = function _refine(query) {
                        queryHook(query, function(q) {
                            return helper.setQuery(q).search();
                        });
                    };
                    _clear = function _clear() {
                        helper.setQuery("").search();
                    };
                }
                return {
                    query: state.query || "",
                    refine: _refine,
                    clear: _clear,
                    widgetParams: widgetParams,
                    isSearchStalled: instantSearchInstance.status === "stalled"
                };
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var query = searchParameters.query || "";
                if (query === "" || uiState && uiState.query === query) return uiState;
                return $a12c3d9b688c0963$var$_objectSpread($a12c3d9b688c0963$var$_objectSpread({}, uiState), {}, {
                    query: query
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                return searchParameters.setQueryParameter("query", uiState.query || "");
            }
        };
    };
};
var $a12c3d9b688c0963$export$2e2bcd8739ae039 = $a12c3d9b688c0963$var$connectSearchBox;





var $effdadfbac31639d$var$_ref2 = (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("path", {
    d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
var $effdadfbac31639d$var$_ref4 = (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("path", {
    d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
var $effdadfbac31639d$var$_ref6 = (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("g", {
    fill: "none",
    "fill-rule": "evenodd"
}, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("g", {
    transform: "translate(1 1)",
    "stroke-width": "2"
}, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("circle", {
    "stroke-opacity": ".5",
    cx: "18",
    cy: "18",
    r: "18"
}), (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
}, (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
}))));
var $effdadfbac31639d$var$defaultTemplate = {
    reset: function reset(_ref) {
        var cssClasses = _ref.cssClasses;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("svg", {
            className: cssClasses.resetIcon,
            viewBox: "0 0 20 20",
            width: "10",
            height: "10",
            "aria-hidden": "true"
        }, $effdadfbac31639d$var$_ref2);
    },
    submit: function submit(_ref3) {
        var cssClasses = _ref3.cssClasses;
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("svg", {
            className: cssClasses.submitIcon,
            width: "10",
            height: "10",
            viewBox: "0 0 40 40",
            "aria-hidden": "true"
        }, $effdadfbac31639d$var$_ref4);
    },
    loadingIndicator: function loadingIndicator(_ref5) {
        var cssClasses = _ref5.cssClasses;
        /* eslint-disable react/no-unknown-property */ // Preact supports kebab case attributes, and using camel case would
        // require using `preact/compat`.
        // @TODO: reconsider using the `react` ESLint preset
        return (0, $450fc775b2f7950e$export$c8a8987d4410bf2d)("svg", {
            "aria-label": "Results are loading",
            className: cssClasses.loadingIcon,
            width: "16",
            height: "16",
            viewBox: "0 0 38 38",
            stroke: "#444",
            "aria-hidden": "true"
        }, $effdadfbac31639d$var$_ref6);
    /* eslint-enable react/no-unknown-property */ }
};
var $effdadfbac31639d$export$2e2bcd8739ae039 = $effdadfbac31639d$var$defaultTemplate;


function $246b5dcb151969a3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $246b5dcb151969a3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $246b5dcb151969a3$var$_typeof(obj);
}
function $246b5dcb151969a3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $246b5dcb151969a3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $246b5dcb151969a3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $246b5dcb151969a3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $246b5dcb151969a3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $246b5dcb151969a3$var$_defineProperty(obj, key, value) {
    key = $246b5dcb151969a3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $246b5dcb151969a3$var$_toPropertyKey(arg) {
    var key = $246b5dcb151969a3$var$_toPrimitive(arg, "string");
    return $246b5dcb151969a3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $246b5dcb151969a3$var$_toPrimitive(input, hint) {
    if ($246b5dcb151969a3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($246b5dcb151969a3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $246b5dcb151969a3$var$withUsage = (0, $049fad80b24500a5$export$2fde5bffc340821e)({
    name: "search-box"
});
var $246b5dcb151969a3$var$suit = (0, $26d2f3c47ecadc8f$export$d8556a2a8f973135)("SearchBox");
var $246b5dcb151969a3$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, placeholder = _ref.placeholder, templates = _ref.templates, autofocus = _ref.autofocus, searchAsYouType = _ref.searchAsYouType, ignoreCompositionEvents = _ref.ignoreCompositionEvents, showReset = _ref.showReset, showSubmit = _ref.showSubmit, showLoadingIndicator = _ref.showLoadingIndicator;
    return function(_ref2) {
        var refine = _ref2.refine, query = _ref2.query, isSearchStalled = _ref2.isSearchStalled;
        (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)((0, $450fc775b2f7950e$export$c8a8987d4410bf2d)((0, $5fc4f1c021bd59de$export$2e2bcd8739ae039), {
            query: query,
            placeholder: placeholder,
            autofocus: autofocus,
            refine: refine,
            searchAsYouType: searchAsYouType,
            ignoreCompositionEvents: ignoreCompositionEvents,
            templates: templates,
            showSubmit: showSubmit,
            showReset: showReset,
            showLoadingIndicator: showLoadingIndicator,
            isSearchStalled: isSearchStalled,
            cssClasses: cssClasses
        }), containerNode);
    };
};
/**
 * The searchbox widget is used to let the user set a text based query.
 *
 * This is usually the  main entry point to start the search in an instantsearch context. For that
 * reason is usually placed on top, and not hidden so that the user can start searching right
 * away.
 *
 */ var $246b5dcb151969a3$var$searchBox = function searchBox(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$placeholder = _ref3.placeholder, placeholder = _ref3$placeholder === void 0 ? "" : _ref3$placeholder, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses, _ref3$autofocus = _ref3.autofocus, autofocus = _ref3$autofocus === void 0 ? false : _ref3$autofocus, _ref3$searchAsYouType = _ref3.searchAsYouType, searchAsYouType = _ref3$searchAsYouType === void 0 ? true : _ref3$searchAsYouType, _ref3$ignoreCompositi = _ref3.ignoreCompositionEvents, ignoreCompositionEvents = _ref3$ignoreCompositi === void 0 ? false : _ref3$ignoreCompositi, _ref3$showReset = _ref3.showReset, showReset = _ref3$showReset === void 0 ? true : _ref3$showReset, _ref3$showSubmit = _ref3.showSubmit, showSubmit = _ref3$showSubmit === void 0 ? true : _ref3$showSubmit, _ref3$showLoadingIndi = _ref3.showLoadingIndicator, showLoadingIndicator = _ref3$showLoadingIndi === void 0 ? true : _ref3$showLoadingIndi, queryHook = _ref3.queryHook, _ref3$templates = _ref3.templates, userTemplates = _ref3$templates === void 0 ? {} : _ref3$templates;
    if (!container) throw new Error($246b5dcb151969a3$var$withUsage("The `container` option is required."));
    var containerNode = (0, $964d85af6623150d$export$ffb2c7b8d67c359a)(container);
    var cssClasses = {
        root: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit(), userCssClasses.root),
        form: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "form"
        }), userCssClasses.form),
        input: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "input"
        }), userCssClasses.input),
        submit: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "submit"
        }), userCssClasses.submit),
        submitIcon: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "submitIcon"
        }), userCssClasses.submitIcon),
        reset: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "reset"
        }), userCssClasses.reset),
        resetIcon: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "resetIcon"
        }), userCssClasses.resetIcon),
        loadingIndicator: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "loadingIndicator"
        }), userCssClasses.loadingIndicator),
        loadingIcon: (0, $6475aab5ef6929da$export$a274e22fb40f762e)($246b5dcb151969a3$var$suit({
            descendantName: "loadingIcon"
        }), userCssClasses.loadingIcon)
    };
    var templates = $246b5dcb151969a3$var$_objectSpread($246b5dcb151969a3$var$_objectSpread({}, (0, $effdadfbac31639d$export$2e2bcd8739ae039)), userTemplates);
    var specializedRenderer = $246b5dcb151969a3$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        placeholder: placeholder,
        templates: templates,
        autofocus: autofocus,
        searchAsYouType: searchAsYouType,
        ignoreCompositionEvents: ignoreCompositionEvents,
        showReset: showReset,
        showSubmit: showSubmit,
        showLoadingIndicator: showLoadingIndicator
    });
    var makeWidget = (0, $a12c3d9b688c0963$export$2e2bcd8739ae039)(specializedRenderer, function() {
        return (0, $450fc775b2f7950e$export$b3890eb0ae9dca99)(null, containerNode);
    });
    return $246b5dcb151969a3$var$_objectSpread($246b5dcb151969a3$var$_objectSpread({}, makeWidget({
        queryHook: queryHook
    })), {}, {
        $$widgetType: "ais.searchBox"
    });
};
var $246b5dcb151969a3$export$2e2bcd8739ae039 = $246b5dcb151969a3$var$searchBox;


var $775ca761c75bac68$exports = {};

(function(global1, factory) {
    factory($775ca761c75bac68$exports, (parcelRequire("91jyD")));
})($775ca761c75bac68$exports, function(exports1) {
    "use strict";
    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __rest(s, e) {
        var t = {};
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function") {
            for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
        }
        return t;
    }
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(g && (g = 0, op[0] && (_ = 0)), _)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    typeof SuppressedError === "function" && SuppressedError;
    var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    function createCommonjsModule(fn) {
        var module = {
            exports: {}
        };
        return fn(module, module.exports), module.exports;
    }
    var meilisearch_umd = createCommonjsModule(function(module, exports1) {
        (function(global1, factory) {
            factory(exports1);
        })(commonjsGlobal, function(exports1) {
            // Type definitions for meilisearch
            // Project: https://github.com/meilisearch/meilisearch-js
            // Definitions by: qdequele <quentin@meilisearch.com> <https://github.com/meilisearch>
            // Definitions: https://github.com/meilisearch/meilisearch-js
            // TypeScript Version: ^3.8.3
            /*
         * SEARCH PARAMETERS
         */ var MatchingStrategies = {
                ALL: "all",
                LAST: "last"
            };
            var ContentTypeEnum = {
                JSON: "application/json",
                CSV: "text/csv",
                NDJSON: "application/x-ndjson"
            };
            /*
         ** TASKS
         */ var TaskStatus = {
                TASK_SUCCEEDED: "succeeded",
                TASK_PROCESSING: "processing",
                TASK_FAILED: "failed",
                TASK_ENQUEUED: "enqueued",
                TASK_CANCELED: "canceled"
            };
            var TaskTypes = {
                DOCUMENTS_ADDITION_OR_UPDATE: "documentAdditionOrUpdate",
                DOCUMENT_DELETION: "documentDeletion",
                DUMP_CREATION: "dumpCreation",
                INDEX_CREATION: "indexCreation",
                INDEX_DELETION: "indexDeletion",
                INDEXES_SWAP: "indexSwap",
                INDEX_UPDATE: "indexUpdate",
                SETTINGS_UPDATE: "settingsUpdate",
                SNAPSHOT_CREATION: "snapshotCreation",
                TASK_CANCELATION: "taskCancelation",
                TASK_DELETION: "taskDeletion"
            };
            var ErrorStatusCode = {
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#index_creation_failed */ INDEX_CREATION_FAILED: "index_creation_failed",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_index_uid */ MISSING_INDEX_UID: "missing_index_uid",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#index_already_exists */ INDEX_ALREADY_EXISTS: "index_already_exists",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#index_not_found */ INDEX_NOT_FOUND: "index_not_found",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_index_uid */ INVALID_INDEX_UID: "invalid_index_uid",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#index_not_accessible */ INDEX_NOT_ACCESSIBLE: "index_not_accessible",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_index_offset */ INVALID_INDEX_OFFSET: "invalid_index_offset",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_index_limit */ INVALID_INDEX_LIMIT: "invalid_index_limit",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_state */ INVALID_STATE: "invalid_state",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#primary_key_inference_failed */ PRIMARY_KEY_INFERENCE_FAILED: "primary_key_inference_failed",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#index_primary_key_already_exists */ INDEX_PRIMARY_KEY_ALREADY_EXISTS: "index_primary_key_already_exists",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_index_primary_key */ INVALID_INDEX_PRIMARY_KEY: "invalid_index_primary_key",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#max_fields_limit_exceeded */ DOCUMENTS_FIELDS_LIMIT_REACHED: "document_fields_limit_reached",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_document_id */ MISSING_DOCUMENT_ID: "missing_document_id",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_document_id */ INVALID_DOCUMENT_ID: "invalid_document_id",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_content_type */ INVALID_CONTENT_TYPE: "invalid_content_type",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_content_type */ MISSING_CONTENT_TYPE: "missing_content_type",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_document_fields */ INVALID_DOCUMENT_FIELDS: "invalid_document_fields",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_document_limit */ INVALID_DOCUMENT_LIMIT: "invalid_document_limit",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_document_offset */ INVALID_DOCUMENT_OFFSET: "invalid_document_offset",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_document_filter */ INVALID_DOCUMENT_FILTER: "invalid_document_filter",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_document_filter */ MISSING_DOCUMENT_FILTER: "missing_document_filter",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_document_vectors_field */ INVALID_DOCUMENT_VECTORS_FIELD: "invalid_document_vectors_field",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#payload_too_large */ PAYLOAD_TOO_LARGE: "payload_too_large",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_payload */ MISSING_PAYLOAD: "missing_payload",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#malformed_payload */ MALFORMED_PAYLOAD: "malformed_payload",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#no_space_left_on_device */ NO_SPACE_LEFT_ON_DEVICE: "no_space_left_on_device",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_store_file */ INVALID_STORE_FILE: "invalid_store_file",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_ranking_rules */ INVALID_RANKING_RULES: "missing_document_id",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_request */ INVALID_REQUEST: "invalid_request",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_document_geo_field */ INVALID_DOCUMENT_GEO_FIELD: "invalid_document_geo_field",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_q */ INVALID_SEARCH_Q: "invalid_search_q",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_offset */ INVALID_SEARCH_OFFSET: "invalid_search_offset",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_limit */ INVALID_SEARCH_LIMIT: "invalid_search_limit",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_page */ INVALID_SEARCH_PAGE: "invalid_search_page",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_hits_per_page */ INVALID_SEARCH_HITS_PER_PAGE: "invalid_search_hits_per_page",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_attributes_to_retrieve */ INVALID_SEARCH_ATTRIBUTES_TO_RETRIEVE: "invalid_search_attributes_to_retrieve",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_attributes_to_crop */ INVALID_SEARCH_ATTRIBUTES_TO_CROP: "invalid_search_attributes_to_crop",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_crop_length */ INVALID_SEARCH_CROP_LENGTH: "invalid_search_crop_length",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_attributes_to_highlight */ INVALID_SEARCH_ATTRIBUTES_TO_HIGHLIGHT: "invalid_search_attributes_to_highlight",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_show_matches_position */ INVALID_SEARCH_SHOW_MATCHES_POSITION: "invalid_search_show_matches_position",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_filter */ INVALID_SEARCH_FILTER: "invalid_search_filter",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_sort */ INVALID_SEARCH_SORT: "invalid_search_sort",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_facets */ INVALID_SEARCH_FACETS: "invalid_search_facets",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_highlight_pre_tag */ INVALID_SEARCH_HIGHLIGHT_PRE_TAG: "invalid_search_highlight_pre_tag",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_highlight_post_tag */ INVALID_SEARCH_HIGHLIGHT_POST_TAG: "invalid_search_highlight_post_tag",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_crop_marker */ INVALID_SEARCH_CROP_MARKER: "invalid_search_crop_marker",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_matching_strategy */ INVALID_SEARCH_MATCHING_STRATEGY: "invalid_search_matching_strategy",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_vector */ INVALID_SEARCH_VECTOR: "invalid_search_vector",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_search_attributes_to_search_on */ INVALID_SEARCH_ATTRIBUTES_TO_SEARCH_ON: "invalid_search_attributes_to_search_on",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#bad_request */ BAD_REQUEST: "bad_request",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#document_not_found */ DOCUMENT_NOT_FOUND: "document_not_found",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#internal */ INTERNAL: "internal",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key */ INVALID_API_KEY: "invalid_api_key",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key_description */ INVALID_API_KEY_DESCRIPTION: "invalid_api_key_description",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key_actions */ INVALID_API_KEY_ACTIONS: "invalid_api_key_actions",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key_indexes */ INVALID_API_KEY_INDEXES: "invalid_api_key_indexes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key_expires_at */ INVALID_API_KEY_EXPIRES_AT: "invalid_api_key_expires_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#api_key_not_found */ API_KEY_NOT_FOUND: "api_key_not_found",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_api_key_uid */ IMMUTABLE_API_KEY_UID: "immutable_api_key_uid",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_api_key_actions */ IMMUTABLE_API_KEY_ACTIONS: "immutable_api_key_actions",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_api_key_indexes */ IMMUTABLE_API_KEY_INDEXES: "immutable_api_key_indexes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_api_key_expires_at */ IMMUTABLE_API_KEY_EXPIRES_AT: "immutable_api_key_expires_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_api_key_created_at */ IMMUTABLE_API_KEY_CREATED_AT: "immutable_api_key_created_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_api_key_updated_at */ IMMUTABLE_API_KEY_UPDATED_AT: "immutable_api_key_updated_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_authorization_header */ MISSING_AUTHORIZATION_HEADER: "missing_authorization_header",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#unretrievable_document */ UNRETRIEVABLE_DOCUMENT: "unretrievable_document",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#database_size_limit_reached */ MAX_DATABASE_SIZE_LIMIT_REACHED: "database_size_limit_reached",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#task_not_found */ TASK_NOT_FOUND: "task_not_found",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#dump_process_failed */ DUMP_PROCESS_FAILED: "dump_process_failed",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#dump_not_found */ DUMP_NOT_FOUND: "dump_not_found",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_swap_duplicate_index_found */ INVALID_SWAP_DUPLICATE_INDEX_FOUND: "invalid_swap_duplicate_index_found",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_swap_indexes */ INVALID_SWAP_INDEXES: "invalid_swap_indexes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_swap_indexes */ MISSING_SWAP_INDEXES: "missing_swap_indexes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_master_key */ MISSING_MASTER_KEY: "missing_master_key",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_types */ INVALID_TASK_TYPES: "invalid_task_types",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_uids */ INVALID_TASK_UIDS: "invalid_task_uids",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_statuses */ INVALID_TASK_STATUSES: "invalid_task_statuses",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_limit */ INVALID_TASK_LIMIT: "invalid_task_limit",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_from */ INVALID_TASK_FROM: "invalid_task_from",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_canceled_by */ INVALID_TASK_CANCELED_BY: "invalid_task_canceled_by",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_task_filters */ MISSING_TASK_FILTERS: "missing_task_filters",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#too_many_open_files */ TOO_MANY_OPEN_FILES: "too_many_open_files",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#io_error */ IO_ERROR: "io_error",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_index_uids */ INVALID_TASK_INDEX_UIDS: "invalid_task_index_uids",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_index_uid */ IMMUTABLE_INDEX_UID: "immutable_index_uid",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_index_created_at */ IMMUTABLE_INDEX_CREATED_AT: "immutable_index_created_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#immutable_index_updated_at */ IMMUTABLE_INDEX_UPDATED_AT: "immutable_index_updated_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_displayed_attributes */ INVALID_SETTINGS_DISPLAYED_ATTRIBUTES: "invalid_settings_displayed_attributes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_searchable_attributes */ INVALID_SETTINGS_SEARCHABLE_ATTRIBUTES: "invalid_settings_searchable_attributes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_filterable_attributes */ INVALID_SETTINGS_FILTERABLE_ATTRIBUTES: "invalid_settings_filterable_attributes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_sortable_attributes */ INVALID_SETTINGS_SORTABLE_ATTRIBUTES: "invalid_settings_sortable_attributes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_ranking_rules */ INVALID_SETTINGS_RANKING_RULES: "invalid_settings_ranking_rules",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_stop_words */ INVALID_SETTINGS_STOP_WORDS: "invalid_settings_stop_words",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_synonyms */ INVALID_SETTINGS_SYNONYMS: "invalid_settings_synonyms",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_distinct_attribute */ INVALID_SETTINGS_DISTINCT_ATTRIBUTE: "invalid_settings_distinct_attribute",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_typo_tolerance */ INVALID_SETTINGS_TYPO_TOLERANCE: "invalid_settings_typo_tolerance",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_faceting */ INVALID_SETTINGS_FACETING: "invalid_settings_faceting",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_settings_pagination */ INVALID_SETTINGS_PAGINATION: "invalid_settings_pagination",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_before_enqueued_at */ INVALID_TASK_BEFORE_ENQUEUED_AT: "invalid_task_before_enqueued_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_after_enqueued_at */ INVALID_TASK_AFTER_ENQUEUED_AT: "invalid_task_after_enqueued_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_before_started_at */ INVALID_TASK_BEFORE_STARTED_AT: "invalid_task_before_started_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_after_started_at */ INVALID_TASK_AFTER_STARTED_AT: "invalid_task_after_started_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_before_finished_at */ INVALID_TASK_BEFORE_FINISHED_AT: "invalid_task_before_finished_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_task_after_finished_at */ INVALID_TASK_AFTER_FINISHED_AT: "invalid_task_after_finished_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_api_key_actions */ MISSING_API_KEY_ACTIONS: "missing_api_key_actions",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_api_key_indexes */ MISSING_API_KEY_INDEXES: "missing_api_key_indexes",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_api_key_expires_at */ MISSING_API_KEY_EXPIRES_AT: "missing_api_key_expires_at",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key_limit */ INVALID_API_KEY_LIMIT: "invalid_api_key_limit",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_api_key_offset */ INVALID_API_KEY_OFFSET: "invalid_api_key_offset",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_facet_search_facet_name */ INVALID_FACET_SEARCH_FACET_NAME: "invalid_facet_search_facet_name",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#missing_facet_search_facet_name */ MISSING_FACET_SEARCH_FACET_NAME: "missing_facet_search_facet_name",
                /** @see https://www.meilisearch.com/docs/reference/errors/error_codes#invalid_facet_search_facet_query */ INVALID_FACET_SEARCH_FACET_QUERY: "invalid_facet_search_facet_query"
            };
            function _iterableToArrayLimit(r, l) {
                var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
                if (null != t) {
                    var e, n, i, u, a = [], f = !0, o = !1;
                    try {
                        if (i = (t = t.call(r)).next, 0 === l) {
                            if (Object(t) !== t) return;
                            f = !1;
                        } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
                    } catch (r) {
                        o = !0, n = r;
                    } finally{
                        try {
                            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                        } finally{
                            if (o) throw n;
                        }
                    }
                    return a;
                }
            }
            function _regeneratorRuntime() {
                _regeneratorRuntime = function() {
                    return e;
                };
                var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
                    t[e] = r.value;
                }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
                function define(t, e, r) {
                    return Object.defineProperty(t, e, {
                        value: r,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), t[e];
                }
                try {
                    define({}, "");
                } catch (t) {
                    define = function(t, e, r) {
                        return t[e] = r;
                    };
                }
                function wrap(t, e, r, n) {
                    var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
                    return o(a, "_invoke", {
                        value: makeInvokeMethod(t, r, c)
                    }), a;
                }
                function tryCatch(t, e, r) {
                    try {
                        return {
                            type: "normal",
                            arg: t.call(e, r)
                        };
                    } catch (t) {
                        return {
                            type: "throw",
                            arg: t
                        };
                    }
                }
                e.wrap = wrap;
                var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
                function Generator() {}
                function GeneratorFunction() {}
                function GeneratorFunctionPrototype() {}
                var p = {};
                define(p, a, function() {
                    return this;
                });
                var d = Object.getPrototypeOf, v = d && d(d(values([])));
                v && v !== r && n.call(v, a) && (p = v);
                var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
                function defineIteratorMethods(t) {
                    [
                        "next",
                        "throw",
                        "return"
                    ].forEach(function(e) {
                        define(t, e, function(t) {
                            return this._invoke(e, t);
                        });
                    });
                }
                function AsyncIterator(t, e) {
                    function invoke(r, o, i, a) {
                        var c = tryCatch(t[r], t, o);
                        if ("throw" !== c.type) {
                            var u = c.arg, h = u.value;
                            return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                                invoke("next", t, i, a);
                            }, function(t) {
                                invoke("throw", t, i, a);
                            }) : e.resolve(h).then(function(t) {
                                u.value = t, i(u);
                            }, function(t) {
                                return invoke("throw", t, i, a);
                            });
                        }
                        a(c.arg);
                    }
                    var r;
                    o(this, "_invoke", {
                        value: function(t, n) {
                            function callInvokeWithMethodAndArg() {
                                return new e(function(e, r) {
                                    invoke(t, n, e, r);
                                });
                            }
                            return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                        }
                    });
                }
                function makeInvokeMethod(e, r, n) {
                    var o = h;
                    return function(i, a) {
                        if (o === f) throw new Error("Generator is already running");
                        if (o === s) {
                            if ("throw" === i) throw a;
                            return {
                                value: t,
                                done: !0
                            };
                        }
                        for(n.method = i, n.arg = a;;){
                            var c = n.delegate;
                            if (c) {
                                var u = maybeInvokeDelegate(c, n);
                                if (u) {
                                    if (u === y) continue;
                                    return u;
                                }
                            }
                            if ("next" === n.method) n.sent = n._sent = n.arg;
                            else if ("throw" === n.method) {
                                if (o === h) throw o = s, n.arg;
                                n.dispatchException(n.arg);
                            } else "return" === n.method && n.abrupt("return", n.arg);
                            o = f;
                            var p = tryCatch(e, r, n);
                            if ("normal" === p.type) {
                                if (o = n.done ? s : l, p.arg === y) continue;
                                return {
                                    value: p.arg,
                                    done: n.done
                                };
                            }
                            "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
                        }
                    };
                }
                function maybeInvokeDelegate(e, r) {
                    var n = r.method, o = e.iterator[n];
                    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
                    var i = tryCatch(o, e.iterator, r.arg);
                    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
                    var a = i.arg;
                    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
                }
                function pushTryEntry(t) {
                    var e = {
                        tryLoc: t[0]
                    };
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
                }
                function resetTryEntry(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e;
                }
                function Context(t) {
                    this.tryEntries = [
                        {
                            tryLoc: "root"
                        }
                    ], t.forEach(pushTryEntry, this), this.reset(!0);
                }
                function values(e) {
                    if (e || "" === e) {
                        var r = e[a];
                        if (r) return r.call(e);
                        if ("function" == typeof e.next) return e;
                        if (!isNaN(e.length)) {
                            var o = -1, i = function next() {
                                for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                                return next.value = t, next.done = !0, next;
                            };
                            return i.next = i;
                        }
                    }
                    throw new TypeError(typeof e + " is not iterable");
                }
                return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
                    value: GeneratorFunctionPrototype,
                    configurable: !0
                }), o(GeneratorFunctionPrototype, "constructor", {
                    value: GeneratorFunction,
                    configurable: !0
                }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
                    var e = "function" == typeof t && t.constructor;
                    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
                }, e.mark = function(t) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
                }, e.awrap = function(t) {
                    return {
                        __await: t
                    };
                }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
                    return this;
                }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
                    void 0 === i && (i = Promise);
                    var a = new AsyncIterator(wrap(t, r, n, o), i);
                    return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
                        return t.done ? t.value : a.next();
                    });
                }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
                    return this;
                }), define(g, "toString", function() {
                    return "[object Generator]";
                }), e.keys = function(t) {
                    var e = Object(t), r = [];
                    for(var n in e)r.push(n);
                    return r.reverse(), function next() {
                        for(; r.length;){
                            var t = r.pop();
                            if (t in e) return next.value = t, next.done = !1, next;
                        }
                        return next.done = !0, next;
                    };
                }, e.values = values, Context.prototype = {
                    constructor: Context,
                    reset: function(e) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
                    },
                    stop: function() {
                        this.done = !0;
                        var t = this.tryEntries[0].completion;
                        if ("throw" === t.type) throw t.arg;
                        return this.rval;
                    },
                    dispatchException: function(e) {
                        if (this.done) throw e;
                        var r = this;
                        function handle(n, o) {
                            return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
                        }
                        for(var o = this.tryEntries.length - 1; o >= 0; --o){
                            var i = this.tryEntries[o], a = i.completion;
                            if ("root" === i.tryLoc) return handle("end");
                            if (i.tryLoc <= this.prev) {
                                var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                                if (c && u) {
                                    if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                    if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                                } else if (c) {
                                    if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                                } else {
                                    if (!u) throw new Error("try statement without catch or finally");
                                    if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function(t, e) {
                        for(var r = this.tryEntries.length - 1; r >= 0; --r){
                            var o = this.tryEntries[r];
                            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                                var i = o;
                                break;
                            }
                        }
                        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
                        var a = i ? i.completion : {};
                        return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
                    },
                    complete: function(t, e) {
                        if ("throw" === t.type) throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
                    },
                    finish: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
                        }
                    },
                    catch: function(t) {
                        for(var e = this.tryEntries.length - 1; e >= 0; --e){
                            var r = this.tryEntries[e];
                            if (r.tryLoc === t) {
                                var n = r.completion;
                                if ("throw" === n.type) {
                                    var o = n.arg;
                                    resetTryEntry(r);
                                }
                                return o;
                            }
                        }
                        throw new Error("illegal catch attempt");
                    },
                    delegateYield: function(e, r, n) {
                        return this.delegate = {
                            iterator: values(e),
                            resultName: r,
                            nextLoc: n
                        }, "next" === this.method && (this.arg = t), y;
                    }
                }, e;
            }
            function _toPrimitive(t, r) {
                if ("object" != typeof t || !t) return t;
                var e = t[Symbol.toPrimitive];
                if (void 0 !== e) {
                    var i = e.call(t, r || "default");
                    if ("object" != typeof i) return i;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === r ? String : Number)(t);
            }
            function _toPropertyKey(t) {
                var i = _toPrimitive(t, "string");
                return "symbol" == typeof i ? i : String(i);
            }
            function _typeof(o) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                    return typeof o;
                } : function(o) {
                    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                }, _typeof(o);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _isNativeReflectConstruct() {
                if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                if (Reflect.construct.sham) return false;
                if (typeof Proxy === "function") return true;
                try {
                    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                    return true;
                } catch (e) {
                    return false;
                }
            }
            function _construct(Parent, args, Class) {
                if (_isNativeReflectConstruct()) _construct = Reflect.construct.bind();
                else _construct = function _construct(Parent, args, Class) {
                    var a = [
                        null
                    ];
                    a.push.apply(a, args);
                    var Constructor = Function.bind.apply(Parent, a);
                    var instance = new Constructor();
                    if (Class) _setPrototypeOf(instance, Class.prototype);
                    return instance;
                };
                return _construct.apply(null, arguments);
            }
            function _isNativeFunction(fn) {
                try {
                    return Function.toString.call(fn).indexOf("[native code]") !== -1;
                } catch (e) {
                    return typeof fn === "function";
                }
            }
            function _wrapNativeSuper(Class) {
                var _cache = typeof Map === "function" ? new Map() : undefined;
                _wrapNativeSuper = function _wrapNativeSuper(Class) {
                    if (Class === null || !_isNativeFunction(Class)) return Class;
                    if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
                    if (typeof _cache !== "undefined") {
                        if (_cache.has(Class)) return _cache.get(Class);
                        _cache.set(Class, Wrapper);
                    }
                    function Wrapper() {
                        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
                    }
                    Wrapper.prototype = Object.create(Class.prototype, {
                        constructor: {
                            value: Wrapper,
                            enumerable: false,
                            writable: true,
                            configurable: true
                        }
                    });
                    return _setPrototypeOf(Wrapper, Class);
                };
                return _wrapNativeSuper(Class);
            }
            function _assertThisInitialized(self1) {
                if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self1;
            }
            function _possibleConstructorReturn(self1, call) {
                if (call && (typeof call === "object" || typeof call === "function")) return call;
                else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                return _assertThisInitialized(self1);
            }
            function _createSuper(Derived) {
                var hasNativeReflectConstruct = _isNativeReflectConstruct();
                return function _createSuperInternal() {
                    var Super = _getPrototypeOf(Derived), result;
                    if (hasNativeReflectConstruct) {
                        var NewTarget = _getPrototypeOf(this).constructor;
                        result = Reflect.construct(Super, arguments, NewTarget);
                    } else result = Super.apply(this, arguments);
                    return _possibleConstructorReturn(this, result);
                };
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
                return arr2;
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _createForOfIteratorHelper(o, allowArrayLike) {
                var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                if (!it) {
                    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                        if (it) o = it;
                        var i = 0;
                        var F = function() {};
                        return {
                            s: F,
                            n: function() {
                                if (i >= o.length) return {
                                    done: true
                                };
                                return {
                                    done: false,
                                    value: o[i++]
                                };
                            },
                            e: function(e) {
                                throw e;
                            },
                            f: F
                        };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var normalCompletion = true, didErr = false, err;
                return {
                    s: function() {
                        it = it.call(o);
                    },
                    n: function() {
                        var step = it.next();
                        normalCompletion = step.done;
                        return step;
                    },
                    e: function(e) {
                        didErr = true;
                        err = e;
                    },
                    f: function() {
                        try {
                            if (!normalCompletion && it.return != null) it.return();
                        } finally{
                            if (didErr) throw err;
                        }
                    }
                };
            }
            /******************************************************************************
        Copyright (c) Microsoft Corporation.
          Permission to use, copy, modify, and/or distribute this software for any
        purpose with or without fee is hereby granted.
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
        REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
        AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
        INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
        LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
        OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
        PERFORMANCE OF THIS SOFTWARE.
        ***************************************************************************** */ function __awaiter(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            }
            var MeiliSearchError = /*#__PURE__*/ function(_Error) {
                _inherits(MeiliSearchError, _Error);
                var _super = _createSuper(MeiliSearchError);
                function MeiliSearchError(message) {
                    var _this;
                    _classCallCheck(this, MeiliSearchError);
                    _this = _super.call(this, message);
                    // Make errors comparison possible. ex: error instanceof MeiliSearchError.
                    Object.setPrototypeOf(_assertThisInitialized(_this), MeiliSearchError.prototype);
                    _this.name = "MeiliSearchError";
                    if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), MeiliSearchError);
                    return _this;
                }
                return _createClass(MeiliSearchError);
            }(/*#__PURE__*/ _wrapNativeSuper(Error));
            var MeiliSearchCommunicationError = /*#__PURE__*/ function(_MeiliSearchError) {
                _inherits(MeiliSearchCommunicationError, _MeiliSearchError);
                var _super = _createSuper(MeiliSearchCommunicationError);
                function MeiliSearchCommunicationError(message, body, url, stack) {
                    var _this;
                    _classCallCheck(this, MeiliSearchCommunicationError);
                    var _a, _b, _c;
                    _this = _super.call(this, message);
                    // Make errors comparison possible. ex: error instanceof MeiliSearchCommunicationError.
                    Object.setPrototypeOf(_assertThisInitialized(_this), MeiliSearchCommunicationError.prototype);
                    _this.name = "MeiliSearchCommunicationError";
                    if (body instanceof Response) {
                        _this.message = body.statusText;
                        _this.statusCode = body.status;
                    }
                    if (body instanceof Error) {
                        _this.errno = body.errno;
                        _this.code = body.code;
                    }
                    if (stack) {
                        _this.stack = stack;
                        _this.stack = (_a = _this.stack) === null || _a === void 0 ? void 0 : _a.replace(/(TypeError|FetchError)/, _this.name);
                        _this.stack = (_b = _this.stack) === null || _b === void 0 ? void 0 : _b.replace("Failed to fetch", "request to ".concat(url, " failed, reason: connect ECONNREFUSED"));
                        _this.stack = (_c = _this.stack) === null || _c === void 0 ? void 0 : _c.replace("Not Found", "Not Found: ".concat(url));
                    } else if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), MeiliSearchCommunicationError);
                    return _this;
                }
                return _createClass(MeiliSearchCommunicationError);
            }(MeiliSearchError);
            var MeiliSearchApiError = /*#__PURE__*/ function(_MeiliSearchError) {
                _inherits(MeiliSearchApiError, _MeiliSearchError);
                var _super = _createSuper(MeiliSearchApiError);
                function MeiliSearchApiError(error, status) {
                    var _this;
                    _classCallCheck(this, MeiliSearchApiError);
                    _this = _super.call(this, error.message);
                    // Make errors comparison possible. ex: error instanceof MeiliSearchApiError.
                    Object.setPrototypeOf(_assertThisInitialized(_this), MeiliSearchApiError.prototype);
                    _this.name = "MeiliSearchApiError";
                    _this.code = error.code;
                    _this.type = error.type;
                    _this.link = error.link;
                    _this.message = error.message;
                    _this.httpStatus = status;
                    if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), MeiliSearchApiError);
                    return _this;
                }
                return _createClass(MeiliSearchApiError);
            }(MeiliSearchError);
            function httpResponseErrorHandler(response) {
                return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                    var responseBody;
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (response.ok) {
                                    _context.next = 11;
                                    break;
                                }
                                _context.prev = 1;
                                _context.next = 4;
                                return response.json();
                            case 4:
                                responseBody = _context.sent;
                                _context.next = 10;
                                break;
                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context["catch"](1);
                                throw new MeiliSearchCommunicationError(response.statusText, response, response.url);
                            case 10:
                                throw new MeiliSearchApiError(responseBody, response.status);
                            case 11:
                                return _context.abrupt("return", response);
                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
            }
            function httpErrorHandler(response, stack, url) {
                if (response.name !== "MeiliSearchApiError") throw new MeiliSearchCommunicationError(response.message, response, url, stack);
                throw response;
            }
            var MeiliSearchTimeOutError = /*#__PURE__*/ function(_MeiliSearchError) {
                _inherits(MeiliSearchTimeOutError, _MeiliSearchError);
                var _super = _createSuper(MeiliSearchTimeOutError);
                function MeiliSearchTimeOutError(message) {
                    var _this;
                    _classCallCheck(this, MeiliSearchTimeOutError);
                    _this = _super.call(this, message);
                    // Make errors comparison possible. ex: error instanceof MeiliSearchTimeOutError.
                    Object.setPrototypeOf(_assertThisInitialized(_this), MeiliSearchTimeOutError.prototype);
                    _this.name = "MeiliSearchTimeOutError";
                    if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized(_this), MeiliSearchTimeOutError);
                    return _this;
                }
                return _createClass(MeiliSearchTimeOutError);
            }(MeiliSearchError);
            function versionErrorHintMessage(message, method) {
                return "".concat(message, "\nHint: It might not be working because maybe you're not up to date with the Meilisearch version that ").concat(method, " call requires.");
            }
            /** Removes undefined entries from object */ function removeUndefinedFromObject(obj) {
                return Object.entries(obj).reduce(function(acc, curEntry) {
                    var _curEntry = _slicedToArray(curEntry, 2), key = _curEntry[0], val = _curEntry[1];
                    if (val !== undefined) acc[key] = val;
                    return acc;
                }, {});
            }
            function sleep(ms) {
                return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return new Promise(function(resolve) {
                                    return setTimeout(resolve, ms);
                                });
                            case 2:
                                return _context.abrupt("return", _context.sent);
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
            }
            function addProtocolIfNotPresent(host) {
                if (!(host.startsWith("https://") || host.startsWith("http://"))) return "http://".concat(host);
                return host;
            }
            function addTrailingSlash(url) {
                if (!url.endsWith("/")) url += "/";
                return url;
            }
            var PACKAGE_VERSION = "0.38.0";
            function toQueryParams(parameters) {
                var params = Object.keys(parameters);
                var queryParams = params.reduce(function(acc, key) {
                    var value = parameters[key];
                    if (value === undefined) return acc;
                    else if (Array.isArray(value)) return Object.assign(Object.assign({}, acc), _defineProperty({}, key, value.join(",")));
                    else if (value instanceof Date) return Object.assign(Object.assign({}, acc), _defineProperty({}, key, value.toISOString()));
                    return Object.assign(Object.assign({}, acc), _defineProperty({}, key, value));
                }, {});
                return queryParams;
            }
            function constructHostURL(host) {
                try {
                    host = addProtocolIfNotPresent(host);
                    host = addTrailingSlash(host);
                    return host;
                } catch (e) {
                    throw new MeiliSearchError("The provided host is not valid.");
                }
            }
            function cloneAndParseHeaders(headers) {
                if (Array.isArray(headers)) return headers.reduce(function(acc, headerPair) {
                    acc[headerPair[0]] = headerPair[1];
                    return acc;
                }, {});
                else if ("has" in headers) {
                    var clonedHeaders = {};
                    headers.forEach(function(value, key) {
                        return clonedHeaders[key] = value;
                    });
                    return clonedHeaders;
                } else return Object.assign({}, headers);
            }
            function createHeaders(config) {
                var _a, _b;
                var agentHeader = "X-Meilisearch-Client";
                var packageAgent = "Meilisearch JavaScript (v".concat(PACKAGE_VERSION, ")");
                var contentType = "Content-Type";
                var authorization = "Authorization";
                var headers = cloneAndParseHeaders((_b = (_a = config.requestConfig) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : {});
                // do not override if user provided the header
                if (config.apiKey && !headers[authorization]) headers[authorization] = "Bearer ".concat(config.apiKey);
                if (!headers[contentType]) headers["Content-Type"] = "application/json";
                // Creates the custom user agent with information on the package used.
                if (config.clientAgents && Array.isArray(config.clientAgents)) {
                    var clients = config.clientAgents.concat(packageAgent);
                    headers[agentHeader] = clients.join(" ; ");
                } else if (config.clientAgents && !Array.isArray(config.clientAgents)) // If the header is defined but not an array
                throw new MeiliSearchError('Meilisearch: The header "'.concat(agentHeader, '" should be an array of string(s).\n'));
                else headers[agentHeader] = packageAgent;
                return headers;
            }
            var HttpRequests = /*#__PURE__*/ function() {
                function HttpRequests(config) {
                    _classCallCheck(this, HttpRequests);
                    this.headers = createHeaders(config);
                    this.requestConfig = config.requestConfig;
                    this.httpClient = config.httpClient;
                    this.requestTimeout = config.timeout;
                    try {
                        var host = constructHostURL(config.host);
                        this.url = new URL(host);
                    } catch (e) {
                        throw new MeiliSearchError("The provided host is not valid.");
                    }
                }
                _createClass(HttpRequests, [
                    {
                        key: "request",
                        value: function request(_ref) {
                            var method = _ref.method, url = _ref.url, params = _ref.params, body = _ref.body, _ref$config = _ref.config, config = _ref$config === void 0 ? {} : _ref$config;
                            var _a;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                var constructURL, queryParams, headers, result, response, parsedBody, stack;
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            constructURL = new URL(url, this.url);
                                            if (params) {
                                                queryParams = new URLSearchParams();
                                                Object.keys(params).filter(function(x) {
                                                    return params[x] !== null;
                                                }).map(function(x) {
                                                    return queryParams.set(x, params[x]);
                                                });
                                                constructURL.search = queryParams.toString();
                                            }
                                            // in case a custom content-type is provided
                                            // do not stringify body
                                            if (!((_a = config.headers) === null || _a === void 0 ? void 0 : _a["Content-Type"])) body = JSON.stringify(body);
                                            headers = Object.assign(Object.assign({}, this.headers), config.headers);
                                            _context.prev = 5;
                                            result = this.fetchWithTimeout(constructURL.toString(), Object.assign(Object.assign(Object.assign({}, config), this.requestConfig), {
                                                method: method,
                                                body: body,
                                                headers: headers
                                            }), this.requestTimeout); // When using a custom HTTP client, the response is returned to allow the user to parse/handle it as they see fit
                                            if (!this.httpClient) {
                                                _context.next = 11;
                                                break;
                                            }
                                            _context.next = 10;
                                            return result;
                                        case 10:
                                            return _context.abrupt("return", _context.sent);
                                        case 11:
                                            _context.next = 13;
                                            return result.then(function(res) {
                                                return httpResponseErrorHandler(res);
                                            });
                                        case 13:
                                            response = _context.sent;
                                            _context.next = 16;
                                            return response.json().catch(function() {
                                                return undefined;
                                            });
                                        case 16:
                                            parsedBody = _context.sent;
                                            return _context.abrupt("return", parsedBody);
                                        case 20:
                                            _context.prev = 20;
                                            _context.t0 = _context["catch"](5);
                                            stack = _context.t0.stack;
                                            httpErrorHandler(_context.t0, stack, constructURL.toString());
                                        case 24:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, this, [
                                    [
                                        5,
                                        20
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "fetchWithTimeout",
                        value: function fetchWithTimeout(url, options, timeout) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                                var _this = this;
                                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            return _context2.abrupt("return", new Promise(function(resolve, reject) {
                                                var fetchFn = _this.httpClient ? _this.httpClient : fetch;
                                                var fetchPromise = fetchFn(url, options);
                                                var promises = [
                                                    fetchPromise
                                                ];
                                                // TimeoutPromise will not run if undefined or zero
                                                var timeoutId;
                                                if (timeout) {
                                                    var timeoutPromise = new Promise(function(_, reject) {
                                                        timeoutId = setTimeout(function() {
                                                            reject(new Error("Error: Request Timed Out"));
                                                        }, timeout);
                                                    });
                                                    promises.push(timeoutPromise);
                                                }
                                                Promise.race(promises).then(resolve).catch(reject).finally(function() {
                                                    clearTimeout(timeoutId);
                                                });
                                            }));
                                        case 1:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2);
                            }));
                        }
                    },
                    {
                        key: "get",
                        value: function get(url, params, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
                                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            _context3.next = 2;
                                            return this.request({
                                                method: "GET",
                                                url: url,
                                                params: params,
                                                config: config
                                            });
                                        case 2:
                                            return _context3.abrupt("return", _context3.sent);
                                        case 3:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3, this);
                            }));
                        }
                    },
                    {
                        key: "post",
                        value: function post(url, data, params, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee4() {
                                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            _context4.next = 2;
                                            return this.request({
                                                method: "POST",
                                                url: url,
                                                body: data,
                                                params: params,
                                                config: config
                                            });
                                        case 2:
                                            return _context4.abrupt("return", _context4.sent);
                                        case 3:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4, this);
                            }));
                        }
                    },
                    {
                        key: "put",
                        value: function put(url, data, params, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee5() {
                                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            _context5.next = 2;
                                            return this.request({
                                                method: "PUT",
                                                url: url,
                                                body: data,
                                                params: params,
                                                config: config
                                            });
                                        case 2:
                                            return _context5.abrupt("return", _context5.sent);
                                        case 3:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5, this);
                            }));
                        }
                    },
                    {
                        key: "patch",
                        value: function patch(url, data, params, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee6() {
                                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                                    while(true)switch(_context6.prev = _context6.next){
                                        case 0:
                                            _context6.next = 2;
                                            return this.request({
                                                method: "PATCH",
                                                url: url,
                                                body: data,
                                                params: params,
                                                config: config
                                            });
                                        case 2:
                                            return _context6.abrupt("return", _context6.sent);
                                        case 3:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }, _callee6, this);
                            }));
                        }
                    },
                    {
                        key: "delete",
                        value: function _delete(url, data, params, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee7() {
                                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            _context7.next = 2;
                                            return this.request({
                                                method: "DELETE",
                                                url: url,
                                                body: data,
                                                params: params,
                                                config: config
                                            });
                                        case 2:
                                            return _context7.abrupt("return", _context7.sent);
                                        case 3:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee7, this);
                            }));
                        }
                    }
                ]);
                return HttpRequests;
            }();
            var EnqueuedTask = /*#__PURE__*/ _createClass(function EnqueuedTask(task) {
                _classCallCheck(this, EnqueuedTask);
                this.taskUid = task.taskUid;
                this.indexUid = task.indexUid;
                this.status = task.status;
                this.type = task.type;
                this.enqueuedAt = new Date(task.enqueuedAt);
            });
            var Task = /*#__PURE__*/ _createClass(function Task(task) {
                _classCallCheck(this, Task);
                this.indexUid = task.indexUid;
                this.status = task.status;
                this.type = task.type;
                this.uid = task.uid;
                this.details = task.details;
                this.canceledBy = task.canceledBy;
                this.error = task.error;
                this.duration = task.duration;
                this.startedAt = new Date(task.startedAt);
                this.enqueuedAt = new Date(task.enqueuedAt);
                this.finishedAt = new Date(task.finishedAt);
            });
            var TaskClient = /*#__PURE__*/ function() {
                function TaskClient(config) {
                    _classCallCheck(this, TaskClient);
                    this.httpRequest = new HttpRequests(config);
                }
                /**
           * Get one task
           *
           * @param uid - Unique identifier of the task
           * @returns
           */ _createClass(TaskClient, [
                    {
                        key: "getTask",
                        value: function getTask(uid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                var url, taskItem;
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            url = "tasks/".concat(uid);
                                            _context.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            taskItem = _context.sent;
                                            return _context.abrupt("return", new Task(taskItem));
                                        case 5:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, this);
                            }));
                        }
                    },
                    {
                        key: "getTasks",
                        value: function getTasks() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                                var url, tasks;
                                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            url = "tasks";
                                            _context2.next = 3;
                                            return this.httpRequest.get(url, toQueryParams(parameters));
                                        case 3:
                                            tasks = _context2.sent;
                                            return _context2.abrupt("return", Object.assign(Object.assign({}, tasks), {
                                                results: tasks.results.map(function(task) {
                                                    return new Task(task);
                                                })
                                            }));
                                        case 5:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2, this);
                            }));
                        }
                    },
                    {
                        key: "waitForTask",
                        value: function waitForTask(taskUid) {
                            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$timeOutMs = _ref.timeOutMs, timeOutMs = _ref$timeOutMs === void 0 ? 5000 : _ref$timeOutMs, _ref$intervalMs = _ref.intervalMs, intervalMs = _ref$intervalMs === void 0 ? 50 : _ref$intervalMs;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
                                var startingTime, response;
                                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            startingTime = Date.now();
                                        case 1:
                                            if (!(Date.now() - startingTime < timeOutMs)) {
                                                _context3.next = 11;
                                                break;
                                            }
                                            _context3.next = 4;
                                            return this.getTask(taskUid);
                                        case 4:
                                            response = _context3.sent;
                                            if ([
                                                TaskStatus.TASK_ENQUEUED,
                                                TaskStatus.TASK_PROCESSING
                                            ].includes(response.status)) {
                                                _context3.next = 7;
                                                break;
                                            }
                                            return _context3.abrupt("return", response);
                                        case 7:
                                            _context3.next = 9;
                                            return sleep(intervalMs);
                                        case 9:
                                            _context3.next = 1;
                                            break;
                                        case 11:
                                            throw new MeiliSearchTimeOutError("timeout of ".concat(timeOutMs, "ms has exceeded on process ").concat(taskUid, " when waiting a task to be resolved."));
                                        case 12:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3, this);
                            }));
                        }
                    },
                    {
                        key: "waitForTasks",
                        value: function waitForTasks(taskUids) {
                            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$timeOutMs = _ref2.timeOutMs, timeOutMs = _ref2$timeOutMs === void 0 ? 5000 : _ref2$timeOutMs, _ref2$intervalMs = _ref2.intervalMs, intervalMs = _ref2$intervalMs === void 0 ? 50 : _ref2$intervalMs;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee4() {
                                var tasks, _iterator, _step, taskUid, task;
                                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            tasks = [];
                                            _iterator = _createForOfIteratorHelper(taskUids);
                                            _context4.prev = 2;
                                            _iterator.s();
                                        case 4:
                                            if ((_step = _iterator.n()).done) {
                                                _context4.next = 12;
                                                break;
                                            }
                                            taskUid = _step.value;
                                            _context4.next = 8;
                                            return this.waitForTask(taskUid, {
                                                timeOutMs: timeOutMs,
                                                intervalMs: intervalMs
                                            });
                                        case 8:
                                            task = _context4.sent;
                                            tasks.push(task);
                                        case 10:
                                            _context4.next = 4;
                                            break;
                                        case 12:
                                            _context4.next = 17;
                                            break;
                                        case 14:
                                            _context4.prev = 14;
                                            _context4.t0 = _context4["catch"](2);
                                            _iterator.e(_context4.t0);
                                        case 17:
                                            _context4.prev = 17;
                                            _iterator.f();
                                            return _context4.finish(17);
                                        case 20:
                                            return _context4.abrupt("return", tasks);
                                        case 21:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4, this, [
                                    [
                                        2,
                                        14,
                                        17,
                                        20
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "cancelTasks",
                        value: function cancelTasks() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee5() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            url = "tasks/cancel";
                                            _context5.next = 3;
                                            return this.httpRequest.post(url, {}, toQueryParams(parameters));
                                        case 3:
                                            task = _context5.sent;
                                            return _context5.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5, this);
                            }));
                        }
                    },
                    {
                        key: "deleteTasks",
                        value: function deleteTasks() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee6() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                                    while(true)switch(_context6.prev = _context6.next){
                                        case 0:
                                            url = "tasks";
                                            _context6.next = 3;
                                            return this.httpRequest.delete(url, {}, toQueryParams(parameters));
                                        case 3:
                                            task = _context6.sent;
                                            return _context6.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }, _callee6, this);
                            }));
                        }
                    }
                ]);
                return TaskClient;
            }();
            /*
         * Bundle: MeiliSearch / Indexes
         * Project: MeiliSearch - Javascript API
         * Author: Quentin de Quelen <quentin@meilisearch.com>
         * Copyright: 2019, MeiliSearch
         */ var Index = /*#__PURE__*/ function() {
                /**
           * @param config - Request configuration options
           * @param uid - UID of the index
           * @param primaryKey - Primary Key of the index
           */ function Index(config, uid, primaryKey) {
                    _classCallCheck(this, Index);
                    this.uid = uid;
                    this.primaryKey = primaryKey;
                    this.httpRequest = new HttpRequests(config);
                    this.tasks = new TaskClient(config);
                }
                ///
                /// SEARCH
                ///
                /**
           * Search for documents into an index
           *
           * @param query - Query string
           * @param options - Search options
           * @param config - Additional request configuration options
           * @returns Promise containing the search response
           */ _createClass(Index, [
                    {
                        key: "search",
                        value: function search(query, options, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/search");
                                            _context.next = 3;
                                            return this.httpRequest.post(url, removeUndefinedFromObject(Object.assign({
                                                q: query
                                            }, options)), undefined, config);
                                        case 3:
                                            return _context.abrupt("return", _context.sent);
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, this);
                            }));
                        }
                    },
                    {
                        key: "searchGet",
                        value: function searchGet(query, options, config) {
                            var _a, _b, _c, _d, _e, _f, _g;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                                var url, parseFilter, getParams;
                                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/search");
                                            parseFilter = function parseFilter(filter) {
                                                if (typeof filter === "string") return filter;
                                                else if (Array.isArray(filter)) throw new MeiliSearchError("The filter query parameter should be in string format when using searchGet");
                                                else return undefined;
                                            };
                                            getParams = Object.assign(Object.assign({
                                                q: query
                                            }, options), {
                                                filter: parseFilter(options === null || options === void 0 ? void 0 : options.filter),
                                                sort: (_a = options === null || options === void 0 ? void 0 : options.sort) === null || _a === void 0 ? void 0 : _a.join(","),
                                                facets: (_b = options === null || options === void 0 ? void 0 : options.facets) === null || _b === void 0 ? void 0 : _b.join(","),
                                                attributesToRetrieve: (_c = options === null || options === void 0 ? void 0 : options.attributesToRetrieve) === null || _c === void 0 ? void 0 : _c.join(","),
                                                attributesToCrop: (_d = options === null || options === void 0 ? void 0 : options.attributesToCrop) === null || _d === void 0 ? void 0 : _d.join(","),
                                                attributesToHighlight: (_e = options === null || options === void 0 ? void 0 : options.attributesToHighlight) === null || _e === void 0 ? void 0 : _e.join(","),
                                                vector: (_f = options === null || options === void 0 ? void 0 : options.vector) === null || _f === void 0 ? void 0 : _f.join(","),
                                                attributesToSearchOn: (_g = options === null || options === void 0 ? void 0 : options.attributesToSearchOn) === null || _g === void 0 ? void 0 : _g.join(",")
                                            });
                                            _context2.next = 5;
                                            return this.httpRequest.get(url, removeUndefinedFromObject(getParams), config);
                                        case 5:
                                            return _context2.abrupt("return", _context2.sent);
                                        case 6:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2, this);
                            }));
                        }
                    },
                    {
                        key: "searchForFacetValues",
                        value: function searchForFacetValues(params, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/facet-search");
                                            _context3.next = 3;
                                            return this.httpRequest.post(url, removeUndefinedFromObject(params), undefined, config);
                                        case 3:
                                            return _context3.abrupt("return", _context3.sent);
                                        case 4:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3, this);
                            }));
                        }
                    },
                    {
                        key: "getRawInfo",
                        value: function getRawInfo() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee4() {
                                var url, res;
                                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid);
                                            _context4.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            res = _context4.sent;
                                            this.primaryKey = res.primaryKey;
                                            this.updatedAt = new Date(res.updatedAt);
                                            this.createdAt = new Date(res.createdAt);
                                            return _context4.abrupt("return", res);
                                        case 8:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4, this);
                            }));
                        }
                    },
                    {
                        key: "fetchInfo",
                        value: function fetchInfo() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee5() {
                                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            _context5.next = 2;
                                            return this.getRawInfo();
                                        case 2:
                                            return _context5.abrupt("return", this);
                                        case 3:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5, this);
                            }));
                        }
                    },
                    {
                        key: "fetchPrimaryKey",
                        value: function fetchPrimaryKey() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee6() {
                                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                                    while(true)switch(_context6.prev = _context6.next){
                                        case 0:
                                            _context6.next = 2;
                                            return this.getRawInfo();
                                        case 2:
                                            this.primaryKey = _context6.sent.primaryKey;
                                            return _context6.abrupt("return", this.primaryKey);
                                        case 4:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }, _callee6, this);
                            }));
                        }
                    },
                    {
                        key: "update",
                        value: /**
             * Update an index.
             *
             * @param data - Data to update
             * @returns Promise to the current Index object with updated information
             */ function update(data) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee7() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid);
                                            _context7.next = 3;
                                            return this.httpRequest.patch(url, data);
                                        case 3:
                                            task = _context7.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context7.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee7, this);
                            }));
                        }
                    },
                    {
                        key: "delete",
                        value: function _delete() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee8() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                                    while(true)switch(_context8.prev = _context8.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid);
                                            _context8.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context8.sent;
                                            return _context8.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context8.stop();
                                    }
                                }, _callee8, this);
                            }));
                        }
                    },
                    {
                        key: "getTasks",
                        value: function getTasks() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee9() {
                                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                                    while(true)switch(_context9.prev = _context9.next){
                                        case 0:
                                            _context9.next = 2;
                                            return this.tasks.getTasks(Object.assign(Object.assign({}, parameters), {
                                                indexUids: [
                                                    this.uid
                                                ]
                                            }));
                                        case 2:
                                            return _context9.abrupt("return", _context9.sent);
                                        case 3:
                                        case "end":
                                            return _context9.stop();
                                    }
                                }, _callee9, this);
                            }));
                        }
                    },
                    {
                        key: "getTask",
                        value: function getTask(taskUid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee10() {
                                return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                                    while(true)switch(_context10.prev = _context10.next){
                                        case 0:
                                            _context10.next = 2;
                                            return this.tasks.getTask(taskUid);
                                        case 2:
                                            return _context10.abrupt("return", _context10.sent);
                                        case 3:
                                        case "end":
                                            return _context10.stop();
                                    }
                                }, _callee10, this);
                            }));
                        }
                    },
                    {
                        key: "waitForTasks",
                        value: function waitForTasks(taskUids) {
                            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$timeOutMs = _ref.timeOutMs, timeOutMs = _ref$timeOutMs === void 0 ? 5000 : _ref$timeOutMs, _ref$intervalMs = _ref.intervalMs, intervalMs = _ref$intervalMs === void 0 ? 50 : _ref$intervalMs;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee11() {
                                return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                                    while(true)switch(_context11.prev = _context11.next){
                                        case 0:
                                            _context11.next = 2;
                                            return this.tasks.waitForTasks(taskUids, {
                                                timeOutMs: timeOutMs,
                                                intervalMs: intervalMs
                                            });
                                        case 2:
                                            return _context11.abrupt("return", _context11.sent);
                                        case 3:
                                        case "end":
                                            return _context11.stop();
                                    }
                                }, _callee11, this);
                            }));
                        }
                    },
                    {
                        key: "waitForTask",
                        value: function waitForTask(taskUid) {
                            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$timeOutMs = _ref2.timeOutMs, timeOutMs = _ref2$timeOutMs === void 0 ? 5000 : _ref2$timeOutMs, _ref2$intervalMs = _ref2.intervalMs, intervalMs = _ref2$intervalMs === void 0 ? 50 : _ref2$intervalMs;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee12() {
                                return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                                    while(true)switch(_context12.prev = _context12.next){
                                        case 0:
                                            _context12.next = 2;
                                            return this.tasks.waitForTask(taskUid, {
                                                timeOutMs: timeOutMs,
                                                intervalMs: intervalMs
                                            });
                                        case 2:
                                            return _context12.abrupt("return", _context12.sent);
                                        case 3:
                                        case "end":
                                            return _context12.stop();
                                    }
                                }, _callee12, this);
                            }));
                        }
                    },
                    {
                        key: "getStats",
                        value: function getStats() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee13() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                                    while(true)switch(_context13.prev = _context13.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/stats");
                                            _context13.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context13.abrupt("return", _context13.sent);
                                        case 4:
                                        case "end":
                                            return _context13.stop();
                                    }
                                }, _callee13, this);
                            }));
                        }
                    },
                    {
                        key: "getDocuments",
                        value: function getDocuments() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            var _a;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee14() {
                                var url, _url, fields;
                                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                                    while(true)switch(_context14.prev = _context14.next){
                                        case 0:
                                            parameters = removeUndefinedFromObject(parameters);
                                            // In case `filter` is provided, use `POST /documents/fetch`
                                            if (!(parameters.filter !== undefined)) {
                                                _context14.next = 15;
                                                break;
                                            }
                                            _context14.prev = 2;
                                            url = "indexes/".concat(this.uid, "/documents/fetch");
                                            _context14.next = 6;
                                            return this.httpRequest.post(url, parameters);
                                        case 6:
                                            return _context14.abrupt("return", _context14.sent);
                                        case 9:
                                            _context14.prev = 9;
                                            _context14.t0 = _context14["catch"](2);
                                            if (_context14.t0 instanceof MeiliSearchCommunicationError) _context14.t0.message = versionErrorHintMessage(_context14.t0.message, "getDocuments");
                                            else if (_context14.t0 instanceof MeiliSearchApiError) _context14.t0.message = versionErrorHintMessage(_context14.t0.message, "getDocuments");
                                            throw _context14.t0;
                                        case 13:
                                            _context14.next = 20;
                                            break;
                                        case 15:
                                            _url = "indexes/".concat(this.uid, "/documents"); // Transform fields to query parameter string format
                                            fields = Array.isArray(parameters === null || parameters === void 0 ? void 0 : parameters.fields) ? {
                                                fields: (_a = parameters === null || parameters === void 0 ? void 0 : parameters.fields) === null || _a === void 0 ? void 0 : _a.join(",")
                                            } : {};
                                            _context14.next = 19;
                                            return this.httpRequest.get(_url, Object.assign(Object.assign({}, parameters), fields));
                                        case 19:
                                            return _context14.abrupt("return", _context14.sent);
                                        case 20:
                                        case "end":
                                            return _context14.stop();
                                    }
                                }, _callee14, this, [
                                    [
                                        2,
                                        9
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "getDocument",
                        value: function getDocument(documentId, parameters) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee15() {
                                var url, fields;
                                return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                                    while(true)switch(_context15.prev = _context15.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents/").concat(documentId);
                                            fields = function() {
                                                var _a;
                                                if (Array.isArray(parameters === null || parameters === void 0 ? void 0 : parameters.fields)) return (_a = parameters === null || parameters === void 0 ? void 0 : parameters.fields) === null || _a === void 0 ? void 0 : _a.join(",");
                                                return undefined;
                                            }();
                                            _context15.next = 4;
                                            return this.httpRequest.get(url, removeUndefinedFromObject(Object.assign(Object.assign({}, parameters), {
                                                fields: fields
                                            })));
                                        case 4:
                                            return _context15.abrupt("return", _context15.sent);
                                        case 5:
                                        case "end":
                                            return _context15.stop();
                                    }
                                }, _callee15, this);
                            }));
                        }
                    },
                    {
                        key: "addDocuments",
                        value: function addDocuments(documents, options) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee16() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                                    while(true)switch(_context16.prev = _context16.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents");
                                            _context16.next = 3;
                                            return this.httpRequest.post(url, documents, options);
                                        case 3:
                                            task = _context16.sent;
                                            return _context16.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context16.stop();
                                    }
                                }, _callee16, this);
                            }));
                        }
                    },
                    {
                        key: "addDocumentsFromString",
                        value: function addDocumentsFromString(documents, contentType, queryParams) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee17() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                                    while(true)switch(_context17.prev = _context17.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents");
                                            _context17.next = 3;
                                            return this.httpRequest.post(url, documents, queryParams, {
                                                headers: {
                                                    "Content-Type": contentType
                                                }
                                            });
                                        case 3:
                                            task = _context17.sent;
                                            return _context17.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context17.stop();
                                    }
                                }, _callee17, this);
                            }));
                        }
                    },
                    {
                        key: "addDocumentsInBatches",
                        value: function addDocumentsInBatches(documents) {
                            var batchSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
                            var options = arguments.length > 2 ? arguments[2] : undefined;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee18() {
                                var updates, i;
                                return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                                    while(true)switch(_context18.prev = _context18.next){
                                        case 0:
                                            updates = [];
                                            i = 0;
                                        case 2:
                                            if (!(i < documents.length)) {
                                                _context18.next = 11;
                                                break;
                                            }
                                            _context18.t0 = updates;
                                            _context18.next = 6;
                                            return this.addDocuments(documents.slice(i, i + batchSize), options);
                                        case 6:
                                            _context18.t1 = _context18.sent;
                                            _context18.t0.push.call(_context18.t0, _context18.t1);
                                        case 8:
                                            i += batchSize;
                                            _context18.next = 2;
                                            break;
                                        case 11:
                                            return _context18.abrupt("return", updates);
                                        case 12:
                                        case "end":
                                            return _context18.stop();
                                    }
                                }, _callee18, this);
                            }));
                        }
                    },
                    {
                        key: "updateDocuments",
                        value: function updateDocuments(documents, options) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee19() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                                    while(true)switch(_context19.prev = _context19.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents");
                                            _context19.next = 3;
                                            return this.httpRequest.put(url, documents, options);
                                        case 3:
                                            task = _context19.sent;
                                            return _context19.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context19.stop();
                                    }
                                }, _callee19, this);
                            }));
                        }
                    },
                    {
                        key: "updateDocumentsInBatches",
                        value: function updateDocumentsInBatches(documents) {
                            var batchSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
                            var options = arguments.length > 2 ? arguments[2] : undefined;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee20() {
                                var updates, i;
                                return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                                    while(true)switch(_context20.prev = _context20.next){
                                        case 0:
                                            updates = [];
                                            i = 0;
                                        case 2:
                                            if (!(i < documents.length)) {
                                                _context20.next = 11;
                                                break;
                                            }
                                            _context20.t0 = updates;
                                            _context20.next = 6;
                                            return this.updateDocuments(documents.slice(i, i + batchSize), options);
                                        case 6:
                                            _context20.t1 = _context20.sent;
                                            _context20.t0.push.call(_context20.t0, _context20.t1);
                                        case 8:
                                            i += batchSize;
                                            _context20.next = 2;
                                            break;
                                        case 11:
                                            return _context20.abrupt("return", updates);
                                        case 12:
                                        case "end":
                                            return _context20.stop();
                                    }
                                }, _callee20, this);
                            }));
                        }
                    },
                    {
                        key: "updateDocumentsFromString",
                        value: function updateDocumentsFromString(documents, contentType, queryParams) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee21() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                                    while(true)switch(_context21.prev = _context21.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents");
                                            _context21.next = 3;
                                            return this.httpRequest.put(url, documents, queryParams, {
                                                headers: {
                                                    "Content-Type": contentType
                                                }
                                            });
                                        case 3:
                                            task = _context21.sent;
                                            return _context21.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context21.stop();
                                    }
                                }, _callee21, this);
                            }));
                        }
                    },
                    {
                        key: "deleteDocument",
                        value: function deleteDocument(documentId) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee22() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                                    while(true)switch(_context22.prev = _context22.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents/").concat(documentId);
                                            _context22.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context22.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context22.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context22.stop();
                                    }
                                }, _callee22, this);
                            }));
                        }
                    },
                    {
                        key: "deleteDocuments",
                        value: function deleteDocuments(params) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee23() {
                                var isDocumentsDeletionQuery, endpoint, url, task;
                                return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                                    while(true)switch(_context23.prev = _context23.next){
                                        case 0:
                                            // If params is of type DocumentsDeletionQuery
                                            isDocumentsDeletionQuery = !Array.isArray(params) && _typeof(params) === "object";
                                            endpoint = isDocumentsDeletionQuery ? "documents/delete" : "documents/delete-batch";
                                            url = "indexes/".concat(this.uid, "/").concat(endpoint);
                                            _context23.prev = 3;
                                            _context23.next = 6;
                                            return this.httpRequest.post(url, params);
                                        case 6:
                                            task = _context23.sent;
                                            return _context23.abrupt("return", new EnqueuedTask(task));
                                        case 10:
                                            _context23.prev = 10;
                                            _context23.t0 = _context23["catch"](3);
                                            if (_context23.t0 instanceof MeiliSearchCommunicationError && isDocumentsDeletionQuery) _context23.t0.message = versionErrorHintMessage(_context23.t0.message, "deleteDocuments");
                                            else if (_context23.t0 instanceof MeiliSearchApiError) _context23.t0.message = versionErrorHintMessage(_context23.t0.message, "deleteDocuments");
                                            throw _context23.t0;
                                        case 14:
                                        case "end":
                                            return _context23.stop();
                                    }
                                }, _callee23, this, [
                                    [
                                        3,
                                        10
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "deleteAllDocuments",
                        value: function deleteAllDocuments() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee24() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                                    while(true)switch(_context24.prev = _context24.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/documents");
                                            _context24.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context24.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context24.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context24.stop();
                                    }
                                }, _callee24, this);
                            }));
                        }
                    },
                    {
                        key: "getSettings",
                        value: function getSettings() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee25() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee25$(_context25) {
                                    while(true)switch(_context25.prev = _context25.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings");
                                            _context25.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context25.abrupt("return", _context25.sent);
                                        case 4:
                                        case "end":
                                            return _context25.stop();
                                    }
                                }, _callee25, this);
                            }));
                        }
                    },
                    {
                        key: "updateSettings",
                        value: function updateSettings(settings) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee26() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                                    while(true)switch(_context26.prev = _context26.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings");
                                            _context26.next = 3;
                                            return this.httpRequest.patch(url, settings);
                                        case 3:
                                            task = _context26.sent;
                                            task.enqueued = new Date(task.enqueuedAt);
                                            return _context26.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context26.stop();
                                    }
                                }, _callee26, this);
                            }));
                        }
                    },
                    {
                        key: "resetSettings",
                        value: function resetSettings() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee27() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                                    while(true)switch(_context27.prev = _context27.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings");
                                            _context27.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context27.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context27.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context27.stop();
                                    }
                                }, _callee27, this);
                            }));
                        }
                    },
                    {
                        key: "getPagination",
                        value: function getPagination() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee28() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                                    while(true)switch(_context28.prev = _context28.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/pagination");
                                            _context28.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context28.abrupt("return", _context28.sent);
                                        case 4:
                                        case "end":
                                            return _context28.stop();
                                    }
                                }, _callee28, this);
                            }));
                        }
                    },
                    {
                        key: "updatePagination",
                        value: function updatePagination(pagination) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee29() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee29$(_context29) {
                                    while(true)switch(_context29.prev = _context29.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/pagination");
                                            _context29.next = 3;
                                            return this.httpRequest.patch(url, pagination);
                                        case 3:
                                            task = _context29.sent;
                                            return _context29.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context29.stop();
                                    }
                                }, _callee29, this);
                            }));
                        }
                    },
                    {
                        key: "resetPagination",
                        value: function resetPagination() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee30() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee30$(_context30) {
                                    while(true)switch(_context30.prev = _context30.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/pagination");
                                            _context30.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context30.sent;
                                            return _context30.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context30.stop();
                                    }
                                }, _callee30, this);
                            }));
                        }
                    },
                    {
                        key: "getSynonyms",
                        value: function getSynonyms() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee31() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee31$(_context31) {
                                    while(true)switch(_context31.prev = _context31.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/synonyms");
                                            _context31.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context31.abrupt("return", _context31.sent);
                                        case 4:
                                        case "end":
                                            return _context31.stop();
                                    }
                                }, _callee31, this);
                            }));
                        }
                    },
                    {
                        key: "updateSynonyms",
                        value: function updateSynonyms(synonyms) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee32() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                                    while(true)switch(_context32.prev = _context32.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/synonyms");
                                            _context32.next = 3;
                                            return this.httpRequest.put(url, synonyms);
                                        case 3:
                                            task = _context32.sent;
                                            return _context32.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context32.stop();
                                    }
                                }, _callee32, this);
                            }));
                        }
                    },
                    {
                        key: "resetSynonyms",
                        value: function resetSynonyms() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee33() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee33$(_context33) {
                                    while(true)switch(_context33.prev = _context33.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/synonyms");
                                            _context33.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context33.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context33.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context33.stop();
                                    }
                                }, _callee33, this);
                            }));
                        }
                    },
                    {
                        key: "getStopWords",
                        value: function getStopWords() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee34() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee34$(_context34) {
                                    while(true)switch(_context34.prev = _context34.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/stop-words");
                                            _context34.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context34.abrupt("return", _context34.sent);
                                        case 4:
                                        case "end":
                                            return _context34.stop();
                                    }
                                }, _callee34, this);
                            }));
                        }
                    },
                    {
                        key: "updateStopWords",
                        value: function updateStopWords(stopWords) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee35() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee35$(_context35) {
                                    while(true)switch(_context35.prev = _context35.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/stop-words");
                                            _context35.next = 3;
                                            return this.httpRequest.put(url, stopWords);
                                        case 3:
                                            task = _context35.sent;
                                            return _context35.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context35.stop();
                                    }
                                }, _callee35, this);
                            }));
                        }
                    },
                    {
                        key: "resetStopWords",
                        value: function resetStopWords() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee36() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee36$(_context36) {
                                    while(true)switch(_context36.prev = _context36.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/stop-words");
                                            _context36.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context36.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context36.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context36.stop();
                                    }
                                }, _callee36, this);
                            }));
                        }
                    },
                    {
                        key: "getRankingRules",
                        value: function getRankingRules() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee37() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee37$(_context37) {
                                    while(true)switch(_context37.prev = _context37.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/ranking-rules");
                                            _context37.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context37.abrupt("return", _context37.sent);
                                        case 4:
                                        case "end":
                                            return _context37.stop();
                                    }
                                }, _callee37, this);
                            }));
                        }
                    },
                    {
                        key: "updateRankingRules",
                        value: function updateRankingRules(rankingRules) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee38() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee38$(_context38) {
                                    while(true)switch(_context38.prev = _context38.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/ranking-rules");
                                            _context38.next = 3;
                                            return this.httpRequest.put(url, rankingRules);
                                        case 3:
                                            task = _context38.sent;
                                            return _context38.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context38.stop();
                                    }
                                }, _callee38, this);
                            }));
                        }
                    },
                    {
                        key: "resetRankingRules",
                        value: function resetRankingRules() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee39() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee39$(_context39) {
                                    while(true)switch(_context39.prev = _context39.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/ranking-rules");
                                            _context39.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context39.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context39.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context39.stop();
                                    }
                                }, _callee39, this);
                            }));
                        }
                    },
                    {
                        key: "getDistinctAttribute",
                        value: function getDistinctAttribute() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee40() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee40$(_context40) {
                                    while(true)switch(_context40.prev = _context40.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/distinct-attribute");
                                            _context40.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context40.abrupt("return", _context40.sent);
                                        case 4:
                                        case "end":
                                            return _context40.stop();
                                    }
                                }, _callee40, this);
                            }));
                        }
                    },
                    {
                        key: "updateDistinctAttribute",
                        value: function updateDistinctAttribute(distinctAttribute) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee41() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee41$(_context41) {
                                    while(true)switch(_context41.prev = _context41.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/distinct-attribute");
                                            _context41.next = 3;
                                            return this.httpRequest.put(url, distinctAttribute);
                                        case 3:
                                            task = _context41.sent;
                                            return _context41.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context41.stop();
                                    }
                                }, _callee41, this);
                            }));
                        }
                    },
                    {
                        key: "resetDistinctAttribute",
                        value: function resetDistinctAttribute() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee42() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee42$(_context42) {
                                    while(true)switch(_context42.prev = _context42.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/distinct-attribute");
                                            _context42.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context42.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context42.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context42.stop();
                                    }
                                }, _callee42, this);
                            }));
                        }
                    },
                    {
                        key: "getFilterableAttributes",
                        value: function getFilterableAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee43() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee43$(_context43) {
                                    while(true)switch(_context43.prev = _context43.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/filterable-attributes");
                                            _context43.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context43.abrupt("return", _context43.sent);
                                        case 4:
                                        case "end":
                                            return _context43.stop();
                                    }
                                }, _callee43, this);
                            }));
                        }
                    },
                    {
                        key: "updateFilterableAttributes",
                        value: function updateFilterableAttributes(filterableAttributes) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee44() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee44$(_context44) {
                                    while(true)switch(_context44.prev = _context44.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/filterable-attributes");
                                            _context44.next = 3;
                                            return this.httpRequest.put(url, filterableAttributes);
                                        case 3:
                                            task = _context44.sent;
                                            return _context44.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context44.stop();
                                    }
                                }, _callee44, this);
                            }));
                        }
                    },
                    {
                        key: "resetFilterableAttributes",
                        value: function resetFilterableAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee45() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee45$(_context45) {
                                    while(true)switch(_context45.prev = _context45.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/filterable-attributes");
                                            _context45.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context45.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context45.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context45.stop();
                                    }
                                }, _callee45, this);
                            }));
                        }
                    },
                    {
                        key: "getSortableAttributes",
                        value: function getSortableAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee46() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee46$(_context46) {
                                    while(true)switch(_context46.prev = _context46.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/sortable-attributes");
                                            _context46.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context46.abrupt("return", _context46.sent);
                                        case 4:
                                        case "end":
                                            return _context46.stop();
                                    }
                                }, _callee46, this);
                            }));
                        }
                    },
                    {
                        key: "updateSortableAttributes",
                        value: function updateSortableAttributes(sortableAttributes) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee47() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee47$(_context47) {
                                    while(true)switch(_context47.prev = _context47.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/sortable-attributes");
                                            _context47.next = 3;
                                            return this.httpRequest.put(url, sortableAttributes);
                                        case 3:
                                            task = _context47.sent;
                                            return _context47.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context47.stop();
                                    }
                                }, _callee47, this);
                            }));
                        }
                    },
                    {
                        key: "resetSortableAttributes",
                        value: function resetSortableAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee48() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee48$(_context48) {
                                    while(true)switch(_context48.prev = _context48.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/sortable-attributes");
                                            _context48.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context48.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context48.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context48.stop();
                                    }
                                }, _callee48, this);
                            }));
                        }
                    },
                    {
                        key: "getSearchableAttributes",
                        value: function getSearchableAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee49() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee49$(_context49) {
                                    while(true)switch(_context49.prev = _context49.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/searchable-attributes");
                                            _context49.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context49.abrupt("return", _context49.sent);
                                        case 4:
                                        case "end":
                                            return _context49.stop();
                                    }
                                }, _callee49, this);
                            }));
                        }
                    },
                    {
                        key: "updateSearchableAttributes",
                        value: function updateSearchableAttributes(searchableAttributes) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee50() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee50$(_context50) {
                                    while(true)switch(_context50.prev = _context50.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/searchable-attributes");
                                            _context50.next = 3;
                                            return this.httpRequest.put(url, searchableAttributes);
                                        case 3:
                                            task = _context50.sent;
                                            return _context50.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context50.stop();
                                    }
                                }, _callee50, this);
                            }));
                        }
                    },
                    {
                        key: "resetSearchableAttributes",
                        value: function resetSearchableAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee51() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee51$(_context51) {
                                    while(true)switch(_context51.prev = _context51.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/searchable-attributes");
                                            _context51.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context51.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context51.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context51.stop();
                                    }
                                }, _callee51, this);
                            }));
                        }
                    },
                    {
                        key: "getDisplayedAttributes",
                        value: function getDisplayedAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee52() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee52$(_context52) {
                                    while(true)switch(_context52.prev = _context52.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/displayed-attributes");
                                            _context52.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context52.abrupt("return", _context52.sent);
                                        case 4:
                                        case "end":
                                            return _context52.stop();
                                    }
                                }, _callee52, this);
                            }));
                        }
                    },
                    {
                        key: "updateDisplayedAttributes",
                        value: function updateDisplayedAttributes(displayedAttributes) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee53() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee53$(_context53) {
                                    while(true)switch(_context53.prev = _context53.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/displayed-attributes");
                                            _context53.next = 3;
                                            return this.httpRequest.put(url, displayedAttributes);
                                        case 3:
                                            task = _context53.sent;
                                            return _context53.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context53.stop();
                                    }
                                }, _callee53, this);
                            }));
                        }
                    },
                    {
                        key: "resetDisplayedAttributes",
                        value: function resetDisplayedAttributes() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee54() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee54$(_context54) {
                                    while(true)switch(_context54.prev = _context54.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/displayed-attributes");
                                            _context54.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context54.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context54.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context54.stop();
                                    }
                                }, _callee54, this);
                            }));
                        }
                    },
                    {
                        key: "getTypoTolerance",
                        value: function getTypoTolerance() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee55() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee55$(_context55) {
                                    while(true)switch(_context55.prev = _context55.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/typo-tolerance");
                                            _context55.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context55.abrupt("return", _context55.sent);
                                        case 4:
                                        case "end":
                                            return _context55.stop();
                                    }
                                }, _callee55, this);
                            }));
                        }
                    },
                    {
                        key: "updateTypoTolerance",
                        value: function updateTypoTolerance(typoTolerance) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee56() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee56$(_context56) {
                                    while(true)switch(_context56.prev = _context56.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/typo-tolerance");
                                            _context56.next = 3;
                                            return this.httpRequest.patch(url, typoTolerance);
                                        case 3:
                                            task = _context56.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context56.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context56.stop();
                                    }
                                }, _callee56, this);
                            }));
                        }
                    },
                    {
                        key: "resetTypoTolerance",
                        value: function resetTypoTolerance() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee57() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee57$(_context57) {
                                    while(true)switch(_context57.prev = _context57.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/typo-tolerance");
                                            _context57.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context57.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context57.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context57.stop();
                                    }
                                }, _callee57, this);
                            }));
                        }
                    },
                    {
                        key: "getFaceting",
                        value: function getFaceting() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee58() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee58$(_context58) {
                                    while(true)switch(_context58.prev = _context58.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/faceting");
                                            _context58.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context58.abrupt("return", _context58.sent);
                                        case 4:
                                        case "end":
                                            return _context58.stop();
                                    }
                                }, _callee58, this);
                            }));
                        }
                    },
                    {
                        key: "updateFaceting",
                        value: function updateFaceting(faceting) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee59() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee59$(_context59) {
                                    while(true)switch(_context59.prev = _context59.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/faceting");
                                            _context59.next = 3;
                                            return this.httpRequest.patch(url, faceting);
                                        case 3:
                                            task = _context59.sent;
                                            return _context59.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context59.stop();
                                    }
                                }, _callee59, this);
                            }));
                        }
                    },
                    {
                        key: "resetFaceting",
                        value: function resetFaceting() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee60() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee60$(_context60) {
                                    while(true)switch(_context60.prev = _context60.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/faceting");
                                            _context60.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context60.sent;
                                            return _context60.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context60.stop();
                                    }
                                }, _callee60, this);
                            }));
                        }
                    },
                    {
                        key: "getSeparatorTokens",
                        value: function getSeparatorTokens() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee61() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee61$(_context61) {
                                    while(true)switch(_context61.prev = _context61.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/separator-tokens");
                                            _context61.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context61.abrupt("return", _context61.sent);
                                        case 4:
                                        case "end":
                                            return _context61.stop();
                                    }
                                }, _callee61, this);
                            }));
                        }
                    },
                    {
                        key: "updateSeparatorTokens",
                        value: function updateSeparatorTokens(separatorTokens) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee62() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee62$(_context62) {
                                    while(true)switch(_context62.prev = _context62.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/separator-tokens");
                                            _context62.next = 3;
                                            return this.httpRequest.put(url, separatorTokens);
                                        case 3:
                                            task = _context62.sent;
                                            return _context62.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context62.stop();
                                    }
                                }, _callee62, this);
                            }));
                        }
                    },
                    {
                        key: "resetSeparatorTokens",
                        value: function resetSeparatorTokens() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee63() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee63$(_context63) {
                                    while(true)switch(_context63.prev = _context63.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/separator-tokens");
                                            _context63.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context63.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context63.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context63.stop();
                                    }
                                }, _callee63, this);
                            }));
                        }
                    },
                    {
                        key: "getNonSeparatorTokens",
                        value: function getNonSeparatorTokens() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee64() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee64$(_context64) {
                                    while(true)switch(_context64.prev = _context64.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/non-separator-tokens");
                                            _context64.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context64.abrupt("return", _context64.sent);
                                        case 4:
                                        case "end":
                                            return _context64.stop();
                                    }
                                }, _callee64, this);
                            }));
                        }
                    },
                    {
                        key: "updateNonSeparatorTokens",
                        value: function updateNonSeparatorTokens(nonSeparatorTokens) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee65() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee65$(_context65) {
                                    while(true)switch(_context65.prev = _context65.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/non-separator-tokens");
                                            _context65.next = 3;
                                            return this.httpRequest.put(url, nonSeparatorTokens);
                                        case 3:
                                            task = _context65.sent;
                                            return _context65.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context65.stop();
                                    }
                                }, _callee65, this);
                            }));
                        }
                    },
                    {
                        key: "resetNonSeparatorTokens",
                        value: function resetNonSeparatorTokens() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee66() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee66$(_context66) {
                                    while(true)switch(_context66.prev = _context66.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/non-separator-tokens");
                                            _context66.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context66.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context66.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context66.stop();
                                    }
                                }, _callee66, this);
                            }));
                        }
                    },
                    {
                        key: "getDictionary",
                        value: function getDictionary() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee67() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee67$(_context67) {
                                    while(true)switch(_context67.prev = _context67.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/dictionary");
                                            _context67.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context67.abrupt("return", _context67.sent);
                                        case 4:
                                        case "end":
                                            return _context67.stop();
                                    }
                                }, _callee67, this);
                            }));
                        }
                    },
                    {
                        key: "updateDictionary",
                        value: function updateDictionary(dictionary) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee68() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee68$(_context68) {
                                    while(true)switch(_context68.prev = _context68.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/dictionary");
                                            _context68.next = 3;
                                            return this.httpRequest.put(url, dictionary);
                                        case 3:
                                            task = _context68.sent;
                                            return _context68.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context68.stop();
                                    }
                                }, _callee68, this);
                            }));
                        }
                    },
                    {
                        key: "resetDictionary",
                        value: function resetDictionary() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee69() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee69$(_context69) {
                                    while(true)switch(_context69.prev = _context69.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/dictionary");
                                            _context69.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context69.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context69.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context69.stop();
                                    }
                                }, _callee69, this);
                            }));
                        }
                    },
                    {
                        key: "getProximityPrecision",
                        value: function getProximityPrecision() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee70() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee70$(_context70) {
                                    while(true)switch(_context70.prev = _context70.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/proximity-precision");
                                            _context70.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context70.abrupt("return", _context70.sent);
                                        case 4:
                                        case "end":
                                            return _context70.stop();
                                    }
                                }, _callee70, this);
                            }));
                        }
                    },
                    {
                        key: "updateProximityPrecision",
                        value: function updateProximityPrecision(proximityPrecision) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee71() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee71$(_context71) {
                                    while(true)switch(_context71.prev = _context71.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/proximity-precision");
                                            _context71.next = 3;
                                            return this.httpRequest.put(url, proximityPrecision);
                                        case 3:
                                            task = _context71.sent;
                                            return _context71.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context71.stop();
                                    }
                                }, _callee71, this);
                            }));
                        }
                    },
                    {
                        key: "resetProximityPrecision",
                        value: function resetProximityPrecision() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee72() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee72$(_context72) {
                                    while(true)switch(_context72.prev = _context72.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/proximity-precision");
                                            _context72.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context72.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context72.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context72.stop();
                                    }
                                }, _callee72, this);
                            }));
                        }
                    },
                    {
                        key: "getEmbedders",
                        value: function getEmbedders() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee73() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee73$(_context73) {
                                    while(true)switch(_context73.prev = _context73.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/embedders");
                                            _context73.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context73.abrupt("return", _context73.sent);
                                        case 4:
                                        case "end":
                                            return _context73.stop();
                                    }
                                }, _callee73, this);
                            }));
                        }
                    },
                    {
                        key: "updateEmbedders",
                        value: function updateEmbedders(embedders) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee74() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee74$(_context74) {
                                    while(true)switch(_context74.prev = _context74.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/embedders");
                                            _context74.next = 3;
                                            return this.httpRequest.patch(url, embedders);
                                        case 3:
                                            task = _context74.sent;
                                            return _context74.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context74.stop();
                                    }
                                }, _callee74, this);
                            }));
                        }
                    },
                    {
                        key: "resetEmbedders",
                        value: function resetEmbedders() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee75() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee75$(_context75) {
                                    while(true)switch(_context75.prev = _context75.next){
                                        case 0:
                                            url = "indexes/".concat(this.uid, "/settings/embedders");
                                            _context75.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            task = _context75.sent;
                                            task.enqueuedAt = new Date(task.enqueuedAt);
                                            return _context75.abrupt("return", task);
                                        case 6:
                                        case "end":
                                            return _context75.stop();
                                    }
                                }, _callee75, this);
                            }));
                        }
                    }
                ], [
                    {
                        key: "create",
                        value: function create(uid) {
                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var config = arguments.length > 2 ? arguments[2] : undefined;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee76() {
                                var url, req, task;
                                return _regeneratorRuntime().wrap(function _callee76$(_context76) {
                                    while(true)switch(_context76.prev = _context76.next){
                                        case 0:
                                            url = "indexes";
                                            req = new HttpRequests(config);
                                            _context76.next = 4;
                                            return req.post(url, Object.assign(Object.assign({}, options), {
                                                uid: uid
                                            }));
                                        case 4:
                                            task = _context76.sent;
                                            return _context76.abrupt("return", new EnqueuedTask(task));
                                        case 6:
                                        case "end":
                                            return _context76.stop();
                                    }
                                }, _callee76);
                            }));
                        }
                    }
                ]);
                return Index;
            }();
            /*
         * Bundle: MeiliSearch
         * Project: MeiliSearch - Javascript API
         * Author: Quentin de Quelen <quentin@meilisearch.com>
         * Copyright: 2019, MeiliSearch
         */ var Client = /*#__PURE__*/ function() {
                /**
           * Creates new MeiliSearch instance
           *
           * @param config - Configuration object
           */ function Client(config) {
                    _classCallCheck(this, Client);
                    this.config = config;
                    this.httpRequest = new HttpRequests(config);
                    this.tasks = new TaskClient(config);
                }
                /**
           * Return an Index instance
           *
           * @param indexUid - The index UID
           * @returns Instance of Index
           */ _createClass(Client, [
                    {
                        key: "index",
                        value: function index(indexUid) {
                            return new Index(this.config, indexUid);
                        }
                    },
                    {
                        key: "getIndex",
                        value: function getIndex(indexUid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            return _context.abrupt("return", new Index(this.config, indexUid).fetchInfo());
                                        case 1:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee, this);
                            }));
                        }
                    },
                    {
                        key: "getRawIndex",
                        value: function getRawIndex(indexUid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2() {
                                return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                                    while(true)switch(_context2.prev = _context2.next){
                                        case 0:
                                            return _context2.abrupt("return", new Index(this.config, indexUid).getRawInfo());
                                        case 1:
                                        case "end":
                                            return _context2.stop();
                                    }
                                }, _callee2, this);
                            }));
                        }
                    },
                    {
                        key: "getIndexes",
                        value: function getIndexes() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3() {
                                var _this = this;
                                var rawIndexes, indexes;
                                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                                    while(true)switch(_context3.prev = _context3.next){
                                        case 0:
                                            _context3.next = 2;
                                            return this.getRawIndexes(parameters);
                                        case 2:
                                            rawIndexes = _context3.sent;
                                            indexes = rawIndexes.results.map(function(index) {
                                                return new Index(_this.config, index.uid, index.primaryKey);
                                            });
                                            return _context3.abrupt("return", Object.assign(Object.assign({}, rawIndexes), {
                                                results: indexes
                                            }));
                                        case 5:
                                        case "end":
                                            return _context3.stop();
                                    }
                                }, _callee3, this);
                            }));
                        }
                    },
                    {
                        key: "getRawIndexes",
                        value: function getRawIndexes() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee4() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                                    while(true)switch(_context4.prev = _context4.next){
                                        case 0:
                                            url = "indexes";
                                            _context4.next = 3;
                                            return this.httpRequest.get(url, parameters);
                                        case 3:
                                            return _context4.abrupt("return", _context4.sent);
                                        case 4:
                                        case "end":
                                            return _context4.stop();
                                    }
                                }, _callee4, this);
                            }));
                        }
                    },
                    {
                        key: "createIndex",
                        value: function createIndex(uid) {
                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee5() {
                                return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                                    while(true)switch(_context5.prev = _context5.next){
                                        case 0:
                                            _context5.next = 2;
                                            return Index.create(uid, options, this.config);
                                        case 2:
                                            return _context5.abrupt("return", _context5.sent);
                                        case 3:
                                        case "end":
                                            return _context5.stop();
                                    }
                                }, _callee5, this);
                            }));
                        }
                    },
                    {
                        key: "updateIndex",
                        value: function updateIndex(uid) {
                            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee6() {
                                return _regeneratorRuntime().wrap(function _callee6$(_context6) {
                                    while(true)switch(_context6.prev = _context6.next){
                                        case 0:
                                            _context6.next = 2;
                                            return new Index(this.config, uid).update(options);
                                        case 2:
                                            return _context6.abrupt("return", _context6.sent);
                                        case 3:
                                        case "end":
                                            return _context6.stop();
                                    }
                                }, _callee6, this);
                            }));
                        }
                    },
                    {
                        key: "deleteIndex",
                        value: function deleteIndex(uid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee7() {
                                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                                    while(true)switch(_context7.prev = _context7.next){
                                        case 0:
                                            _context7.next = 2;
                                            return new Index(this.config, uid).delete();
                                        case 2:
                                            return _context7.abrupt("return", _context7.sent);
                                        case 3:
                                        case "end":
                                            return _context7.stop();
                                    }
                                }, _callee7, this);
                            }));
                        }
                    },
                    {
                        key: "deleteIndexIfExists",
                        value: function deleteIndexIfExists(uid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee8() {
                                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                                    while(true)switch(_context8.prev = _context8.next){
                                        case 0:
                                            _context8.prev = 0;
                                            _context8.next = 3;
                                            return this.deleteIndex(uid);
                                        case 3:
                                            return _context8.abrupt("return", true);
                                        case 6:
                                            _context8.prev = 6;
                                            _context8.t0 = _context8["catch"](0);
                                            if (!(_context8.t0.code === ErrorStatusCode.INDEX_NOT_FOUND)) {
                                                _context8.next = 10;
                                                break;
                                            }
                                            return _context8.abrupt("return", false);
                                        case 10:
                                            throw _context8.t0;
                                        case 11:
                                        case "end":
                                            return _context8.stop();
                                    }
                                }, _callee8, this, [
                                    [
                                        0,
                                        6
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "swapIndexes",
                        value: function swapIndexes(params) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee9() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                                    while(true)switch(_context9.prev = _context9.next){
                                        case 0:
                                            url = "/swap-indexes";
                                            _context9.next = 3;
                                            return this.httpRequest.post(url, params);
                                        case 3:
                                            return _context9.abrupt("return", _context9.sent);
                                        case 4:
                                        case "end":
                                            return _context9.stop();
                                    }
                                }, _callee9, this);
                            }));
                        }
                    },
                    {
                        key: "multiSearch",
                        value: function multiSearch(queries, config) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee10() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                                    while(true)switch(_context10.prev = _context10.next){
                                        case 0:
                                            url = "multi-search";
                                            _context10.next = 3;
                                            return this.httpRequest.post(url, queries, undefined, config);
                                        case 3:
                                            return _context10.abrupt("return", _context10.sent);
                                        case 4:
                                        case "end":
                                            return _context10.stop();
                                    }
                                }, _callee10, this);
                            }));
                        }
                    },
                    {
                        key: "getTasks",
                        value: function getTasks() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee11() {
                                return _regeneratorRuntime().wrap(function _callee11$(_context11) {
                                    while(true)switch(_context11.prev = _context11.next){
                                        case 0:
                                            _context11.next = 2;
                                            return this.tasks.getTasks(parameters);
                                        case 2:
                                            return _context11.abrupt("return", _context11.sent);
                                        case 3:
                                        case "end":
                                            return _context11.stop();
                                    }
                                }, _callee11, this);
                            }));
                        }
                    },
                    {
                        key: "getTask",
                        value: function getTask(taskUid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee12() {
                                return _regeneratorRuntime().wrap(function _callee12$(_context12) {
                                    while(true)switch(_context12.prev = _context12.next){
                                        case 0:
                                            _context12.next = 2;
                                            return this.tasks.getTask(taskUid);
                                        case 2:
                                            return _context12.abrupt("return", _context12.sent);
                                        case 3:
                                        case "end":
                                            return _context12.stop();
                                    }
                                }, _callee12, this);
                            }));
                        }
                    },
                    {
                        key: "waitForTasks",
                        value: function waitForTasks(taskUids) {
                            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$timeOutMs = _ref.timeOutMs, timeOutMs = _ref$timeOutMs === void 0 ? 5000 : _ref$timeOutMs, _ref$intervalMs = _ref.intervalMs, intervalMs = _ref$intervalMs === void 0 ? 50 : _ref$intervalMs;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee13() {
                                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                                    while(true)switch(_context13.prev = _context13.next){
                                        case 0:
                                            _context13.next = 2;
                                            return this.tasks.waitForTasks(taskUids, {
                                                timeOutMs: timeOutMs,
                                                intervalMs: intervalMs
                                            });
                                        case 2:
                                            return _context13.abrupt("return", _context13.sent);
                                        case 3:
                                        case "end":
                                            return _context13.stop();
                                    }
                                }, _callee13, this);
                            }));
                        }
                    },
                    {
                        key: "waitForTask",
                        value: function waitForTask(taskUid) {
                            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$timeOutMs = _ref2.timeOutMs, timeOutMs = _ref2$timeOutMs === void 0 ? 5000 : _ref2$timeOutMs, _ref2$intervalMs = _ref2.intervalMs, intervalMs = _ref2$intervalMs === void 0 ? 50 : _ref2$intervalMs;
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee14() {
                                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                                    while(true)switch(_context14.prev = _context14.next){
                                        case 0:
                                            _context14.next = 2;
                                            return this.tasks.waitForTask(taskUid, {
                                                timeOutMs: timeOutMs,
                                                intervalMs: intervalMs
                                            });
                                        case 2:
                                            return _context14.abrupt("return", _context14.sent);
                                        case 3:
                                        case "end":
                                            return _context14.stop();
                                    }
                                }, _callee14, this);
                            }));
                        }
                    },
                    {
                        key: "cancelTasks",
                        value: function cancelTasks(parameters) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee15() {
                                return _regeneratorRuntime().wrap(function _callee15$(_context15) {
                                    while(true)switch(_context15.prev = _context15.next){
                                        case 0:
                                            _context15.next = 2;
                                            return this.tasks.cancelTasks(parameters);
                                        case 2:
                                            return _context15.abrupt("return", _context15.sent);
                                        case 3:
                                        case "end":
                                            return _context15.stop();
                                    }
                                }, _callee15, this);
                            }));
                        }
                    },
                    {
                        key: "deleteTasks",
                        value: function deleteTasks() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee16() {
                                return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                                    while(true)switch(_context16.prev = _context16.next){
                                        case 0:
                                            _context16.next = 2;
                                            return this.tasks.deleteTasks(parameters);
                                        case 2:
                                            return _context16.abrupt("return", _context16.sent);
                                        case 3:
                                        case "end":
                                            return _context16.stop();
                                    }
                                }, _callee16, this);
                            }));
                        }
                    },
                    {
                        key: "getKeys",
                        value: function getKeys() {
                            var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee17() {
                                var url, keys;
                                return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                                    while(true)switch(_context17.prev = _context17.next){
                                        case 0:
                                            url = "keys";
                                            _context17.next = 3;
                                            return this.httpRequest.get(url, parameters);
                                        case 3:
                                            keys = _context17.sent;
                                            keys.results = keys.results.map(function(key) {
                                                return Object.assign(Object.assign({}, key), {
                                                    createdAt: new Date(key.createdAt),
                                                    updatedAt: new Date(key.updatedAt)
                                                });
                                            });
                                            return _context17.abrupt("return", keys);
                                        case 6:
                                        case "end":
                                            return _context17.stop();
                                    }
                                }, _callee17, this);
                            }));
                        }
                    },
                    {
                        key: "getKey",
                        value: function getKey(keyOrUid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee18() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee18$(_context18) {
                                    while(true)switch(_context18.prev = _context18.next){
                                        case 0:
                                            url = "keys/".concat(keyOrUid);
                                            _context18.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context18.abrupt("return", _context18.sent);
                                        case 4:
                                        case "end":
                                            return _context18.stop();
                                    }
                                }, _callee18, this);
                            }));
                        }
                    },
                    {
                        key: "createKey",
                        value: function createKey(options) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee19() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                                    while(true)switch(_context19.prev = _context19.next){
                                        case 0:
                                            url = "keys";
                                            _context19.next = 3;
                                            return this.httpRequest.post(url, options);
                                        case 3:
                                            return _context19.abrupt("return", _context19.sent);
                                        case 4:
                                        case "end":
                                            return _context19.stop();
                                    }
                                }, _callee19, this);
                            }));
                        }
                    },
                    {
                        key: "updateKey",
                        value: function updateKey(keyOrUid, options) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee20() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                                    while(true)switch(_context20.prev = _context20.next){
                                        case 0:
                                            url = "keys/".concat(keyOrUid);
                                            _context20.next = 3;
                                            return this.httpRequest.patch(url, options);
                                        case 3:
                                            return _context20.abrupt("return", _context20.sent);
                                        case 4:
                                        case "end":
                                            return _context20.stop();
                                    }
                                }, _callee20, this);
                            }));
                        }
                    },
                    {
                        key: "deleteKey",
                        value: function deleteKey(keyOrUid) {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee21() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                                    while(true)switch(_context21.prev = _context21.next){
                                        case 0:
                                            url = "keys/".concat(keyOrUid);
                                            _context21.next = 3;
                                            return this.httpRequest.delete(url);
                                        case 3:
                                            return _context21.abrupt("return", _context21.sent);
                                        case 4:
                                        case "end":
                                            return _context21.stop();
                                    }
                                }, _callee21, this);
                            }));
                        }
                    },
                    {
                        key: "health",
                        value: function health() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee22() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                                    while(true)switch(_context22.prev = _context22.next){
                                        case 0:
                                            url = "health";
                                            _context22.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context22.abrupt("return", _context22.sent);
                                        case 4:
                                        case "end":
                                            return _context22.stop();
                                    }
                                }, _callee22, this);
                            }));
                        }
                    },
                    {
                        key: "isHealthy",
                        value: function isHealthy() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee23() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                                    while(true)switch(_context23.prev = _context23.next){
                                        case 0:
                                            _context23.prev = 0;
                                            url = "health";
                                            _context23.next = 4;
                                            return this.httpRequest.get(url);
                                        case 4:
                                            return _context23.abrupt("return", true);
                                        case 7:
                                            _context23.prev = 7;
                                            _context23.t0 = _context23["catch"](0);
                                            return _context23.abrupt("return", false);
                                        case 10:
                                        case "end":
                                            return _context23.stop();
                                    }
                                }, _callee23, this, [
                                    [
                                        0,
                                        7
                                    ]
                                ]);
                            }));
                        }
                    },
                    {
                        key: "getStats",
                        value: function getStats() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee24() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee24$(_context24) {
                                    while(true)switch(_context24.prev = _context24.next){
                                        case 0:
                                            url = "stats";
                                            _context24.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context24.abrupt("return", _context24.sent);
                                        case 4:
                                        case "end":
                                            return _context24.stop();
                                    }
                                }, _callee24, this);
                            }));
                        }
                    },
                    {
                        key: "getVersion",
                        value: function getVersion() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee25() {
                                var url;
                                return _regeneratorRuntime().wrap(function _callee25$(_context25) {
                                    while(true)switch(_context25.prev = _context25.next){
                                        case 0:
                                            url = "version";
                                            _context25.next = 3;
                                            return this.httpRequest.get(url);
                                        case 3:
                                            return _context25.abrupt("return", _context25.sent);
                                        case 4:
                                        case "end":
                                            return _context25.stop();
                                    }
                                }, _callee25, this);
                            }));
                        }
                    },
                    {
                        key: "createDump",
                        value: function createDump() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee26() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                                    while(true)switch(_context26.prev = _context26.next){
                                        case 0:
                                            url = "dumps";
                                            _context26.next = 3;
                                            return this.httpRequest.post(url);
                                        case 3:
                                            task = _context26.sent;
                                            return _context26.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context26.stop();
                                    }
                                }, _callee26, this);
                            }));
                        }
                    },
                    {
                        key: "createSnapshot",
                        value: function createSnapshot() {
                            return __awaiter(this, void 0, void 0, /*#__PURE__*/ _regeneratorRuntime().mark(function _callee27() {
                                var url, task;
                                return _regeneratorRuntime().wrap(function _callee27$(_context27) {
                                    while(true)switch(_context27.prev = _context27.next){
                                        case 0:
                                            url = "snapshots";
                                            _context27.next = 3;
                                            return this.httpRequest.post(url);
                                        case 3:
                                            task = _context27.sent;
                                            return _context27.abrupt("return", new EnqueuedTask(task));
                                        case 5:
                                        case "end":
                                            return _context27.stop();
                                    }
                                }, _callee27, this);
                            }));
                        }
                    },
                    {
                        key: "generateTenantToken",
                        value: function generateTenantToken(_apiKeyUid, _searchRules, _options) {
                            var error = new Error();
                            throw new Error("Meilisearch: failed to generate a tenant token. Generation of a token only works in a node environment \n ".concat(error.stack, "."));
                        }
                    }
                ]);
                return Client;
            }();
            var MeiliSearch = /*#__PURE__*/ function(_Client) {
                _inherits(MeiliSearch, _Client);
                var _super = _createSuper(MeiliSearch);
                function MeiliSearch(config) {
                    _classCallCheck(this, MeiliSearch);
                    return _super.call(this, config);
                }
                return _createClass(MeiliSearch);
            }(Client);
            exports1.ContentTypeEnum = ContentTypeEnum;
            exports1.ErrorStatusCode = ErrorStatusCode;
            exports1.Index = Index;
            exports1.MatchingStrategies = MatchingStrategies;
            exports1.MeiliSearch = MeiliSearch;
            exports1.MeiliSearchApiError = MeiliSearchApiError;
            exports1.MeiliSearchCommunicationError = MeiliSearchCommunicationError;
            exports1.MeiliSearchError = MeiliSearchError;
            exports1.MeiliSearchTimeOutError = MeiliSearchTimeOutError;
            exports1.Meilisearch = MeiliSearch;
            exports1.TaskStatus = TaskStatus;
            exports1.TaskTypes = TaskTypes;
            exports1["default"] = MeiliSearch;
            exports1.httpErrorHandler = httpErrorHandler;
            exports1.httpResponseErrorHandler = httpResponseErrorHandler;
            exports1.versionErrorHintMessage = versionErrorHintMessage;
            Object.defineProperty(exports1, "__esModule", {
                value: true
            });
        });
    });
    var meilisearch_umd$1 = /*@__PURE__*/ getDefaultExportFromCjs(meilisearch_umd);
    var meilisearch_umd$2 = /*#__PURE__*/ Object.freeze(/*#__PURE__*/ Object.assign(/*#__PURE__*/ Object.create(null), meilisearch_umd, {
        "default": meilisearch_umd$1
    }));
    function isPureObject(data) {
        return typeof data === "object" && !Array.isArray(data) && data !== null;
    }
    /**
     * Get the configuration of instant meilisearch
     *
     * @param {InstantMeiliSearchOptions} option
     * @returns {InstantMeiliSearchConfig}
     */ function getInstantMeilisearchConfig(options) {
        var defaultOptions = {
            placeholderSearch: true,
            keepZeroFacets: false,
            clientAgents: [],
            finitePagination: false
        };
        return __assign(__assign({}, defaultOptions), options);
    }
    /**
     * Resolves apiKey if it is a function
     * @param  {string | ApiKeyCallback} apiKey
     * @returns {string} api key value
     */ function getApiKey(apiKey) {
        // If apiKey is function, call it to get the apiKey
        if (typeof apiKey === "function") {
            var apiKeyFnValue = apiKey();
            if (typeof apiKeyFnValue !== "string") throw new TypeError("Provided apiKey function (2nd parameter) did not return a string, expected string");
            return apiKeyFnValue;
        }
        return apiKey;
    }
    /**
     * Validates host and apiKey parameters, throws if invalid
     * @param hostUrl
     * @param apiKey
     */ function validateInstantMeiliSearchParams(hostUrl, apiKey, instantMeiliSearchOptions) {
        var requestConfig = instantMeiliSearchOptions.requestConfig, httpClient = instantMeiliSearchOptions.httpClient;
        // Validate host url
        if (typeof hostUrl !== "string") throw new TypeError("Provided hostUrl value (1st parameter) is not a string, expected string");
        // Validate api key
        if (typeof apiKey !== "string" && typeof apiKey !== "function") throw new TypeError("Provided apiKey value (2nd parameter) is not a string or a function, expected string or function");
        // Validate requestConfig
        if (requestConfig !== undefined && !isPureObject(requestConfig)) throw new TypeError("Provided requestConfig should be an object");
        // Validate custom HTTP client
        if (httpClient && typeof httpClient !== "function") throw new TypeError("Provided custom httpClient should be a function");
    }
    /**
     * @param  {ResponseCacher} cache
     */ function SearchResolver(client, cache) {
        return {
            multiSearch: function(searchQueries, instantSearchPagination) {
                return __awaiter(this, void 0, void 0, function() {
                    var key, cachedResponse, searchResponses, responseWithPagination;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                key = cache.formatKey([
                                    searchQueries
                                ]);
                                cachedResponse = cache.getEntry(key);
                                // Check if specific request is already cached with its associated search response.
                                if (cachedResponse) return [
                                    2 /*return*/ ,
                                    cachedResponse
                                ];
                                return [
                                    4 /*yield*/ ,
                                    client.multiSearch({
                                        queries: searchQueries
                                    })
                                ];
                            case 1:
                                searchResponses = _a.sent();
                                responseWithPagination = searchResponses.results.map(function(response, index) {
                                    return __assign(__assign({}, response), {
                                        // TODO: should be removed at one point
                                        pagination: instantSearchPagination[index] || {}
                                    });
                                });
                                // Cache response
                                cache.setEntry(key, responseWithPagination);
                                return [
                                    2 /*return*/ ,
                                    responseWithPagination
                                ];
                        }
                    });
                });
            }
        };
    }
    function adaptGeoSearch(_a) {
        var insideBoundingBox = _a.insideBoundingBox, aroundLatLng = _a.aroundLatLng, aroundRadius = _a.aroundRadius, minimumAroundRadius = _a.minimumAroundRadius;
        var middlePoint;
        var radius;
        var filter;
        if (aroundLatLng) {
            var _b = aroundLatLng.split(",").map(function(pt) {
                return Number.parseFloat(pt).toFixed(5);
            }), lat = _b[0], lng = _b[1];
            middlePoint = [
                lat,
                lng
            ];
        }
        if (aroundRadius != null || minimumAroundRadius != null) {
            if (aroundRadius === "all") console.warn("instant-meilisearch is not compatible with the `all` value on the aroundRadius parameter");
            else if (aroundRadius != null) radius = aroundRadius;
            else radius = minimumAroundRadius;
        }
        if (insideBoundingBox && typeof insideBoundingBox === "string") {
            var _c = insideBoundingBox.split(",").map(function(pt) {
                return parseFloat(pt);
            }), lat1 = _c[0], lng1 = _c[1], lat2 = _c[2], lng2 = _c[3];
            filter = "_geoBoundingBox([".concat(lat1, ", ").concat(lng1, "], [").concat(lat2, ", ").concat(lng2, "])");
        } else if (middlePoint != null && radius != null) {
            var lat = middlePoint[0], lng = middlePoint[1];
            filter = "_geoRadius(".concat(lat, ", ").concat(lng, ", ").concat(radius, ")");
        }
        return filter;
    }
    var filterEscapeRegExp = /([\\"])/g;
    function getValueWithEscapedBackslashesAndQuotes(value) {
        return value.replace(filterEscapeRegExp, "\\$1");
    }
    /**
     * Transform InstantSearch [facet filter](https://www.algolia.com/doc/api-reference/api-parameters/facetFilters/)
     * to Meilisearch compatible filter format.
     * Change sign from `:` to `=`
     * "facet:facetValue" becomes "facet=facetValue"
     *
     * Wrap both the facet and its facet value between quotes.
     * This avoids formatting issues on facets containing multiple words.
     * Escape backslash \\ and quote " characters.
     *
     * 'My facet:My facet value' becomes '"My facet":"My facet value"'
     *
     * @param {string} filter
     * @returns {string}
     */ function transformFacetFilter(filter) {
        var escapedFilter = getValueWithEscapedBackslashesAndQuotes(filter);
        var colonIndex = escapedFilter.indexOf(":");
        var attribute = escapedFilter.slice(0, colonIndex);
        var value = escapedFilter.slice(colonIndex + 1);
        return '"'.concat(attribute, '"="').concat(value, '"');
    }
    /**
     * Transform InstantSearch [numeric filter](https://www.algolia.com/doc/api-reference/api-parameters/numericFilters/)
     * to Meilisearch compatible filter format.
     *
     * 'price:5.99 TO 100' becomes '"price" 5.99 TO 100'
     *
     * 'price = 5.99' becomes '"price"=5.99'
     *
     * Wrap the attribute between quotes.
     * Escape backslash (\\) and quote (") characters.
     *
     * @param {string} filter
     * @returns {string}
     */ function transformNumericFilter(filter) {
        var splitNumericFilter = function() {
            var attributeMatch = filter.match(/^([^<!>:=]*)([<!>:=]+)(.*)$/);
            if (attributeMatch) {
                var _a = attributeMatch.slice(1), attribute_1 = _a[0], dirtyOperator = _a[1], valueEnd = _a[2];
                var operatorMatch = dirtyOperator.match(/^([<!>]?=|<|>|:){1}(.*)/) || [
                    "",
                    ""
                ];
                var _b = operatorMatch.slice(1), operator_1 = _b[0], valueStart = _b[1];
                var cleanedValue = valueStart + valueEnd;
                return [
                    attribute_1,
                    operator_1,
                    cleanedValue
                ];
            }
            return [
                filter,
                "",
                ""
            ];
        };
        var _a = splitNumericFilter(), attribute = _a[0], operator = _a[1], value = _a[2];
        var escapedAttribute = getValueWithEscapedBackslashesAndQuotes(attribute);
        return '"'.concat(escapedAttribute.trim(), '"').concat(operator === ":" ? " " : operator).concat(value.trim());
    }
    /**
     * Iterate over all filters.
     * Return the filters in a Meilisearch compatible format.
     *
     * @param  {(filter: string) => string} transformCallback
     * @param  {SearchContext['facetFilters']} filters
     * @returns {Filter}
     */ function transformFilters(transformCallback, filters) {
        return typeof filters === "string" ? transformCallback(filters) : filters.map(function(filter) {
            return typeof filter === "string" ? transformCallback(filter) : filter.map(function(nestedFilter) {
                return transformCallback(nestedFilter);
            });
        });
    }
    /**
     * Return the filter in an array if it is a string
     * If filter is array, return without change.
     *
     * @param  {Filter} [filter]
     * @returns {Array|undefined}
     */ function filterToArray(filter) {
        return typeof filter === "string" ? [
            filter
        ] : filter;
    }
    /**
     * Merge filters, transformedNumericFilters and transformedFacetFilters
     * together.
     *
     * @param  {string} filters
     * @param  {Filter} transformedNumericFilters
     * @param  {Filter} transformedFacetFilters
     * @returns {Filter}
     */ function mergeFilters(filters, transformedNumericFilters, transformedFacetFilters) {
        var adaptedNumericFilters = filterToArray(transformedNumericFilters);
        var adaptedFacetFilters = filterToArray(transformedFacetFilters);
        var adaptedFilters = [];
        if (filters !== undefined) adaptedFilters.push(filters);
        if (adaptedNumericFilters !== undefined) adaptedFilters.push.apply(adaptedFilters, adaptedNumericFilters);
        if (adaptedFacetFilters !== undefined) adaptedFilters.push.apply(adaptedFilters, adaptedFacetFilters);
        return adaptedFilters;
    }
    /**
     * Adapt instantsearch.js filters to Meilisearch filters by
     * combining and transforming all provided filters.
     *
     * @param  {string|undefined} filters
     * @param  {SearchContext['numericFilters']} numericFilters
     * @param  {SearchContext['facetFilters']} facetFilters
     * @returns {Filter}
     */ function adaptFilters(filters, numericFilters, facetFilters) {
        var transformedNumericFilters = numericFilters !== undefined ? transformFilters(transformNumericFilter, numericFilters) : numericFilters;
        var transformedFacetFilters = facetFilters !== undefined ? transformFilters(transformFacetFilter, facetFilters) : facetFilters;
        return mergeFilters(filters, transformedNumericFilters, transformedFacetFilters);
    }
    function isPaginationRequired(filter, query, placeholderSearch) {
        // To disable pagination:
        // placeholderSearch must be disabled
        // The search query must be empty
        // There must be no filters
        return !(!placeholderSearch && !query && (!filter || filter.length === 0));
    }
    function setScrollPagination(pagination, paginationRequired) {
        var page = pagination.page, hitsPerPage = pagination.hitsPerPage;
        if (!paginationRequired) return {
            limit: 0,
            offset: 0
        };
        return {
            limit: hitsPerPage + 1,
            offset: page * hitsPerPage
        };
    }
    function setFinitePagination(pagination, paginationRequired) {
        var page = pagination.page, hitsPerPage = pagination.hitsPerPage;
        if (!paginationRequired) return {
            hitsPerPage: 0,
            page: page + 1
        };
        else return {
            hitsPerPage: hitsPerPage,
            page: page + 1
        };
    }
    /**
     * Adapts instantsearch.js and instant-meilisearch options
     * to meilisearch search query parameters.
     *
     * @param  {SearchContext} searchContext
     */ function MeiliParamsCreator(searchContext) {
        var query = searchContext.query, indexUid = searchContext.indexUid, facets = searchContext.facets, attributesToSnippet = searchContext.attributesToSnippet, snippetEllipsisText = searchContext.snippetEllipsisText, filters = searchContext.filters, numericFilters = searchContext.numericFilters, facetFilters = searchContext.facetFilters, attributesToRetrieve = searchContext.attributesToRetrieve, attributesToHighlight = searchContext.attributesToHighlight, highlightPreTag = searchContext.highlightPreTag, highlightPostTag = searchContext.highlightPostTag, placeholderSearch = searchContext.placeholderSearch, pagination = searchContext.pagination, sort = searchContext.sort, restrictSearchableAttributes = searchContext.restrictSearchableAttributes, overrideParams = searchContext.meiliSearchParams;
        var meiliSearchParams = {
            indexUid: indexUid
        };
        var meilisearchFilters = adaptFilters(filters, numericFilters, facetFilters);
        return {
            getParams: function() {
                return meiliSearchParams;
            },
            addQuery: function() {
                meiliSearchParams.q = query;
            },
            addFacets: function() {
                var value = facets;
                if (value !== undefined) // despite Instantsearch.js typing it as `string[]`,
                // it still can send `string`
                meiliSearchParams.facets = typeof value === "string" ? [
                    value
                ] : value;
            },
            addAttributesToCrop: function() {
                var _a;
                var value = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.attributesToCrop) !== null && _a !== void 0 ? _a : attributesToSnippet;
                if (value !== undefined) meiliSearchParams.attributesToCrop = value;
            },
            addCropLength: function() {
                var value = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.cropLength;
                if (value !== undefined) meiliSearchParams.cropLength = value;
            },
            addCropMarker: function() {
                var _a;
                var value = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.cropMarker) !== null && _a !== void 0 ? _a : snippetEllipsisText;
                if (value !== undefined) meiliSearchParams.cropMarker = value;
            },
            addFilters: function() {
                if (meilisearchFilters.length) meiliSearchParams.filter = meilisearchFilters;
            },
            addAttributesToRetrieve: function() {
                var _a;
                var value = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.attributesToRetrieve) !== null && _a !== void 0 ? _a : attributesToRetrieve;
                if (value !== undefined) meiliSearchParams.attributesToRetrieve = value;
            },
            addAttributesToHighlight: function() {
                var _a, _b;
                meiliSearchParams.attributesToHighlight = (_b = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.attributesToHighlight) !== null && _a !== void 0 ? _a : attributesToHighlight) !== null && _b !== void 0 ? _b : [
                    "*"
                ];
            },
            addPreTag: function() {
                var _a, _b;
                meiliSearchParams.highlightPreTag = (_b = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.highlightPreTag) !== null && _a !== void 0 ? _a : highlightPreTag) !== null && _b !== void 0 ? _b : "__ais-highlight__";
            },
            addPostTag: function() {
                var _a, _b;
                meiliSearchParams.highlightPostTag = (_b = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.highlightPostTag) !== null && _a !== void 0 ? _a : highlightPostTag) !== null && _b !== void 0 ? _b : "__/ais-highlight__";
            },
            addPagination: function() {
                var paginationRequired = isPaginationRequired(meilisearchFilters, query, placeholderSearch);
                if (pagination.finite) {
                    var _a = setFinitePagination(pagination, paginationRequired), hitsPerPage = _a.hitsPerPage, page = _a.page;
                    meiliSearchParams.hitsPerPage = hitsPerPage;
                    meiliSearchParams.page = page;
                } else {
                    var _b = setScrollPagination(pagination, paginationRequired), limit = _b.limit, offset = _b.offset;
                    meiliSearchParams.limit = limit;
                    meiliSearchParams.offset = offset;
                }
            },
            addSort: function() {
                if (sort === null || sort === void 0 ? void 0 : sort.length) meiliSearchParams.sort = Array.isArray(sort) ? sort : [
                    sort
                ];
            },
            addGeoSearchFilter: function() {
                var insideBoundingBox = searchContext.insideBoundingBox, aroundLatLng = searchContext.aroundLatLng, aroundRadius = searchContext.aroundRadius, minimumAroundRadius = searchContext.minimumAroundRadius;
                var filter = adaptGeoSearch({
                    insideBoundingBox: insideBoundingBox,
                    aroundLatLng: aroundLatLng,
                    aroundRadius: aroundRadius,
                    minimumAroundRadius: minimumAroundRadius
                });
                if (filter !== undefined) {
                    if (Array.isArray(meiliSearchParams.filter)) meiliSearchParams.filter.unshift(filter);
                    else meiliSearchParams.filter = [
                        filter
                    ];
                }
            },
            addShowMatchesPosition: function() {
                var value = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.showMatchesPosition;
                if (value !== undefined) meiliSearchParams.showMatchesPosition = value;
            },
            addMatchingStrategy: function() {
                var value = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.matchingStrategy;
                if (value !== undefined) meiliSearchParams.matchingStrategy = value;
            },
            addShowRankingScore: function() {
                var value = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.showRankingScore;
                if (value !== undefined) meiliSearchParams.showRankingScore = value;
            },
            addAttributesToSearchOn: function() {
                var value = (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.attributesToSearchOn) !== undefined ? overrideParams.attributesToSearchOn : restrictSearchableAttributes;
                if (value !== undefined) meiliSearchParams.attributesToSearchOn = value;
            },
            addHybridSearch: function() {
                var value = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.hybrid;
                if (value !== undefined) meiliSearchParams.hybrid = value;
            }
        };
    }
    /**
     * Adapt search request from instantsearch.js
     * to search request compliant with Meilisearch
     *
     * @param  {SearchContext} searchContext
     * @returns {MeiliSearchMultiSearchParams}
     */ function adaptSearchParams(searchContext) {
        var meilisearchParams = MeiliParamsCreator(searchContext);
        meilisearchParams.addQuery();
        meilisearchParams.addFacets();
        meilisearchParams.addAttributesToCrop();
        meilisearchParams.addCropLength();
        meilisearchParams.addCropMarker();
        meilisearchParams.addFilters();
        meilisearchParams.addAttributesToRetrieve();
        meilisearchParams.addAttributesToHighlight();
        meilisearchParams.addPreTag();
        meilisearchParams.addPostTag();
        meilisearchParams.addPagination();
        meilisearchParams.addSort();
        meilisearchParams.addGeoSearchFilter();
        meilisearchParams.addShowMatchesPosition();
        meilisearchParams.addMatchingStrategy();
        meilisearchParams.addShowRankingScore();
        meilisearchParams.addAttributesToSearchOn();
        meilisearchParams.addHybridSearch();
        return meilisearchParams.getParams();
    }
    function removeDuplicate(key) {
        var indexes = [];
        return function(object) {
            if (indexes.includes(object[key])) return false;
            indexes.push(object[key]);
            return true;
        };
    }
    /**
     * @param  {any} str
     * @returns {boolean}
     */ /**
     * @param  {any[]} arr
     * @returns {string}
     */ function stringifyArray(arr) {
        return arr.reduce(function(acc, curr) {
            return acc += JSON.stringify(curr);
        }, "");
    }
    /**
     * Stringify values following instantsearch practices.
     *
     * @param  {any} value - value that needs to be stringified
     */ function stringifyValue(value) {
        if (typeof value === "string") // String
        return value;
        else if (value === undefined) // undefined
        return JSON.stringify(null);
        else return JSON.stringify(value);
    }
    /**
     * Recursif function wrap the deepest possible value
     * the following way: { value: "xx" }.
     *
     * For example:
     *
     * {
     * "rootField": { "value": "x" }
     * "nestedField": { child: { value: "y" } }
     * }
     *
     * recursivity continues until the value is not an array or an object.
     *
     * @param  {any} value - value of a field
     *
     * @returns Record<string, any>
     */ function wrapValue(value) {
        if (Array.isArray(value)) // Array
        return value.map(function(elem) {
            return wrapValue(elem);
        });
        else if (isPureObject(value)) // Object
        return Object.keys(value).reduce(function(nested, key) {
            nested[key] = wrapValue(value[key]);
            return nested;
        }, {});
        else return {
            value: stringifyValue(value)
        };
    }
    /**
     * Adapt Meilisearch formatted fields to a format compliant to instantsearch.js.
     *
     * @param  {Record<string} formattedHit
     * @param  {SearchContext} searchContext
     * @returns {Record}
     */ function adaptFormattedFields(hit) {
        if (!hit) return {};
        var _formattedResult = wrapValue(hit);
        var highlightedHit = {
            // We could not determine what the differences are between those two fields.
            _highlightResult: _formattedResult,
            _snippetResult: _formattedResult
        };
        return highlightedHit;
    }
    /**
     * @param  {any[]} hits
     * @returns {Array<Record<string, any>>}
     */ function adaptGeoResponse(hits) {
        var _a;
        for(var i = 0; i < hits.length; i++){
            var objectID = "".concat(i + Math.random() * 1000000);
            if (hits[i]._geo) {
                hits[i]._geoloc = hits[i]._geo;
                hits[i].objectID = objectID;
            }
            if ((_a = hits[i]._formatted) === null || _a === void 0 ? void 0 : _a._geo) {
                hits[i]._formatted._geoloc = hits[i]._formatted._geo;
                hits[i]._formatted.objectID = objectID;
            }
        }
        return hits;
    }
    /**
     * @param  {MeilisearchMultiSearchResult} searchResult
     * @param  {SearchContext} searchContext
     * @returns {Array<Record<string, any>>}
     */ function adaptHits(searchResponse, config) {
        var hits = searchResponse.hits;
        var hitsPerPage = searchResponse.pagination.hitsPerPage;
        var finitePagination = config.finitePagination, primaryKey = config.primaryKey; // Needs: finite, hitsPerPage
        // if the length of the hits is bigger than the hitsPerPage
        // It means that there is still pages to come as we append limit by hitsPerPage + 1
        // In which case we still need to remove the additional hit returned by Meilisearch
        if (!finitePagination && hits.length > hitsPerPage) hits.splice(hits.length - 1, 1);
        var adaptedHits = hits.map(function(hit) {
            // Creates Hit object compliant with InstantSearch
            if (Object.keys(hit).length > 0) {
                var formattedHit = hit._formatted;
                hit._matchesPosition;
                var documentFields = __rest(hit, [
                    "_formatted",
                    "_matchesPosition"
                ]);
                var adaptedHit = Object.assign(documentFields, adaptFormattedFields(formattedHit));
                if (primaryKey) adaptedHit.objectID = hit[primaryKey];
                return adaptedHit;
            }
            return hit;
        });
        adaptedHits = adaptGeoResponse(adaptedHits);
        return adaptedHits;
    }
    function adaptTotalHits(searchResponse) {
        var _a = searchResponse.hitsPerPage, hitsPerPage = _a === void 0 ? 0 : _a, _b = searchResponse.totalPages, totalPages = _b === void 0 ? 0 : _b, estimatedTotalHits = searchResponse.estimatedTotalHits, totalHits = searchResponse.totalHits;
        if (estimatedTotalHits != null) return estimatedTotalHits;
        else if (totalHits != null) return totalHits;
        // Should not happen but safeguarding just in case
        return hitsPerPage * totalPages;
    }
    function adaptNbPages(searchResponse, hitsPerPage) {
        if (searchResponse.totalPages != null) return searchResponse.totalPages;
        // Avoid dividing by 0
        if (hitsPerPage === 0) return 0;
        var _a = searchResponse.limit, limit = _a === void 0 ? 20 : _a, _b = searchResponse.offset, offset = _b === void 0 ? 0 : _b, hits = searchResponse.hits;
        var additionalPage = hits.length >= limit ? 1 : 0;
        return offset / hitsPerPage + 1 + additionalPage;
    }
    function adaptPaginationParameters(searchResponse, paginationState) {
        var hitsPerPage = paginationState.hitsPerPage, page = paginationState.page;
        var nbPages = adaptNbPages(searchResponse, hitsPerPage);
        return {
            page: page,
            nbPages: nbPages,
            hitsPerPage: hitsPerPage
        };
    }
    function getFacetNames(facets) {
        if (!facets) return [];
        else if (typeof facets === "string") return [
            facets
        ];
        return facets;
    }
    // Fills the missing facetValue in the current facet distribution if `keepZeroFacet` is true
    // using the initial facet distribution. Ex:
    //
    // Initial distribution: { genres: { horror: 10, comedy: 4 } }
    // Current distribution: { genres: { horror: 3 }}
    // Returned distribution: { genres: { horror: 3, comedy: 0 }}
    function fillMissingFacetValues(facets, initialFacetDistribution, facetDistribution) {
        var facetNames = getFacetNames(facets);
        var filledDistribution = {};
        for(var _i = 0, facetNames_1 = facetNames; _i < facetNames_1.length; _i++){
            var facet = facetNames_1[_i];
            for(var facetValue in initialFacetDistribution[facet]){
                if (!filledDistribution[facet]) // initialize sub object
                filledDistribution[facet] = facetDistribution[facet] || {};
                if (!filledDistribution[facet][facetValue]) filledDistribution[facet][facetValue] = 0;
                else filledDistribution[facet][facetValue] = facetDistribution[facet][facetValue];
            }
        }
        return filledDistribution;
    }
    function adaptFacetDistribution(keepZeroFacets, facets, initialFacetDistribution, facetDistribution) {
        if (keepZeroFacets) {
            facetDistribution = facetDistribution || {};
            return fillMissingFacetValues(facets, initialFacetDistribution, facetDistribution);
        }
        return facetDistribution;
    }
    function adaptFacetStats(meiliFacetStats) {
        var facetStats = Object.keys(meiliFacetStats).reduce(function(stats, facet) {
            stats[facet] = __assign(__assign({}, meiliFacetStats[facet]), {
                avg: 0,
                sum: 0
            }); // Set at 0 as these numbers are not provided by Meilisearch
            return stats;
        }, {});
        return facetStats;
    }
    /**
     * Adapt multiple search results from Meilisearch
     * to search results compliant with instantsearch.js
     *
     * @param  {Array<MeilisearchMultiSearchResult<T>>} searchResponse
     * @param  {Record<string, FacetDistribution>} initialFacetDistribution
     * @param  {InstantMeiliSearchConfig} config
     * @returns {{ results: Array<AlgoliaSearchResponse<T>> }}
     */ function adaptSearchResults(meilisearchResults, initialFacetDistribution, config) {
        var instantSearchResult = meilisearchResults.map(function(meilisearchResult) {
            return adaptSearchResult(meilisearchResult, initialFacetDistribution[meilisearchResult.indexUid], config);
        });
        return {
            results: instantSearchResult
        };
    }
    /**
     * Adapt search result from Meilisearch
     * to search result compliant with instantsearch.js
     *
     * @param  {MeilisearchMultiSearchResult<Record<string>>} searchResponse
     * @param  {Record<string, FacetDistribution>} initialFacetDistribution
     * @param  {InstantMeiliSearchConfig} config
     * @returns {AlgoliaSearchResponse<T>}
     */ function adaptSearchResult(meiliSearchResult, initialFacetDistribution, config) {
        var processingTimeMs = meiliSearchResult.processingTimeMs, query = meiliSearchResult.query, indexUid = meiliSearchResult.indexUid, _a = meiliSearchResult.facetDistribution, responseFacetDistribution = _a === void 0 ? {} : _a, _b = meiliSearchResult.facetStats, facetStats = _b === void 0 ? {} : _b;
        var facets = Object.keys(responseFacetDistribution);
        var _c = adaptPaginationParameters(meiliSearchResult, meiliSearchResult.pagination), hitsPerPage = _c.hitsPerPage, page = _c.page, nbPages = _c.nbPages;
        var hits = adaptHits(meiliSearchResult, config);
        var nbHits = adaptTotalHits(meiliSearchResult);
        var facetDistribution = adaptFacetDistribution(config.keepZeroFacets, facets, initialFacetDistribution, responseFacetDistribution);
        // Create result object compliant with InstantSearch
        var adaptedSearchResult = {
            index: indexUid,
            hitsPerPage: hitsPerPage,
            page: page,
            facets: facetDistribution,
            nbPages: nbPages,
            nbHits: nbHits,
            processingTimeMS: processingTimeMs,
            query: query,
            hits: hits,
            params: "",
            exhaustiveNbHits: false,
            facets_stats: adaptFacetStats(facetStats)
        };
        return adaptedSearchResult;
    }
    /**
     * Split sort string into an array.
     *
     * Example:
     * '_geoPoint(37.8153, -122.4784):asc,title:asc,description:desc'
     *
     * becomes:
     * [
     * '_geoPoint(37.8153, -122.4784):asc',
     * 'title:asc',
     * 'description:desc',
     * ]
     *
     * @param {string} sortStr
     * @returns {string[]}
     */ function splitSortString(sortStr) {
        if (!sortStr) return [];
        var regex = /[^:]+:(?:asc|desc)/g;
        var sortRules = [];
        var match;
        while((match = regex.exec(sortStr)) !== null)sortRules.push(match[0]);
        return sortRules.map(function(str) {
            return str.replace(/^,+|,+$/, "");
        });
    }
    /**
     * Create the current state of the pagination
     *
     * @param  {boolean} [finite]
     * @param  {number} [hitsPerPage]
     * @param  {number} [page]
     * @returns {SearchContext}
     */ function createPaginationState(finite, hitsPerPage, page) {
        return {
            hitsPerPage: hitsPerPage === undefined ? 20 : hitsPerPage,
            page: page || 0,
            finite: !!finite
        };
    }
    function separateIndexFromSortRules(indexName) {
        var colonIndex = indexName.indexOf(":");
        if (colonIndex === -1) return {
            indexUid: indexName,
            sortBy: ""
        };
        return {
            indexUid: indexName.substring(0, colonIndex),
            sortBy: indexName.substring(colonIndex + 1)
        };
    }
    /**
     * @param  {AlgoliaMultipleQueriesQuery} searchRequest
     * @param  {Context} options
     * @returns {SearchContext}
     */ function createSearchContext(searchRequest, options) {
        var query = searchRequest.query, indexName = searchRequest.indexName, instantSearchParams = searchRequest.params;
        // Split index name and possible sorting rules
        var _a = separateIndexFromSortRules(indexName), indexUid = _a.indexUid, sortBy = _a.sortBy;
        var paginationState = createPaginationState(options.finitePagination, instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.hitsPerPage, instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.page);
        var searchContext = __assign(__assign(__assign(__assign({}, options), {
            query: query
        }), instantSearchParams), {
            sort: splitSortString(sortBy),
            indexUid: indexUid,
            pagination: paginationState,
            placeholderSearch: options.placeholderSearch !== false,
            keepZeroFacets: !!options.keepZeroFacets
        });
        return searchContext;
    }
    /**
     * @param  {AlgoliaMultipleQueriesQuery} searchRequest
     * @param  {Context} options
     * @returns {SearchContext}
     */ function createFacetSearchContext(searchRequest, options) {
        // Split index name and possible sorting rules
        var _a = separateIndexFromSortRules(searchRequest.indexName), indexUid = _a.indexUid, sortBy = _a.sortBy;
        var instantSearchParams = searchRequest.params;
        var paginationState = createPaginationState(options.finitePagination, instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.hitsPerPage, instantSearchParams === null || instantSearchParams === void 0 ? void 0 : instantSearchParams.page);
        var searchContext = __assign(__assign(__assign({}, options), instantSearchParams), {
            sort: splitSortString(sortBy),
            indexUid: indexUid,
            pagination: paginationState,
            placeholderSearch: options.placeholderSearch !== false,
            keepZeroFacets: !!options.keepZeroFacets
        });
        return searchContext;
    }
    /**
     * @param  {Record<string} cache
     * @returns {SearchCache}
     */ function SearchCache(cache) {
        if (cache === void 0) cache = {};
        var searchCache = cache;
        return {
            getEntry: function(key) {
                if (searchCache[key]) try {
                    return JSON.parse(searchCache[key]);
                } catch (_) {
                    return undefined;
                }
                return undefined;
            },
            formatKey: function(components) {
                return stringifyArray(components);
            },
            setEntry: function(key, searchResponse) {
                searchCache[key] = JSON.stringify(searchResponse);
            },
            clearCache: function() {
                searchCache = {};
            }
        };
    }
    function getParametersWithoutFilters(searchContext) {
        var defaultSearchContext = __assign(__assign({}, searchContext), {
            // placeholdersearch true to ensure a request is made
            placeholderSearch: true,
            // query set to empty to ensure retrieving the default facetdistribution
            query: ""
        });
        var meilisearchParams = MeiliParamsCreator(defaultSearchContext);
        meilisearchParams.addFacets();
        meilisearchParams.addPagination();
        return meilisearchParams.getParams();
    }
    // Fetch the initial facets distribution of an Index
    // Used to show the facets when `placeholderSearch` is set to true
    // Used to fill the missing facet values when `keepZeroFacets` is set to true
    function initFacetDistribution(searchResolver, queries, initialFacetDistribution) {
        return __awaiter(this, void 0, void 0, function() {
            var removeIndexUidDuplicates, searchQueries, results, _i, results_1, searchResult;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        removeIndexUidDuplicates = removeDuplicate("indexUid");
                        searchQueries = queries.filter(removeIndexUidDuplicates) // only make one request per indexUid
                        .filter(function(_a) {
                            var indexUid = _a.indexUid;
                            // avoid requesting on indexes that already have an initial facetDistribution
                            return !Object.keys(initialFacetDistribution).includes(indexUid);
                        });
                        if (searchQueries.length === 0) return [
                            2 /*return*/ ,
                            initialFacetDistribution
                        ];
                        return [
                            4 /*yield*/ ,
                            searchResolver.multiSearch(searchQueries, [])
                        ];
                    case 1:
                        results = _a.sent();
                        for(_i = 0, results_1 = results; _i < results_1.length; _i++){
                            searchResult = results_1[_i];
                            initialFacetDistribution[searchResult.indexUid] = searchResult.facetDistribution || {};
                        }
                        return [
                            2 /*return*/ ,
                            initialFacetDistribution
                        ];
                }
            });
        });
    }
    function fillMissingFacets(initialFacetDistribution, meilisearchResults) {
        for(var _i = 0, meilisearchResults_1 = meilisearchResults; _i < meilisearchResults_1.length; _i++){
            var searchResult = meilisearchResults_1[_i];
            initialFacetDistribution[searchResult.indexUid] = __assign(__assign({}, searchResult.facetDistribution || {}), initialFacetDistribution[searchResult.indexUid] || {});
        }
        return initialFacetDistribution;
    }
    var PACKAGE_VERSION = "0.17.0";
    var constructClientAgents = function(clientAgents) {
        if (clientAgents === void 0) clientAgents = [];
        var instantMeilisearchAgent = "Meilisearch instant-meilisearch (v".concat(PACKAGE_VERSION, ")");
        return clientAgents.concat(instantMeilisearchAgent);
    };
    /**
     * Instantiate SearchClient required by instantsearch.js.
     *
     * @param  {string} hostUrl
     * @param  {string | ApiKeyCallback} [apiKey='']
     * @param  {InstantMeiliSearchOptions} [instantMeiliSearchOptions={}]
     * @returns {InstantMeiliSearchObject}
     */ function instantMeiliSearch(hostUrl, apiKey, instantMeiliSearchOptions) {
        if (apiKey === void 0) apiKey = "";
        if (instantMeiliSearchOptions === void 0) instantMeiliSearchOptions = {};
        // Validate parameters
        validateInstantMeiliSearchParams(hostUrl, apiKey, instantMeiliSearchOptions);
        // Resolve possible function to get apiKey
        apiKey = getApiKey(apiKey);
        var clientAgents = constructClientAgents(instantMeiliSearchOptions.clientAgents);
        var meilisearchConfig = {
            host: hostUrl,
            apiKey: apiKey,
            clientAgents: clientAgents
        };
        if (instantMeiliSearchOptions.httpClient !== undefined) meilisearchConfig.httpClient = instantMeiliSearchOptions.httpClient;
        if (instantMeiliSearchOptions.requestConfig !== undefined) meilisearchConfig.requestConfig = instantMeiliSearchOptions.requestConfig;
        var meilisearchClient = new meilisearch_umd.MeiliSearch(meilisearchConfig);
        var searchCache = SearchCache();
        // create search resolver with included cache
        var searchResolver = SearchResolver(meilisearchClient, searchCache);
        var initialFacetDistribution = {};
        var instantMeilisearchConfig = getInstantMeilisearchConfig(instantMeiliSearchOptions);
        return {
            meiliSearchInstance: meilisearchClient,
            setMeiliSearchParams: function(params) {
                var meiliSearchParams = instantMeiliSearchOptions.meiliSearchParams;
                instantMeiliSearchOptions.meiliSearchParams = meiliSearchParams === undefined ? params : __assign(__assign({}, meiliSearchParams), params);
            },
            searchClient: {
                clearCache: function() {
                    return searchCache.clearCache();
                },
                /**
                 * @param  {readonlyAlgoliaMultipleQueriesQuery[]} instantSearchRequests
                 * @returns {Array}
                 */ search: function(instantSearchRequests) {
                    return __awaiter(this, void 0, void 0, function() {
                        var meilisearchRequests, instantSearchPagination, initialFacetDistributionsRequests, _i, instantSearchRequests_1, searchRequest, searchContext, meilisearchSearchQuery, defaultSearchQuery, meilisearchResults, instantSearchResponse, e_1;
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    _a.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    meilisearchRequests = [];
                                    instantSearchPagination = [];
                                    initialFacetDistributionsRequests = [];
                                    for(_i = 0, instantSearchRequests_1 = instantSearchRequests; _i < instantSearchRequests_1.length; _i++){
                                        searchRequest = instantSearchRequests_1[_i];
                                        searchContext = createSearchContext(searchRequest, instantMeiliSearchOptions);
                                        meilisearchSearchQuery = adaptSearchParams(searchContext);
                                        meilisearchRequests.push(meilisearchSearchQuery);
                                        defaultSearchQuery = getParametersWithoutFilters(searchContext);
                                        initialFacetDistributionsRequests.push(defaultSearchQuery);
                                        // Keep information about the pagination parameters of instantsearch as
                                        // they are needed to adapt the search response of Meilisearch
                                        instantSearchPagination.push(searchContext.pagination);
                                    }
                                    return [
                                        4 /*yield*/ ,
                                        initFacetDistribution(searchResolver, initialFacetDistributionsRequests, initialFacetDistribution)
                                    ];
                                case 1:
                                    initialFacetDistribution = _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        searchResolver.multiSearch(meilisearchRequests, instantSearchPagination // Create issue on pagination
                                        )
                                    ];
                                case 2:
                                    meilisearchResults = _a.sent();
                                    // Fill the missing facet values if keepZeroFacets is true
                                    initialFacetDistribution = fillMissingFacets(initialFacetDistribution, meilisearchResults);
                                    instantSearchResponse = adaptSearchResults(meilisearchResults, initialFacetDistribution, instantMeilisearchConfig);
                                    return [
                                        2 /*return*/ ,
                                        instantSearchResponse
                                    ];
                                case 3:
                                    e_1 = _a.sent();
                                    console.error(e_1);
                                    throw new Error(e_1);
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                },
                searchForFacetValues: function(requests) {
                    return __awaiter(this, void 0, void 0, function() {
                        var results, _i, requests_1, request, searchContext, meilisearchSearchQuery, meilisearchRequest, meilisearchResponse, facetHits, result;
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    results = [];
                                    _i = 0, requests_1 = requests;
                                    _a.label = 1;
                                case 1:
                                    if (!(_i < requests_1.length)) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    request = requests_1[_i];
                                    searchContext = createFacetSearchContext(request, instantMeiliSearchOptions);
                                    meilisearchSearchQuery = adaptSearchParams(searchContext);
                                    meilisearchRequest = __assign(__assign({}, meilisearchSearchQuery), {
                                        facetQuery: request.params.facetQuery,
                                        facetName: request.params.facetName
                                    });
                                    delete meilisearchRequest.indexUid;
                                    return [
                                        4 /*yield*/ ,
                                        meilisearchClient.index(searchContext.indexUid).searchForFacetValues(meilisearchRequest)
                                    ];
                                case 2:
                                    meilisearchResponse = _a.sent();
                                    facetHits = meilisearchResponse.facetHits.map(function(facetHit) {
                                        return __assign(__assign({}, facetHit), {
                                            // not currently supported
                                            highlighted: facetHit.value
                                        });
                                    });
                                    result = {
                                        facetHits: facetHits,
                                        exhaustiveFacetsCount: false,
                                        processingTimeMS: meilisearchResponse.processingTimeMs
                                    };
                                    results.push(result);
                                    _a.label = 3;
                                case 3:
                                    _i++;
                                    return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ ,
                                        results
                                    ];
                            }
                        });
                    });
                }
            }
        };
    }
    exports1.instantMeiliSearch = instantMeiliSearch;
    exports1.meilisearch = meilisearch_umd$2;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


const $7b02c5030a53b061$var$searchInstance = function(hitsContainer) {
    return (0, $9a68c624c672fabe$export$2e2bcd8739ae039)({
        indexName: "documents",
        searchClient: (0, $775ca761c75bac68$exports.instantMeiliSearch)("https://meilisearch.wisderm.com", "ee8098e9d7ee167222a972ec95ec9449114fb5dc795757da86e707315e8f048d", {
            placeholderSearch: false
        }).searchClient,
        searchFunction (helper) {
            if (helper.state.query.trim() === "") document.querySelector(hitsContainer).style.display = "none";
            else document.querySelector(hitsContainer).style.display = "block";
            helper.search();
        }
    });
};
const $7b02c5030a53b061$var$searchBoxWidget = function(container) {
    return (0, $246b5dcb151969a3$export$2e2bcd8739ae039)({
        container: container,
        placeholder: "Search for ingredients, products, supplements and studies.",
        autofocus: true,
        cssClasses: {
            input: [
                "p-2",
                "self-center",
                "text-lg",
                "border-2 border-lilac-300",
                "focus:ring-0 focus:border-lilac-500"
            ],
            submit: [
                "bg-lilac-800",
                "border-2 border-lilac-300",
                "h-10"
            ],
            submitIcon: [
                "bg-lilac-800"
            ]
        }
    });
};
const $7b02c5030a53b061$var$hitsWidget = function(container) {
    return (0, $9169b8376f1e6cf3$export$2e2bcd8739ae039)({
        container: container,
        templates: {
            item (hit, { html: html, components: components }) {
                return html`
          <a href="${hit.link}">
            <div class="cursor-pointer text-left text-gray-700 hover:text-lilac-800 hover:underline">
              ${components.Highlight({
                    attribute: "name",
                    hit: hit
                })}
            </div>
          </a>
        `;
            },
            empty: '<div class="ais-Hits-item text-left text-gray-700">No results</div>'
        }
    });
};
const $7b02c5030a53b061$var$configureWidget = (0, $d384af5640276fb9$export$2e2bcd8739ae039)({
    hitsPerPage: 5
});
const $7b02c5030a53b061$var$headerSearch = $7b02c5030a53b061$var$searchInstance("#headerHits");
$7b02c5030a53b061$var$headerSearch.addWidgets([
    $7b02c5030a53b061$var$searchBoxWidget("#headerSearchbox"),
    $7b02c5030a53b061$var$hitsWidget("#headerHits"),
    $7b02c5030a53b061$var$configureWidget
]);
$7b02c5030a53b061$var$headerSearch.start();
if (document.querySelector("#searchbox")) {
    const search = $7b02c5030a53b061$var$searchInstance("#hits");
    search.addWidgets([
        $7b02c5030a53b061$var$searchBoxWidget("#searchbox"),
        $7b02c5030a53b061$var$hitsWidget("#hits"),
        $7b02c5030a53b061$var$configureWidget
    ]);
    search.start();
}
const $7b02c5030a53b061$var$searchBtn = document.querySelector("#search-btn");
const $7b02c5030a53b061$var$searchDiv = document.querySelector("#search-div");
$7b02c5030a53b061$var$searchBtn.addEventListener("click", ()=>{
    $7b02c5030a53b061$var$searchDiv.classList.toggle("hidden");
    if (!$7b02c5030a53b061$var$searchDiv.classList.contains("hidden")) document.querySelector("input.ais-SearchBox-input").focus();
});
[
    "ingredient",
    "product",
    "supplement",
    "clinical",
    "mechanistic",
    "tolerability"
].forEach((kind)=>{
    const kindToggle = document.querySelector(`#${kind}-toggle`);
    if (kindToggle !== null) kindToggle.addEventListener("click", ()=>{
        const moreRows = document.querySelectorAll(`.more-${kind}`);
        moreRows.forEach((row)=>row.classList.toggle("hidden"));
        if (kindToggle.textContent.includes("more")) kindToggle.textContent = kindToggle.textContent.replace("more", "fewer");
        else kindToggle.textContent = kindToggle.textContent.replace("fewer", "more");
    });
});

})();
//# sourceMappingURL=index.js.map
